webpackJsonp([0],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(102);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

// v-resize
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('resize', {
  inserted: function inserted(el, binding) {
    var resizeObserver = new ResizeObserver(function (entries) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;

          binding.value(entry);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });

    // v-resize.border
    var boxModel = binding.modifiers.border ? 'border-box' : 'content-box';

    resizeObserver.observe(el, { box: boxModel });
  },
  unbind: function unbind(el) {
    resizeObserver.disconnect(el);
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  var token = $('[name="csrf-token"]').attr('content');
  request.headers.set('X-CSRF-TOKEN', token);
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]);

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "jQuery"
var external__jQuery_ = __webpack_require__(63);
var external__jQuery__default = /*#__PURE__*/__webpack_require__.n(external__jQuery_);

// EXTERNAL MODULE: ./vendor/assets/javascripts/chosen.js
var chosen = __webpack_require__(104);
var chosen_default = /*#__PURE__*/__webpack_require__.n(chosen);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/chosen-field.vue
//
//
//
//
//
//




/* harmony default export */ var chosen_field = ({
  mounted: function mounted() {
    external__jQuery__default()(this.$el).children('select').chosen({
      allow_single_deselect: true,
      placeholder_text_single: "Select one"
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-993d5e12","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/chosen-field.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-field cm-chosen-field"
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_chosen_field = (esExports);
// CONCATENATED MODULE: ./app/javascript/components/chosen-field.vue
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  chosen_field,
  components_chosen_field,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var javascript_components_chosen_field = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// Chosen, a Select Box Enhancer for jQuery and Prototype
// by Patrick Filler for Harvest, http://getharvest.com
//
// Version 0.9.15
// Full source at https://github.com/harvesthq/chosen
// Copyright (c) 2011 Harvest http://getharvest.com

// MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
// This file is generated by `cake build`, do not edit it by hand.
(function () {
  var e;e = function () {
    function e() {
      this.options_index = 0, this.parsed = [];
    }return e.prototype.add_node = function (e) {
      return e.nodeName.toUpperCase() === "OPTGROUP" ? this.add_group(e) : this.add_option(e);
    }, e.prototype.add_group = function (e) {
      var t, n, r, i, s, o;t = this.parsed.length, this.parsed.push({ array_index: t, group: !0, label: e.label, children: 0, disabled: e.disabled }), s = e.childNodes, o = [];for (r = 0, i = s.length; r < i; r++) {
        n = s[r], o.push(this.add_option(n, t, e.disabled));
      }return o;
    }, e.prototype.add_option = function (e, t, n) {
      if (e.nodeName.toUpperCase() === "OPTION") return e.text !== "" ? (t != null && (this.parsed[t].children += 1), this.parsed.push({ array_index: this.parsed.length, options_index: this.options_index, value: e.value, text: e.text, html: e.innerHTML, selected: e.selected, disabled: n === !0 ? n : e.disabled, group_array_index: t, classes: e.className, style: e.style.cssText })) : this.parsed.push({ array_index: this.parsed.length, options_index: this.options_index, empty: !0 }), this.options_index += 1;
    }, e;
  }(), e.select_to_array = function (t) {
    var n, r, i, s, o;r = new e(), o = t.childNodes;for (i = 0, s = o.length; i < s; i++) {
      n = o[i], r.add_node(n);
    }return r.parsed;
  }, this.SelectParser = e;
}).call(this), function () {
  var e, t;t = this, e = function () {
    function e(t, n) {
      this.form_field = t, this.options = n != null ? n : {};if (!e.browser_is_supported()) return;this.is_multiple = this.form_field.multiple, this.set_default_text(), this.set_default_values(), this.setup(), this.set_up_html(), this.register_observers(), this.finish_setup();
    }return e.prototype.set_default_values = function () {
      var e = this;return this.click_test_action = function (t) {
        return e.test_active_click(t);
      }, this.activate_action = function (t) {
        return e.activate_field(t);
      }, this.active_field = !1, this.mouse_on_container = !1, this.results_showing = !1, this.result_highlighted = null, this.result_single_selected = null, this.allow_single_deselect = this.options.allow_single_deselect != null && this.form_field.options[0] != null && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : !1, this.disable_search_threshold = this.options.disable_search_threshold || 0, this.disable_search = this.options.disable_search || !1, this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : !0, this.search_contains = this.options.search_contains || !1, this.single_backstroke_delete = this.options.single_backstroke_delete || !1, this.max_selected_options = this.options.max_selected_options || Infinity, this.inherit_select_classes = this.options.inherit_select_classes || !1;
    }, e.prototype.set_default_text = function () {
      return this.form_field.getAttribute("data-placeholder") ? this.default_text = this.form_field.getAttribute("data-placeholder") : this.is_multiple ? this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || e.default_multiple_text : this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || e.default_single_text, this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || e.default_no_result_text;
    }, e.prototype.mouse_enter = function () {
      return this.mouse_on_container = !0;
    }, e.prototype.mouse_leave = function () {
      return this.mouse_on_container = !1;
    }, e.prototype.input_focus = function (e) {
      var t = this;if (this.is_multiple) {
        if (!this.active_field) return setTimeout(function () {
          return t.container_mousedown();
        }, 50);
      } else if (!this.active_field) return this.activate_field();
    }, e.prototype.input_blur = function (e) {
      var t = this;if (!this.mouse_on_container) return this.active_field = !1, setTimeout(function () {
        return t.blur_test();
      }, 100);
    }, e.prototype.result_add_option = function (e) {
      var t, n;return e.disabled ? "" : (e.dom_id = this.container_id + "_o_" + e.array_index, t = e.selected && this.is_multiple ? [] : ["active-result"], e.selected && t.push("result-selected"), e.group_array_index != null && t.push("group-option"), e.classes !== "" && t.push(e.classes), n = e.style.cssText !== "" ? ' style="' + e.style + '"' : "", '<li id="' + e.dom_id + '" class="' + t.join(" ") + '"' + n + ">" + e.html + "</li>");
    }, e.prototype.results_update_field = function () {
      return this.set_default_text(), this.is_multiple || this.results_reset_cleanup(), this.result_clear_highlight(), this.result_single_selected = null, this.results_build();
    }, e.prototype.results_toggle = function () {
      return this.results_showing ? this.results_hide() : this.results_show();
    }, e.prototype.results_search = function (e) {
      return this.results_showing ? this.winnow_results() : this.results_show();
    }, e.prototype.choices_count = function () {
      var e, t, n, r;if (this.selected_option_count != null) return this.selected_option_count;this.selected_option_count = 0, r = this.form_field.options;for (t = 0, n = r.length; t < n; t++) {
        e = r[t], e.selected && (this.selected_option_count += 1);
      }return this.selected_option_count;
    }, e.prototype.choices_click = function (e) {
      e.preventDefault();if (!this.results_showing) return this.results_show();
    }, e.prototype.keyup_checker = function (e) {
      var t, n;t = (n = e.which) != null ? n : e.keyCode, this.search_field_scale();switch (t) {case 8:
          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) return this.keydown_backstroke();if (!this.pending_backstroke) return this.result_clear_highlight(), this.results_search();break;case 13:
          e.preventDefault();if (this.results_showing) return this.result_select(e);break;case 27:
          return this.results_showing && this.results_hide(), !0;case 9:case 38:case 40:case 16:case 91:case 17:
          break;default:
          return this.results_search();}
    }, e.prototype.generate_field_id = function () {
      var e;return e = this.generate_random_id(), this.form_field.id = e, e;
    }, e.prototype.generate_random_char = function () {
      var e, t, n;return e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", n = Math.floor(Math.random() * e.length), t = e.substring(n, n + 1);
    }, e.prototype.container_width = function () {
      return this.options.width != null ? this.options.width : "" + this.form_field.offsetWidth + "px";
    }, e.browser_is_supported = function () {
      var e;return window.navigator.appName === "Microsoft Internet Explorer" ? null !== (e = document.documentMode) && e >= 8 : !0;
    }, e.default_multiple_text = "Select Some Options", e.default_single_text = "Select an Option", e.default_no_result_text = "No results match", e;
  }(), t.AbstractChosen = e;
}.call(this), function () {
  var e,
      t,
      n,
      r,
      i = {}.hasOwnProperty,
      s = function s(e, t) {
    function r() {
      this.constructor = e;
    }for (var n in t) {
      i.call(t, n) && (e[n] = t[n]);
    }return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
  };n = this, e = jQuery, e.fn.extend({ chosen: function chosen(n) {
      return AbstractChosen.browser_is_supported() ? this.each(function (r) {
        var i;i = e(this);if (!i.hasClass("chzn-done")) return i.data("chosen", new t(this, n));
      }) : this;
    } }), t = function (t) {
    function i() {
      return r = i.__super__.constructor.apply(this, arguments), r;
    }return s(i, t), i.prototype.setup = function () {
      return this.form_field_jq = e(this.form_field), this.current_selectedIndex = this.form_field.selectedIndex, this.is_rtl = this.form_field_jq.hasClass("chzn-rtl");
    }, i.prototype.finish_setup = function () {
      return this.form_field_jq.addClass("chzn-done");
    }, i.prototype.set_up_html = function () {
      var t, n;return this.container_id = this.form_field.id.length ? this.form_field.id.replace(/[^\w]/g, "_") : this.generate_field_id(), this.container_id += "_chzn", t = ["chzn-container"], t.push("chzn-container-" + (this.is_multiple ? "multi" : "single")), this.inherit_select_classes && this.form_field.className && t.push(this.form_field.className), this.is_rtl && t.push("chzn-rtl"), n = { id: this.container_id, "class": t.join(" "), style: "width: " + this.container_width() + ";", title: this.form_field.title }, this.container = e("<div />", n), this.is_multiple ? this.container.html('<ul class="chzn-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop"><ul class="chzn-results"></ul></div>') : this.container.html('<a href="javascript:void(0)" class="chzn-single chzn-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chzn-drop"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>'), this.form_field_jq.hide().after(this.container), this.dropdown = this.container.find("div.chzn-drop").first(), this.search_field = this.container.find("input").first(), this.search_results = this.container.find("ul.chzn-results").first(), this.search_field_scale(), this.search_no_results = this.container.find("li.no-results").first(), this.is_multiple ? (this.search_choices = this.container.find("ul.chzn-choices").first(), this.search_container = this.container.find("li.search-field").first()) : (this.search_container = this.container.find("div.chzn-search").first(), this.selected_item = this.container.find(".chzn-single").first()), this.results_build(), this.set_tab_index(), this.set_label_behavior(), this.form_field_jq.trigger("liszt:ready", { chosen: this });
    }, i.prototype.register_observers = function () {
      var e = this;return this.container.mousedown(function (t) {
        e.container_mousedown(t);
      }), this.container.mouseup(function (t) {
        e.container_mouseup(t);
      }), this.container.mouseenter(function (t) {
        e.mouse_enter(t);
      }), this.container.mouseleave(function (t) {
        e.mouse_leave(t);
      }), this.search_results.mouseup(function (t) {
        e.search_results_mouseup(t);
      }), this.search_results.mouseover(function (t) {
        e.search_results_mouseover(t);
      }), this.search_results.mouseout(function (t) {
        e.search_results_mouseout(t);
      }), this.search_results.bind("mousewheel DOMMouseScroll", function (t) {
        e.search_results_mousewheel(t);
      }), this.form_field_jq.bind("liszt:updated", function (t) {
        e.results_update_field(t);
      }), this.form_field_jq.bind("liszt:activate", function (t) {
        e.activate_field(t);
      }), this.form_field_jq.bind("liszt:open", function (t) {
        e.container_mousedown(t);
      }), this.search_field.blur(function (t) {
        e.input_blur(t);
      }), this.search_field.keyup(function (t) {
        e.keyup_checker(t);
      }), this.search_field.keydown(function (t) {
        e.keydown_checker(t);
      }), this.search_field.focus(function (t) {
        e.input_focus(t);
      }), this.is_multiple ? this.search_choices.click(function (t) {
        e.choices_click(t);
      }) : this.container.click(function (e) {
        e.preventDefault();
      });
    }, i.prototype.search_field_disabled = function () {
      this.is_disabled = this.form_field_jq[0].disabled;if (this.is_disabled) return this.container.addClass("chzn-disabled"), this.search_field[0].disabled = !0, this.is_multiple || this.selected_item.unbind("focus", this.activate_action), this.close_field();this.container.removeClass("chzn-disabled"), this.search_field[0].disabled = !1;if (!this.is_multiple) return this.selected_item.bind("focus", this.activate_action);
    }, i.prototype.container_mousedown = function (t) {
      if (!this.is_disabled) {
        t && t.type === "mousedown" && !this.results_showing && t.preventDefault();if (t == null || !e(t.target).hasClass("search-choice-close")) return this.active_field ? !this.is_multiple && t && (e(t.target)[0] === this.selected_item[0] || e(t.target).parents("a.chzn-single").length) && (t.preventDefault(), this.results_toggle()) : (this.is_multiple && this.search_field.val(""), e(document).click(this.click_test_action), this.results_show()), this.activate_field();
      }
    }, i.prototype.container_mouseup = function (e) {
      if (e.target.nodeName === "ABBR" && !this.is_disabled) return this.results_reset(e);
    }, i.prototype.search_results_mousewheel = function (e) {
      var t, n, r;t = -((n = e.originalEvent) != null ? n.wheelDelta : void 0) || ((r = e.originialEvent) != null ? r.detail : void 0);if (t != null) return e.preventDefault(), e.type === "DOMMouseScroll" && (t *= 40), this.search_results.scrollTop(t + this.search_results.scrollTop());
    }, i.prototype.blur_test = function (e) {
      if (!this.active_field && this.container.hasClass("chzn-container-active")) return this.close_field();
    }, i.prototype.close_field = function () {
      return e(document).unbind("click", this.click_test_action), this.active_field = !1, this.results_hide(), this.container.removeClass("chzn-container-active"), this.winnow_results_clear(), this.clear_backstroke(), this.show_search_field_default(), this.search_field_scale();
    }, i.prototype.activate_field = function () {
      return this.container.addClass("chzn-container-active"), this.active_field = !0, this.search_field.val(this.search_field.val()), this.search_field.focus();
    }, i.prototype.test_active_click = function (t) {
      return e(t.target).parents("#" + this.container_id).length ? this.active_field = !0 : this.close_field();
    }, i.prototype.results_build = function () {
      var e, t, r, i, s;this.parsing = !0, this.selected_option_count = null, this.results_data = n.SelectParser.select_to_array(this.form_field), this.is_multiple && this.choices_count() > 0 ? this.search_choices.find("li.search-choice").remove() : this.is_multiple || (this.selected_item.addClass("chzn-default").find("span").text(this.default_text), this.disable_search || this.form_field.options.length <= this.disable_search_threshold ? this.container.addClass("chzn-container-single-nosearch") : this.container.removeClass("chzn-container-single-nosearch")), e = "", s = this.results_data;for (r = 0, i = s.length; r < i; r++) {
        t = s[r], t.group ? e += this.result_add_group(t) : t.empty || (e += this.result_add_option(t), t.selected && this.is_multiple ? this.choice_build(t) : t.selected && !this.is_multiple && (this.selected_item.removeClass("chzn-default").find("span").text(t.text), this.allow_single_deselect && this.single_deselect_control_build()));
      }return this.search_field_disabled(), this.show_search_field_default(), this.search_field_scale(), this.search_results.html(e), this.parsing = !1;
    }, i.prototype.result_add_group = function (t) {
      return t.disabled ? "" : (t.dom_id = this.container_id + "_g_" + t.array_index, '<li id="' + t.dom_id + '" class="group-result">' + e("<div />").text(t.label).html() + "</li>");
    }, i.prototype.result_do_highlight = function (e) {
      var t, n, r, i, s;if (e.length) {
        this.result_clear_highlight(), this.result_highlight = e, this.result_highlight.addClass("highlighted"), r = parseInt(this.search_results.css("maxHeight"), 10), s = this.search_results.scrollTop(), i = r + s, n = this.result_highlight.position().top + this.search_results.scrollTop(), t = n + this.result_highlight.outerHeight();if (t >= i) return this.search_results.scrollTop(t - r > 0 ? t - r : 0);if (n < s) return this.search_results.scrollTop(n);
      }
    }, i.prototype.result_clear_highlight = function () {
      return this.result_highlight && this.result_highlight.removeClass("highlighted"), this.result_highlight = null;
    }, i.prototype.results_show = function () {
      if (this.result_single_selected != null) this.result_do_highlight(this.result_single_selected);else if (this.is_multiple && this.max_selected_options <= this.choices_count()) return this.form_field_jq.trigger("liszt:maxselected", { chosen: this }), !1;return this.container.addClass("chzn-with-drop"), this.form_field_jq.trigger("liszt:showing_dropdown", { chosen: this }), this.results_showing = !0, this.search_field.focus(), this.search_field.val(this.search_field.val()), this.winnow_results();
    }, i.prototype.results_hide = function () {
      return this.result_clear_highlight(), this.container.removeClass("chzn-with-drop"), this.form_field_jq.trigger("liszt:hiding_dropdown", { chosen: this }), this.results_showing = !1;
    }, i.prototype.set_tab_index = function (e) {
      var t;if (this.form_field_jq.attr("tabindex")) return t = this.form_field_jq.attr("tabindex"), this.form_field_jq.attr("tabindex", -1), this.search_field.attr("tabindex", t);
    }, i.prototype.set_label_behavior = function () {
      var t = this;this.form_field_label = this.form_field_jq.parents("label"), !this.form_field_label.length && this.form_field.id.length && (this.form_field_label = e("label[for='" + this.form_field.id + "']"));if (this.form_field_label.length > 0) return this.form_field_label.click(function (e) {
        return t.is_multiple ? t.container_mousedown(e) : t.activate_field();
      });
    }, i.prototype.show_search_field_default = function () {
      return this.is_multiple && this.choices_count() < 1 && !this.active_field ? (this.search_field.val(this.default_text), this.search_field.addClass("default")) : (this.search_field.val(""), this.search_field.removeClass("default"));
    }, i.prototype.search_results_mouseup = function (t) {
      var n;n = e(t.target).hasClass("active-result") ? e(t.target) : e(t.target).parents(".active-result").first();if (n.length) return this.result_highlight = n, this.result_select(t), this.search_field.focus();
    }, i.prototype.search_results_mouseover = function (t) {
      var n;n = e(t.target).hasClass("active-result") ? e(t.target) : e(t.target).parents(".active-result").first();if (n) return this.result_do_highlight(n);
    }, i.prototype.search_results_mouseout = function (t) {
      if (e(t.target).hasClass("active-result")) return this.result_clear_highlight();
    }, i.prototype.choice_build = function (t) {
      var n,
          r,
          i = this;return n = e("<li />", { "class": "search-choice" }).html("<span>" + t.html + "</span>"), t.disabled ? n.addClass("search-choice-disabled") : (r = e("<a />", { href: "#", "class": "search-choice-close", rel: t.array_index }), r.click(function (e) {
        return i.choice_destroy_link_click(e);
      }), n.append(r)), this.search_container.before(n);
    }, i.prototype.choice_destroy_link_click = function (t) {
      t.preventDefault(), t.stopPropagation();if (!this.is_disabled) return this.choice_destroy(e(t.target));
    }, i.prototype.choice_destroy = function (e) {
      if (this.result_deselect(e.attr("rel"))) return this.show_search_field_default(), this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1 && this.results_hide(), e.parents("li").first().remove(), this.search_field_scale();
    }, i.prototype.results_reset = function () {
      this.form_field.options[0].selected = !0, this.selected_option_count = null, this.selected_item.find("span").text(this.default_text), this.is_multiple || this.selected_item.addClass("chzn-default"), this.show_search_field_default(), this.results_reset_cleanup(), this.form_field_jq.trigger("change");if (this.active_field) return this.results_hide();
    }, i.prototype.results_reset_cleanup = function () {
      return this.current_selectedIndex = this.form_field.selectedIndex, this.selected_item.find("abbr").remove();
    }, i.prototype.result_select = function (e) {
      var t, n, r, i;if (this.result_highlight) return t = this.result_highlight, n = t.attr("id"), this.result_clear_highlight(), this.is_multiple && this.max_selected_options <= this.choices_count() ? (this.form_field_jq.trigger("liszt:maxselected", { chosen: this }), !1) : (this.is_multiple ? this.result_deactivate(t) : (this.search_results.find(".result-selected").removeClass("result-selected"), this.result_single_selected = t, this.selected_item.removeClass("chzn-default")), t.addClass("result-selected"), i = n.substr(n.lastIndexOf("_") + 1), r = this.results_data[i], r.selected = !0, this.form_field.options[r.options_index].selected = !0, this.selected_option_count = null, this.is_multiple ? this.choice_build(r) : (this.selected_item.find("span").first().text(r.text), this.allow_single_deselect && this.single_deselect_control_build()), (!e.metaKey && !e.ctrlKey || !this.is_multiple) && this.results_hide(), this.search_field.val(""), (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) && this.form_field_jq.trigger("change", { selected: this.form_field.options[r.options_index].value }), this.current_selectedIndex = this.form_field.selectedIndex, this.search_field_scale());
    }, i.prototype.result_activate = function (e) {
      return e.addClass("active-result");
    }, i.prototype.result_deactivate = function (e) {
      return e.removeClass("active-result");
    }, i.prototype.result_deselect = function (t) {
      var n, r;return r = this.results_data[t], this.form_field.options[r.options_index].disabled ? !1 : (r.selected = !1, this.form_field.options[r.options_index].selected = !1, this.selected_option_count = null, n = e("#" + this.container_id + "_o_" + t), n.removeClass("result-selected").addClass("active-result").show(), this.result_clear_highlight(), this.winnow_results(), this.form_field_jq.trigger("change", { deselected: this.form_field.options[r.options_index].value }), this.search_field_scale(), !0);
    }, i.prototype.single_deselect_control_build = function () {
      if (!this.allow_single_deselect) return;return this.selected_item.find("abbr").length || this.selected_item.find("span").first().after('<abbr class="search-choice-close"></abbr>'), this.selected_item.addClass("chzn-single-with-deselect");
    }, i.prototype.winnow_results = function () {
      var t, n, r, i, s, o, u, a, f, l, c, h, p, d, v, m, g, y;this.no_results_clear(), f = 0, l = this.search_field.val() === this.default_text ? "" : e("<div/>").text(e.trim(this.search_field.val())).html(), o = this.search_contains ? "" : "^", s = new RegExp(o + l.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "i"), p = new RegExp(l.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "i"), y = this.results_data;for (d = 0, m = y.length; d < m; d++) {
        n = y[d];if (!n.disabled && !n.empty) if (n.group) e("#" + n.dom_id).css("display", "none");else if (!this.is_multiple || !n.selected) {
          t = !1, a = n.dom_id, u = e("#" + a);if (s.test(n.html)) t = !0, f += 1;else if (this.enable_split_word_search && (n.html.indexOf(" ") >= 0 || n.html.indexOf("[") === 0)) {
            i = n.html.replace(/\[|\]/g, "").split(" ");if (i.length) for (v = 0, g = i.length; v < g; v++) {
              r = i[v], s.test(r) && (t = !0, f += 1);
            }
          }t ? (l.length ? (c = n.html.search(p), h = n.html.substr(0, c + l.length) + "</em>" + n.html.substr(c + l.length), h = h.substr(0, c) + "<em>" + h.substr(c)) : h = n.html, u.html(h), this.result_activate(u), n.group_array_index != null && e("#" + this.results_data[n.group_array_index].dom_id).css("display", "list-item")) : (this.result_highlight && a === this.result_highlight.attr("id") && this.result_clear_highlight(), this.result_deactivate(u));
        }
      }return f < 1 && l.length ? this.no_results(l) : this.winnow_results_set_highlight();
    }, i.prototype.winnow_results_clear = function () {
      var t, n, r, i, s;this.search_field.val(""), n = this.search_results.find("li"), s = [];for (r = 0, i = n.length; r < i; r++) {
        t = n[r], t = e(t), t.hasClass("group-result") ? s.push(t.css("display", "auto")) : !this.is_multiple || !t.hasClass("result-selected") ? s.push(this.result_activate(t)) : s.push(void 0);
      }return s;
    }, i.prototype.winnow_results_set_highlight = function () {
      var e, t;if (!this.result_highlight) {
        t = this.is_multiple ? [] : this.search_results.find(".result-selected.active-result"), e = t.length ? t.first() : this.search_results.find(".active-result").first();if (e != null) return this.result_do_highlight(e);
      }
    }, i.prototype.no_results = function (t) {
      var n;return n = e('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>'), n.find("span").first().html(t), this.search_results.append(n);
    }, i.prototype.no_results_clear = function () {
      return this.search_results.find(".no-results").remove();
    }, i.prototype.keydown_arrow = function () {
      var t, n;this.result_highlight ? this.results_showing && (n = this.result_highlight.nextAll("li.active-result").first(), n && this.result_do_highlight(n)) : (t = this.search_results.find("li.active-result").first(), t && this.result_do_highlight(e(t)));if (!this.results_showing) return this.results_show();
    }, i.prototype.keyup_arrow = function () {
      var e;if (!this.results_showing && !this.is_multiple) return this.results_show();if (this.result_highlight) return e = this.result_highlight.prevAll("li.active-result"), e.length ? this.result_do_highlight(e.first()) : (this.choices_count() > 0 && this.results_hide(), this.result_clear_highlight());
    }, i.prototype.keydown_backstroke = function () {
      var e;if (this.pending_backstroke) return this.choice_destroy(this.pending_backstroke.find("a").first()), this.clear_backstroke();e = this.search_container.siblings("li.search-choice").last();if (e.length && !e.hasClass("search-choice-disabled")) return this.pending_backstroke = e, this.single_backstroke_delete ? this.keydown_backstroke() : this.pending_backstroke.addClass("search-choice-focus");
    }, i.prototype.clear_backstroke = function () {
      return this.pending_backstroke && this.pending_backstroke.removeClass("search-choice-focus"), this.pending_backstroke = null;
    }, i.prototype.keydown_checker = function (e) {
      var t, n;t = (n = e.which) != null ? n : e.keyCode, this.search_field_scale(), t !== 8 && this.pending_backstroke && this.clear_backstroke();switch (t) {case 8:
          this.backstroke_length = this.search_field.val().length;break;case 9:
          this.results_showing && !this.is_multiple && this.result_select(e), this.mouse_on_container = !1;break;case 13:
          e.preventDefault();break;case 38:
          e.preventDefault(), this.keyup_arrow();break;case 40:
          this.keydown_arrow();}
    }, i.prototype.search_field_scale = function () {
      var t, n, r, i, s, o, u, a;if (this.is_multiple) {
        n = 0, o = 0, i = "position:absolute; left: -1000px; top: -1000px; display:none;", s = ["font-size", "font-style", "font-weight", "font-family", "line-height", "text-transform", "letter-spacing"];for (u = 0, a = s.length; u < a; u++) {
          r = s[u], i += r + ":" + this.search_field.css(r) + ";";
        }return t = e("<div />", { style: i }), t.text(this.search_field.val()), e("body").append(t), o = t.width() + 25, t.remove(), this.f_width || (this.f_width = this.container.outerWidth()), o > this.f_width - 10 && (o = this.f_width - 10), this.search_field.css({ width: o + "px" });
      }
    }, i.prototype.generate_random_id = function () {
      var t;t = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char();while (e("#" + t).length > 0) {
        t += this.generate_random_char();
      }return t;
    }, i;
  }(AbstractChosen), n.Chosen = t;
}.call(this);

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
Copyright 2012 Igor Vaynberg

Version: @@ver@@ Timestamp: @@timestamp@@

This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
General Public License version 2 (the "GPL License"). You may choose either license to govern your
use of this software only upon the condition that you accept all of the terms of either the Apache
License or the GPL License.

You may obtain a copy of the Apache License and the GPL License at:

    http://www.apache.org/licenses/LICENSE-2.0
    http://www.gnu.org/licenses/gpl-2.0.html

Unless required by applicable law or agreed to in writing, software distributed under the
Apache License or the GPL Licesnse is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
the specific language governing permissions and limitations under the Apache License and the GPL License.
*/
(function ($) {
    if (typeof $.fn.each2 == "undefined") {
        $.fn.extend({
            /*
            * 4-10 times faster .each replacement
            * use it carefully, as it overrides jQuery context of element on each iteration
            */
            each2: function each2(c) {
                var j = $([0]),
                    i = -1,
                    l = this.length;
                while (++i < l && (j.context = j[0] = this[i]) && c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
                ) {}
                return this;
            }
        });
    }
})(jQuery);

(function ($, undefined) {
    "use strict";
    /*global document, window, jQuery, console */

    if (window.Select2 !== undefined) {
        return;
    }

    var KEY,
        AbstractSelect2,
        SingleSelect2,
        MultiSelect2,
        nextUid,
        sizer,
        lastMousePosition = { x: 0, y: 0 },
        $document,
        scrollBarDimensions,
        KEY = {
        TAB: 9,
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        HOME: 36,
        END: 35,
        BACKSPACE: 8,
        DELETE: 46,
        isArrow: function isArrow(k) {
            k = k.which ? k.which : k;
            switch (k) {
                case KEY.LEFT:
                case KEY.RIGHT:
                case KEY.UP:
                case KEY.DOWN:
                    return true;
            }
            return false;
        },
        isControl: function isControl(e) {
            var k = e.which;
            switch (k) {
                case KEY.SHIFT:
                case KEY.CTRL:
                case KEY.ALT:
                    return true;
            }

            if (e.metaKey) return true;

            return false;
        },
        isFunctionKey: function isFunctionKey(k) {
            k = k.which ? k.which : k;
            return k >= 112 && k <= 123;
        }
    },
        MEASURE_SCROLLBAR_TEMPLATE = "<div class='select2-measure-scrollbar'></div>";

    $document = $(document);

    nextUid = function () {
        var counter = 1;return function () {
            return counter++;
        };
    }();

    function indexOf(value, array) {
        var i = 0,
            l = array.length;
        for (; i < l; i = i + 1) {
            if (equal(value, array[i])) return i;
        }
        return -1;
    }

    function measureScrollbar() {
        var $template = $(MEASURE_SCROLLBAR_TEMPLATE);
        $template.appendTo('body');

        var dim = {
            width: $template.width() - $template[0].clientWidth,
            height: $template.height() - $template[0].clientHeight
        };
        $template.remove();

        return dim;
    }

    /**
     * Compares equality of a and b
     * @param a
     * @param b
     */
    function equal(a, b) {
        if (a === b) return true;
        if (a === undefined || b === undefined) return false;
        if (a === null || b === null) return false;
        if (a.constructor === String) return a + '' === b + ''; // IE requires a+'' instead of just a
        if (b.constructor === String) return b + '' === a + ''; // IE requires b+'' instead of just b
        return false;
    }

    /**
     * Splits the string into an array of values, trimming each value. An empty array is returned for nulls or empty
     * strings
     * @param string
     * @param separator
     */
    function splitVal(string, separator) {
        var val, i, l;
        if (string === null || string.length < 1) return [];
        val = string.split(separator);
        for (i = 0, l = val.length; i < l; i = i + 1) {
            val[i] = $.trim(val[i]);
        }return val;
    }

    function getSideBorderPadding(element) {
        return element.outerWidth(false) - element.width();
    }

    function installKeyUpChangeEvent(element) {
        var key = "keyup-change-value";
        element.on("keydown", function () {
            if ($.data(element, key) === undefined) {
                $.data(element, key, element.val());
            }
        });
        element.on("keyup", function () {
            var val = $.data(element, key);
            if (val !== undefined && element.val() !== val) {
                $.removeData(element, key);
                element.trigger("keyup-change");
            }
        });
    }

    $document.on("mousemove", function (e) {
        lastMousePosition.x = e.pageX;
        lastMousePosition.y = e.pageY;
    });

    /**
     * filters mouse events so an event is fired only if the mouse moved.
     *
     * filters out mouse events that occur when mouse is stationary but
     * the elements under the pointer are scrolled.
     */
    function installFilteredMouseMove(element) {
        element.on("mousemove", function (e) {
            var lastpos = lastMousePosition;
            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
                $(e.target).trigger("mousemove-filtered", e);
            }
        });
    }

    /**
     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
     * within the last quietMillis milliseconds.
     *
     * @param quietMillis number of milliseconds to wait before invoking fn
     * @param fn function to be debounced
     * @param ctx object to be used as this reference within fn
     * @return debounced version of fn
     */
    function debounce(quietMillis, fn, ctx) {
        ctx = ctx || undefined;
        var timeout;
        return function () {
            var args = arguments;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                fn.apply(ctx, args);
            }, quietMillis);
        };
    }

    /**
     * A simple implementation of a thunk
     * @param formula function used to lazily initialize the thunk
     * @return {Function}
     */
    function thunk(formula) {
        var evaluated = false,
            value;
        return function () {
            if (evaluated === false) {
                value = formula();evaluated = true;
            }
            return value;
        };
    };

    function installDebouncedScroll(threshold, element) {
        var notify = debounce(threshold, function (e) {
            element.trigger("scroll-debounced", e);
        });
        element.on("scroll", function (e) {
            if (indexOf(e.target, element.get()) >= 0) notify(e);
        });
    }

    function focus($el) {
        if ($el[0] === document.activeElement) return;

        /* set the focus in a 0 timeout - that way the focus is set after the processing
            of the current event has finished - which seems like the only reliable way
            to set focus */
        window.setTimeout(function () {
            var el = $el[0],
                pos = $el.val().length,
                range;

            $el.focus();

            /* make sure el received focus so we do not error out when trying to manipulate the caret.
                sometimes modals or others listeners may steal it after its set */
            if ($el.is(":visible") && el === document.activeElement) {

                /* after the focus is set move the caret to the end, necessary when we val()
                    just before setting focus */
                if (el.setSelectionRange) {
                    el.setSelectionRange(pos, pos);
                } else if (el.createTextRange) {
                    range = el.createTextRange();
                    range.collapse(false);
                    range.select();
                }
            }
        }, 0);
    }

    function getCursorInfo(el) {
        el = $(el)[0];
        var offset = 0;
        var length = 0;
        if ('selectionStart' in el) {
            offset = el.selectionStart;
            length = el.selectionEnd - offset;
        } else if ('selection' in document) {
            el.focus();
            var sel = document.selection.createRange();
            length = document.selection.createRange().text.length;
            sel.moveStart('character', -el.value.length);
            offset = sel.text.length - length;
        }
        return { offset: offset, length: length };
    }

    function killEvent(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    function killEventImmediately(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }

    function measureTextWidth(e) {
        if (!sizer) {
            var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
            sizer = $(document.createElement("div")).css({
                position: "absolute",
                left: "-10000px",
                top: "-10000px",
                display: "none",
                fontSize: style.fontSize,
                fontFamily: style.fontFamily,
                fontStyle: style.fontStyle,
                fontWeight: style.fontWeight,
                letterSpacing: style.letterSpacing,
                textTransform: style.textTransform,
                whiteSpace: "nowrap"
            });
            sizer.attr("class", "select2-sizer");
            $("body").append(sizer);
        }
        sizer.text(e.val());
        return sizer.width();
    }

    function syncCssClasses(dest, src, adapter) {
        var classes,
            replacements = [],
            adapted;

        classes = dest.attr("class");
        if (classes) {
            classes = '' + classes; // for IE which returns object
            $(classes.split(" ")).each2(function () {
                if (this.indexOf("select2-") === 0) {
                    replacements.push(this);
                }
            });
        }
        classes = src.attr("class");
        if (classes) {
            classes = '' + classes; // for IE which returns object
            $(classes.split(" ")).each2(function () {
                if (this.indexOf("select2-") !== 0) {
                    adapted = adapter(this);
                    if (adapted) {
                        replacements.push(this);
                    }
                }
            });
        }
        dest.attr("class", replacements.join(" "));
    }

    function markMatch(text, term, markup, escapeMarkup) {
        var match = text.toUpperCase().indexOf(term.toUpperCase()),
            tl = term.length;

        if (match < 0) {
            markup.push(escapeMarkup(text));
            return;
        }

        markup.push(escapeMarkup(text.substring(0, match)));
        markup.push("<span class='select2-match'>");
        markup.push(escapeMarkup(text.substring(match, match + tl)));
        markup.push("</span>");
        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
    }

    function defaultEscapeMarkup(markup) {
        var replace_map = {
            '\\': '&#92;',
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            "/": '&#47;'
        };

        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
            return replace_map[match];
        });
    }

    /**
     * Produces an ajax-based query function
     *
     * @param options object containing configuration paramters
     * @param options.params parameter map for the transport ajax call, can contain such options as cache, jsonpCallback, etc. see $.ajax
     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
     * @param options.url url for the data
     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
     * @param options.dataType request data type: ajax, jsonp, other datatatypes supported by jQuery's $.ajax function or the transport function if specified
     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
     * @param options.results a function(remoteData, pageNumber) that converts data returned form the remote request to the format expected by Select2.
     *      The expected format is an object containing the following keys:
     *      results array of objects that will be used as choices
     *      more (optional) boolean indicating whether there are more results available
     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
     */
    function ajax(options) {
        var timeout,
            // current scheduled but not yet executed request
        requestSequence = 0,
            // sequence used to drop out-of-order responses
        handler = null,
            quietMillis = options.quietMillis || 100,
            ajaxUrl = options.url,
            self = this;

        return function (query) {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                requestSequence += 1; // increment the sequence
                var requestNumber = requestSequence,
                    // this request's sequence number
                data = options.data,
                    // ajax data function
                url = ajaxUrl,
                    // ajax url string or function
                transport = options.transport || $.fn.select2.ajaxDefaults.transport,

                // deprecated - to be removed in 4.0  - use params instead
                deprecated = {
                    type: options.type || 'GET', // set type of request (GET or POST)
                    cache: options.cache || false,
                    jsonpCallback: options.jsonpCallback || undefined,
                    dataType: options.dataType || "json"
                },
                    params = $.extend({}, $.fn.select2.ajaxDefaults.params, deprecated);

                data = data ? data.call(self, query.term, query.page, query.context) : null;
                url = typeof url === 'function' ? url.call(self, query.term, query.page, query.context) : url;

                if (handler) {
                    handler.abort();
                }

                if (options.params) {
                    if ($.isFunction(options.params)) {
                        $.extend(params, options.params.call(self));
                    } else {
                        $.extend(params, options.params);
                    }
                }

                $.extend(params, {
                    url: url,
                    dataType: options.dataType,
                    data: data,
                    success: function success(data) {
                        if (requestNumber < requestSequence) {
                            return;
                        }
                        // TODO - replace query.page with query so users have access to term, page, etc.
                        var results = options.results(data, query.page);
                        query.callback(results);
                    }
                });
                handler = transport.call(self, params);
            }, quietMillis);
        };
    }

    /**
     * Produces a query function that works with a local array
     *
     * @param options object containing configuration parameters. The options parameter can either be an array or an
     * object.
     *
     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
     *
     * If the object form is used ti is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
     * the text.
     */
    function local(options) {
        var data = options,
            // data elements
        dataText,
            tmp,
            text = function text(item) {
            return "" + item.text;
        }; // function used to retrieve the text portion of a data item that is matched against the search

        if ($.isArray(data)) {
            tmp = data;
            data = { results: tmp };
        }

        if ($.isFunction(data) === false) {
            tmp = data;
            data = function data() {
                return tmp;
            };
        }

        var dataItem = data();
        if (dataItem.text) {
            text = dataItem.text;
            // if text is not a function we assume it to be a key name
            if (!$.isFunction(text)) {
                dataText = dataItem.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
                text = function text(item) {
                    return item[dataText];
                };
            }
        }

        return function (query) {
            var t = query.term,
                filtered = { results: [] },
                _process;
            if (t === "") {
                query.callback(data());
                return;
            }

            _process = function process(datum, collection) {
                var group, attr;
                datum = datum[0];
                if (datum.children) {
                    group = {};
                    for (attr in datum) {
                        if (datum.hasOwnProperty(attr)) group[attr] = datum[attr];
                    }
                    group.children = [];
                    $(datum.children).each2(function (i, childDatum) {
                        _process(childDatum, group.children);
                    });
                    if (group.children.length || query.matcher(t, text(group), datum)) {
                        collection.push(group);
                    }
                } else {
                    if (query.matcher(t, text(datum), datum)) {
                        collection.push(datum);
                    }
                }
            };

            $(data().results).each2(function (i, datum) {
                _process(datum, filtered.results);
            });
            query.callback(filtered);
        };
    }

    // TODO javadoc
    function tags(data) {
        var isFunc = $.isFunction(data);
        return function (query) {
            var t = query.term,
                filtered = { results: [] };
            $(isFunc ? data() : data).each(function () {
                var isObject = this.text !== undefined,
                    text = isObject ? this.text : this;
                if (t === "" || query.matcher(t, text)) {
                    filtered.results.push(isObject ? this : { id: this, text: this });
                }
            });
            query.callback(filtered);
        };
    }

    /**
     * Checks if the formatter function should be used.
     *
     * Throws an error if it is not a function. Returns true if it should be used,
     * false if no formatting should be performed.
     *
     * @param formatter
     */
    function checkFormatter(formatter, formatterName) {
        if ($.isFunction(formatter)) return true;
        if (!formatter) return false;
        throw new Error("formatterName must be a function or a falsy value");
    }

    function evaluate(val) {
        return $.isFunction(val) ? val() : val;
    }

    function countResults(results) {
        var count = 0;
        $.each(results, function (i, item) {
            if (item.children) {
                count += countResults(item.children);
            } else {
                count++;
            }
        });
        return count;
    }

    /**
     * Default tokenizer. This function uses breaks the input on substring match of any string from the
     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
     * two options have to be defined in order for the tokenizer to work.
     *
     * @param input text user has typed so far or pasted into the search field
     * @param selection currently selected choices
     * @param selectCallback function(choice) callback tho add the choice to selection
     * @param opts select2's opts
     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
     */
    function defaultTokenizer(input, selection, selectCallback, opts) {
        var original = input,
            // store the original so we can compare and know if we need to tell the search to update its text
        dupe = false,
            // check for whether a token we extracted represents a duplicate selected choice
        token,
            // token
        index,
            // position at which the separator was found
        i,
            l,
            // looping variables
        separator; // the matched separator

        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;

        while (true) {
            index = -1;

            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
                separator = opts.tokenSeparators[i];
                index = input.indexOf(separator);
                if (index >= 0) break;
            }

            if (index < 0) break; // did not find any token separator in the input string, bail

            token = input.substring(0, index);
            input = input.substring(index + separator.length);

            if (token.length > 0) {
                token = opts.createSearchChoice(token, selection);
                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
                    dupe = false;
                    for (i = 0, l = selection.length; i < l; i++) {
                        if (equal(opts.id(token), opts.id(selection[i]))) {
                            dupe = true;break;
                        }
                    }

                    if (!dupe) selectCallback(token);
                }
            }
        }

        if (original !== input) return input;
    }

    /**
     * Creates a new class
     *
     * @param superClass
     * @param methods
     */
    function clazz(SuperClass, methods) {
        var constructor = function constructor() {};
        constructor.prototype = new SuperClass();
        constructor.prototype.constructor = constructor;
        constructor.prototype.parent = SuperClass.prototype;
        constructor.prototype = $.extend(constructor.prototype, methods);
        return constructor;
    }

    AbstractSelect2 = clazz(Object, {

        // abstract
        bind: function bind(func) {
            var self = this;
            return function () {
                func.apply(self, arguments);
            };
        },

        // abstract
        init: function init(opts) {
            var results,
                search,
                resultsSelector = ".select2-results",
                disabled,
                readonly;

            // prepare options
            this.opts = opts = this.prepareOpts(opts);

            this.id = opts.id;

            // destroy if called on an existing component
            if (opts.element.data("select2") !== undefined && opts.element.data("select2") !== null) {
                this.destroy();
            }

            this.container = this.createContainer();

            this.containerId = "s2id_" + (opts.element.attr("id") || "autogen" + nextUid());
            this.containerSelector = "#" + this.containerId.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
            this.container.attr("id", this.containerId);

            // cache the body so future lookups are cheap
            this.body = thunk(function () {
                return opts.element.closest("body");
            });

            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);

            this.container.css(evaluate(opts.containerCss));
            this.container.addClass(evaluate(opts.containerCssClass));

            this.elementTabIndex = this.opts.element.attr("tabindex");

            // swap container for the element
            this.opts.element.data("select2", this).attr("tabindex", "-1").before(this.container);
            this.container.data("select2", this);

            this.dropdown = this.container.find(".select2-drop");
            this.dropdown.addClass(evaluate(opts.dropdownCssClass));
            this.dropdown.data("select2", this);

            this.results = results = this.container.find(resultsSelector);
            this.search = search = this.container.find("input.select2-input");

            this.resultsPage = 0;
            this.context = null;

            // initialize the container
            this.initContainer();

            installFilteredMouseMove(this.results);
            this.dropdown.on("mousemove-filtered touchstart touchmove touchend", resultsSelector, this.bind(this.highlightUnderEvent));

            installDebouncedScroll(80, this.results);
            this.dropdown.on("scroll-debounced", resultsSelector, this.bind(this.loadMoreIfNeeded));

            // do not propagate change event from the search field out of the component
            $(this.container).on("change", ".select2-input", function (e) {
                e.stopPropagation();
            });
            $(this.dropdown).on("change", ".select2-input", function (e) {
                e.stopPropagation();
            });

            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
            if ($.fn.mousewheel) {
                results.mousewheel(function (e, delta, deltaX, deltaY) {
                    var top = results.scrollTop(),
                        height;
                    if (deltaY > 0 && top - deltaY <= 0) {
                        results.scrollTop(0);
                        killEvent(e);
                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
                        results.scrollTop(results.get(0).scrollHeight - results.height());
                        killEvent(e);
                    }
                });
            }

            installKeyUpChangeEvent(search);
            search.on("keyup-change input paste", this.bind(this.updateResults));
            search.on("focus", function () {
                search.addClass("select2-focused");
            });
            search.on("blur", function () {
                search.removeClass("select2-focused");
            });

            this.dropdown.on("mouseup", resultsSelector, this.bind(function (e) {
                if ($(e.target).closest(".select2-result-selectable").length > 0) {
                    this.highlightUnderEvent(e);
                    this.selectHighlighted(e);
                }
            }));

            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
            // dom it will trigger the popup close, which is not what we want
            this.dropdown.on("click mouseup mousedown", function (e) {
                e.stopPropagation();
            });

            if ($.isFunction(this.opts.initSelection)) {
                // initialize selection based on the current value of the source element
                this.initSelection();

                // if the user has provided a function that can set selection based on the value of the source element
                // we monitor the change event on the element and trigger it, allowing for two way synchronization
                this.monitorSource();
            }

            if (opts.maximumInputLength !== null) {
                this.search.attr("maxlength", opts.maximumInputLength);
            }

            var disabled = opts.element.prop("disabled");
            if (disabled === undefined) disabled = false;
            this.enable(!disabled);

            var readonly = opts.element.prop("readonly");
            if (readonly === undefined) readonly = false;
            this.readonly(readonly);

            // Calculate size of scrollbar
            scrollBarDimensions = scrollBarDimensions || measureScrollbar();

            this.autofocus = opts.element.prop("autofocus");
            opts.element.prop("autofocus", false);
            if (this.autofocus) this.focus();
        },

        // abstract
        destroy: function destroy() {
            var select2 = this.opts.element.data("select2");

            if (this.propertyObserver) {
                delete this.propertyObserver;this.propertyObserver = null;
            }

            if (select2 !== undefined) {

                select2.container.remove();
                select2.dropdown.remove();
                select2.opts.element.removeClass("select2-offscreen").removeData("select2").off(".select2").attr({ "tabindex": this.elementTabIndex }).prop("autofocus", this.autofocus || false).show();
            }
        },

        // abstract
        optionToData: function optionToData(element) {
            if (element.is("option")) {
                return {
                    id: element.prop("value"),
                    text: element.text(),
                    element: element.get(),
                    css: element.attr("class"),
                    disabled: element.prop("disabled"),
                    locked: equal(element.attr("locked"), "locked")
                };
            } else if (element.is("optgroup")) {
                return {
                    text: element.attr("label"),
                    children: [],
                    element: element.get(),
                    css: element.attr("class")
                };
            }
        },

        // abstract
        prepareOpts: function prepareOpts(opts) {
            var element,
                select,
                idKey,
                ajaxUrl,
                self = this;

            element = opts.element;

            if (element.get(0).tagName.toLowerCase() === "select") {
                this.select = select = opts.element;
            }

            if (select) {
                // these options are not allowed when attached to a select because they are picked up off the element itself
                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
                    if (this in opts) {
                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
                    }
                });
            }

            opts = $.extend({}, {
                populateResults: function populateResults(container, results, query) {
                    var _populate,
                        data,
                        result,
                        children,
                        id = this.opts.id;

                    _populate = function populate(results, container, depth) {

                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;

                        results = opts.sortResults(results, container, query);

                        for (i = 0, l = results.length; i < l; i = i + 1) {

                            result = results[i];

                            disabled = result.disabled === true;
                            selectable = !disabled && id(result) !== undefined;

                            compound = result.children && result.children.length > 0;

                            node = $("<li></li>");
                            node.addClass("select2-results-dept-" + depth);
                            node.addClass("select2-result");
                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
                            if (disabled) {
                                node.addClass("select2-disabled");
                            }
                            if (compound) {
                                node.addClass("select2-result-with-children");
                            }
                            node.addClass(self.opts.formatResultCssClass(result));

                            label = $(document.createElement("div"));
                            label.addClass("select2-result-label");

                            formatted = opts.formatResult(result, label, query, self.opts.escapeMarkup);
                            if (formatted !== undefined) {
                                label.html(formatted);
                            }

                            node.append(label);

                            if (compound) {

                                innerContainer = $("<ul></ul>");
                                innerContainer.addClass("select2-result-sub");
                                _populate(result.children, innerContainer, depth + 1);
                                node.append(innerContainer);
                            }

                            node.data("select2-data", result);
                            container.append(node);
                        }
                    };

                    _populate(results, container, 0);
                }
            }, $.fn.select2.defaults, opts);

            if (typeof opts.id !== "function") {
                idKey = opts.id;
                opts.id = function (e) {
                    return e[idKey];
                };
            }

            if ($.isArray(opts.element.data("select2Tags"))) {
                if ("tags" in opts) {
                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
                }
                opts.tags = opts.element.data("select2Tags");
            }

            if (select) {
                opts.query = this.bind(function (query) {
                    var data = { results: [], more: false },
                        term = query.term,
                        children,
                        placeholderOption,
                        _process2;

                    _process2 = function process(element, collection) {
                        var group;
                        if (element.is("option")) {
                            if (query.matcher(term, element.text(), element)) {
                                collection.push(self.optionToData(element));
                            }
                        } else if (element.is("optgroup")) {
                            group = self.optionToData(element);
                            element.children().each2(function (i, elm) {
                                _process2(elm, group.children);
                            });
                            if (group.children.length > 0) {
                                collection.push(group);
                            }
                        }
                    };

                    children = element.children();

                    // ignore the placeholder option if there is one
                    if (this.getPlaceholder() !== undefined && children.length > 0) {
                        placeholderOption = this.getPlaceholderOption();
                        if (placeholderOption) {
                            children = children.not(placeholderOption);
                        }
                    }

                    children.each2(function (i, elm) {
                        _process2(elm, data.results);
                    });

                    query.callback(data);
                });
                // this is needed because inside val() we construct choices from options and there id is hardcoded
                opts.id = function (e) {
                    return e.id;
                };
                opts.formatResultCssClass = function (data) {
                    return data.css;
                };
            } else {
                if (!("query" in opts)) {

                    if ("ajax" in opts) {
                        ajaxUrl = opts.element.data("ajax-url");
                        if (ajaxUrl && ajaxUrl.length > 0) {
                            opts.ajax.url = ajaxUrl;
                        }
                        opts.query = ajax.call(opts.element, opts.ajax);
                    } else if ("data" in opts) {
                        opts.query = local(opts.data);
                    } else if ("tags" in opts) {
                        opts.query = tags(opts.tags);
                        if (opts.createSearchChoice === undefined) {
                            opts.createSearchChoice = function (term) {
                                return { id: term, text: term };
                            };
                        }
                        if (opts.initSelection === undefined) {
                            opts.initSelection = function (element, callback) {
                                var data = [];
                                $(splitVal(element.val(), opts.separator)).each(function () {
                                    var id = this,
                                        text = this,
                                        tags = opts.tags;
                                    if ($.isFunction(tags)) tags = tags();
                                    $(tags).each(function () {
                                        if (equal(this.id, id)) {
                                            text = this.text;return false;
                                        }
                                    });
                                    data.push({ id: id, text: text });
                                });

                                callback(data);
                            };
                        }
                    }
                }
            }
            if (typeof opts.query !== "function") {
                throw "query function not defined for Select2 " + opts.element.attr("id");
            }

            return opts;
        },

        /**
         * Monitor the original element for changes and update select2 accordingly
         */
        // abstract
        monitorSource: function monitorSource() {
            var el = this.opts.element,
                sync;

            el.on("change.select2", this.bind(function (e) {
                if (this.opts.element.data("select2-change-triggered") !== true) {
                    this.initSelection();
                }
            }));

            sync = this.bind(function () {

                var enabled,
                    readonly,
                    self = this;

                // sync enabled state

                var disabled = el.prop("disabled");
                if (disabled === undefined) disabled = false;
                this.enable(!disabled);

                var readonly = el.prop("readonly");
                if (readonly === undefined) readonly = false;
                this.readonly(readonly);

                syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
                this.container.addClass(evaluate(this.opts.containerCssClass));

                syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
                this.dropdown.addClass(evaluate(this.opts.dropdownCssClass));
            });

            // mozilla and IE
            el.on("propertychange.select2 DOMAttrModified.select2", sync);

            // hold onto a reference of the callback to work around a chromium bug
            if (this.mutationCallback === undefined) {
                this.mutationCallback = function (mutations) {
                    mutations.forEach(sync);
                };
            }

            // safari and chrome
            if (typeof WebKitMutationObserver !== "undefined") {
                if (this.propertyObserver) {
                    delete this.propertyObserver;this.propertyObserver = null;
                }
                this.propertyObserver = new WebKitMutationObserver(this.mutationCallback);
                this.propertyObserver.observe(el.get(0), { attributes: true, subtree: false });
            }
        },

        // abstract
        triggerSelect: function triggerSelect(data) {
            var evt = $.Event("select2-selecting", { val: this.id(data), object: data });
            this.opts.element.trigger(evt);
            return !evt.isDefaultPrevented();
        },

        /**
         * Triggers the change event on the source element
         */
        // abstract
        triggerChange: function triggerChange(details) {

            details = details || {};
            details = $.extend({}, details, { type: "change", val: this.val() });
            // prevents recursive triggering
            this.opts.element.data("select2-change-triggered", true);
            this.opts.element.trigger(details);
            this.opts.element.data("select2-change-triggered", false);

            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
            // so here we trigger the click event manually
            this.opts.element.click();

            // ValidationEngine ignorea the change event and listens instead to blur
            // so here we trigger the blur event manually if so desired
            if (this.opts.blurOnChange) this.opts.element.blur();
        },

        //abstract
        isInterfaceEnabled: function isInterfaceEnabled() {
            return this.enabledInterface === true;
        },

        // abstract
        enableInterface: function enableInterface() {
            var enabled = this._enabled && !this._readonly,
                disabled = !enabled;

            if (enabled === this.enabledInterface) return false;

            this.container.toggleClass("select2-container-disabled", disabled);
            this.close();
            this.enabledInterface = enabled;

            return true;
        },

        // abstract
        enable: function enable(enabled) {
            if (enabled === undefined) enabled = true;
            if (this._enabled === enabled) return false;
            this._enabled = enabled;

            this.opts.element.prop("disabled", !enabled);
            this.enableInterface();
            return true;
        },

        // abstract
        readonly: function readonly(enabled) {
            if (enabled === undefined) enabled = false;
            if (this._readonly === enabled) return false;
            this._readonly = enabled;

            this.opts.element.prop("readonly", enabled);
            this.enableInterface();
            return true;
        },

        // abstract
        opened: function opened() {
            return this.container.hasClass("select2-dropdown-open");
        },

        // abstract
        positionDropdown: function positionDropdown() {
            var $dropdown = this.dropdown,
                offset = this.container.offset(),
                height = this.container.outerHeight(false),
                width = this.container.outerWidth(false),
                dropHeight = $dropdown.outerHeight(false),
                viewPortRight = $(window).scrollLeft() + $(window).width(),
                viewportBottom = $(window).scrollTop() + $(window).height(),
                dropTop = offset.top + height,
                dropLeft = offset.left,
                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
                enoughRoomAbove = offset.top - dropHeight >= this.body().scrollTop(),
                dropWidth = $dropdown.outerWidth(false),
                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight,
                aboveNow = $dropdown.hasClass("select2-drop-above"),
                bodyOffset,
                above,
                css,
                resultsListNode;

            if (this.opts.dropdownAutoWidth) {
                resultsListNode = $('.select2-results', $dropdown)[0];
                $dropdown.addClass('select2-drop-auto-width');
                $dropdown.css('width', '');
                // Add scrollbar width to dropdown if vertical scrollbar is present
                dropWidth = $dropdown.outerWidth(false) + (resultsListNode.scrollHeight === resultsListNode.clientHeight ? 0 : scrollBarDimensions.width);
                dropWidth > width ? width = dropWidth : dropWidth = width;
                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight;
            } else {
                this.container.removeClass('select2-drop-auto-width');
            }

            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body().scrollTop(), "enough?", enoughRoomAbove);

            // fix positioning when body has an offset and is not position: static

            if (this.body().css('position') !== 'static') {
                bodyOffset = this.body().offset();
                dropTop -= bodyOffset.top;
                dropLeft -= bodyOffset.left;
            }

            // always prefer the current above/below alignment, unless there is not enough room

            if (aboveNow) {
                above = true;
                if (!enoughRoomAbove && enoughRoomBelow) above = false;
            } else {
                above = false;
                if (!enoughRoomBelow && enoughRoomAbove) above = true;
            }

            if (!enoughRoomOnRight) {
                dropLeft = offset.left + width - dropWidth;
            }

            if (above) {
                dropTop = offset.top - dropHeight;
                this.container.addClass("select2-drop-above");
                $dropdown.addClass("select2-drop-above");
            } else {
                this.container.removeClass("select2-drop-above");
                $dropdown.removeClass("select2-drop-above");
            }

            css = $.extend({
                top: dropTop,
                left: dropLeft,
                width: width
            }, evaluate(this.opts.dropdownCss));

            $dropdown.css(css);
        },

        // abstract
        shouldOpen: function shouldOpen() {
            var event;

            if (this.opened()) return false;

            if (this._enabled === false || this._readonly === true) return false;

            event = $.Event("select2-opening");
            this.opts.element.trigger(event);
            return !event.isDefaultPrevented();
        },

        // abstract
        clearDropdownAlignmentPreference: function clearDropdownAlignmentPreference() {
            // clear the classes used to figure out the preference of where the dropdown should be opened
            this.container.removeClass("select2-drop-above");
            this.dropdown.removeClass("select2-drop-above");
        },

        /**
         * Opens the dropdown
         *
         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
         */
        // abstract
        open: function open() {

            if (!this.shouldOpen()) return false;

            this.opening();

            return true;
        },

        /**
         * Performs the opening of the dropdown
         */
        // abstract
        opening: function opening() {
            var cid = this.containerId,
                scroll = "scroll." + cid,
                resize = "resize." + cid,
                orient = "orientationchange." + cid,
                mask,
                undermask = undefined,
                maskCss;

            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");

            this.clearDropdownAlignmentPreference();

            if (this.dropdown[0] !== this.body().children().last()[0]) {
                this.dropdown.detach().appendTo(this.body());
            }

            // create the dropdown mask if doesnt already exist
            mask = $("#select2-drop-mask");
            if (mask.length == 0) {
                mask = $(document.createElement("div"));
                mask.attr("id", "select2-drop-mask").attr("class", "select2-drop-mask");
                mask.hide();
                mask.appendTo(this.body());
                mask.on("mousedown touchstart click", function (e) {
                    var dropdown = $("#select2-drop"),
                        self;
                    if (dropdown.length > 0) {
                        self = dropdown.data("select2");
                        if (self.opts.selectOnBlur) {
                            self.selectHighlighted({ noFocus: true });
                        }
                        self.close();
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            }

            // IE requires an iframe shim to cover controls like selects
            if ($.support.opacity) {
                // a hack to detect older IE browsers - they do not support opacity
                undermask = $("#select2-drop-undermask");
                if (undermask.length == 0) {
                    undermask = $(document.createElement("iframe"));
                    undermask.attr("src", "about:blank");
                    undermask.attr("id", "select2-drop-undermask").attr("class", "select2-drop-undermask");
                    undermask.attr("allowTransparency", "true");
                    undermask.attr("frameborder", "0");
                    undermask.hide();
                    undermask.appendTo(this.body());
                }
            }

            // ensure the mask is always right before the dropdown
            if (this.dropdown.prev()[0] !== mask[0]) {
                this.dropdown.before(mask);
            }

            // ensure the undermask is always right before the mask
            if (undermask && mask.prev()[0] !== undermask[0]) {
                mask.before(undermask);
            }

            // move the global id to the correct dropdown
            $("#select2-drop").removeAttr("id");
            this.dropdown.attr("id", "select2-drop");

            // show the elements
            maskCss = _makeMaskCss();

            if (undermask) {
                undermask.css(maskCss).show();
            }

            mask.css(maskCss).show();

            this.dropdown.show();
            this.positionDropdown();

            this.dropdown.addClass("select2-drop-active");
            this.ensureHighlightVisible();

            // attach listeners to events that can change the position of the container and thus require
            // the position of the dropdown to be updated as well so it does not come unglued from the container
            var that = this;
            this.container.parents().add(window).each(function () {
                $(this).on(resize + " " + scroll + " " + orient, function (e) {
                    var maskCss = _makeMaskCss();
                    $("#select2-drop-undermask").css(maskCss);
                    $("#select2-drop-mask").css(maskCss);
                    that.positionDropdown();
                });
            });

            function _makeMaskCss() {
                return {
                    width: Math.max(document.documentElement.scrollWidth, $(window).width()),
                    height: Math.max(document.documentElement.scrollHeight, $(window).height())
                };
            }
        },

        // abstract
        close: function close() {
            if (!this.opened()) return;

            var cid = this.containerId,
                scroll = "scroll." + cid,
                resize = "resize." + cid,
                orient = "orientationchange." + cid;

            // unbind event listeners
            this.container.parents().add(window).each(function () {
                $(this).off(scroll).off(resize).off(orient);
            });

            this.clearDropdownAlignmentPreference();

            $("#select2-drop-undermask").hide();
            $("#select2-drop-mask").hide();
            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
            this.dropdown.hide();
            this.container.removeClass("select2-dropdown-open");
            this.results.empty();

            this.clearSearch();
            this.search.removeClass("select2-active");
            this.opts.element.trigger($.Event("select2-close"));
        },

        /**
         * Opens control, sets input value, and updates results.
         */
        // abstract
        externalSearch: function externalSearch(term) {
            this.open();
            this.search.val(term);
            this.updateResults(false);
        },

        // abstract
        clearSearch: function clearSearch() {},

        //abstract
        getMaximumSelectionSize: function getMaximumSelectionSize() {
            return evaluate(this.opts.maximumSelectionSize);
        },

        // abstract
        ensureHighlightVisible: function ensureHighlightVisible() {
            var results = this.results,
                children,
                index,
                child,
                hb,
                rb,
                y,
                more;

            index = this.highlight();

            if (index < 0) return;

            if (index == 0) {

                // if the first element is highlighted scroll all the way to the top,
                // that way any unselectable headers above it will also be scrolled
                // into view

                results.scrollTop(0);
                return;
            }

            children = this.findHighlightableChoices().find('.select2-result-label');

            child = $(children[index]);

            hb = child.offset().top + child.outerHeight(true);

            // if this is the last child lets also make sure select2-more-results is visible
            if (index === children.length - 1) {
                more = results.find("li.select2-more-results");
                if (more.length > 0) {
                    hb = more.offset().top + more.outerHeight(true);
                }
            }

            rb = results.offset().top + results.outerHeight(true);
            if (hb > rb) {
                results.scrollTop(results.scrollTop() + (hb - rb));
            }
            y = child.offset().top - results.offset().top;

            // make sure the top of the element is visible
            if (y < 0 && child.css('display') != 'none') {
                results.scrollTop(results.scrollTop() + y); // y is negative
            }
        },

        // abstract
        findHighlightableChoices: function findHighlightableChoices() {
            return this.results.find(".select2-result-selectable:not(.select2-selected):not(.select2-disabled)");
        },

        // abstract
        moveHighlight: function moveHighlight(delta) {
            var choices = this.findHighlightableChoices(),
                index = this.highlight();

            while (index > -1 && index < choices.length) {
                index += delta;
                var choice = $(choices[index]);
                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
                    this.highlight(index);
                    break;
                }
            }
        },

        // abstract
        highlight: function highlight(index) {
            var choices = this.findHighlightableChoices(),
                choice,
                data;

            if (arguments.length === 0) {
                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
            }

            if (index >= choices.length) index = choices.length - 1;
            if (index < 0) index = 0;

            this.results.find(".select2-highlighted").removeClass("select2-highlighted");

            choice = $(choices[index]);
            choice.addClass("select2-highlighted");

            this.ensureHighlightVisible();

            data = choice.data("select2-data");
            if (data) {
                this.opts.element.trigger({ type: "select2-highlight", val: this.id(data), choice: data });
            }
        },

        // abstract
        countSelectableResults: function countSelectableResults() {
            return this.findHighlightableChoices().length;
        },

        // abstract
        highlightUnderEvent: function highlightUnderEvent(event) {
            var el = $(event.target).closest(".select2-result-selectable");
            if (el.length > 0 && !el.is(".select2-highlighted")) {
                var choices = this.findHighlightableChoices();
                this.highlight(choices.index(el));
            } else if (el.length == 0) {
                // if we are over an unselectable item remove al highlights
                this.results.find(".select2-highlighted").removeClass("select2-highlighted");
            }
        },

        // abstract
        loadMoreIfNeeded: function loadMoreIfNeeded() {
            var results = this.results,
                more = results.find("li.select2-more-results"),
                below,
                // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
            offset = -1,
                // index of first element without data
            page = this.resultsPage + 1,
                self = this,
                term = this.search.val(),
                context = this.context;

            if (more.length === 0) return;
            below = more.offset().top - results.offset().top - results.height();

            if (below <= this.opts.loadMorePadding) {
                more.addClass("select2-active");
                this.opts.query({
                    element: this.opts.element,
                    term: term,
                    page: page,
                    context: context,
                    matcher: this.opts.matcher,
                    callback: this.bind(function (data) {

                        // ignore a response if the select2 has been closed before it was received
                        if (!self.opened()) return;

                        self.opts.populateResults.call(this, results, data.results, { term: term, page: page, context: context });
                        self.postprocessResults(data, false, false);

                        if (data.more === true) {
                            more.detach().appendTo(results).text(self.opts.formatLoadMore(page + 1));
                            window.setTimeout(function () {
                                self.loadMoreIfNeeded();
                            }, 10);
                        } else {
                            more.remove();
                        }
                        self.positionDropdown();
                        self.resultsPage = page;
                        self.context = data.context;
                    }) });
            }
        },

        /**
         * Default tokenizer function which does nothing
         */
        tokenize: function tokenize() {},

        /**
         * @param initial whether or not this is the call to this method right after the dropdown has been opened
         */
        // abstract
        updateResults: function updateResults(initial) {
            var search = this.search,
                results = this.results,
                opts = this.opts,
                data,
                self = this,
                input,
                term = search.val(),
                lastTerm = $.data(this.container, "select2-last-term");

            // prevent duplicate queries against the same term
            if (initial !== true && lastTerm && equal(term, lastTerm)) return;

            $.data(this.container, "select2-last-term", term);

            // if the search is currently hidden we do not alter the results
            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
                return;
            }

            function postRender() {
                results.scrollTop(0);
                search.removeClass("select2-active");
                self.positionDropdown();
            }

            function render(html) {
                results.html(html);
                postRender();
            }

            var maxSelSize = this.getMaximumSelectionSize();
            if (maxSelSize >= 1) {
                data = this.data();
                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
                    render("<li class='select2-selection-limit'>" + opts.formatSelectionTooBig(maxSelSize) + "</li>");
                    return;
                }
            }

            if (search.val().length < opts.minimumInputLength) {
                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
                    render("<li class='select2-no-results'>" + opts.formatInputTooShort(search.val(), opts.minimumInputLength) + "</li>");
                } else {
                    render("");
                }
                if (initial && this.showSearch) this.showSearch(true);
                return;
            }

            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
                    render("<li class='select2-no-results'>" + opts.formatInputTooLong(search.val(), opts.maximumInputLength) + "</li>");
                } else {
                    render("");
                }
                return;
            }

            if (opts.formatSearching && this.findHighlightableChoices().length === 0) {
                render("<li class='select2-searching'>" + opts.formatSearching() + "</li>");
            }

            search.addClass("select2-active");

            // give the tokenizer a chance to pre-process the input
            input = this.tokenize();
            if (input != undefined && input != null) {
                search.val(input);
            }

            this.resultsPage = 1;

            opts.query({
                element: opts.element,
                term: search.val(),
                page: this.resultsPage,
                context: null,
                matcher: opts.matcher,
                callback: this.bind(function (data) {
                    var def; // default choice

                    // ignore a response if the select2 has been closed before it was received
                    if (!this.opened()) {
                        this.search.removeClass("select2-active");
                        return;
                    }

                    // save context, if any
                    this.context = data.context === undefined ? null : data.context;
                    // create a default choice and prepend it to the list
                    if (this.opts.createSearchChoice && search.val() !== "") {
                        def = this.opts.createSearchChoice.call(null, search.val(), data.results);
                        if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
                            if ($(data.results).filter(function () {
                                return equal(self.id(this), self.id(def));
                            }).length === 0) {
                                data.results.unshift(def);
                            }
                        }
                    }

                    if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
                        render("<li class='select2-no-results'>" + opts.formatNoMatches(search.val()) + "</li>");
                        return;
                    }

                    results.empty();
                    self.opts.populateResults.call(this, results, data.results, { term: search.val(), page: this.resultsPage, context: null });

                    if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
                        results.append("<li class='select2-more-results'>" + self.opts.escapeMarkup(opts.formatLoadMore(this.resultsPage)) + "</li>");
                        window.setTimeout(function () {
                            self.loadMoreIfNeeded();
                        }, 10);
                    }

                    this.postprocessResults(data, initial);

                    postRender();

                    this.opts.element.trigger({ type: "select2-loaded", data: data });
                }) });
        },

        // abstract
        cancel: function cancel() {
            this.close();
        },

        // abstract
        blur: function blur() {
            // if selectOnBlur == true, select the currently highlighted option
            if (this.opts.selectOnBlur) this.selectHighlighted({ noFocus: true });

            this.close();
            this.container.removeClass("select2-container-active");
            // synonymous to .is(':focus'), which is available in jquery >= 1.6
            if (this.search[0] === document.activeElement) {
                this.search.blur();
            }
            this.clearSearch();
            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
        },

        // abstract
        focusSearch: function focusSearch() {
            focus(this.search);
        },

        // abstract
        selectHighlighted: function selectHighlighted(options) {
            var index = this.highlight(),
                highlighted = this.results.find(".select2-highlighted"),
                data = highlighted.closest('.select2-result').data("select2-data");

            if (data) {
                this.highlight(index);
                this.onSelect(data, options);
            }
        },

        // abstract
        getPlaceholder: function getPlaceholder() {
            var placeholderOption;
            return this.opts.element.attr("placeholder") || this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
            this.opts.element.data("placeholder") || this.opts.placeholder || ((placeholderOption = this.getPlaceholderOption()) !== undefined ? placeholderOption.text() : undefined);
        },

        // abstract
        getPlaceholderOption: function getPlaceholderOption() {
            if (this.select) {
                var firstOption = this.select.children().first();
                if (this.opts.placeholderOption !== undefined) {
                    //Determine the placeholder option based on the specified placeholderOption setting
                    return this.opts.placeholderOption === "first" && firstOption || typeof this.opts.placeholderOption === "function" && this.opts.placeholderOption(this.select);
                } else if (firstOption.text() === "" && firstOption.val() === "") {
                    //No explicit placeholder option specified, use the first if it's blank
                    return firstOption;
                }
            }
        },

        /**
         * Get the desired width for the container element.  This is
         * derived first from option `width` passed to select2, then
         * the inline 'style' on the original element, and finally
         * falls back to the jQuery calculated element width.
         */
        // abstract
        initContainerWidth: function initContainerWidth() {
            function resolveContainerWidth() {
                var style, attrs, matches, i, l;

                if (this.opts.width === "off") {
                    return null;
                } else if (this.opts.width === "element") {
                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
                    // check if there is inline style on the element that contains width
                    style = this.opts.element.attr('style');
                    if (style !== undefined) {
                        attrs = style.split(';');
                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
                            matches = attrs[i].replace(/\s/g, '').match(/width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
                            if (matches !== null && matches.length >= 1) return matches[1];
                        }
                    }

                    if (this.opts.width === "resolve") {
                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
                        // when attached to input type=hidden or elements hidden via css
                        style = this.opts.element.css('width');
                        if (style.indexOf("%") > 0) return style;

                        // finally, fallback on the calculated width of the element
                        return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
                    }

                    return null;
                } else if ($.isFunction(this.opts.width)) {
                    return this.opts.width();
                } else {
                    return this.opts.width;
                }
            };

            var width = resolveContainerWidth.call(this);
            if (width !== null) {
                this.container.css("width", width);
            }
        }
    });

    SingleSelect2 = clazz(AbstractSelect2, {

        // single

        createContainer: function createContainer() {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container"
            }).html(["<a href='javascript:void(0)' onclick='return false;' class='select2-choice' tabindex='-1'>", "   <span>&nbsp;</span><abbr class='select2-search-choice-close'></abbr>", "   <div><b></b></div>", "</a>", "<input class='select2-focusser select2-offscreen' type='text'/>", "<div class='select2-drop select2-display-none'>", "   <div class='select2-search'>", "       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'/>", "   </div>", "   <ul class='select2-results'>", "   </ul>", "</div>"].join(""));
            return container;
        },

        // single
        enableInterface: function enableInterface() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.focusser.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // single
        opening: function opening() {
            var el, range, len;

            if (this.opts.minimumResultsForSearch >= 0) {
                this.showSearch(true);
            }

            this.parent.opening.apply(this, arguments);

            if (this.showSearchInput !== false) {
                // IE appends focusser.val() at the end of field :/ so we manually insert it at the beginning using a range
                // all other browsers handle this just fine

                this.search.val(this.focusser.val());
            }
            this.search.focus();
            // move the cursor to the end after focussing, otherwise it will be at the beginning and
            // new text will appear *before* focusser.val()
            el = this.search.get(0);
            if (el.createTextRange) {
                range = el.createTextRange();
                range.collapse(false);
                range.select();
            } else if (el.setSelectionRange) {
                len = this.search.val().length;
                el.setSelectionRange(len, len);
            }

            this.focusser.prop("disabled", true).val("");
            this.updateResults(true);
            this.opts.element.trigger($.Event("select2-open"));
        },

        // single
        close: function close() {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);
            this.focusser.removeAttr("disabled");
            this.focusser.focus();
        },

        // single
        focus: function focus() {
            if (this.opened()) {
                this.close();
            } else {
                this.focusser.removeAttr("disabled");
                this.focusser.focus();
            }
        },

        // single
        isFocused: function isFocused() {
            return this.container.hasClass("select2-container-active");
        },

        // single
        cancel: function cancel() {
            this.parent.cancel.apply(this, arguments);
            this.focusser.removeAttr("disabled");
            this.focusser.focus();
        },

        // single
        initContainer: function initContainer() {

            var selection,
                container = this.container,
                dropdown = this.dropdown;

            if (this.opts.minimumResultsForSearch < 0) {
                this.showSearch(false);
            } else {
                this.showSearch(true);
            }

            this.selection = selection = container.find(".select2-choice");

            this.focusser = container.find(".select2-focusser");

            // rewrite labels from original element to focusser
            this.focusser.attr("id", "s2id_autogen" + nextUid());

            $("label[for='" + this.opts.element.attr("id") + "']").attr('for', this.focusser.attr('id'));

            this.focusser.attr("tabindex", this.elementTabIndex);

            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                    return;
                }

                switch (e.which) {
                    case KEY.UP:
                    case KEY.DOWN:
                        this.moveHighlight(e.which === KEY.UP ? -1 : 1);
                        killEvent(e);
                        return;
                    case KEY.ENTER:
                        this.selectHighlighted();
                        killEvent(e);
                        return;
                    case KEY.TAB:
                        this.selectHighlighted({ noFocus: true });
                        return;
                    case KEY.ESC:
                        this.cancel(e);
                        killEvent(e);
                        return;
                }
            }));

            this.search.on("blur", this.bind(function (e) {
                // a workaround for chrome to keep the search field focussed when the scroll bar is used to scroll the dropdown.
                // without this the search field loses focus which is annoying
                if (document.activeElement === this.body().get(0)) {
                    window.setTimeout(this.bind(function () {
                        this.search.focus();
                    }), 0);
                }
            }));

            this.focusser.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
                    return;
                }

                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER && this.opts.openOnEnter) {
                    this.open();
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
                    if (this.opts.allowClear) {
                        this.clear();
                    }
                    killEvent(e);
                    return;
                }
            }));

            installKeyUpChangeEvent(this.focusser);
            this.focusser.on("keyup-change input", this.bind(function (e) {
                if (this.opts.minimumResultsForSearch >= 0) {
                    e.stopPropagation();
                    if (this.opened()) return;
                    this.open();
                }
            }));

            selection.on("mousedown", "abbr", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;
                this.clear();
                killEventImmediately(e);
                this.close();
                this.selection.focus();
            }));

            selection.on("mousedown", this.bind(function (e) {

                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }

                if (this.opened()) {
                    this.close();
                } else if (this.isInterfaceEnabled()) {
                    this.open();
                }

                killEvent(e);
            }));

            dropdown.on("mousedown", this.bind(function () {
                this.search.focus();
            }));

            selection.on("focus", this.bind(function (e) {
                killEvent(e);
            }));

            this.focusser.on("focus", this.bind(function () {
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            })).on("blur", this.bind(function () {
                if (!this.opened()) {
                    this.container.removeClass("select2-container-active");
                    this.opts.element.trigger($.Event("select2-blur"));
                }
            }));
            this.search.on("focus", this.bind(function () {
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            }));

            this.initContainerWidth();
            this.opts.element.addClass("select2-offscreen");
            this.setPlaceholder();
        },

        // single
        clear: function clear(triggerChange) {
            var data = this.selection.data("select2-data");
            if (data) {
                // guard against queued quick consecutive clicks
                var placeholderOption = this.getPlaceholderOption();
                this.opts.element.val(placeholderOption ? placeholderOption.val() : "");
                this.selection.find("span").empty();
                this.selection.removeData("select2-data");
                this.setPlaceholder();

                if (triggerChange !== false) {
                    this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
                    this.triggerChange({ removed: data });
                }
            }
        },

        /**
         * Sets selection based on source element's value
         */
        // single
        initSelection: function initSelection() {
            var selected;
            if (this.isPlaceholderOptionSelected()) {
                this.updateSelection([]);
                this.close();
                this.setPlaceholder();
            } else {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function (selected) {
                    if (selected !== undefined && selected !== null) {
                        self.updateSelection(selected);
                        self.close();
                        self.setPlaceholder();
                    }
                });
            }
        },

        isPlaceholderOptionSelected: function isPlaceholderOptionSelected() {
            var placeholderOption;
            return (placeholderOption = this.getPlaceholderOption()) !== undefined && placeholderOption.is(':selected') || this.opts.element.val() === "" || this.opts.element.val() === undefined || this.opts.element.val() === null;
        },

        // single
        prepareOpts: function prepareOpts() {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self = this;

            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install the selection initializer
                opts.initSelection = function (element, callback) {
                    var selected = element.find(":selected");
                    // a single select box always has a value, no need to null check 'selected'
                    callback(self.optionToData(selected));
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var id = element.val();
                    //search in data by id, storing the actual matching item
                    var match = null;
                    opts.query({
                        matcher: function matcher(term, text, el) {
                            var is_match = equal(id, opts.id(el));
                            if (is_match) {
                                match = el;
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function () {
                            callback(match);
                        }
                    });
                };
            }

            return opts;
        },

        // single
        getPlaceholder: function getPlaceholder() {
            // if a placeholder is specified on a single select without a valid placeholder option ignore it
            if (this.select) {
                if (this.getPlaceholderOption() === undefined) {
                    return undefined;
                }
            }

            return this.parent.getPlaceholder.apply(this, arguments);
        },

        // single
        setPlaceholder: function setPlaceholder() {
            var placeholder = this.getPlaceholder();

            if (this.isPlaceholderOptionSelected() && placeholder !== undefined) {

                // check for a placeholder option if attached to a select
                if (this.select && this.getPlaceholderOption() === undefined) return;

                this.selection.find("span").html(this.opts.escapeMarkup(placeholder));

                this.selection.addClass("select2-default");

                this.container.removeClass("select2-allowclear");
            }
        },

        // single
        postprocessResults: function postprocessResults(data, initial, noHighlightUpdate) {
            var selected = 0,
                self = this,
                showSearchInput = true;

            // find the selected element in the result list

            this.findHighlightableChoices().each2(function (i, elm) {
                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
                    selected = i;
                    return false;
                }
            });

            // and highlight it
            if (noHighlightUpdate !== false) {
                this.highlight(selected);
            }

            // hide the search box if this is the first we got the results and there are enough of them for search

            if (initial === true) {
                var min = this.opts.minimumResultsForSearch;
                if (min >= 0) {
                    this.showSearch(countResults(data.results) >= min);
                }
            }
        },

        // single
        showSearch: function showSearch(showSearchInput) {
            if (this.showSearchInput === showSearchInput) return;

            this.showSearchInput = showSearchInput;

            this.dropdown.find(".select2-search").toggleClass("select2-search-hidden", !showSearchInput);
            this.dropdown.find(".select2-search").toggleClass("select2-offscreen", !showSearchInput);
            //add "select2-with-searchbox" to the container if search box is shown
            $(this.dropdown, this.container).toggleClass("select2-with-searchbox", showSearchInput);
        },

        // single
        onSelect: function onSelect(data, options) {

            if (!this.triggerSelect(data)) {
                return;
            }

            var old = this.opts.element.val(),
                oldData = this.data();

            this.opts.element.val(this.id(data));
            this.updateSelection(data);

            this.opts.element.trigger({ type: "select2-selected", val: this.id(data), choice: data });

            this.close();

            if (!options || !options.noFocus) this.selection.focus();

            if (!equal(old, this.id(data))) {
                this.triggerChange({ added: data, removed: oldData });
            }
        },

        // single
        updateSelection: function updateSelection(data) {

            var container = this.selection.find("span"),
                formatted,
                cssClass;

            this.selection.data("select2-data", data);

            container.empty();
            formatted = this.opts.formatSelection(data, container);
            if (formatted !== undefined) {
                container.append(this.opts.escapeMarkup(formatted));
            }
            cssClass = this.opts.formatSelectionCssClass(data, container);
            if (cssClass !== undefined) {
                container.addClass(cssClass);
            }

            this.selection.removeClass("select2-default");

            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
                this.container.addClass("select2-allowclear");
            }
        },

        // single
        val: function val() {
            var val,
                triggerChange = false,
                data = null,
                self = this,
                oldData = this.data();

            if (arguments.length === 0) {
                return this.opts.element.val();
            }

            val = arguments[0];

            if (arguments.length > 1) {
                triggerChange = arguments[1];
            }

            if (this.select) {
                this.select.val(val).find(":selected").each2(function (i, elm) {
                    data = self.optionToData(elm);
                    return false;
                });
                this.updateSelection(data);
                this.setPlaceholder();
                if (triggerChange) {
                    this.triggerChange({ added: data, removed: oldData });
                }
            } else {
                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
                if (!val && val !== 0) {
                    this.clear(triggerChange);
                    return;
                }
                if (this.opts.initSelection === undefined) {
                    throw new Error("cannot call val() if initSelection() is not defined");
                }
                this.opts.element.val(val);
                this.opts.initSelection(this.opts.element, function (data) {
                    self.opts.element.val(!data ? "" : self.id(data));
                    self.updateSelection(data);
                    self.setPlaceholder();
                    if (triggerChange) {
                        self.triggerChange({ added: data, removed: oldData });
                    }
                });
            }
        },

        // single
        clearSearch: function clearSearch() {
            this.search.val("");
            this.focusser.val("");
        },

        // single
        data: function data(value, triggerChange) {
            var data;

            if (arguments.length === 0) {
                data = this.selection.data("select2-data");
                if (data == undefined) data = null;
                return data;
            } else {
                if (!value || value === "") {
                    this.clear(triggerChange);
                } else {
                    data = this.data();
                    this.opts.element.val(!value ? "" : this.id(value));
                    this.updateSelection(value);
                    if (triggerChange) {
                        this.triggerChange({ added: value, removed: data });
                    }
                }
            }
        }
    });

    MultiSelect2 = clazz(AbstractSelect2, {

        // multi
        createContainer: function createContainer() {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container select2-container-multi"
            }).html(["    <ul class='select2-choices'>",
            //"<li class='select2-search-choice'><span>California</span><a href="javascript:void(0)" class="select2-search-choice-close"></a></li>" ,
            "  <li class='select2-search-field'>", "    <input type='text' autocomplete='off' autocorrect='off' autocapitilize='off' spellcheck='false' class='select2-input'>", "  </li>", "</ul>", "<div class='select2-drop select2-drop-multi select2-display-none'>", "   <ul class='select2-results'>", "   </ul>", "</div>"].join(""));
            return container;
        },

        // multi
        prepareOpts: function prepareOpts() {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self = this;

            // TODO validate placeholder is a string if specified

            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install sthe selection initializer
                opts.initSelection = function (element, callback) {

                    var data = [];

                    element.find(":selected").each2(function (i, elm) {
                        data.push(self.optionToData(elm));
                    });
                    callback(data);
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var ids = splitVal(element.val(), opts.separator);
                    //search in data by array of ids, storing matching items in a list
                    var matches = [];
                    opts.query({
                        matcher: function matcher(term, text, el) {
                            var is_match = $.grep(ids, function (id) {
                                return equal(id, opts.id(el));
                            }).length;
                            if (is_match) {
                                matches.push(el);
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function () {
                            // reorder matches based on the order they appear in the ids array because right now
                            // they are in the order in which they appear in data array
                            var ordered = [];
                            for (var i = 0; i < ids.length; i++) {
                                var id = ids[i];
                                for (var j = 0; j < matches.length; j++) {
                                    var match = matches[j];
                                    if (equal(id, opts.id(match))) {
                                        ordered.push(match);
                                        matches.splice(j, 1);
                                        break;
                                    }
                                }
                            }
                            callback(ordered);
                        }
                    });
                };
            }

            return opts;
        },

        selectChoice: function selectChoice(choice) {

            var selected = this.container.find(".select2-search-choice-focus");
            if (selected.length && choice && choice[0] == selected[0]) {} else {
                if (selected.length) {
                    this.opts.element.trigger("choice-deselected", selected);
                }
                selected.removeClass("select2-search-choice-focus");
                if (choice && choice.length) {
                    this.close();
                    choice.addClass("select2-search-choice-focus");
                    this.opts.element.trigger("choice-selected", choice);
                }
            }
        },

        // multi
        initContainer: function initContainer() {

            var selector = ".select2-choices",
                selection;

            this.searchContainer = this.container.find(".select2-search-field");
            this.selection = selection = this.container.find(selector);

            var _this = this;
            this.selection.on("mousedown", ".select2-search-choice", function (e) {
                //killEvent(e);
                _this.search[0].focus();
                _this.selectChoice($(this));
            });
            //.sortable({
            //    items: " > li",
            //    tolerance: "pointer",
            //    revert: 100
            //});

            // rewrite labels from original element to focusser
            this.search.attr("id", "s2id_autogen" + nextUid());
            $("label[for='" + this.opts.element.attr("id") + "']").attr('for', this.search.attr('id'));

            this.search.on("input paste", this.bind(function () {
                if (!this.isInterfaceEnabled()) return;
                if (!this.opened()) {
                    this.open();
                }
            }));

            this.search.attr("tabindex", this.elementTabIndex);

            this.keydowns = 0;
            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                ++this.keydowns;
                var selected = selection.find(".select2-search-choice-focus");
                var prev = selected.prev(".select2-search-choice:not(.select2-locked)");
                var next = selected.next(".select2-search-choice:not(.select2-locked)");
                var pos = getCursorInfo(this.search);

                if (selected.length && (e.which == KEY.LEFT || e.which == KEY.RIGHT || e.which == KEY.BACKSPACE || e.which == KEY.DELETE || e.which == KEY.ENTER)) {
                    var selectedChoice = selected;
                    if (e.which == KEY.LEFT && prev.length) {
                        selectedChoice = prev;
                    } else if (e.which == KEY.RIGHT) {
                        selectedChoice = next.length ? next : null;
                    } else if (e.which === KEY.BACKSPACE) {
                        this.unselect(selected.first());
                        this.search.width(10);
                        selectedChoice = prev.length ? prev : next;
                    } else if (e.which == KEY.DELETE) {
                        this.unselect(selected.first());
                        this.search.width(10);
                        selectedChoice = next.length ? next : null;
                    } else if (e.which == KEY.ENTER) {
                        selectedChoice = null;
                    }

                    this.selectChoice(selectedChoice);
                    killEvent(e);
                    if (!selectedChoice || !selectedChoice.length) {
                        this.open();
                    }
                    return;
                } else if ((e.which === KEY.BACKSPACE && this.keydowns == 1 || e.which == KEY.LEFT) && pos.offset == 0 && !pos.length) {

                    this.selectChoice(selection.find(".select2-search-choice:not(.select2-locked)").last());
                    killEvent(e);
                    return;
                } else {
                    this.selectChoice(null);
                }

                if (this.opened()) {
                    switch (e.which) {
                        case KEY.UP:
                        case KEY.DOWN:
                            this.moveHighlight(e.which === KEY.UP ? -1 : 1);
                            killEvent(e);
                            return;
                        case KEY.ENTER:
                            this.selectHighlighted();
                            killEvent(e);
                            return;
                        case KEY.TAB:
                            this.selectHighlighted({ noFocus: true });
                            this.close();
                            return;
                        case KEY.ESC:
                            this.cancel(e);
                            killEvent(e);
                            return;
                    }
                }

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
                    return;
                }

                if (e.which === KEY.ENTER) {
                    if (this.opts.openOnEnter === false) {
                        return;
                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
                        return;
                    }
                }

                this.open();

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                }

                if (e.which === KEY.ENTER) {
                    // prevent form from being submitted
                    killEvent(e);
                }
            }));

            this.search.on("keyup", this.bind(function (e) {
                this.keydowns = 0;
                this.resizeSearch();
            }));

            this.search.on("blur", this.bind(function (e) {
                this.container.removeClass("select2-container-active");
                this.search.removeClass("select2-focused");
                this.selectChoice(null);
                if (!this.opened()) this.clearSearch();
                e.stopImmediatePropagation();
                this.opts.element.trigger($.Event("select2-blur"));
            }));

            this.container.on("click", selector, this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;
                if ($(e.target).closest(".select2-search-choice").length > 0) {
                    // clicked inside a select2 search choice, do not open
                    return;
                }
                this.selectChoice(null);
                this.clearPlaceholder();
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.open();
                this.focusSearch();
                e.preventDefault();
            }));

            this.container.on("focus", selector, this.bind(function () {
                if (!this.isInterfaceEnabled()) return;
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
                this.dropdown.addClass("select2-drop-active");
                this.clearPlaceholder();
            }));

            this.initContainerWidth();
            this.opts.element.addClass("select2-offscreen");

            // set the placeholder if necessary
            this.clearSearch();
        },

        // multi
        enableInterface: function enableInterface() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.search.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // multi
        initSelection: function initSelection() {
            var data;
            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
                this.updateSelection([]);
                this.close();
                // set the placeholder if necessary
                this.clearSearch();
            }
            if (this.select || this.opts.element.val() !== "") {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function (data) {
                    if (data !== undefined && data !== null) {
                        self.updateSelection(data);
                        self.close();
                        // set the placeholder if necessary
                        self.clearSearch();
                    }
                });
            }
        },

        // multi
        clearSearch: function clearSearch() {
            var placeholder = this.getPlaceholder(),
                maxWidth = this.getMaxSearchWidth();

            if (placeholder !== undefined && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
                this.search.val(placeholder).addClass("select2-default");
                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
                // we could call this.resizeSearch(), but we do not because that requires a sizer and we do not want to create one so early because of a firefox bug, see #944
                this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
            } else {
                this.search.val("").width(10);
            }
        },

        // multi
        clearPlaceholder: function clearPlaceholder() {
            if (this.search.hasClass("select2-default")) {
                this.search.val("").removeClass("select2-default");
            }
        },

        // multi
        opening: function opening() {
            this.clearPlaceholder(); // should be done before super so placeholder is not used to search
            this.resizeSearch();

            this.parent.opening.apply(this, arguments);

            this.focusSearch();

            this.updateResults(true);
            this.search.focus();
            this.opts.element.trigger($.Event("select2-open"));
        },

        // multi
        close: function close() {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);
        },

        // multi
        focus: function focus() {
            this.close();
            this.search.focus();
            //this.opts.element.triggerHandler("focus");
        },

        // multi
        isFocused: function isFocused() {
            return this.search.hasClass("select2-focused");
        },

        // multi
        updateSelection: function updateSelection(data) {
            var ids = [],
                filtered = [],
                self = this;

            // filter out duplicates
            $(data).each(function () {
                if (indexOf(self.id(this), ids) < 0) {
                    ids.push(self.id(this));
                    filtered.push(this);
                }
            });
            data = filtered;

            this.selection.find(".select2-search-choice").remove();
            $(data).each(function () {
                self.addSelectedChoice(this);
            });
            self.postprocessResults();
        },

        // multi
        tokenize: function tokenize() {
            var input = this.search.val();
            input = this.opts.tokenizer(input, this.data(), this.bind(this.onSelect), this.opts);
            if (input != null && input != undefined) {
                this.search.val(input);
                if (input.length > 0) {
                    this.open();
                }
            }
        },

        // multi
        onSelect: function onSelect(data, options) {

            if (!this.triggerSelect(data)) {
                return;
            }

            this.addSelectedChoice(data);

            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });

            if (this.select || !this.opts.closeOnSelect) this.postprocessResults();

            if (this.opts.closeOnSelect) {
                this.close();
                this.search.width(10);
            } else {
                if (this.countSelectableResults() > 0) {
                    this.search.width(10);
                    this.resizeSearch();
                    if (this.getMaximumSelectionSize() > 0 && this.val().length >= this.getMaximumSelectionSize()) {
                        // if we reached max selection size repaint the results so choices
                        // are replaced with the max selection reached message
                        this.updateResults(true);
                    }
                    this.positionDropdown();
                } else {
                    // if nothing left to select close
                    this.close();
                    this.search.width(10);
                }
            }

            // since its not possible to select an element that has already been
            // added we do not need to check if this is a new element before firing change
            this.triggerChange({ added: data });

            if (!options || !options.noFocus) this.focusSearch();
        },

        // multi
        cancel: function cancel() {
            this.close();
            this.focusSearch();
        },

        addSelectedChoice: function addSelectedChoice(data) {
            var enableChoice = !data.locked,
                enabledItem = $("<li class='select2-search-choice'>" + "    <div></div>" + "    <a href='#' onclick='return false;' class='select2-search-choice-close' tabindex='-1'></a>" + "</li>"),
                disabledItem = $("<li class='select2-search-choice select2-locked'>" + "<div></div>" + "</li>");
            var choice = enableChoice ? enabledItem : disabledItem,
                id = this.id(data),
                val = this.getVal(),
                formatted,
                cssClass;

            formatted = this.opts.formatSelection(data, choice.find("div"));
            if (formatted != undefined) {
                choice.find("div").replaceWith("<div>" + this.opts.escapeMarkup(formatted) + "</div>");
            }
            cssClass = this.opts.formatSelectionCssClass(data, choice.find("div"));
            if (cssClass != undefined) {
                choice.addClass(cssClass);
            }

            if (enableChoice) {
                choice.find(".select2-search-choice-close").on("mousedown", killEvent).on("click dblclick", this.bind(function (e) {
                    if (!this.isInterfaceEnabled()) return;

                    $(e.target).closest(".select2-search-choice").fadeOut('fast', this.bind(function () {
                        this.unselect($(e.target));
                        this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
                        this.close();
                        this.focusSearch();
                    })).dequeue();
                    killEvent(e);
                })).on("focus", this.bind(function () {
                    if (!this.isInterfaceEnabled()) return;
                    this.container.addClass("select2-container-active");
                    this.dropdown.addClass("select2-drop-active");
                }));
            }

            choice.data("select2-data", data);
            choice.insertBefore(this.searchContainer);

            val.push(id);
            this.setVal(val);
        },

        // multi
        unselect: function unselect(selected) {
            var val = this.getVal(),
                data,
                index;

            selected = selected.closest(".select2-search-choice");

            if (selected.length === 0) {
                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
            }

            data = selected.data("select2-data");

            if (!data) {
                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
                // and invoked on an element already removed
                return;
            }

            index = indexOf(this.id(data), val);

            if (index >= 0) {
                val.splice(index, 1);
                this.setVal(val);
                if (this.select) this.postprocessResults();
            }
            selected.remove();

            this.opts.element.trigger({ type: "removed", val: this.id(data), choice: data });
            this.triggerChange({ removed: data });
        },

        // multi
        postprocessResults: function postprocessResults(data, initial, noHighlightUpdate) {
            var val = this.getVal(),
                choices = this.results.find(".select2-result"),
                compound = this.results.find(".select2-result-with-children"),
                self = this;

            choices.each2(function (i, choice) {
                var id = self.id(choice.data("select2-data"));
                if (indexOf(id, val) >= 0) {
                    choice.addClass("select2-selected");
                    // mark all children of the selected parent as selected
                    choice.find(".select2-result-selectable").addClass("select2-selected");
                }
            });

            compound.each2(function (i, choice) {
                // hide an optgroup if it doesnt have any selectable children
                if (!choice.is('.select2-result-selectable') && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
                    choice.addClass("select2-selected");
                }
            });

            if (this.highlight() == -1 && noHighlightUpdate !== false) {
                self.highlight(0);
            }

            //If all results are chosen render formatNoMAtches
            if (!this.opts.createSearchChoice && !choices.filter('.select2-result:not(.select2-selected)').length > 0) {
                if (!data || data && !data.more && this.results.find(".select2-no-results").length === 0) {
                    this.results.append("<li class='select2-no-results'>" + self.opts.formatNoMatches(self.search.val()) + "</li>");
                }
            }
        },

        // multi
        getMaxSearchWidth: function getMaxSearchWidth() {
            return this.selection.width() - getSideBorderPadding(this.search);
        },

        // multi
        resizeSearch: function resizeSearch() {
            var minimumWidth,
                left,
                maxWidth,
                containerLeft,
                searchWidth,
                sideBorderPadding = getSideBorderPadding(this.search);

            minimumWidth = measureTextWidth(this.search) + 10;

            left = this.search.offset().left;

            maxWidth = this.selection.width();
            containerLeft = this.selection.offset().left;

            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;

            if (searchWidth < minimumWidth) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth < 40) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth <= 0) {
                searchWidth = minimumWidth;
            }

            this.search.width(searchWidth);
        },

        // multi
        getVal: function getVal() {
            var val;
            if (this.select) {
                val = this.select.val();
                return val === null ? [] : val;
            } else {
                val = this.opts.element.val();
                return splitVal(val, this.opts.separator);
            }
        },

        // multi
        setVal: function setVal(val) {
            var unique;
            if (this.select) {
                this.select.val(val);
            } else {
                unique = [];
                // filter out duplicates
                $(val).each(function () {
                    if (indexOf(this, unique) < 0) unique.push(this);
                });
                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
            }
        },

        // multi
        buildChangeDetails: function buildChangeDetails(old, current) {
            var current = current.slice(0),
                old = old.slice(0);

            // remove intersection from each array
            for (var i = 0; i < current.length; i++) {
                for (var j = 0; j < old.length; j++) {
                    if (equal(this.opts.id(current[i]), this.opts.id(old[j]))) {
                        current.splice(i, 1);
                        i--;
                        old.splice(j, 1);
                        j--;
                    }
                }
            }

            return { added: current, removed: old };
        },

        // multi
        val: function val(_val, triggerChange) {
            var oldData,
                self = this,
                changeDetails;

            if (arguments.length === 0) {
                return this.getVal();
            }

            oldData = this.data();
            if (!oldData.length) oldData = [];

            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
            if (!_val && _val !== 0) {
                this.opts.element.val("");
                this.updateSelection([]);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange({ added: this.data(), removed: oldData });
                }
                return;
            }

            // val is a list of ids
            this.setVal(_val);

            if (this.select) {
                this.opts.initSelection(this.select, this.bind(this.updateSelection));
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(oldData, this.data()));
                }
            } else {
                if (this.opts.initSelection === undefined) {
                    throw new Error("val() cannot be called if initSelection() is not defined");
                }

                this.opts.initSelection(this.opts.element, function (data) {
                    var ids = $.map(data, self.id);
                    self.setVal(ids);
                    self.updateSelection(data);
                    self.clearSearch();
                    if (triggerChange) {
                        self.triggerChange(this.buildChangeDetails(oldData, this.data()));
                    }
                });
            }
            this.clearSearch();
        },

        // multi
        onSortStart: function onSortStart() {
            if (this.select) {
                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
            }

            // collapse search field into 0 width so its container can be collapsed as well
            this.search.width(0);
            // hide the container
            this.searchContainer.hide();
        },

        // multi
        onSortEnd: function onSortEnd() {

            var val = [],
                self = this;

            // show search and move it to the end of the list
            this.searchContainer.show();
            // make sure the search container is the last item in the list
            this.searchContainer.appendTo(this.searchContainer.parent());
            // since we collapsed the width in dragStarted, we resize it here
            this.resizeSearch();

            // update selection

            this.selection.find(".select2-search-choice").each(function () {
                val.push(self.opts.id($(this).data("select2-data")));
            });
            this.setVal(val);
            this.triggerChange();
        },

        // multi
        data: function data(values, triggerChange) {
            var self = this,
                ids,
                old;
            if (arguments.length === 0) {
                return this.selection.find(".select2-search-choice").map(function () {
                    return $(this).data("select2-data");
                }).get();
            } else {
                old = this.data();
                if (!values) {
                    values = [];
                }
                ids = $.map(values, function (e) {
                    return self.opts.id(e);
                });
                this.setVal(ids);
                this.updateSelection(values);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(old, this.data()));
                }
            }
        }
    });

    $.fn.select2 = function () {

        var args = Array.prototype.slice.call(arguments, 0),
            opts,
            select2,
            method,
            value,
            multiple,
            allowedMethods = ["val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "dropdown", "onSortStart", "onSortEnd", "enable", "readonly", "positionDropdown", "data", "search"],
            valueMethods = ["val", "opened", "isFocused", "container", "data"],
            methodsMap = { search: "externalSearch" };

        this.each(function () {
            if (args.length === 0 || _typeof(args[0]) === "object") {
                opts = args.length === 0 ? {} : $.extend({}, args[0]);
                opts.element = $(this);

                if (opts.element.get(0).tagName.toLowerCase() === "select") {
                    multiple = opts.element.prop("multiple");
                } else {
                    multiple = opts.multiple || false;
                    if ("tags" in opts) {
                        opts.multiple = multiple = true;
                    }
                }

                select2 = multiple ? new MultiSelect2() : new SingleSelect2();
                select2.init(opts);
            } else if (typeof args[0] === "string") {

                if (indexOf(args[0], allowedMethods) < 0) {
                    throw "Unknown method: " + args[0];
                }

                value = undefined;
                select2 = $(this).data("select2");
                if (select2 === undefined) return;

                method = args[0];

                if (method === "container") {
                    value = select2.container;
                } else if (method === "dropdown") {
                    value = select2.dropdown;
                } else {
                    if (methodsMap[method]) method = methodsMap[method];

                    value = select2[method].apply(select2, args.slice(1));
                }
                if (indexOf(args[0], valueMethods) >= 0) {
                    return false;
                }
            } else {
                throw "Invalid arguments to select2 plugin: " + args;
            }
        });
        return value === undefined ? this : value;
    };

    // plugin defaults, accessible to users
    $.fn.select2.defaults = {
        width: "copy",
        loadMorePadding: 0,
        closeOnSelect: true,
        openOnEnter: true,
        containerCss: {},
        dropdownCss: {},
        containerCssClass: "",
        dropdownCssClass: "",
        formatResult: function formatResult(result, container, query, escapeMarkup) {
            var markup = [];
            markMatch(result.text, query.term, markup, escapeMarkup);
            return markup.join("");
        },
        formatSelection: function formatSelection(data, container) {
            return data ? data.text : undefined;
        },
        sortResults: function sortResults(results, container, query) {
            return results;
        },
        formatResultCssClass: function formatResultCssClass(data) {
            return undefined;
        },
        formatSelectionCssClass: function formatSelectionCssClass(data, container) {
            return undefined;
        },
        formatNoMatches: function formatNoMatches() {
            return "No matches found";
        },
        formatInputTooShort: function formatInputTooShort(input, min) {
            var n = min - input.length;return "Please enter " + n + " more character" + (n == 1 ? "" : "s");
        },
        formatInputTooLong: function formatInputTooLong(input, max) {
            var n = input.length - max;return "Please delete " + n + " character" + (n == 1 ? "" : "s");
        },
        formatSelectionTooBig: function formatSelectionTooBig(limit) {
            return "You can only select " + limit + " item" + (limit == 1 ? "" : "s");
        },
        formatLoadMore: function formatLoadMore(pageNumber) {
            return "Loading more results...";
        },
        formatSearching: function formatSearching() {
            return "Searching...";
        },
        minimumResultsForSearch: 0,
        minimumInputLength: 0,
        maximumInputLength: null,
        maximumSelectionSize: 0,
        id: function id(e) {
            return e.id;
        },
        matcher: function matcher(term, text) {
            return ('' + text).toUpperCase().indexOf(('' + term).toUpperCase()) >= 0;
        },
        separator: ",",
        tokenSeparators: [],
        tokenizer: defaultTokenizer,
        escapeMarkup: defaultEscapeMarkup,
        blurOnChange: false,
        selectOnBlur: false,
        adaptContainerCssClass: function adaptContainerCssClass(c) {
            return c;
        },
        adaptDropdownCssClass: function adaptDropdownCssClass(c) {
            return null;
        }
    };

    $.fn.select2.ajaxDefaults = {
        transport: $.ajax,
        params: {
            type: "GET",
            cache: false,
            dataType: "json"
        }
    };

    // exports
    window.Select2 = {
        query: {
            ajax: ajax,
            local: local,
            tags: tags
        }, util: {
            debounce: debounce,
            markMatch: markMatch,
            escapeMarkup: defaultEscapeMarkup
        }, "class": {
            "abstract": AbstractSelect2,
            "single": SingleSelect2,
            "multi": MultiSelect2
        }
    };
})(jQuery);

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.array-buffer.js
var es6_typed_array_buffer = __webpack_require__(107);
var es6_typed_array_buffer_default = /*#__PURE__*/__webpack_require__.n(es6_typed_array_buffer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.int8-array.js
var es6_typed_int8_array = __webpack_require__(112);
var es6_typed_int8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int8_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint8-array.js
var es6_typed_uint8_array = __webpack_require__(118);
var es6_typed_uint8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint8-clamped-array.js
var es6_typed_uint8_clamped_array = __webpack_require__(119);
var es6_typed_uint8_clamped_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_clamped_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.int16-array.js
var es6_typed_int16_array = __webpack_require__(120);
var es6_typed_int16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int16_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint16-array.js
var es6_typed_uint16_array = __webpack_require__(121);
var es6_typed_uint16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint16_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.int32-array.js
var es6_typed_int32_array = __webpack_require__(122);
var es6_typed_int32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int32_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint32-array.js
var es6_typed_uint32_array = __webpack_require__(123);
var es6_typed_uint32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint32_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.float32-array.js
var es6_typed_float32_array = __webpack_require__(124);
var es6_typed_float32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float32_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.float64-array.js
var es6_typed_float64_array = __webpack_require__(125);
var es6_typed_float64_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float64_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.map.js
var es6_map = __webpack_require__(126);
var es6_map_default = /*#__PURE__*/__webpack_require__.n(es6_map);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__(130);
var es6_set_default = /*#__PURE__*/__webpack_require__.n(es6_set);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.weak-map.js
var es6_weak_map = __webpack_require__(131);
var es6_weak_map_default = /*#__PURE__*/__webpack_require__.n(es6_weak_map);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.weak-set.js
var es6_weak_set = __webpack_require__(134);
var es6_weak_set_default = /*#__PURE__*/__webpack_require__.n(es6_weak_set);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.apply.js
var es6_reflect_apply = __webpack_require__(135);
var es6_reflect_apply_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_apply);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.construct.js
var es6_reflect_construct = __webpack_require__(136);
var es6_reflect_construct_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_construct);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.define-property.js
var es6_reflect_define_property = __webpack_require__(137);
var es6_reflect_define_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_define_property);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.delete-property.js
var es6_reflect_delete_property = __webpack_require__(138);
var es6_reflect_delete_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_delete_property);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.get.js
var es6_reflect_get = __webpack_require__(139);
var es6_reflect_get_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js
var es6_reflect_get_own_property_descriptor = __webpack_require__(140);
var es6_reflect_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_own_property_descriptor);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.get-prototype-of.js
var es6_reflect_get_prototype_of = __webpack_require__(141);
var es6_reflect_get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.has.js
var es6_reflect_has = __webpack_require__(142);
var es6_reflect_has_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_has);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.is-extensible.js
var es6_reflect_is_extensible = __webpack_require__(143);
var es6_reflect_is_extensible_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_is_extensible);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.own-keys.js
var es6_reflect_own_keys = __webpack_require__(144);
var es6_reflect_own_keys_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_own_keys);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.prevent-extensions.js
var es6_reflect_prevent_extensions = __webpack_require__(146);
var es6_reflect_prevent_extensions_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_prevent_extensions);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.set.js
var es6_reflect_set = __webpack_require__(147);
var es6_reflect_set_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.set-prototype-of.js
var es6_reflect_set_prototype_of = __webpack_require__(148);
var es6_reflect_set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__(149);
var es6_promise_default = /*#__PURE__*/__webpack_require__.n(es6_promise);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__(151);
var es6_symbol_default = /*#__PURE__*/__webpack_require__.n(es6_symbol);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__(153);
var es6_object_assign_default = /*#__PURE__*/__webpack_require__.n(es6_object_assign);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.is.js
var es6_object_is = __webpack_require__(154);
var es6_object_is_default = /*#__PURE__*/__webpack_require__.n(es6_object_is);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__(155);
var es6_function_name_default = /*#__PURE__*/__webpack_require__.n(es6_function_name);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.raw.js
var es6_string_raw = __webpack_require__(156);
var es6_string_raw_default = /*#__PURE__*/__webpack_require__.n(es6_string_raw);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.from-code-point.js
var es6_string_from_code_point = __webpack_require__(157);
var es6_string_from_code_point_default = /*#__PURE__*/__webpack_require__.n(es6_string_from_code_point);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.code-point-at.js
var es6_string_code_point_at = __webpack_require__(158);
var es6_string_code_point_at_default = /*#__PURE__*/__webpack_require__.n(es6_string_code_point_at);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.repeat.js
var es6_string_repeat = __webpack_require__(159);
var es6_string_repeat_default = /*#__PURE__*/__webpack_require__.n(es6_string_repeat);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__(161);
var es6_string_starts_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_starts_with);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.ends-with.js
var es6_string_ends_with = __webpack_require__(163);
var es6_string_ends_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_ends_with);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__(164);
var es6_string_includes_default = /*#__PURE__*/__webpack_require__.n(es6_string_includes);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.flags.js
var es6_regexp_flags = __webpack_require__(165);
var es6_regexp_flags_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_flags);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.match.js
var es6_regexp_match = __webpack_require__(166);
var es6_regexp_match_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_match);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__(167);
var es6_regexp_replace_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_replace);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__(168);
var es6_regexp_split_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_split);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.search.js
var es6_regexp_search = __webpack_require__(169);
var es6_regexp_search_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_search);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__(170);
var es6_array_from_default = /*#__PURE__*/__webpack_require__.n(es6_array_from);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.of.js
var es6_array_of = __webpack_require__(171);
var es6_array_of_default = /*#__PURE__*/__webpack_require__.n(es6_array_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.copy-within.js
var es6_array_copy_within = __webpack_require__(172);
var es6_array_copy_within_default = /*#__PURE__*/__webpack_require__.n(es6_array_copy_within);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__(173);
var es6_array_find_default = /*#__PURE__*/__webpack_require__.n(es6_array_find);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__(174);
var es6_array_find_index_default = /*#__PURE__*/__webpack_require__.n(es6_array_find_index);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.fill.js
var es6_array_fill = __webpack_require__(175);
var es6_array_fill_default = /*#__PURE__*/__webpack_require__.n(es6_array_fill);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__(66);
var es6_array_iterator_default = /*#__PURE__*/__webpack_require__.n(es6_array_iterator);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-finite.js
var es6_number_is_finite = __webpack_require__(176);
var es6_number_is_finite_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_finite);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-integer.js
var es6_number_is_integer = __webpack_require__(177);
var es6_number_is_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-safe-integer.js
var es6_number_is_safe_integer = __webpack_require__(179);
var es6_number_is_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_safe_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-nan.js
var es6_number_is_nan = __webpack_require__(180);
var es6_number_is_nan_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_nan);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.epsilon.js
var es6_number_epsilon = __webpack_require__(181);
var es6_number_epsilon_default = /*#__PURE__*/__webpack_require__.n(es6_number_epsilon);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.min-safe-integer.js
var es6_number_min_safe_integer = __webpack_require__(182);
var es6_number_min_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_min_safe_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.max-safe-integer.js
var es6_number_max_safe_integer = __webpack_require__(183);
var es6_number_max_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_max_safe_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.acosh.js
var es6_math_acosh = __webpack_require__(184);
var es6_math_acosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_acosh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.asinh.js
var es6_math_asinh = __webpack_require__(186);
var es6_math_asinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_asinh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.atanh.js
var es6_math_atanh = __webpack_require__(187);
var es6_math_atanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_atanh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.cbrt.js
var es6_math_cbrt = __webpack_require__(188);
var es6_math_cbrt_default = /*#__PURE__*/__webpack_require__.n(es6_math_cbrt);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.clz32.js
var es6_math_clz32 = __webpack_require__(189);
var es6_math_clz32_default = /*#__PURE__*/__webpack_require__.n(es6_math_clz32);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.cosh.js
var es6_math_cosh = __webpack_require__(190);
var es6_math_cosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_cosh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.expm1.js
var es6_math_expm1 = __webpack_require__(191);
var es6_math_expm1_default = /*#__PURE__*/__webpack_require__.n(es6_math_expm1);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.fround.js
var es6_math_fround = __webpack_require__(192);
var es6_math_fround_default = /*#__PURE__*/__webpack_require__.n(es6_math_fround);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.hypot.js
var es6_math_hypot = __webpack_require__(193);
var es6_math_hypot_default = /*#__PURE__*/__webpack_require__.n(es6_math_hypot);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.imul.js
var es6_math_imul = __webpack_require__(194);
var es6_math_imul_default = /*#__PURE__*/__webpack_require__.n(es6_math_imul);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.log1p.js
var es6_math_log1p = __webpack_require__(195);
var es6_math_log1p_default = /*#__PURE__*/__webpack_require__.n(es6_math_log1p);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.log10.js
var es6_math_log10 = __webpack_require__(196);
var es6_math_log10_default = /*#__PURE__*/__webpack_require__.n(es6_math_log10);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.log2.js
var es6_math_log2 = __webpack_require__(197);
var es6_math_log2_default = /*#__PURE__*/__webpack_require__.n(es6_math_log2);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.sign.js
var es6_math_sign = __webpack_require__(198);
var es6_math_sign_default = /*#__PURE__*/__webpack_require__.n(es6_math_sign);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.sinh.js
var es6_math_sinh = __webpack_require__(199);
var es6_math_sinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_sinh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.tanh.js
var es6_math_tanh = __webpack_require__(200);
var es6_math_tanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_tanh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.trunc.js
var es6_math_trunc = __webpack_require__(201);
var es6_math_trunc_default = /*#__PURE__*/__webpack_require__.n(es6_math_trunc);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__(202);
var es7_array_includes_default = /*#__PURE__*/__webpack_require__.n(es7_array_includes);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.values.js
var es7_object_values = __webpack_require__(203);
var es7_object_values_default = /*#__PURE__*/__webpack_require__.n(es7_object_values);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.entries.js
var es7_object_entries = __webpack_require__(205);
var es7_object_entries_default = /*#__PURE__*/__webpack_require__.n(es7_object_entries);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__(206);
var es7_object_get_own_property_descriptors_default = /*#__PURE__*/__webpack_require__.n(es7_object_get_own_property_descriptors);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.string.pad-start.js
var es7_string_pad_start = __webpack_require__(207);
var es7_string_pad_start_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_start);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.string.pad-end.js
var es7_string_pad_end = __webpack_require__(209);
var es7_string_pad_end_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_end);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(210);
var web_timers_default = /*#__PURE__*/__webpack_require__.n(web_timers);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.immediate.js
var web_immediate = __webpack_require__(211);
var web_immediate_default = /*#__PURE__*/__webpack_require__.n(web_immediate);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__(212);
var web_dom_iterable_default = /*#__PURE__*/__webpack_require__.n(web_dom_iterable);

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(213);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);

// EXTERNAL MODULE: ./app/javascript/lib/vue.js
var vue = __webpack_require__(100);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/static-map.vue
//
//
//
//
//
//

/* harmony default export */ var static_map = ({
  props: ['src']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f578ed6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/static-map.vue
var static_map_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gmap"
  }, [_c('img', {
    attrs: {
      "src": _vm.src,
      "alt": "Map"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: static_map_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_static_map = (esExports);
// CONCATENATED MODULE: ./app/javascript/components/static-map.vue
function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f578ed6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  static_map,
  components_static_map,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var javascript_components_static_map = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/details.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var details = ({
  props: ["company", "editable", "isForm"],

  data: function data() {
    return {
      labels: {
        size: I18n.t("activerecord.attributes.company.size"),
        year_founded: I18n.t("activerecord.attributes.company.year_founded")
      },
      industriesExpanded: false,
      expertiseExpanded: false
    };
  },

  computed: {
    websiteHostname: function websiteHostname() {
      var a = document.createElement("a");

      a.setAttribute("href", this.company.website);

      return a.hostname.replace("www.", "");
    },
    socialNetworks: function socialNetworks() {
      var networkHash = this.company.social_networks;

      return Object.keys(networkHash).filter(function (service) {
        return networkHash[service].username;
      }).map(function (service) {
        return _extends({
          service: service
        }, networkHash[service]);
      });
    },
    isOnTheWeb: function isOnTheWeb() {
      return this.company.website || this.socialNetworks.length > 0;
    },
    viewCompanyPath: function viewCompanyPath() {
      return "/companies/" + this.company.slug;
    },
    editCompanyPath: function editCompanyPath() {
      return "/companies/" + this.company.slug + "/edit";
    }
  },

  methods: {
    getDirectoryPath: function getDirectoryPath(filter, id) {
      return "/companies?" + filter + "=" + id;
    },
    toggleIndustries: function toggleIndustries() {
      this.industriesExpanded = !this.industriesExpanded;
    },
    toggleExpertise: function toggleExpertise() {
      this.expertiseExpanded = !this.expertiseExpanded;
    }
  },

  components: {
    StaticMap: javascript_components_static_map
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d676522","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/details.vue
var details_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [(_vm.company.email) ? _c('a', {
    staticClass: "contact details__button cm-button",
    attrs: {
      "href": 'mailto:' + _vm.company.email
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("contact")))]) : _vm._e(), _vm._v(" "), (_vm.company.locations && !_vm.company.remote) ? _vm._m(0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-list sidebar-box"
  }, [(_vm.editable) ? _c('a', {
    staticClass: "edit-link ss-icon",
    attrs: {
      "href": _vm.editCompanyPath,
      "title": "Edit company"
    }
  }, [_vm._v("compose")]) : _vm._e(), _vm._v(" "), _c('dl', [(_vm.isOnTheWeb) ? [_c('div', {
    staticClass: "detail-group"
  }, [_c('dt', {
    staticClass: "detail-label"
  }, [_vm._v(_vm._s(_vm.I18n.t("on_the_web")))]), _vm._v(" "), _c('dd', {
    staticClass: "detail-value"
  }, [(_vm.company.website) ? _c('a', {
    attrs: {
      "href": _vm.company.website
    }
  }, [_vm._v(_vm._s(_vm.websiteHostname))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "social-links"
  }, _vm._l((_vm.socialNetworks), function(socialNetwork) {
    return _c('li', {
      key: socialNetwork.service,
      staticClass: "social-link"
    }, [_c('a', {
      attrs: {
        "href": socialNetwork.url
      }
    }, [_c('i', {
      staticClass: "ss-icon ss-social-regular"
    }, [_vm._v(_vm._s(socialNetwork.service))]), _vm._v(" "), _c('span', {
      staticClass: "social-link__username"
    }, [_vm._v(_vm._s(socialNetwork.username))])])])
  }))])])] : _vm._e(), _vm._v(" "), (!_vm.company.remote) ? [(_vm.company.locations.length > 1 || _vm.company.remote_employees) ? _c('div', [_c('dt', {
    staticClass: "detail-label"
  }, [_vm._v("Locations")]), _vm._v(" "), _c('dd', {
    staticClass: "detail-value"
  }, [_c('ul', {
    staticClass: "location-list"
  }, [_vm._l((_vm.company.locations), function(location, i) {
    return _c('li', [(i == 0 && _vm.company.locations.length > 1) ? _c('div', {
      staticClass: "hq-tag"
    }, [_vm._v("\n                  HQ\n                ")]) : _vm._e(), _vm._v("\n                " + _vm._s(location.address) + "\n              ")])
  }), _vm._v(" "), (_vm.company.remote_employees) ? _c('li', {
    staticClass: "remote-friendly-tag"
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("wifi")]), _vm._v("\n                We're remote friendly!\n              ")]) : _vm._e()], 2)])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.company.industries.length > 0) ? [_c('div', {
    staticClass: "detail-group"
  }, [_c('dt', {
    staticClass: "detail-label"
  }, [_vm._v(_vm._s(_vm.I18n.t("industries")))]), _vm._v(" "), _c('dd', {
    staticClass: "detail-value"
  }, [_c('ul', _vm._l((_vm.company.industries), function(industry, n) {
    return (n < 3 || _vm.industriesExpanded) ? _c('li', {
      key: industry[0],
      staticClass: "tag"
    }, [_c('a', {
      attrs: {
        "href": _vm.getDirectoryPath('industry_id', industry[0])
      }
    }, [_vm._v(_vm._s(industry[1]))])]) : _vm._e()
  })), _vm._v(" "), (_vm.company.industries.length > 3) ? _c('a', {
    staticClass: "expand",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleIndustries($event)
      }
    }
  }, [(!_vm.industriesExpanded) ? [_vm._v("\n                See all " + _vm._s(_vm.company.industries.length) + "\n              ")] : [_vm._v(" See less ")]], 2) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.company.expertise.length > 0) ? [_c('div', {
    staticClass: "detail-group"
  }, [_c('dt', {
    staticClass: "detail-label"
  }, [_vm._v("\n            " + _vm._s(_vm.I18n.t("activerecord.attributes.company.skill_tag_ids")) + "\n          ")]), _vm._v(" "), _c('dd', {
    staticClass: "detail-value"
  }, [_c('ul', _vm._l((_vm.company.expertise), function(expertise, n) {
    return (n < 3 || _vm.expertiseExpanded) ? _c('li', {
      key: expertise[0],
      staticClass: "tag"
    }, [_c('a', {
      attrs: {
        "href": _vm.getDirectoryPath('skill_tag_id', expertise[0])
      }
    }, [_vm._v(_vm._s(expertise[1]))])]) : _vm._e()
  })), _vm._v(" "), (_vm.company.expertise.length > 3) ? _c('a', {
    staticClass: "expand",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleExpertise($event)
      }
    }
  }, [(!_vm.expertiseExpanded) ? [_vm._v("\n                See all " + _vm._s(_vm.company.expertise.length) + "\n              ")] : [_vm._v(" See less ")]], 2) : _vm._e()])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.labels), function(label, key) {
    return (_vm.company[key]) ? [_c('div', {
      staticClass: "detail-group"
    }, [_c('dt', {
      staticClass: "detail-label"
    }, [_vm._v(_vm._s(label))]), _vm._v(" "), _c('dd', {
      staticClass: "detail-value"
    }, [_vm._v(_vm._s(_vm._self[key] || _vm.company[key]))])])] : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.company.global) ? _c('div', {
    staticClass: "sponsor"
  }, [_c('div', {
    staticClass: "global-partner"
  }, [_vm._v("\n      " + _vm._s(_vm.I18n.t("global_partner")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "global-partner-link"
  }, [_c('a', {
    attrs: {
      "href": "/partner"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("what_is_this_question")))])])]) : _vm._e(), _vm._v(" "), (_vm.editable && _vm.isForm) ? _c('a', {
    staticClass: "cm-button details__button view-company",
    attrs: {
      "href": _vm.viewCompanyPath
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("view_company")))]) : (_vm.editable) ? _c('a', {
    staticClass: "cm-button details__button edit-company",
    attrs: {
      "href": _vm.editCompanyPath
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("edit_company")))]) : _vm._e()], 1)
}
var details_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('static-map', {
    attrs: {
      "src": _vm.company.google_maps_src
    }
  })
}]
var details_esExports = { render: details_render, staticRenderFns: details_staticRenderFns }
/* harmony default export */ var company_details = (details_esExports);
// CONCATENATED MODULE: ./app/javascript/company/details.vue
function details_injectStyle (ssrContext) {
  __webpack_require__(262)
}
var details_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var details___vue_styles__ = details_injectStyle
/* scopeId */
var details___vue_scopeId__ = "data-v-6d676522"
/* moduleIdentifier (server only) */
var details___vue_module_identifier__ = null
var details_Component = details_normalizeComponent(
  details,
  company_details,
  details___vue_styles__,
  details___vue_scopeId__,
  details___vue_module_identifier__
)

/* harmony default export */ var javascript_company_details = (details_Component.exports);

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__(265);
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/autosize-textarea.vue
//
//
//
//



/* harmony default export */ var autosize_textarea = ({
  props: ['value'],
  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    }
  },
  mounted: function mounted() {
    autosize_default()(this.$el);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2939b64f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/autosize-textarea.vue
var autosize_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.value))])
}
var autosize_textarea_staticRenderFns = []
var autosize_textarea_esExports = { render: autosize_textarea_render, staticRenderFns: autosize_textarea_staticRenderFns }
/* harmony default export */ var components_autosize_textarea = (autosize_textarea_esExports);
// CONCATENATED MODULE: ./app/javascript/components/autosize-textarea.vue
var autosize_textarea_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var autosize_textarea___vue_styles__ = null
/* scopeId */
var autosize_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var autosize_textarea___vue_module_identifier__ = null
var autosize_textarea_Component = autosize_textarea_normalizeComponent(
  autosize_textarea,
  components_autosize_textarea,
  autosize_textarea___vue_styles__,
  autosize_textarea___vue_scopeId__,
  autosize_textarea___vue_module_identifier__
)

/* harmony default export */ var javascript_components_autosize_textarea = (autosize_textarea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/inline-form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var inline_form = ({
  props: ['company', 'editable'],
  data: function data() {
    return {
      showingForm: false,
      errors: []
    };
  },
  methods: {
    showForm: function showForm() {
      this.showingForm = true;
    },
    saveForm: function saveForm() {
      var _this = this;

      this.errors = [];

      this.$http.patch('/companies/' + this.company.id, { company: this.company }).then(function (response) {
        // TODO Emit updated data to parent?
        _this.showingForm = false;
      }, function (response) {
        _this.errors = response.body.errors;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17bb7db6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/inline-form.vue
var inline_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-form"
  }, [(_vm.errors.length > 0) ? _c('div', {
    staticClass: "error-messages"
  }, [_c('p', {
    staticClass: "message-error ss-alert"
  }, [_vm._v(_vm._s(_vm.errors.join(', ')))])]) : _vm._e(), _vm._v(" "), (_vm.showingForm) ? _c('form', [_vm._t("fields"), _vm._v(" "), _c('input', {
    staticClass: "cm-button small",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.I18n.t('save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveForm($event)
      }
    }
  })], 2) : _c('div', {
    staticClass: "inline-form__content"
  }, [_vm._t("default"), _vm._v(" "), (_vm.editable) ? _c('button', {
    staticClass: "edit-button ss-icon",
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v("compose")]) : _vm._e()], 2)])
}
var inline_form_staticRenderFns = []
var inline_form_esExports = { render: inline_form_render, staticRenderFns: inline_form_staticRenderFns }
/* harmony default export */ var company_inline_form = (inline_form_esExports);
// CONCATENATED MODULE: ./app/javascript/company/inline-form.vue
function inline_form_injectStyle (ssrContext) {
  __webpack_require__(266)
}
var inline_form_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var inline_form___vue_styles__ = inline_form_injectStyle
/* scopeId */
var inline_form___vue_scopeId__ = "data-v-17bb7db6"
/* moduleIdentifier (server only) */
var inline_form___vue_module_identifier__ = null
var inline_form_Component = inline_form_normalizeComponent(
  inline_form,
  company_inline_form,
  inline_form___vue_styles__,
  inline_form___vue_scopeId__,
  inline_form___vue_module_identifier__
)

/* harmony default export */ var javascript_company_inline_form = (inline_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/mission-statement.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mission_statement = ({
  props: ['id', 'value', 'editable'],
  data: function data() {
    return {
      company: {
        id: this.id,
        mission_statement: this.value
      }
    };
  },
  components: {
    AutosizeTextarea: javascript_components_autosize_textarea,
    InlineForm: javascript_company_inline_form
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22b5854a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/mission-statement.vue
var mission_statement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('inline-form', {
    attrs: {
      "company": _vm.company,
      "editable": _vm.editable
    }
  }, [_c('template', {
    slot: "fields"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "v-company-mission-statement"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('activerecord.attributes.company.mission_statement')))]), _vm._v(" "), _c('autosize-textarea', {
    staticClass: "cm-field",
    attrs: {
      "id": "v-company-mission-statement",
      "rows": "3"
    },
    model: {
      value: (_vm.company.mission_statement),
      callback: function($$v) {
        _vm.company.mission_statement = $$v
      },
      expression: "company.mission_statement"
    }
  })], 1), _vm._v(" "), (_vm.company.mission_statement) ? _c('p', {
    staticClass: "mission-statement"
  }, [_vm._v(_vm._s(_vm.company.mission_statement))]) : (_vm.editable) ? _c('p', {
    staticClass: "mission-statement mission-statement--empty"
  }, [_vm._v(_vm._s(_vm.I18n.t('add_a_mission_statement')))]) : _vm._e()], 2)], 1)
}
var mission_statement_staticRenderFns = []
var mission_statement_esExports = { render: mission_statement_render, staticRenderFns: mission_statement_staticRenderFns }
/* harmony default export */ var company_mission_statement = (mission_statement_esExports);
// CONCATENATED MODULE: ./app/javascript/company/mission-statement.vue
function mission_statement_injectStyle (ssrContext) {
  __webpack_require__(264)
}
var mission_statement_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var mission_statement___vue_styles__ = mission_statement_injectStyle
/* scopeId */
var mission_statement___vue_scopeId__ = "data-v-22b5854a"
/* moduleIdentifier (server only) */
var mission_statement___vue_module_identifier__ = null
var mission_statement_Component = mission_statement_normalizeComponent(
  mission_statement,
  company_mission_statement,
  mission_statement___vue_styles__,
  mission_statement___vue_scopeId__,
  mission_statement___vue_module_identifier__
)

/* harmony default export */ var javascript_company_mission_statement = (mission_statement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/motto.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var motto = ({
  props: ['id', 'value', 'editable'],

  data: function data() {
    return {
      company: {
        id: this.id,
        motto: this.value
      }
    };
  },

  components: {
    AutosizeTextarea: javascript_components_autosize_textarea,
    InlineForm: javascript_company_inline_form
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d6d00c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/motto.vue
var motto_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('inline-form', {
    attrs: {
      "company": _vm.company,
      "editable": _vm.editable
    }
  }, [_c('template', {
    slot: "fields"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "v-company-motto"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('activerecord.attributes.company.motto')))]), _vm._v(" "), _c('autosize-textarea', {
    staticClass: "cm-field",
    attrs: {
      "id": "v-company-motto",
      "type": "text",
      "rows": "1",
      "maxlength": "85"
    },
    model: {
      value: (_vm.company.motto),
      callback: function($$v) {
        _vm.company.motto = $$v
      },
      expression: "company.motto"
    }
  })], 1), _vm._v(" "), (_vm.company.motto) ? _c('p', {
    staticClass: "motto"
  }, [_vm._v(_vm._s(_vm.company.motto))]) : _c('p', {
    staticClass: "motto motto--empty"
  }, [_vm._v(_vm._s(_vm.I18n.t('add_a_company_motto')))])], 2)], 1)
}
var motto_staticRenderFns = []
var motto_esExports = { render: motto_render, staticRenderFns: motto_staticRenderFns }
/* harmony default export */ var company_motto = (motto_esExports);
// CONCATENATED MODULE: ./app/javascript/company/motto.vue
function motto_injectStyle (ssrContext) {
  __webpack_require__(267)
}
var motto_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var motto___vue_styles__ = motto_injectStyle
/* scopeId */
var motto___vue_scopeId__ = "data-v-26d6d00c"
/* moduleIdentifier (server only) */
var motto___vue_module_identifier__ = null
var motto_Component = motto_normalizeComponent(
  motto,
  company_motto,
  motto___vue_styles__,
  motto___vue_scopeId__,
  motto___vue_module_identifier__
)

/* harmony default export */ var javascript_company_motto = (motto_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/name.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var company_name = ({
  props: ['id', 'value', 'editable'],
  data: function data() {
    return {
      company: {
        id: this.id,
        name: this.value
      }
    };
  },
  components: {
    InlineForm: javascript_company_inline_form
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c7c62e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/name.vue
var name_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('inline-form', {
    attrs: {
      "company": _vm.company,
      "editable": _vm.editable
    }
  }, [_c('template', {
    slot: "fields"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "v-company-name"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    staticClass: "cm-field",
    attrs: {
      "id": "v-company-name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "name"
  }, [_c('a', {
    attrs: {
      "href": ("/companies/" + (_vm.company.id))
    }
  }, [_vm._v(_vm._s(_vm.company.name))])])], 2)], 1)
}
var name_staticRenderFns = []
var name_esExports = { render: name_render, staticRenderFns: name_staticRenderFns }
/* harmony default export */ var javascript_company_name = (name_esExports);
// CONCATENATED MODULE: ./app/javascript/company/name.vue
function name_injectStyle (ssrContext) {
  __webpack_require__(268)
}
var name_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var name___vue_styles__ = name_injectStyle
/* scopeId */
var name___vue_scopeId__ = "data-v-75c7c62e"
/* moduleIdentifier (server only) */
var name___vue_module_identifier__ = null
var name_Component = name_normalizeComponent(
  company_name,
  javascript_company_name,
  name___vue_styles__,
  name___vue_scopeId__,
  name___vue_module_identifier__
)

/* harmony default export */ var app_javascript_company_name = (name_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/fact.vue
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var fact = ({
  props: ['id', 'companyId', 'header', 'text', 'editable'],
  data: function data() {
    return {
      company: {
        id: this.companyId
      },
      fact: {
        id: this.id,
        header_value: this.header,
        text_value: this.text
      },
      response: null,
      showingForm: false
    };
  },


  computed: {
    isExistingFact: function isExistingFact() {
      // as opposed to sample/placeholder facts
      return !!this.fact.id;
    }
  },

  methods: {
    toggleForm: function toggleForm() {
      this.showingForm = !this.showingForm;
    },
    handleSave: function handleSave() {
      var _this = this;

      if (this.isExistingFact) {
        this.$http.patch('/companies/' + this.company.id, {
          company: {
            facts_attributes: _defineProperty({}, this.fact.id, {
              header: this.fact.header_value,
              text: this.fact.text_value
            })
          }
        }).then(function (response) {
          _this.response = response;
          _this.showingForm = false;
        }, function (response) {
          _this.response = response;
        });
      } else {
        this.$http.post('/companies/' + this.company.id + '/facts', {
          header: this.fact.header_value,
          text: this.fact.text_value
        }).then(function (response) {
          _this.response = response;
          _this.fact.id = response.body.id;
          _this.showingForm = false;
        }, function (response) {
          _this.response = response;
        });
      }
    },
    handleCancel: function handleCancel() {
      var _this2 = this;

      var oldHeader = void 0,
          oldText = void 0;

      if (this.response && this.response.body) {
        if (this.isExistingFact && this.response.body.company) {
          var currentFact = this.response.body.company.facts.find(function (fact) {
            return fact.id === _this2.fact.id;
          });
          oldHeader = currentFact.header;
          oldText = currentFact.text;
        } else {
          oldHeader = this.response.body.header;
          oldText = this.response.body.text;
        }
      } else {
        oldHeader = this.header;
        oldText = this.text;
      }

      this.fact.header_value = oldHeader;
      this.fact.text_value = oldText;

      this.toggleForm();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2681498f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/fact.vue
var fact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fact"
  }, [(_vm.showingForm && _vm.editable) ? _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "f_header"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('question_title')))]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fact.header_value),
      expression: "fact.header_value"
    }],
    staticClass: "cm-field val-required",
    attrs: {
      "type": "text",
      "id": "f_header",
      "required": "true",
      "placeholder": _vm.I18n.t('question_title')
    },
    domProps: {
      "value": (_vm.fact.header_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fact.header_value = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "f_text"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('your_answer')))]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fact.text_value),
      expression: "fact.text_value"
    }],
    staticClass: "cm-field val-required",
    attrs: {
      "type": "text",
      "id": "f_text",
      "required": "true",
      "placeholder": _vm.I18n.t('your_answer')
    },
    domProps: {
      "value": (_vm.fact.text_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fact.text_value = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-action-row"
  }, [_c('input', {
    staticClass: "cm-button save-changes",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.I18n.t('save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleSave($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "cancel-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("cancel")))]), _vm._v(" "), (_vm.isExistingFact) ? _c('a', {
    staticClass: "delete-link",
    attrs: {
      "rel": "nofollow",
      "data-method": "delete",
      "href": ("/companies/" + (_vm.company.id) + "/facts/" + (_vm.fact.id))
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.I18n.t('delete_fact')))])]) : _vm._e()])]) : [_c('div', {
    staticClass: "fact__header"
  }, [_vm._v(_vm._s(_vm.fact.header_value))]), _vm._v(" "), _c('div', {
    staticClass: "fact__text"
  }, [_c('span', [_vm._v(_vm._s(_vm.fact.text_value))]), _vm._v(" "), (_vm.editable) ? _c('button', {
    staticClass: "edit-button ss-icon",
    on: {
      "click": _vm.toggleForm
    }
  }, [_vm._v("compose")]) : _vm._e()])]], 2)
}
var fact_staticRenderFns = []
var fact_esExports = { render: fact_render, staticRenderFns: fact_staticRenderFns }
/* harmony default export */ var company_fact = (fact_esExports);
// CONCATENATED MODULE: ./app/javascript/company/fact.vue
function fact_injectStyle (ssrContext) {
  __webpack_require__(270)
}
var fact_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var fact___vue_styles__ = fact_injectStyle
/* scopeId */
var fact___vue_scopeId__ = "data-v-2681498f"
/* moduleIdentifier (server only) */
var fact___vue_module_identifier__ = null
var fact_Component = fact_normalizeComponent(
  fact,
  company_fact,
  fact___vue_styles__,
  fact___vue_scopeId__,
  fact___vue_module_identifier__
)

/* harmony default export */ var javascript_company_fact = (fact_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/tag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var tag = ({
  props: {
    label: {
      type: String
    },
    value: {
      type: String,
      required: true
    },
    theme: {
      type: String
      // [panda]
    }
  },

  data: function data() {
    return { isFocused: false };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f02b9c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/tag.vue
var tag_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-tag",
    class: ( _obj = {
      "cm-tag--is-focused": _vm.isFocused
    }, _obj[("cm-tag--" + _vm.theme)] = _vm.theme, _obj )
  }, [_vm._t("default"), _vm._v("\n  " + _vm._s(_vm.label || _vm.value) + "\n  "), _c('button', {
    staticClass: "cm-tag__close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('delete', _vm.value)
      },
      "focus": function($event) {
        _vm.isFocused = true
      },
      "blur": function($event) {
        _vm.isFocused = false
      }
    }
  }, [_vm._v("close")])], 2)
  var _obj;
}
var tag_staticRenderFns = []
var tag_esExports = { render: tag_render, staticRenderFns: tag_staticRenderFns }
/* harmony default export */ var components_tag = (tag_esExports);
// CONCATENATED MODULE: ./app/javascript/components/tag.vue
function tag_injectStyle (ssrContext) {
  __webpack_require__(273)
}
var tag_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var tag___vue_styles__ = tag_injectStyle
/* scopeId */
var tag___vue_scopeId__ = "data-v-15f02b9c"
/* moduleIdentifier (server only) */
var tag___vue_module_identifier__ = null
var tag_Component = tag_normalizeComponent(
  tag,
  components_tag,
  tag___vue_styles__,
  tag___vue_scopeId__,
  tag___vue_module_identifier__
)

/* harmony default export */ var javascript_components_tag = (tag_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/select.vue
var select__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_select = ({
  components: {
    CmTag: javascript_components_tag
  },

  props: {
    options: {
      type: Array
      // [{ name: String, value: [String, Number] }]
    },
    multiple: {
      type: Boolean
    },
    includeSearch: {
      type: Boolean
    },
    name: {
      type: String
    },
    nullLabel: {
      type: String
    },
    label: {
      type: String
    },
    value: {
      type: [String, Array]
    },
    compact: {
      type: Boolean
    },
    showTags: {
      type: Boolean
    }
  },

  data: function data() {
    return {
      isOpen: false,
      searchText: ""
    };
  },


  computed: {
    allOptions: function allOptions() {
      var _this = this;

      var mergedArray = this.nullOption ? [this.nullOption].concat(_toConsumableArray(this.options)) : this.options;

      return mergedArray.map(function (option) {
        return select__extends({}, option, {
          isSelected: _this.multiple ? _this.value.includes(option.value) : option.value === _this.value
        });
      });
    },
    filteredOptions: function filteredOptions() {
      var _this2 = this;

      if (this.searchText) {
        return this.allOptions.filter(function (option) {
          return option.label.toLowerCase().includes(_this2.searchText.toLowerCase());
        });
      } else {
        return this.allOptions;
      }
    },
    nullOption: function nullOption() {
      if (this.nullLabel) {
        return {
          label: this.nullLabel,
          value: null
        };
      }
    },
    currentOption: function currentOption() {
      var _this3 = this;

      if (!this.multiple) {
        return this.options.find(function (option) {
          return option.value === _this3.value;
        });
      }
    },
    selectedOptions: function selectedOptions() {
      var _this4 = this;

      if (this.multiple) {
        return this.options.filter(function (option) {
          return _this4.value.includes(option.value);
        });
      }
    },
    buttonLabel: function buttonLabel() {
      return this.currentOption ? this.currentOption.label : this.nullLabel || this.label;
    }
  },

  methods: {
    handleButtonFocus: function handleButtonFocus() {
      if (!this.isOpen) {
        var targets = [this.$el.querySelector(".cm-select__search-input"), this.$el.querySelector(".cm-select__item--is-selected"), this.$el.querySelector(".cm-select__item")].filter(Boolean);

        targets[0].focus();
      }
    },
    handleFocusin: function handleFocusin(e) {
      this.isOpen = true;
    },
    handleFocusout: function handleFocusout(e) {
      if (!this.$el.contains(e.relatedTarget)) {
        this.isOpen = false;
      }
    },
    handleChange: function handleChange(e, value) {
      if (value === null) {
        this.resetValue();
      } else {
        var newValue = void 0;

        if (this.multiple) {
          if (e.target.checked) {
            newValue = [].concat(_toConsumableArray(this.value), [value]);
          } else {
            newValue = this.value.filter(function (el) {
              return el !== value;
            });
          }
        } else {
          newValue = value;
        }

        this.$emit("input", newValue);
      }

      this.$refs.popup.scrollTop = 0; // chrome tries to scroll unscrollable divs to surface the newly-focused element...
    },
    removeTag: function removeTag(value) {
      var newValue = this.value.filter(function (el) {
        return el !== value;
      });
      this.$emit("input", newValue);
    },
    resetValue: function resetValue() {
      this.$emit("input", this.multiple ? [] : null);
    },
    handleOptionClick: function handleOptionClick(e) {
      var _this5 = this;

      // send close after focus event. closes when we want—
      // but also allows user to use ↑↓ keys to re-open the select
      if (this.isOpen && !this.multiple) {
        window.setTimeout(function () {
          _this5.isOpen = false;
        }, 10);
      } else {
        this.isOpen = true;
      }
    },
    selectSibling: function selectSibling(direction) {
      var focusedElement = document.activeElement;
      var itemList = [].concat(_toConsumableArray(this.$el.querySelectorAll(".cm-select__item")));
      var selectedItem = this.$el.querySelector(".cm-select__item--is-selected");
      var currentIndex = itemList.indexOf(selectedItem);
      var newIndex = (currentIndex + direction + itemList.length) % itemList.length;

      if (!multiple) {
        itemList[newIndex].querySelector("input").click();
      }
      if (focusedElement === this.$refs.searchInput) {
        focusedElement.focus();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25221494","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/select.vue
var select_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-select",
    class: {
      'cm-select--compact': _vm.compact,
      'cm-select--tags': _vm.showTags
    },
    on: {
      "focusin": _vm.handleFocusin,
      "focusout": _vm.handleFocusout
    }
  }, [(_vm.showTags && _vm.multiple) ? _c('div', {
    staticClass: "cm-select__input-container"
  }, [_c('div', {
    staticClass: "cm-select__input-wrapper"
  }, [_vm._l((_vm.selectedOptions), function(tag) {
    return _c('cm-tag', {
      key: tag,
      staticClass: "cm-select__tag",
      attrs: {
        "value": tag.value,
        "label": tag.label,
        "theme": "panda"
      },
      on: {
        "delete": _vm.removeTag
      }
    })
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "searchInput",
    staticClass: "cm-select__input-container__search-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.buttonLabel
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.selectSibling(-1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.selectSibling(1)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })], 2)]) : _c('button', {
    staticClass: "cm-select__button",
    attrs: {
      "type": "button"
    },
    on: {
      "focus": _vm.handleButtonFocus,
      "click": _vm.handleButtonFocus
    }
  }, [_vm._v("\n    " + _vm._s(_vm.buttonLabel) + "\n    "), _c('div', {
    staticClass: "cm-select__button-arrow"
  }, [_vm._v("\n      " + _vm._s(_vm.isOpen ? "navigateup" : "navigatedown") + "\n    ")])]), _vm._v(" "), _c('div', {
    ref: "popup",
    staticClass: "cm-select__popup",
    class: {
      'cm-select__popup--is-open': _vm.isOpen
    }
  }, [(_vm.includeSearch && !_vm.showTags) ? _c('div', {
    staticClass: "cm-select__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "searchInput",
    staticClass: "cm-select__search-input",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.selectSibling(-1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.selectSibling(1)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cm-select__items"
  }, _vm._l((_vm.filteredOptions), function(option) {
    return _c('label', {
      key: option.value,
      staticClass: "cm-select__item",
      class: {
        'cm-select__item--is-selected': option.isSelected
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
        },
        "click": _vm.handleOptionClick
      }
    }, [_c('input', {
      staticClass: "cm-select__item-input",
      attrs: {
        "type": _vm.multiple ? 'checkbox' : 'radio',
        "name": _vm.name
      },
      domProps: {
        "value": option.value,
        "checked": option.isSelected
      },
      on: {
        "change": function($event) {
          _vm.handleChange($event, option.value)
        },
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }), _vm._v("\n        " + _vm._s(option.label) + "\n        "), (option.isSelected) ? _c('span', {
      staticClass: "cm-select__check ss-icon"
    }, [_vm._v("check")]) : _vm._e()])
  }))])])
}
var select_staticRenderFns = []
var select_esExports = { render: select_render, staticRenderFns: select_staticRenderFns }
/* harmony default export */ var javascript_components_select = (select_esExports);
// CONCATENATED MODULE: ./app/javascript/components/select.vue
function select_injectStyle (ssrContext) {
  __webpack_require__(272)
}
var select_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var select___vue_styles__ = select_injectStyle
/* scopeId */
var select___vue_scopeId__ = "data-v-25221494"
/* moduleIdentifier (server only) */
var select___vue_module_identifier__ = null
var select_Component = select_normalizeComponent(
  components_select,
  javascript_components_select,
  select___vue_styles__,
  select___vue_scopeId__,
  select___vue_module_identifier__
)

/* harmony default export */ var app_javascript_components_select = (select_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/breakfast-food.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var breakfast_food = ({
  components: {
    CmSelect: app_javascript_components_select
  },

  props: ["company", "breakfastFoods", "editable"],

  data: function data() {
    return {
      value: this.company.breakfast_food,
      showingForm: false,
      breakfastFoods: this.breakfastFoods
    };
  },

  computed: {
    options: function options() {
      var _this = this;

      return Object.keys(this.breakfastFoods).map(function (key) {
        return {
          label: _this.breakfastFoods[key],
          value: key
        };
      });
    }
  },
  methods: {
    showForm: function showForm() {
      this.showingForm = !this.showingForm;
    },
    saveForm: function saveForm() {
      var _this2 = this;

      var attrs = {
        breakfast_food: this.value
      };

      this.$http.patch("/companies/" + this.company.slug, { company: attrs }).then(function (response) {
        // TODO Emit updated data to parent?
        _this2.showingForm = false;
      }, function (response) {
        // TODO Display error messages
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e0ad71a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/breakfast-food.vue
var breakfast_food_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fact"
  }, [(_vm.showingForm && _vm.editable) ? _c('form', [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "breakfast-foods"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("activerecord.attributes.company.breakfast_food")))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('CmSelect', {
    staticClass: "breakfast-foods__select",
    attrs: {
      "name": "breakfast-foods",
      "options": _vm.options,
      "label": _vm.I18n.t('choose_breakfast_food')
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-action-row"
  }, [_c('input', {
    staticClass: "cm-button save-changes",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.I18n.t('save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveForm($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "cancel-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('cancel')))])])]) : [_c('div', {
    staticClass: "fact__header"
  }, [_vm._v(_vm._s(_vm.I18n.t("activerecord.attributes.company.breakfast_food")))]), _vm._v(" "), _c('div', {
    staticClass: "fact__text"
  }, [_c('span', [_vm._v(_vm._s(_vm.value ? _vm.I18n.t('breakfast_foods.' + _vm.value) : _vm.I18n.t('choose_breakfast_food')))]), _vm._v(" "), (_vm.editable) ? _c('button', {
    staticClass: "edit-button ss-icon",
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v("compose")]) : _vm._e()])]], 2)
}
var breakfast_food_staticRenderFns = []
var breakfast_food_esExports = { render: breakfast_food_render, staticRenderFns: breakfast_food_staticRenderFns }
/* harmony default export */ var company_breakfast_food = (breakfast_food_esExports);
// CONCATENATED MODULE: ./app/javascript/company/breakfast-food.vue
function breakfast_food_injectStyle (ssrContext) {
  __webpack_require__(271)
}
var breakfast_food_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var breakfast_food___vue_styles__ = breakfast_food_injectStyle
/* scopeId */
var breakfast_food___vue_scopeId__ = "data-v-6e0ad71a"
/* moduleIdentifier (server only) */
var breakfast_food___vue_module_identifier__ = null
var breakfast_food_Component = breakfast_food_normalizeComponent(
  breakfast_food,
  company_breakfast_food,
  breakfast_food___vue_styles__,
  breakfast_food___vue_scopeId__,
  breakfast_food___vue_module_identifier__
)

/* harmony default export */ var javascript_company_breakfast_food = (breakfast_food_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/facts.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var facts = ({
  components: { CompanyFact: javascript_company_fact, BreakfastFood: javascript_company_breakfast_food },

  props: ['company', 'editable', 'breakfastFoods'],

  data: function data() {
    return {
      showingForm: false
    };
  },


  methods: {
    toggleForm: function toggleForm() {
      this.showingForm = !this.showingForm;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a558ed18","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/facts.vue
var facts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facts"
  }, [(_vm.company.breakfast_food || _vm.editable) ? _c('breakfast-food', _vm._b({}, 'breakfast-food', {
    company: _vm.company,
    editable: _vm.editable,
    breakfastFoods: _vm.breakfastFoods
  }, false)) : _vm._e(), _vm._v(" "), _vm._l((_vm.company.facts), function(fact) {
    return _c('company-fact', {
      attrs: {
        "editable": _vm.editable,
        "companyId": _vm.company.slug,
        "id": fact.id,
        "header": fact.header,
        "text": fact.text
      }
    })
  }), _vm._v(" "), (_vm.editable) ? _c('span', {
    staticClass: "small-icon-btn repeat-btn toggle-fun-fact",
    on: {
      "click": _vm.toggleForm
    }
  }, [_c('span', {
    staticClass: "ss-icon is-big"
  }, [_vm._v("plus")]), _c('a', {
    staticClass: "add_fields"
  }, [_vm._v(_vm._s(_vm.I18n.t('create_your_own_question')))])]) : _vm._e(), _vm._v(" "), (_vm.editable && _vm.showingForm) ? _c('form', {
    attrs: {
      "method": "post",
      "action": ("/companies/" + (_vm.company.slug) + "/facts")
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "f_header"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('question_title')))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "f_text"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('your_answer')))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('footer', [_c('input', {
    staticClass: "cm-button save-changes",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.I18n.t('save')
    }
  })])]) : _vm._e()], 2)
}
var facts_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "cm-field val-required",
    attrs: {
      "type": "text",
      "name": "fact[header]",
      "id": "f_header",
      "required": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "cm-field val-required",
    attrs: {
      "type": "text",
      "name": "fact[text]",
      "id": "f_text",
      "required": "true"
    }
  })])
}]
var facts_esExports = { render: facts_render, staticRenderFns: facts_staticRenderFns }
/* harmony default export */ var company_facts = (facts_esExports);
// CONCATENATED MODULE: ./app/javascript/company/facts.vue
function facts_injectStyle (ssrContext) {
  __webpack_require__(269)
}
var facts_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var facts___vue_styles__ = facts_injectStyle
/* scopeId */
var facts___vue_scopeId__ = "data-v-a558ed18"
/* moduleIdentifier (server only) */
var facts___vue_module_identifier__ = null
var facts_Component = facts_normalizeComponent(
  facts,
  company_facts,
  facts___vue_styles__,
  facts___vue_scopeId__,
  facts___vue_module_identifier__
)

/* harmony default export */ var javascript_company_facts = (facts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/like.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var like = ({
  props: ['company'],

  data: function data() {
    return {
      liked: this.company.liked,
      likeLoading: false
    };
  },


  methods: {
    toggleLike: function toggleLike() {
      var _this = this;

      this.likeLoading = true;

      if (!this.liked) {
        window.makeItRainHearts();
      }

      this.$http.put('/companies/' + this.company.slug + '/like.json').then(function (response) {
        _this.liked = !_this.liked;

        _this.likeLoading = false;
      }, function (response) {
        // TODO Display error messages
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cd953a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/like.vue
var like_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: [_vm.likeLoading ? 'is-flashing' : '', 'cm-button', 'is-inverted'],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleLike($event)
      }
    }
  }, [(_vm.liked) ? [_vm._v("\n    Unlike\n  ")] : [_vm._v("\n    Like\n  ")]], 2)
}
var like_staticRenderFns = []
var like_esExports = { render: like_render, staticRenderFns: like_staticRenderFns }
/* harmony default export */ var company_like = (like_esExports);
// CONCATENATED MODULE: ./app/javascript/company/like.vue
function like_injectStyle (ssrContext) {
  __webpack_require__(274)
}
var like_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var like___vue_styles__ = like_injectStyle
/* scopeId */
var like___vue_scopeId__ = "data-v-49cd953a"
/* moduleIdentifier (server only) */
var like___vue_module_identifier__ = null
var like_Component = like_normalizeComponent(
  like,
  company_like,
  like___vue_styles__,
  like___vue_scopeId__,
  like___vue_module_identifier__
)

/* harmony default export */ var javascript_company_like = (like_Component.exports);

// CONCATENATED MODULE: ./app/javascript/lib/elastic-search.js
var elastic_search__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// TODO: add support for from / size params
var elastic_search_search = function search(options) {
  var url = window.location.origin + "/" + options.index + "/_search";
  var requestBody = elastic_search__extends({ size: options.size, from: options.from }, options.body);

  return fetch(url, {
    method: 'POST',
    headers: { "Content-type": "application/json" },
    body: new Blob([JSON.stringify(requestBody, null, 2)], { type: 'application/json' })
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data;
  });
};

var preprocessQueryString = function preprocessQueryString(input) {
  return input.replace(/[\<\>]/g, '') // remove banned chars
  .replace(/([\+\-\=\!\(\){\}\[\]\^\"\~\*\?\:\/\\])/g, '\\$1') // escape reserved chars
  .trim() // remove outer spaces
  .replace(/ +|$/g, '~ ') // add fuzzies but ignore double spaces
  ;
};

/* harmony default export */ var elastic_search = (elastic_search_search);
// EXTERNAL MODULE: ./node_modules/url-search-params-polyfill/index.js
var url_search_params_polyfill = __webpack_require__(276);
var url_search_params_polyfill_default = /*#__PURE__*/__webpack_require__.n(url_search_params_polyfill);

// CONCATENATED MODULE: ./app/javascript/lib/url.js


var getURLParams = function getURLParams() {
  return new URLSearchParams(window.location.search);
};

var stringifyURLParams = function stringifyURLParams(parameters) {
  var paramsInstance = new URLSearchParams();
  Object.entries(parameters).forEach(function (entry) {
    return paramsInstance.append(entry[0], entry[1]);
  });
  return paramsInstance.toString();
};

var greenhouseShortRegex = /^http:\/\/grnh\.se\/([a-z|0-9]{1,})$/i;
var greenhouseRegex = /^https?:\/\/(?:boards.(greenhouse).io)\/([a-z0-9_-]{1,})(?:\?gh_src=([a-z|0-9]*))?\/?$/i;
var leverRegex = /^https?:\/\/(?:jobs.(lever).co)\/([^\/]{1,})\/?$/i;

var isGreenhouseShortURL = function isGreenhouseShortURL(url) {
  return greenhouseShortRegex.test(url);
};

var getAtsDataFromURL = function getAtsDataFromURL(url) {
  if (url) {
    if (isGreenhouseShortURL(url)) {
      var _groups = url.match(greenhouseShortRegex);

      return { provider: 'greenhouse', username: undefined, referral: _groups[1] };
    }

    var tests = [greenhouseRegex, leverRegex];

    var match = tests.find(function (test) {
      return test.test(url);
    });

    var groups = url.match(match);

    return { provider: groups[1], username: groups[2], referral: groups[3] };
  }
};
// EXTERNAL MODULE: ./node_modules/date-fns/esm/index.js + 312 modules
var esm = __webpack_require__(49);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/jobs.vue
function jobs__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var jobs = ({
  props: ['company', 'editable'],

  data: function data() {
    return {
      response: null,

      page: 0,
      size: 5
    };
  },
  created: function created() {
    var _this = this;

    this.fetchResults().then(function (response) {
      _this.response = response;
    }).catch(function (error) {
      console.error(error);
    }).then(function () {
      _this.isLoading = false;
    });
  },


  computed: {
    query: function query() {
      return {
        size: this.size,
        sort: [{ created_at: "desc" }, "_score"],
        query: {
          bool: {
            must: [{ match: { visible: true } }, { match: { "company.application_status": "published" } }, { match: { "company.id": this.company.id } }]
          }
        }
      };
    },
    jobs: function jobs() {
      if (!this.response) return [];
      return this.response.hits.hits.map(function (hit) {
        return hit._source;
      });
    },
    totalJobCount: function totalJobCount() {
      return this.response ? this.response.hits.total : 0;
    },
    atsProvider: function atsProvider() {
      return this.company.ats_provider ? this.company.ats_provider.toLowerCase().split(' ').map(function (s) {
        return s.charAt(0).toUpperCase() + s.substring(1);
      }).join(' ') : null;
    }
  },

  methods: {
    fetchResults: function fetchResults() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      return elastic_search({
        index: "jobs",
        size: this.size,
        from: this.size * page,
        body: this.query
      });
    },
    fetchNextPage: function fetchNextPage() {
      var _this2 = this;

      this.fetchResults(this.page + 1).then(function (response) {
        var _response$hits$hits;

        (_response$hits$hits = _this2.response.hits.hits).push.apply(_response$hits$hits, jobs__toConsumableArray(response.hits.hits));

        _this2.page++;
      }).catch(function (error) {
        console.error(error);
      }).then(function () {
        _this2.isLoading = false;
      });
    },
    fetchAll: function fetchAll() {
      var _this3 = this;

      elastic_search({
        index: "jobs",
        size: 9999,
        body: this.query
      }).then(function (response) {
        _this3.response = response;
      }).catch(function (error) {
        console.error(error);
      }).then(function () {
        _this3.isLoading = false;
      });
    },
    formatCommitment: function formatCommitment(str) {
      return str.split('_').map(function (s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
      }).join('-');
    },
    formatTimeAgo: function formatTimeAgo(time) {
      return Object(esm["b" /* formatDistanceStrict */])(Object(esm["c" /* parseISO */])(time), new Date());
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae4b6b0e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/jobs.vue
var jobs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.totalJobCount > 0 || _vm.editable) ? _c('section', {
    staticClass: "company__section company__section--work"
  }, [_c('header', [_c('section', [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v(_vm._s(_vm.totalJobCount === 1 ?
    _vm.I18n.t('job_openings_at_company', {
      name: _vm.company.name
    }) :
    _vm.I18n.t('num_job_openings_at_company', {
      name: _vm.company.name,
      num: _vm.totalJobCount
    })))]), _vm._v(" "), (_vm.editable) ? _c('span', [_c('a', {
    staticClass: "pill-button",
    attrs: {
      "href": ("/companies/" + (_vm.company.slug) + "/jobs/new")
    }
  }, [_c('span', {
    staticClass: "pill-button__text"
  }, [_vm._v(_vm._s(_vm.I18n.t('create_job_post')))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.atsProvider) ? _c('a', {
    staticClass: "pill-button",
    attrs: {
      "href": ("/companies/" + (_vm.company.slug) + "/disconnect_ats"),
      "rel": "nofollow",
      "data-method": "post",
      "data-confirm": _vm.I18n.t('confirm_gallery_disconnect')
    }
  }, [_c('span', {
    staticClass: "pill-button__text"
  }, [_vm._v(_vm._s(("Disconnect " + _vm.atsProvider)))]), _vm._v(" "), _vm._m(1)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "jobs"
  }, _vm._l((_vm.jobs), function(job, n) {
    return _c('div', {
      staticClass: "company__job"
    }, [(_vm.editable) ? _c('a', {
      staticClass: "company__job__edit",
      attrs: {
        "href": ("/companies/" + (_vm.company.slug) + "/jobs/" + (job.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "ss-icon"
    }, [_vm._v("compose")])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "company__job__link",
      attrs: {
        "href": ("/companies/" + (_vm.company.slug) + "/jobs/" + (job.id) + "/click")
      }
    }, [_c('div', {
      staticClass: "company__job__info"
    }, [_c('span', {
      staticClass: "company__job__title"
    }, [_vm._v(_vm._s(job.title))]), _vm._v(" "), _c('time', {
      staticClass: "company__job__timestamp",
      attrs: {
        "datetime": job.created_at
      }
    }, [_vm._v(_vm._s(_vm.formatTimeAgo(job.created_at)) + " ago")])]), _vm._v(" "), _c('div', {
      staticClass: "company__job__details"
    }, [_c('div', {
      staticClass: "company__job__location-details"
    }, [(job.location && !job.remote) ? _c('div', {
      staticClass: "company__job__location"
    }, [_vm._v(_vm._s(job.location))]) : _vm._e(), _vm._v(" "), (job.remote) ? _c('div', {
      staticClass: "company__job__location company__job__location--remote"
    }, [_vm._v("Remote")]) : (job.remote_friendly) ? _c('div', {
      staticClass: "company__job__location company__job__location--remote"
    }, [_vm._v("Remote Friendly")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "company__job__location__icon"
    }, [_vm._v(_vm._s(job.location && !job.remote ? "location" : "wifi"))])]), _vm._v(" "), _c('span', {
      staticClass: "company__job__hours"
    }, [_vm._v(_vm._s(_vm.formatCommitment(job.commitment.name)))])])])])
  })), _vm._v(" "), (_vm.jobs.length < _vm.totalJobCount) ? _c('footer', [(_vm.editable) ? [_c('button', {
    staticClass: "cm-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fetchNextPage()
      }
    }
  }, [_vm._v("More")]), _vm._v(" "), _c('button', {
    staticClass: "cm-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fetchAll()
      }
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('view_all_num_jobs', {
    num: _vm.totalJobCount
  })))])] : [_c('a', {
    staticClass: "cm-button",
    attrs: {
      "href": ("/jobs?company_id=" + (_vm.company.id))
    }
  }, [_vm._v("\n        " + _vm._s(_vm.I18n.t('view_all_num_jobs', {
    num: _vm.totalJobCount
  })) + "\n      ")])]], 2) : _vm._e()]) : _vm._e()
}
var jobs_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pill-button__icon"
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("add")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pill-button__icon"
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("delete")])])
}]
var jobs_esExports = { render: jobs_render, staticRenderFns: jobs_staticRenderFns }
/* harmony default export */ var company_jobs = (jobs_esExports);
// CONCATENATED MODULE: ./app/javascript/company/jobs.vue
function jobs_injectStyle (ssrContext) {
  __webpack_require__(275)
}
var jobs_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var jobs___vue_styles__ = jobs_injectStyle
/* scopeId */
var jobs___vue_scopeId__ = "data-v-ae4b6b0e"
/* moduleIdentifier (server only) */
var jobs___vue_module_identifier__ = null
var jobs_Component = jobs_normalizeComponent(
  jobs,
  company_jobs,
  jobs___vue_styles__,
  jobs___vue_scopeId__,
  jobs___vue_module_identifier__
)

/* harmony default export */ var javascript_company_jobs = (jobs_Component.exports);

// EXTERNAL MODULE: ./app/javascript/components/chosen-field.vue + 2 modules
var chosen_field = __webpack_require__(103);

// EXTERNAL MODULE: ./app/javascript/components/mixins/form-options.js
var form_options = __webpack_require__(51);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/image-field.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var image_field = ({
  mixins: [form_options["a" /* default */]],

  props: {
    editable: {
      default: true
    },
    removable: {
      default: true
    },
    resizable: {
      default: false
    },
    width: String,
    height: String,
    message: {
      default: null
    },
    recommendations: {
      default: null
    },
    required: {
      default: false
    }
  },

  data: function data() {
    return {
      showDropzone: false,
      hasValue: !!this.value,
      currentValue: this.value,
      currentMessage: this.message,
      isFull: false,
      isRequired: this.required
    };
  },
  mounted: function mounted() {
    if (typeof I18n != 'undefined') {
      this.currentMessage = I18n.t('drop_a_file_here_or_click_to_browse');
    } else {
      this.currentMessage = 'Drop a file here or click to browse';
    }

    if (this.resizable == false) {
      this.isFull = false;
    } else if (this.hasValue) {
      this.isFull = true;
    } else {
      this.isFull = false;
    }

    if (this.hasValue) {
      this.isRequired = false;
    }
  },


  computed: {
    imageFilename: function imageFilename() {
      if (this.currentValue && !this.currentValue.match(/^data:.+/)) return this.currentValue.split("/").pop();
    },
    showControls: function showControls() {
      return this.currentValue && this.hasValue;
    },
    attributeHuman: function attributeHuman() {
      return this.attribute.split(',')[0];
    }
  },

  methods: {
    toggleDropzone: function toggleDropzone() {
      this.showDropzone = !this.showDropzone;
      this.$refs.fileSelect.click();

      if (this.removable) {
        this.removeFile();
      }

      if (this.resizable) {
        this.isFull = false;
      }

      if (this.required) {
        this.isRequired = true;
      }
    },
    readFile: function readFile(event) {
      var _this = this;

      var files = event.target.files;

      if (files && files[0]) {
        if (this.allowedType(files[0])) {
          var reader = new FileReader();

          reader.onload = function (e) {
            var imageUrl = e.target.result;

            _this.$refs.img.setAttribute('src', imageUrl);
            _this.updateValue(imageUrl);
          };

          reader.readAsDataURL(files[0]);

          this.$el.querySelector('.image-field__remove_file').value = '';

          this.$emit('readFile', this.paramName, files[0]);
        } else {
          if (typeof I18n != 'undefined') {
            this.currentMessage = 'Please use a JPG, PNG, or GIF';
          } else {
            this.currentMessage = I18n.t('please_use_a_jpg_png_or_gif');
          }
        }
      }

      if (this.resizable) {
        this.isFull = true;
      }
    },
    removeFile: function removeFile() {
      this.$el.querySelector('input[type="file"]').value = '';
      this.$el.querySelector('.image-field__remove_file').value = '1';
      this.updateValue(null);
    },
    removeParamName: function removeParamName() {
      return this.paramName.replace(/\[(?!.*\[)/, '[remove_');
    },
    updateValue: function updateValue(value) {
      this.hasValue = !!value;
      this.showDropzone = !value;
      this.currentValue = value;
      this.$emit('input', value);
    },
    allowedType: function allowedType(file) {
      var allowedTypes = ['jpg', 'jpeg', 'png', 'gif'];
      var extension = file.name.split('.').pop().toLowerCase();

      return allowedTypes.indexOf(extension) > -1;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2601cc0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/image-field.vue
var image_field_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-field",
    class: {
      'full': _vm.isFull
    },
    style: ({
      width: _vm.width,
      height: _vm.height
    })
  }, [(_vm.editable) ? _c('div', {
    staticClass: "image-field__dropzone"
  }, [_c('div', {
    staticClass: "image-field__prompt dz-message"
  }, [_c('span', {
    staticClass: "ss-icon"
  }, [_vm._v("upload")]), _vm._v(" "), _c('span', {
    staticClass: "image-field__message"
  }, [_vm._v(_vm._s(_vm.currentMessage))]), _vm._v(" "), (_vm.recommendations) ? _c('span', {
    staticClass: "image-field__recommendations"
  }, [_vm._v(_vm._s(_vm.recommendations))]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "fileSelect",
    staticClass: "image-field__file",
    class: {
      'val-required': _vm.isRequired
    },
    attrs: {
      "id": _vm.inputId,
      "name": _vm.paramName,
      "type": "file",
      "accept": "image/*",
      "required": _vm.isRequired
    },
    on: {
      "change": _vm.readFile
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "image-field__remove_file",
    attrs: {
      "type": "hidden",
      "name": _vm.removeParamName()
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue && !_vm.showDropzone),
      expression: "currentValue && !showDropzone"
    }],
    ref: "img",
    staticClass: "image-field__preview",
    attrs: {
      "src": _vm.currentValue
    }
  })]), _vm._v(" "), (_vm.showControls) ? _c('div', {
    staticClass: "image-field__controls"
  }, [(_vm.editable) ? _c('button', {
    staticClass: "image-field__edit ss-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleDropzone($event)
      }
    }
  }, [_vm._v("upload")]) : _vm._e(), _vm._v(" "), (_vm.editable && _vm.removable) ? _c('button', {
    staticClass: "image-field__remove ss-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeFile($event)
      }
    }
  }, [_vm._v("delete")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
}
var image_field_staticRenderFns = []
var image_field_esExports = { render: image_field_render, staticRenderFns: image_field_staticRenderFns }
/* harmony default export */ var components_image_field = (image_field_esExports);
// CONCATENATED MODULE: ./app/javascript/components/image-field.vue
function image_field_injectStyle (ssrContext) {
  __webpack_require__(277)
}
var image_field_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var image_field___vue_styles__ = image_field_injectStyle
/* scopeId */
var image_field___vue_scopeId__ = "data-v-e2601cc0"
/* moduleIdentifier (server only) */
var image_field___vue_module_identifier__ = null
var image_field_Component = image_field_normalizeComponent(
  image_field,
  components_image_field,
  image_field___vue_styles__,
  image_field___vue_scopeId__,
  image_field___vue_module_identifier__
)

/* harmony default export */ var javascript_components_image_field = (image_field_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/multiple-image-field.vue
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var multiple_image_field = ({
  mixins: [form_options["a" /* default */]],
  props: {
    editable: {
      default: true
    },
    removable: {
      default: true
    },
    width: String,
    height: String,
    values: {
      type: Array
    }
  },
  components: {
    ImageField: javascript_components_image_field
  },
  mounted: function mounted() {
    if (this.values.length > 0) {
      this.imageCount = this.values.length;
    } else {
      this.imageCount = 1;
    }
  },
  data: function data() {
    return {
      imageCount: 1
    };
  },

  methods: {
    addImageField: function addImageField() {
      this.imageCount = this.imageCount + 1;
    },
    humanAttribute: function humanAttribute(n) {
      return this.attribute + ',' + (n - 1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6e6de3","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/multiple-image-field.vue
var multiple_image_field_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiple-image-field"
  }, [_vm._l((_vm.imageCount), function(n) {
    return [_c('image-field', {
      attrs: {
        "model": _vm.model,
        "attribute": _vm.humanAttribute(n),
        "height": _vm.height,
        "value": _vm.values[n - 1]
      }
    }, [_vm._t("default")], 2)]
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.addImageField
    }
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("plus")]), _vm._v(" New image")])], 2)
}
var multiple_image_field_staticRenderFns = []
var multiple_image_field_esExports = { render: multiple_image_field_render, staticRenderFns: multiple_image_field_staticRenderFns }
/* harmony default export */ var components_multiple_image_field = (multiple_image_field_esExports);
// CONCATENATED MODULE: ./app/javascript/components/multiple-image-field.vue
function multiple_image_field_injectStyle (ssrContext) {
  __webpack_require__(278)
}
var multiple_image_field_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var multiple_image_field___vue_styles__ = multiple_image_field_injectStyle
/* scopeId */
var multiple_image_field___vue_scopeId__ = "data-v-1c6e6de3"
/* moduleIdentifier (server only) */
var multiple_image_field___vue_module_identifier__ = null
var multiple_image_field_Component = multiple_image_field_normalizeComponent(
  multiple_image_field,
  components_multiple_image_field,
  multiple_image_field___vue_styles__,
  multiple_image_field___vue_scopeId__,
  multiple_image_field___vue_module_identifier__
)

/* harmony default export */ var javascript_components_multiple_image_field = (multiple_image_field_Component.exports);

// EXTERNAL MODULE: ./app/javascript/components/location-field.vue + 2 modules
var location_field = __webpack_require__(64);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/location-fields.vue
var location_fields__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var location_fields = ({
  props: {
    company_data: {
      required: true
    }
  },

  data: function data() {
    var company = JSON.parse(this.company_data);
    company.locations = company.locations.map(function (l, i) {
      return location_fields__extends({}, l, {
        _destroy: 0,
        index: i
      });
    });

    return {
      company: company
    };
  },

  components: {
    locationField: location_field["a" /* default */]
  },

  mounted: function mounted() {
    if (this.company.locations.length < 1) {
      this.addLocation({ hq: true });
    }
  },


  watch: {
    company: {
      handler: function handler() {
        var _this = this;

        var index = 0;

        this.company.locations.forEach(function (location, i) {
          if (!location._destroy) {
            _this.company.locations[i].index = index;
            index++;
          } else {}
        });
      },
      deep: true
    }
  },

  methods: {
    addLocation: function addLocation(options) {
      this.company.locations.push(location_fields__extends({
        address: '',
        _destroy: false
      }, options));
    },
    toggleRemote: function toggleRemote(e) {
      this.company.remote = e.target.checked;

      if (e.target.checked === true) {
        this.company.remote_employees = false;
      }
    },
    toggleRemoteEmployees: function toggleRemoteEmployees(e) {
      this.company.remote_employees = e.target.checked;

      if (e.target.checked === true) {
        this.company.remote = false;
      }
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdf44a2e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/location-fields.vue
var location_fields_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location-fields"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.company.remote),
      expression: "!company.remote"
    }]
  }, [_vm._l((_vm.company.locations), function(location, index) {
    return _c('div', {
      key: location.id || index,
      staticClass: "location-field",
      model: {
        value: (_vm.company.locations),
        callback: function($$v) {
          _vm.company.locations = $$v
        },
        expression: "company.locations"
      }
    }, [(location.hq) ? [_c('locationField', {
      staticClass: "location-input hq",
      attrs: {
        "model": ("company[locations_attributes][" + index + "]"),
        "attribute": "address",
        "placeholder": "Enter your headquarters location",
        "required": !_vm.company.remote
      },
      model: {
        value: (location.address),
        callback: function($$v) {
          location.address = $$v
        },
        expression: "location.address"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.company.locations.length > 1),
        expression: "company.locations.length > 1"
      }],
      staticClass: "hq-label"
    }, [_vm._v("\n          Headquarters\n        ")])] : [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!location._destroy),
        expression: "!location._destroy"
      }]
    }, [_c('locationField', {
      staticClass: "location-input",
      attrs: {
        "model": ("company[locations_attributes][" + index + "]"),
        "attribute": "address",
        "placeholder": "Enter another location"
      },
      model: {
        value: (location.address),
        callback: function($$v) {
          location.address = $$v
        },
        expression: "location.address"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "location-controls location-controls--remove small-icon-btn"
    }, [_c('span', {
      staticClass: "ss-icon is-big"
    }, [_vm._v("minus")]), _vm._v(" "), _c('p', {
      staticClass: "remove-location",
      on: {
        "click": function($event) {
          location._destroy = 1
        }
      }
    }, [_vm._v("Remove location")])])], 1)], _vm._v(" "), _vm._l((['index', 'id', 'address', 'hq']), function(key) {
      return _c('input', {
        key: key,
        attrs: {
          "type": "hidden",
          "name": ("company[locations_attributes][" + index + "][" + key + "]")
        },
        domProps: {
          "value": location[key]
        }
      })
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": ("company[locations_attributes][" + index + "][_destroy]")
      },
      domProps: {
        "value": location._destroy || _vm.company.remote
      }
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "location-controls small-icon-btn"
  }, [_c('span', {
    staticClass: "ss-icon is-big"
  }, [_vm._v("plus")]), _vm._v(" "), _c('a', {
    staticClass: "add-location",
    on: {
      "click": _vm.addLocation
    }
  }, [_vm._v("Add another location")])]), _vm._v(" "), _c('hr', {
    staticClass: "locations_rule"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "remote-checkboxes"
  }, [_c('div', {
    staticClass: "cm-field cm-radio-field"
  }, [_c('label', {
    staticClass: "cm-label remote"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "company[remote]"
    },
    domProps: {
      "checked": _vm.company.remote
    },
    on: {
      "change": _vm.toggleRemote
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "company[remote]",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.company.remote
    }
  }), _vm._v("\n        " + _vm._s(_vm.I18n.t('activerecord.attributes.company.remote')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "cm-field cm-radio-field"
  }, [_c('label', {
    staticClass: "cm-label remote"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "company[remote_employees]"
    },
    domProps: {
      "checked": _vm.company.remote_employees
    },
    on: {
      "change": _vm.toggleRemoteEmployees
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "company[remote_employees]",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.company.remote_employees
    }
  }), _vm._v("\n        " + _vm._s(_vm.I18n.t('activerecord.attributes.company.remote_employees')) + "\n      ")])])])])
}
var location_fields_staticRenderFns = []
var location_fields_esExports = { render: location_fields_render, staticRenderFns: location_fields_staticRenderFns }
/* harmony default export */ var components_location_fields = (location_fields_esExports);
// CONCATENATED MODULE: ./app/javascript/components/location-fields.vue
function location_fields_injectStyle (ssrContext) {
  __webpack_require__(279)
}
var location_fields_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var location_fields___vue_styles__ = location_fields_injectStyle
/* scopeId */
var location_fields___vue_scopeId__ = "data-v-bdf44a2e"
/* moduleIdentifier (server only) */
var location_fields___vue_module_identifier__ = null
var location_fields_Component = location_fields_normalizeComponent(
  location_fields,
  components_location_fields,
  location_fields___vue_styles__,
  location_fields___vue_scopeId__,
  location_fields___vue_module_identifier__
)

/* harmony default export */ var javascript_components_location_fields = (location_fields_Component.exports);

// EXTERNAL MODULE: external "jQuery"
var external__jQuery_ = __webpack_require__(63);
var external__jQuery__default = /*#__PURE__*/__webpack_require__.n(external__jQuery_);

// EXTERNAL MODULE: ./vendor/assets/javascripts/select2.js
var select2 = __webpack_require__(218);
var select2_default = /*#__PURE__*/__webpack_require__.n(select2);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/skills-field.vue
//
//
//
//
//
//




/* harmony default export */ var skills_field = ({
  mounted: function mounted() {
    var selectTag = this.$el.querySelector('select');

    external__jQuery__default()(selectTag).select2({
      closeOnSelect: false
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-279c89c7","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/skills-field.vue
var skills_field_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-field"
  }, [_vm._t("default")], 2)
}
var skills_field_staticRenderFns = []
var skills_field_esExports = { render: skills_field_render, staticRenderFns: skills_field_staticRenderFns }
/* harmony default export */ var components_skills_field = (skills_field_esExports);
// CONCATENATED MODULE: ./app/javascript/components/skills-field.vue
var skills_field_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var skills_field___vue_styles__ = null
/* scopeId */
var skills_field___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var skills_field___vue_module_identifier__ = null
var skills_field_Component = skills_field_normalizeComponent(
  skills_field,
  components_skills_field,
  skills_field___vue_styles__,
  skills_field___vue_scopeId__,
  skills_field___vue_module_identifier__
)

/* harmony default export */ var javascript_components_skills_field = (skills_field_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/collaborator-field.vue
//
//
//
//
//
//




/* harmony default export */ var collaborator_field = ({
  mounted: function mounted() {
    var selectTag = this.$el.querySelector('input');

    external__jQuery__default()(selectTag).select2({
      ajax: {
        url: '/individuals/user_autocomplete',
        dataType: 'json',
        data: function data(term, page, context) {
          return {
            q: term
          };
        },
        results: function results(data) {
          return {
            results: data.map(function (user) {
              return {
                id: user['id'],
                text: user['username']
              };
            })
          };
        }
      },
      closeOnSelect: false
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a9d48b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/collaborator-field.vue
var collaborator_field_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-field"
  }, [_vm._t("default")], 2)
}
var collaborator_field_staticRenderFns = []
var collaborator_field_esExports = { render: collaborator_field_render, staticRenderFns: collaborator_field_staticRenderFns }
/* harmony default export */ var components_collaborator_field = (collaborator_field_esExports);
// CONCATENATED MODULE: ./app/javascript/components/collaborator-field.vue
var collaborator_field_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var collaborator_field___vue_styles__ = null
/* scopeId */
var collaborator_field___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var collaborator_field___vue_module_identifier__ = null
var collaborator_field_Component = collaborator_field_normalizeComponent(
  collaborator_field,
  components_collaborator_field,
  collaborator_field___vue_styles__,
  collaborator_field___vue_scopeId__,
  collaborator_field___vue_module_identifier__
)

/* harmony default export */ var javascript_components_collaborator_field = (collaborator_field_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var modal = ({
  data: function data() {
    return {
      modalShowing: false
    };
  },


  methods: {
    toggleModal: function toggleModal() {
      this.modalShowing = !this.modalShowing;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2acf23c5","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/modal.vue
var modal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('span', {
    staticClass: "modal__trigger",
    on: {
      "click": function($event) {
        _vm.toggleModal()
      }
    }
  }, [_vm._t("trigger")], 2), _vm._v(" "), (_vm.modalShowing) ? _c('div', {
    staticClass: "modal__overlay"
  }, [_c('a', {
    staticClass: "cm-button modal__trigger modal__trigger--inner",
    on: {
      "click": function($event) {
        _vm.toggleModal()
      }
    }
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticClass: "modal__content"
  }, [_c('div', {
    staticClass: "modal__inner-content"
  }, [_vm._t("content")], 2)])]) : _vm._e()])
}
var modal_staticRenderFns = []
var modal_esExports = { render: modal_render, staticRenderFns: modal_staticRenderFns }
/* harmony default export */ var components_modal = (modal_esExports);
// CONCATENATED MODULE: ./app/javascript/components/modal.vue
function modal_injectStyle (ssrContext) {
  __webpack_require__(280)
}
var modal_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var modal___vue_styles__ = modal_injectStyle
/* scopeId */
var modal___vue_scopeId__ = "data-v-2acf23c5"
/* moduleIdentifier (server only) */
var modal___vue_module_identifier__ = null
var modal_Component = modal_normalizeComponent(
  modal,
  components_modal,
  modal___vue_styles__,
  modal___vue_scopeId__,
  modal___vue_module_identifier__
)

/* harmony default export */ var javascript_components_modal = (modal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/social-links.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var social_links = ({
  mixins: [form_options["a" /* default */]],

  props: {
    data: {
      type: Object,
      default: {
        twitter: {
          value: null,
          placeholder: 'https://twitter.com/example'
        },
        facebook: {
          value: null,
          placeholder: 'https://facebook.com/example'
        },
        instagram: {
          value: null,
          placeholder: 'https://instagram.com/example'
        }
      }
    }
  },

  data: function data() {
    return {
      services: this.data
    };
  },
  mounted: function mounted() {
    // show at least one service if all are blank
    var firstService;
    for (var service in this.services) {
      if (!firstService) firstService = service;
      if (this.services[firstService].value !== null) return;
    }
    this.services[firstService].value = '';
  },


  methods: {
    linkClassList: function linkClassList(service) {
      var list = ['link', 'ss-icon', 'ss-social-regular'];

      if (this.services[service].value !== null) {
        list.push('link--active');
      }

      return list;
    },
    serviceName: function serviceName(service) {
      return this.model + '[' + service + '_username]';
    },
    toggleService: function toggleService(service) {
      this.services[service].value = this.services[service].value == null ? "" : null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663c9e71","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/social-links.vue
var social_links_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social"
  }, [_c('nav', _vm._l((_vm.services), function(attributes, service) {
    return _c('a', {
      class: _vm.linkClassList(service),
      attrs: {
        "href": "#",
        "title": service
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleService(service)
        }
      }
    }, [_vm._v(_vm._s(service))])
  })), _vm._v(" "), _c('section', _vm._l((_vm.services), function(attributes, service) {
    return (attributes.value != null) ? _c('article', [_c('i', {
      staticClass: "ss-icon ss-social-regular",
      attrs: {
        "title": service
      }
    }, [_vm._v(_vm._s(service))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attributes.value),
        expression: "attributes.value"
      }],
      staticClass: "cm-field",
      attrs: {
        "type": "text",
        "name": _vm.serviceName(service),
        "placeholder": attributes.placeholder
      },
      domProps: {
        "value": (attributes.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          attributes.value = $event.target.value
        }
      }
    })]) : _vm._e()
  }))])
}
var social_links_staticRenderFns = []
var social_links_esExports = { render: social_links_render, staticRenderFns: social_links_staticRenderFns }
/* harmony default export */ var components_social_links = (social_links_esExports);
// CONCATENATED MODULE: ./app/javascript/components/social-links.vue
function social_links_injectStyle (ssrContext) {
  __webpack_require__(281)
}
var social_links_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var social_links___vue_styles__ = social_links_injectStyle
/* scopeId */
var social_links___vue_scopeId__ = "data-v-663c9e71"
/* moduleIdentifier (server only) */
var social_links___vue_module_identifier__ = null
var social_links_Component = social_links_normalizeComponent(
  social_links,
  components_social_links,
  social_links___vue_styles__,
  social_links___vue_scopeId__,
  social_links___vue_module_identifier__
)

/* harmony default export */ var javascript_components_social_links = (social_links_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(101);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(102);

// CONCATENATED MODULE: ./app/javascript/state/store.js



var store = new vuex_esm["a" /* default */].Store({
  state: {
    translations: {}
  },
  mutations: {
    setTranslation: function setTranslation(state, _ref) {
      var key = _ref.key,
          value = _ref.value;

      vue_esm["a" /* default */].set(state.translations, key, value);
    }
  },
  actions: {
    setTranslation: function setTranslation(_ref2, _ref3) {
      var commit = _ref2.commit;
      var key = _ref3.key,
          value = _ref3.value;

      commit('setTranslation', { key: key, value: value });
    }
  }
});

/* harmony default export */ var state_store = (store);
// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var whatwg_fetch_fetch = __webpack_require__(283);

// CONCATENATED MODULE: ./app/javascript/mixins/translation.js




/* harmony default export */ var mixins_translation = ({
  methods: {
    translate: function translate(key, args) {
      var _this = this;

      if (state_store.state.translations[key]) {
        return this.getTranslation(key, args);
      } else {
        // fetch the translation from rails if it's not already pending
        if (state_store.state.translations[key] !== null) {
          // set our pending state with null (not undefined)
          state_store.dispatch('setTranslation', {
            key: key,
            value: null
          });

          fetch('/translation?' + stringifyURLParams({ key: key }), {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            }
          }).then(function (response) {
            response.json().then(function (data) {
              state_store.dispatch('setTranslation', {
                key: key,
                value: data.result
              });

              // i don't love this but because we're calling a function
              // instead of using native reactivity,
              // we need to  manually re-render after getting the data
              _this.$forceUpdate();
            });
          }, function (error) {
            console.error(error.message);
          });
        }

        return '';
      }
    },
    getTranslation: function getTranslation(key, args) {
      var translation = state_store.state.translations[key];

      if (args) {
        // replace dynamic text
        Object.keys(args).forEach(function (key) {
          var regex = new RegExp('%{' + key + '}', 'gi');
          translation = translation.replace(regex, args[key]);
        });
      }

      return translation;
    }
  }
});
// EXTERNAL MODULE: ./node_modules/marked/lib/marked.js
var marked = __webpack_require__(285);
var marked_default = /*#__PURE__*/__webpack_require__.n(marked);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/markdown.vue
//
//
//
//



/* harmony default export */ var markdown = ({
  props: {
    input: {
      type: String
    }
  },

  computed: {
    output: function output() {
      return marked_default()(this.input);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c2e29f2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/markdown.vue
var markdown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.output)
    }
  })
}
var markdown_staticRenderFns = []
var markdown_esExports = { render: markdown_render, staticRenderFns: markdown_staticRenderFns }
/* harmony default export */ var components_markdown = (markdown_esExports);
// CONCATENATED MODULE: ./app/javascript/components/markdown.vue
function markdown_injectStyle (ssrContext) {
  __webpack_require__(284)
}
var markdown_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var markdown___vue_styles__ = markdown_injectStyle
/* scopeId */
var markdown___vue_scopeId__ = "data-v-1c2e29f2"
/* moduleIdentifier (server only) */
var markdown___vue_module_identifier__ = null
var markdown_Component = markdown_normalizeComponent(
  markdown,
  components_markdown,
  markdown___vue_styles__,
  markdown___vue_scopeId__,
  markdown___vue_module_identifier__
)

/* harmony default export */ var javascript_components_markdown = (markdown_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/ats-edit-form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ats_edit_form = ({
  mixins: [mixins_translation],

  components: { Markdown: javascript_components_markdown },

  props: {
    company: {
      type: Object
    }
  },

  data: function data() {
    return {
      ats_url: null,
      ats_provider: this.company.ats_provider,
      ats_username: this.company.ats_username,
      ats_referral_code: this.company.ats_referral_code,

      providers: [{
        label: "Greenhouse", value: "greenhouse"
      }, {
        label: "Lever", value: "lever"
      }]
    };
  },


  computed: {
    hasExistingATSData: function hasExistingATSData() {
      return !!this.company.ats_provider || !!this.company.ats_username || !!this.company.ats_referral_code;
    },
    activeProvider: function activeProvider() {
      var _this = this;

      return this.providers.find(function (p) {
        return p.value === _this.ats_provider;
      }) || { label: "Provider" };
    }
  },

  watch: {
    ats_url: function ats_url(nextUrl, prevUrl) {
      var data = getAtsDataFromURL(nextUrl);

      this.ats_provider = data.provider || this.ats_provider;
      this.ats_username = data.username || this.ats_username;
      this.ats_referral_code = data.referral || this.ats_referral_code;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4f3335c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/ats-edit-form.vue
var ats_edit_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats-edit-form"
  }, [_c('fieldset', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasExistingATSData),
      expression: "!hasExistingATSData"
    }],
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "company_ats_url"
    }
  }, [_vm._v(_vm._s(_vm.translate("activerecord.attributes.company.ats_url")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ats_url),
      expression: "ats_url"
    }],
    staticClass: "cm-field",
    attrs: {
      "type": "url",
      "id": "company_ats_url"
    },
    domProps: {
      "value": (_vm.ats_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ats_url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('aside', {
    staticClass: "cm-desc"
  }, [_c('Markdown', {
    attrs: {
      "input": _vm.translate('company_ats_url_helper_text')
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ats_provider || _vm.ats_username),
      expression: "ats_provider || ats_username"
    }]
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ats_url),
      expression: "ats_url"
    }],
    staticClass: "cm-notice"
  }, [_vm._v(_vm._s(_vm.translate("forms.ats.autofilled_ats_properties")))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label required",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.translate("activerecord.attributes.company.ats_provider")))]), _vm._v(" "), _vm._l((_vm.providers), function(provider) {
    return _c('label', {
      key: provider.value,
      staticClass: "ats-edit-form__radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ats_provider),
        expression: "ats_provider"
      }],
      attrs: {
        "name": "company[ats_provider]",
        "type": "radio",
        "required": ""
      },
      domProps: {
        "value": provider.value,
        "checked": _vm._q(_vm.ats_provider, provider.value)
      },
      on: {
        "__c": function($event) {
          _vm.ats_provider = provider.value
        }
      }
    }), _vm._v("\n          " + _vm._s(provider.label) + "\n        ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label required",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.translate("activerecord.attributes.company.ats_username")) + "\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ats_username),
      expression: "ats_username"
    }],
    staticClass: "cm-field",
    attrs: {
      "name": "company[ats_username]",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.ats_username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ats_username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Markdown', {
    staticClass: "cm-desc",
    attrs: {
      "input": _vm.translate(
        'activerecord.attributes.company.ats_username_helper_text', {
          provider: _vm.activeProvider.label
        }
      )
    }
  })], 1), _vm._v(" "), (_vm.ats_provider === 'greenhouse') ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.translate("activerecord.attributes.company.ats_referral_code")) + "\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ats_referral_code),
      expression: "ats_referral_code"
    }],
    staticClass: "cm-field",
    attrs: {
      "name": "company[ats_referral_code]",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ats_referral_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ats_referral_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Markdown', {
    staticClass: "cm-desc",
    attrs: {
      "input": _vm.translate(
        "activerecord.attributes.company.ats_referral_code_helper_text", {
          provider: _vm.activeProvider.label
        }
      )
    }
  })], 1) : _vm._e()])])])
}
var ats_edit_form_staticRenderFns = []
var ats_edit_form_esExports = { render: ats_edit_form_render, staticRenderFns: ats_edit_form_staticRenderFns }
/* harmony default export */ var components_ats_edit_form = (ats_edit_form_esExports);
// CONCATENATED MODULE: ./app/javascript/components/ats-edit-form.vue
function ats_edit_form_injectStyle (ssrContext) {
  __webpack_require__(282)
}
var ats_edit_form_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var ats_edit_form___vue_styles__ = ats_edit_form_injectStyle
/* scopeId */
var ats_edit_form___vue_scopeId__ = "data-v-b4f3335c"
/* moduleIdentifier (server only) */
var ats_edit_form___vue_module_identifier__ = null
var ats_edit_form_Component = ats_edit_form_normalizeComponent(
  ats_edit_form,
  components_ats_edit_form,
  ats_edit_form___vue_styles__,
  ats_edit_form___vue_scopeId__,
  ats_edit_form___vue_module_identifier__
)

/* harmony default export */ var javascript_components_ats_edit_form = (ats_edit_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/heart.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var heart = ({
  props: ["company"],

  data: function data() {
    return {
      liked: this.company.liked,
      likeLoading: false
    };
  },


  methods: {
    toggleLike: function toggleLike() {
      var _this = this;

      this.likeLoading = true;

      if (!this.liked) {
        window.makeItRainHearts();
      }

      this.$http.put("/companies/" + this.company.id + "/like.json").then(function (response) {
        _this.liked = !_this.liked;

        if (_this.liked) {
          _this.$emit("like");
        } else {
          _this.$emit("unlike");
        }

        _this.likeLoading = false;
      }, function (error) {
        // TODO Display error messages
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08390ab3","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/heart.vue
var heart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cm-like",
    class: {
      'cm-like--liked': _vm.liked,
      'is-flashing': _vm.likeLoading,
    },
    attrs: {
      "data-company": _vm.company.id
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleLike($event)
      }
    }
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("heart")])])
}
var heart_staticRenderFns = []
var heart_esExports = { render: heart_render, staticRenderFns: heart_staticRenderFns }
/* harmony default export */ var company_heart = (heart_esExports);
// CONCATENATED MODULE: ./app/javascript/company/heart.vue
function heart_injectStyle (ssrContext) {
  __webpack_require__(287)
}
var heart_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var heart___vue_styles__ = heart_injectStyle
/* scopeId */
var heart___vue_scopeId__ = "data-v-08390ab3"
/* moduleIdentifier (server only) */
var heart___vue_module_identifier__ = null
var heart_Component = heart_normalizeComponent(
  heart,
  company_heart,
  heart___vue_styles__,
  heart___vue_scopeId__,
  heart___vue_module_identifier__
)

/* harmony default export */ var javascript_company_heart = (heart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/company-card.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var company_card = ({
  components: {
    Heart: javascript_company_heart
  },

  mixins: [mixins_translation],

  props: {
    company: {
      type: Object
    },
    liked: {
      type: Boolean
    },
    isLoggedIn: {
      type: Boolean
    },
    mini: {
      type: Boolean
    }
  },

  computed: {
    location: function location() {
      var locations = this.company.locations;
      return locations && locations.length && locations[0].address;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77781810","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/company-card.vue
var company_card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-company-card__container",
    class: {
      mini: _vm.mini
    }
  }, [_c('a', {
    staticClass: "cm-company-card cm-card raised",
    class: {
      mini: _vm.mini
    },
    attrs: {
      "href": _vm.company.url
    }
  }, [(_vm.company.is_hiring) ? _c('div', {
    staticClass: "cm-company-card__hiring"
  }, [_vm._v("\n      " + _vm._s(_vm.translate('hiring')) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.mini) ? _c('div', {
    staticClass: "cm-company-card__banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.company.banner || '/companies/' + _vm.company.id + '/banner',
      "alt": ((_vm.company.name) + " banner"),
      "loading": "lazy"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cm-company-card__info"
  }, [_c('aside', {
    staticClass: "cm-company-card__logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.company.logo,
      "alt": ((_vm.company.name) + " logo"),
      "loading": "lazy"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "cm-company-card__name"
  }, [_c('h3', [_vm._v(_vm._s(_vm.company.name))]), _vm._v(" "), (_vm.location) ? _c('p', {
    staticClass: "cm-company-card__location"
  }, [_vm._v(_vm._s(_vm.location))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "cm-company-card__motto"
  }, [_vm._v(_vm._s(_vm.company.motto))])])])])])
}
var company_card_staticRenderFns = []
var company_card_esExports = { render: company_card_render, staticRenderFns: company_card_staticRenderFns }
/* harmony default export */ var components_company_card = (company_card_esExports);
// CONCATENATED MODULE: ./app/javascript/components/company-card.vue
function company_card_injectStyle (ssrContext) {
  __webpack_require__(286)
}
var company_card_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var company_card___vue_styles__ = company_card_injectStyle
/* scopeId */
var company_card___vue_scopeId__ = "data-v-77781810"
/* moduleIdentifier (server only) */
var company_card___vue_module_identifier__ = null
var company_card_Component = company_card_normalizeComponent(
  company_card,
  components_company_card,
  company_card___vue_styles__,
  company_card___vue_scopeId__,
  company_card___vue_module_identifier__
)

/* harmony default export */ var javascript_components_company_card = (company_card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/dom-template.vue













/* harmony default export */ var dom_template = ({
  props: {
    company: Object
  },
  template: '#js-company',
  components: {
    ChosenField: chosen_field["a" /* default */],
    ImageField: javascript_components_image_field,
    MultipleImageField: javascript_components_multiple_image_field,
    LocationField: location_field["a" /* default */],
    LocationFields: javascript_components_location_fields,
    SkillsField: javascript_components_skills_field,
    CollaboratorField: javascript_components_collaborator_field,
    Modal: javascript_components_modal,
    SocialLinks: javascript_components_social_links,
    AtsEditForm: javascript_components_ats_edit_form,
    CompanyCard: javascript_components_company_card
  }
});
// CONCATENATED MODULE: ./app/javascript/company/dom-template.vue
var dom_template_normalizeComponent = __webpack_require__(7)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var dom_template___vue_styles__ = null
/* scopeId */
var dom_template___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dom_template___vue_module_identifier__ = null
var dom_template_Component = dom_template_normalizeComponent(
  dom_template,
  __vue_template__,
  dom_template___vue_styles__,
  dom_template___vue_scopeId__,
  dom_template___vue_module_identifier__
)

/* harmony default export */ var company_dom_template = (dom_template_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/editable-image.vue
function editable_image__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//



/* harmony default export */ var editable_image = ({
  props: {
    resource: {
      type: Object,
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: true
    },
    recommendations: {
      type: String
    },
    resizable: {
      type: Boolean,
      default: false
    },
    kitten: {
      type: Boolean,
      default: false,
      required: false
    },
    width: [Number, String],
    height: [Number, String]
  },
  data: function data() {
    return {
      model: Object.keys(this.resource)[0],
      response: this.resource,
      saving: false,
      message: undefined
    };
  },

  computed: {
    imageUrl: function imageUrl() {
      if (this.message) {
        return undefined;
      } else if (this.kitten == true) {
        return this.url + '/banner';
      } else {
        return this.response[this.model][this.attribute + '_url'];
      }
    }
  },
  methods: {
    saveImage: function saveImage(param, file) {
      var _this = this;

      this.errors = [];

      var formData = new FormData();
      formData.append(param, file, file.name);

      this.saving = true;

      this.$http.patch(this.url, formData).then(function (response) {
        _this.response = response.body;
        _this.saving = false;
      }, function (response) {
        // TODO Display error messages
        _this.saving = false;

        _this.message = response.body.errors.join(', ');
      });
    },
    handleInput: function handleInput(value) {
      if (!value) this.deleteImage();
    },
    deleteImage: function deleteImage() {
      var _this2 = this;

      var params = editable_image__defineProperty({}, this.model, editable_image__defineProperty({}, 'remove_' + this.attribute, true));

      this.saving = true;

      this.$http.patch(this.url, params).then(function (response) {
        _this2.response = response.body;
        _this2.saving = false;
      });
    }
  },
  components: {
    ImageField: javascript_components_image_field
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea99356c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/editable-image.vue
var editable_image_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('image-field', _vm._b({
    staticClass: "editable-image",
    attrs: {
      "value": _vm.imageUrl,
      "message": _vm.message
    },
    on: {
      "readFile": function (param, file) {
        _vm.saveImage(param, file)
      },
      "input": _vm.handleInput
    }
  }, 'image-field', {
    model: _vm.model,
    attribute: _vm.attribute,
    editable: _vm.editable,
    removable: _vm.removable,
    recommendations: _vm.recommendations,
    resizable: _vm.resizable
  }, false), [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saving),
      expression: "saving"
    }],
    staticClass: "loading"
  })])
}
var editable_image_staticRenderFns = []
var editable_image_esExports = { render: editable_image_render, staticRenderFns: editable_image_staticRenderFns }
/* harmony default export */ var components_editable_image = (editable_image_esExports);
// CONCATENATED MODULE: ./app/javascript/components/editable-image.vue
var editable_image_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var editable_image___vue_styles__ = null
/* scopeId */
var editable_image___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editable_image___vue_module_identifier__ = null
var editable_image_Component = editable_image_normalizeComponent(
  editable_image,
  components_editable_image,
  editable_image___vue_styles__,
  editable_image___vue_scopeId__,
  editable_image___vue_module_identifier__
)

/* harmony default export */ var javascript_components_editable_image = (editable_image_Component.exports);

// EXTERNAL MODULE: ./node_modules/sortablejs/Sortable.js
var Sortable = __webpack_require__(288);
var Sortable_default = /*#__PURE__*/__webpack_require__.n(Sortable);

// CONCATENATED MODULE: ./app/javascript/company/mixins/users.js


/* harmony default export */ var users = ({
  mounted: function mounted() {
    if (!this.editable) return;

    var vm = this;
    var el = document.getElementById('people');

    if (el) {
      var sortable = Sortable_default.a.create(el, {
        handle: '.sortable-handle',
        onUpdate: function onUpdate(event) {
          var companyUsers = this.toArray().map(function (id, index) {
            return { id: parseInt(id), position: index };
          });

          vm.$http.patch('/companies/' + vm.company.slug + '/company_users', {
            company_users: companyUsers
          });
        }
      });
    }
  }
});
// EXTERNAL MODULE: ./app/javascript/lib/youtube-iframes.js
var youtube_iframes = __webpack_require__(74);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/profile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ var profile = ({
  props: {
    company: {
      type: Object,
      required: true
    },
    breakfastFoods: {
      type: Array,
      required: true
    },
    admin: {
      type: Boolean,
      default: false
    },
    stub: {
      type: Boolean,
      default: true
    },
    form: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      resource: {
        company: this.company
      },
      url: '/companies/' + this.company.slug,
      editable: !!this.admin,
      likeLoading: false,
      liked: this.company.liked
    };
  },
  mounted: function mounted() {
    Object(youtube_iframes["b" /* initYoutubeIframeAPI */])();
  },

  mixins: [users],
  components: {
    DomTemplate: company_dom_template,
    EditableImage: javascript_components_editable_image,
    CompanyDetails: javascript_company_details,
    CompanyMissionStatement: javascript_company_mission_statement,
    CompanyMotto: javascript_company_motto,
    CompanyName: app_javascript_company_name,
    CompanyFacts: javascript_company_facts,
    CompanyLike: javascript_company_like,
    CompanyJobs: javascript_company_jobs
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d09d956","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/profile.vue
var profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dom-template', {
    attrs: {
      "company": _vm.company
    }
  }, [(_vm.company.banner_url) ? _c('div', {
    staticClass: "company-banner",
    slot: "banner"
  }, [_c('editable-image', _vm._b({
    attrs: {
      "attribute": "banner",
      "width": "4000",
      "height": "1400",
      "recommendations": "Recommended dimensions: 2560 × 900"
    }
  }, 'editable-image', _vm.$data, false))], 1) : _vm._e(), _vm._v(" "), (!_vm.company.banner_url) ? _c('div', {
    staticClass: "company-banner",
    slot: "banner"
  }, [_c('editable-image', _vm._b({
    attrs: {
      "kitten": true,
      "attribute": "banner",
      "width": "4000",
      "height": "1400",
      "recommendations": "Recommended dimensions: 2560 × 900"
    }
  }, 'editable-image', _vm.$data, false))], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "sidebar"
  }, [_c('div', {
    staticClass: "company-name"
  }, [(_vm.company.logo_url || _vm.editable) ? _c('div', {
    staticClass: "company-logo"
  }, [_c('editable-image', _vm._b({
    attrs: {
      "attribute": "logo",
      "width": "380",
      "height": "380",
      "removable": false,
      "recommendations": "Recommended dimensions: 380 x 380"
    }
  }, 'editable-image', _vm.$data, false))], 1) : _vm._e(), _vm._v(" "), _c('company-name', {
    attrs: {
      "id": _vm.company.slug,
      "value": _vm.company.name,
      "editable": _vm.editable
    }
  }), _vm._v(" "), (_vm.company.locations.length > 0 && !_vm.company.remote) ? _c('p', {
    staticClass: "company-location"
  }, [_vm._v(_vm._s(_vm.company.locations[0].address))]) : _vm._e(), _vm._v(" "), (_vm.company.remote) ? _c('p', {
    staticClass: "company-location"
  }, [_vm._v("The Internet")]) : _vm._e(), _vm._v(" "), (this.company.motto || this.admin) ? _c('company-motto', {
    attrs: {
      "id": _vm.company.slug,
      "value": _vm.company.motto,
      "editable": _vm.editable
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('company-details', {
    attrs: {
      "company": _vm.company,
      "is-form": _vm.form,
      "editable": _vm.editable
    }
  })], 1), _vm._v(" "), _c('company-mission-statement', {
    attrs: {
      "id": _vm.company.slug,
      "value": _vm.company.mission_statement,
      "editable": _vm.editable
    },
    slot: "mission-statement"
  }), _vm._v(" "), (_vm.company.gif_url || _vm.form) ? _c('div', {
    staticClass: "company-gif",
    slot: "gif"
  }, [_c('editable-image', _vm._b({
    staticStyle: {
      "height": "400px"
    },
    attrs: {
      "attribute": "gif",
      "width": "400",
      "height": "400",
      "resizable": true
    }
  }, 'editable-image', _vm.$data, false))], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "jobs"
  }, [_c('company-jobs', {
    attrs: {
      "company": _vm.company,
      "editable": _vm.editable
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "facts"
  }, [_c('company-facts', _vm._b({}, 'company-facts', {
    company: _vm.company,
    breakfastFoods: _vm.breakfastFoods,
    editable: _vm.editable
  }, false))], 1), _vm._v(" "), _c('template', {
    slot: "like"
  }, [_c('company-like', {
    attrs: {
      "company": _vm.company
    }
  })], 1)], 2)
}
var profile_staticRenderFns = []
var profile_esExports = { render: profile_render, staticRenderFns: profile_staticRenderFns }
/* harmony default export */ var company_profile = (profile_esExports);
// CONCATENATED MODULE: ./app/javascript/company/profile.vue
function profile_injectStyle (ssrContext) {
  __webpack_require__(260)
}
var profile_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var profile___vue_styles__ = profile_injectStyle
/* scopeId */
var profile___vue_scopeId__ = "data-v-4d09d956"
/* moduleIdentifier (server only) */
var profile___vue_module_identifier__ = null
var profile_Component = profile_normalizeComponent(
  profile,
  company_profile,
  profile___vue_styles__,
  profile___vue_scopeId__,
  profile___vue_module_identifier__
)

/* harmony default export */ var javascript_company_profile = (profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/job.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var job = ({
  mixins: [mixins_translation],

  props: {
    show: {
      type: Object,
      default: function _default() {
        return {
          motto: true,
          time: true,
          company: false
        };
      }
    },
    job: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean
    },
    context: {
      type: String
    }
  },

  computed: {
    commitment: function commitment() {
      if (!this.job.commitment.name) return "";

      return this.job.commitment.name.split("_").map(function (s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
      }).join("-");
    },
    updatedAtTimeAgo: function updatedAtTimeAgo() {
      return Object(esm["b" /* formatDistanceStrict */])(Object(esm["c" /* parseISO */])(this.job.updated_at), new Date());
    }
  },

  methods: {
    toggle: function toggle() {
      this.toggled = !this.toggled;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3768582c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/job.vue
var job_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job",
    class: {
      'job--with-motto': _vm.show.motto,
        'job--with-date': _vm.show.motto,
    }
  }, [_c('div', {
    staticClass: "job__card"
  }, [_c('a', {
    staticClass: "job__link",
    attrs: {
      "href": _vm.job.url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "job__logo"
  }, [_c('img', {
    staticClass: "job__logo__image",
    attrs: {
      "src": _vm.job.company.logo,
      "loading": "lazy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job__text"
  }, [(_vm.show.date) ? _c('time', {
    staticClass: "job__timestamp",
    attrs: {
      "datetime": _vm.job.updated_at
    }
  }, [_vm._v("\n        " + _vm._s(_vm.updatedAtTimeAgo) + " ago\n      ")]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "job__title"
  }, [_vm._v("\n        " + _vm._s(_vm.job.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "job__company"
  }, [_c('a', {
    staticClass: "job__company__link",
    attrs: {
      "href": _vm.job.company.url
    }
  }, [_c('h3', {
    staticClass: "job__company__name"
  }, [_vm._v("\n            " + _vm._s(_vm.job.company.name) + "\n          ")]), _vm._v(" "), (_vm.show.motto && _vm.job.company.motto) ? _c('span', {
    staticClass: "job__company__motto"
  }, [_vm._v("\n            · " + _vm._s(_vm.job.company.motto) + "\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "job__stats"
  }, [_c('div', {
    staticClass: "job__stat"
  }, [_c('span', {
    staticClass: "job__stat-icon"
  }, [_vm._v("clock")]), _vm._v(" "), _c('span', {
    staticClass: "job__stat-value",
    attrs: {
      "title": _vm.commitment
    }
  }, [_vm._v(_vm._s(_vm.commitment))])]), _vm._v(" "), (_vm.job.remote) ? _c('div', {
    staticClass: "job__stat"
  }, [_c('span', {
    staticClass: "job__stat-icon"
  }, [_vm._v("wifi")]), _vm._v(" "), _c('span', {
    staticClass: "job__stat-value",
    attrs: {
      "title": _vm.translate('remote')
    }
  }, [_vm._v(_vm._s(_vm.translate('remote')))])]) : [(_vm.job.remote_friendly) ? _c('div', {
    staticClass: "job__stat"
  }, [_c('span', {
    staticClass: "job__stat-icon"
  }, [_vm._v("wifi")]), _vm._v(" "), _c('span', {
    staticClass: "job__stat-value",
    attrs: {
      "title": _vm.translate('remote_friendly')
    }
  }, [_vm._v(_vm._s(_vm.translate('remote_friendly')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "job__stat"
  }, [_c('span', {
    staticClass: "job__stat-icon"
  }, [_vm._v("location")]), _vm._v(" "), _c('span', {
    staticClass: "job__stat-value",
    attrs: {
      "title": _vm.job.location
    }
  }, [_vm._v(_vm._s(_vm.job.location))])])]], 2)])])
}
var job_staticRenderFns = []
var job_esExports = { render: job_render, staticRenderFns: job_staticRenderFns }
/* harmony default export */ var company_job = (job_esExports);
// CONCATENATED MODULE: ./app/javascript/company/job.vue
function job_injectStyle (ssrContext) {
  __webpack_require__(290)
}
var job_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var job___vue_styles__ = job_injectStyle
/* scopeId */
var job___vue_scopeId__ = "data-v-3768582c"
/* moduleIdentifier (server only) */
var job___vue_module_identifier__ = null
var job_Component = job_normalizeComponent(
  job,
  company_job,
  job___vue_styles__,
  job___vue_scopeId__,
  job___vue_module_identifier__
)

/* harmony default export */ var javascript_company_job = (job_Component.exports);

// CONCATENATED MODULE: ./app/javascript/lib/number.js
var formatNumber = function formatNumber(value) {
  var locale = document.documentElement.lang;
  return value.toLocaleString(locale);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/guild-search.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var guild_search = ({
  props: {
    value: {
      type: String
    },
    resultCount: {
      type: Number,
      required: true
    },
    unitLabels: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      isFocused: false
    };
  },


  computed: {
    placeholderLabel: function placeholderLabel() {
      var unit = this.resultCount === 1 ? this.unitLabels.singular : this.unitLabels.plural;

      if (this.resultCount) {
        return formatNumber(this.resultCount) + " " + unit;
      } else {
        return unit;
      }
    }
  },

  methods: {
    formatNumber: formatNumber,

    handleFocus: function handleFocus() {
      this.isFocused = true;
    },
    handleBlur: function handleBlur(event) {
      if (event.relatedTarget === null) return;
      if (document.activeElement === null) return;

      var focusedOutside = !this.$el.contains(event.relatedTarget);

      if (focusedOutside) {
        this.isFocused = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86d1cd4c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/guild-search.vue
var guild_search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-guild-search-field"
  }, [_c('div', {
    staticClass: "cm-guild-search-field__input-wrapper"
  }, [_c('label', {
    staticClass: "cm-guild-search-field__placeholder",
    class: {
      "cm-guild-search-field__placeholder--visible": _vm.value === "",
    },
    attrs: {
      "for": "cm-guild-search-field__input"
    }
  }, [_vm._v("\n      Search "), _c(_vm.resultCount ? "strong" : "span", {
    tag: "component"
  }, [_vm._v(_vm._s(_vm.placeholderLabel))]), _vm._v(" by keyword\n    ")], 1), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "cm-guild-search-field__input",
    attrs: {
      "id": "cm-guild-search-field__input",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit("input", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cm-guild-search-field__icon"
  }, [_vm._v("🔎")])])])
}
var guild_search_staticRenderFns = []
var guild_search_esExports = { render: guild_search_render, staticRenderFns: guild_search_staticRenderFns }
/* harmony default export */ var components_guild_search = (guild_search_esExports);
// CONCATENATED MODULE: ./app/javascript/components/guild-search.vue
function guild_search_injectStyle (ssrContext) {
  __webpack_require__(292)
}
var guild_search_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var guild_search___vue_styles__ = guild_search_injectStyle
/* scopeId */
var guild_search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var guild_search___vue_module_identifier__ = null
var guild_search_Component = guild_search_normalizeComponent(
  guild_search,
  components_guild_search,
  guild_search___vue_styles__,
  guild_search___vue_scopeId__,
  guild_search___vue_module_identifier__
)

/* harmony default export */ var javascript_components_guild_search = (guild_search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/expand.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var expand = ({
  props: {
    media: {
      type: String // eg (min-width: 400px)
    }
  },

  data: function data() {
    return {
      userExpanded: false,

      matchesMediaQuery: false
    };
  },
  mounted: function mounted() {
    if (this.media) {
      this.checkMediaQuery();
      window.addEventListener("resize", this.checkMediaQuery);
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.checkMediaQuery);
  },


  computed: {
    isExpanded: function isExpanded() {
      return this.matchesMediaQuery ? this.userExpanded : true;
    }
  },

  methods: {
    toggleExpansion: function toggleExpansion() {
      this.userExpanded = !this.userExpanded;
    },
    checkMediaQuery: function checkMediaQuery() {
      this.matchesMediaQuery = window.matchMedia(this.media).matches;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-affc819c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/expand.vue
var expand_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-expand",
    attrs: {
      "aria-expanded": _vm.userExpanded
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.matchesMediaQuery),
      expression: "matchesMediaQuery"
    }],
    staticClass: "cm-expand__header",
    on: {
      "click": _vm.toggleExpansion
    }
  }, [_c('h2', {
    staticClass: "cm-expand__header__heading"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('button', {
    staticClass: "cm-expand__header__arrow",
    attrs: {
      "type": "cm-button",
      "tabindex": "0"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.userExpanded ? "navigateup" : "navigatedown") + "\n    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExpanded),
      expression: "isExpanded"
    }],
    staticClass: "cm-expand__expandable-region"
  }, [_vm._t("default")], 2)])
}
var expand_staticRenderFns = []
var expand_esExports = { render: expand_render, staticRenderFns: expand_staticRenderFns }
/* harmony default export */ var components_expand = (expand_esExports);
// CONCATENATED MODULE: ./app/javascript/components/expand.vue
function expand_injectStyle (ssrContext) {
  __webpack_require__(293)
}
var expand_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var expand___vue_styles__ = expand_injectStyle
/* scopeId */
var expand___vue_scopeId__ = "data-v-affc819c"
/* moduleIdentifier (server only) */
var expand___vue_module_identifier__ = null
var expand_Component = expand_normalizeComponent(
  expand,
  components_expand,
  expand___vue_styles__,
  expand___vue_scopeId__,
  expand___vue_module_identifier__
)

/* harmony default export */ var javascript_components_expand = (expand_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/directory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var directory = ({
  components: {
    GuildSearch: javascript_components_guild_search,
    CmTag: javascript_components_tag,
    Expand: javascript_components_expand
  },

  props: {
    results: {
      type: Array
    },
    inputText: {
      type: String
    },
    activeFilters: {
      type: Array
    },
    isLoading: {
      type: Boolean
    },
    filters: {
      type: Array
    },
    resultCount: {
      type: Number
    },
    unitLabels: {
      type: Object
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    hasInput: function hasInput() {
      return this.activeFilters.length || this.inputText !== "";
    },
    resultCountLabel: function resultCountLabel() {
      if (this.isInitialLoad) return "Loading...";

      return [!this.hasInput && "Searching", formatNumber(this.resultCount), this.hasInput && "Matching", this.resultCount === 1 ? this.unitLabels.singular : this.unitLabels.plural].filter(Boolean).join(" ");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4330e785","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/directory.vue
var directory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "directory",
    class: {
      'directory--is-loading': _vm.isLoading,
    }
  }, [_c('GuildSearch', _vm._b({
    staticClass: "directory__input",
    attrs: {
      "value": _vm.inputText
    },
    on: {
      "input": function($event) {
        _vm.$emit('text-input', $event)
      }
    }
  }, 'GuildSearch', {
    resultCount: _vm.resultCount,
    unitLabels: {
      singular: _vm.unitLabels.singular.toLowerCase(),
      plural: _vm.unitLabels.plural.toLowerCase(),
    }
  }, false)), _vm._v(" "), _c('Expand', {
    attrs: {
      "media": "(max-width: 959px)"
    }
  }, [_c('span', {
    slot: "header"
  }, [_vm._v("Filter " + _vm._s(_vm.unitLabels.plural))]), _vm._v(" "), _c('div', {
    staticClass: "directory__filters-list"
  }, [_vm._t("filters")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "directory__results-meta"
  }, [_c('span', {
    staticClass: "directory__result-count",
    class: {
      'directory__result-count--is-loading': _vm.isLoading
    }
  }, [_vm._v(_vm._s(_vm.resultCountLabel))]), _vm._v(" "), (_vm.activeFilters.length) ? _c('button', {
    staticClass: "directory__clear-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('clear-all')
      }
    }
  }, [_vm._v("Clear all")]) : _vm._e(), _vm._v(" "), (_vm.activeFilters.length) ? _c('div', {
    staticClass: "directory__filter-tags"
  }, _vm._l((_vm.activeFilters), function(filter) {
    return _c('CmTag', {
      key: filter.keys[0],
      staticClass: "directory__filter-tag",
      attrs: {
        "label": filter.label,
        "value": filter.label
      },
      on: {
        "delete": function($event) {
          _vm.$emit("clear-filter", filter.keys, filter.match)
        }
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "directory__list",
    class: {
      'directory__list--is-loading': _vm.isLoading,
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.results.length < _vm.resultCount) ? _c('button', {
    staticClass: "directory__load-button cm-button wide",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('more-click')
      }
    }
  }, [_vm._v("More")]) : _vm._e()], 1)
}
var directory_staticRenderFns = []
var directory_esExports = { render: directory_render, staticRenderFns: directory_staticRenderFns }
/* harmony default export */ var components_directory = (directory_esExports);
// CONCATENATED MODULE: ./app/javascript/components/directory.vue
function directory_injectStyle (ssrContext) {
  __webpack_require__(291)
}
var directory_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var directory___vue_styles__ = directory_injectStyle
/* scopeId */
var directory___vue_scopeId__ = "data-v-4330e785"
/* moduleIdentifier (server only) */
var directory___vue_module_identifier__ = null
var directory_Component = directory_normalizeComponent(
  directory,
  components_directory,
  directory___vue_styles__,
  directory___vue_scopeId__,
  directory___vue_module_identifier__
)

/* harmony default export */ var javascript_components_directory = (directory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/checkbox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_checkbox = ({
  model: {
    prop: "checked"
  },

  props: {
    checked: {
      type: Boolean
    },
    label: {
      type: String
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-708f004a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/checkbox.vue
var checkbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "change": function($event) {
        _vm.$emit('input', $event.target.checked)
      }
    }
  }), _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])])
}
var checkbox_staticRenderFns = []
var checkbox_esExports = { render: checkbox_render, staticRenderFns: checkbox_staticRenderFns }
/* harmony default export */ var javascript_components_checkbox = (checkbox_esExports);
// CONCATENATED MODULE: ./app/javascript/components/checkbox.vue
function checkbox_injectStyle (ssrContext) {
  __webpack_require__(294)
}
var checkbox_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var checkbox___vue_styles__ = checkbox_injectStyle
/* scopeId */
var checkbox___vue_scopeId__ = "data-v-708f004a"
/* moduleIdentifier (server only) */
var checkbox___vue_module_identifier__ = null
var checkbox_Component = checkbox_normalizeComponent(
  components_checkbox,
  javascript_components_checkbox,
  checkbox___vue_styles__,
  checkbox___vue_scopeId__,
  checkbox___vue_module_identifier__
)

/* harmony default export */ var app_javascript_components_checkbox = (checkbox_Component.exports);

// EXTERNAL MODULE: ./app/javascript/lib/google-maps.js
var google_maps = __webpack_require__(73);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/location-filter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var location_filter = ({
  props: {
    location: {
      type: String
    },
    coords: {
      type: Object
    },
    radius: {
      type: String
    }
  },

  data: function data() {
    return {
      searchText: this.location,
      miles: [5, 10, 25, 50],
      radius: "5 miles"
    };
  },
  mounted: function mounted() {
    var _this = this;

    google_maps["a" /* default */].load(function (google) {
      var autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, {
        types: ["geocode"],
        fields: ["name", "geometry.location", "formatted_address"]
      });

      google.maps.event.addListener(autocomplete, "place_changed", function () {
        var place = autocomplete.getPlace();

        if (place.name !== "" && place.geometry) {
          _this.$emit("location", place.formatted_address);
          _this.$emit("coords", {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          });
        } else {
          _this.$emit("location", "");
          _this.$emit("coords", { lat: null, lng: null });
        }
      });
    });
  },


  watch: {
    location: function location(nextValue) {
      this.searchText = nextValue;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2106b028","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/location-filter.vue
var location_filter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-location-filter"
  }, [_c('span', {
    staticClass: "cm-location-filter__location-icon"
  }, [_vm._v("location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "input",
    staticClass: "cm-location-filter__input",
    attrs: {
      "type": "text",
      "placeholder": "Location",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cm-location-filter__separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "cm-location-filter__radius"
  }, [_c('select', {
    staticClass: "cm-location-filter__radius-select",
    domProps: {
      "value": _vm.radius
    },
    on: {
      "input": function($event) {
        _vm.$emit('radius', $event.target.value)
      }
    }
  }, _vm._l((_vm.miles), function(mile) {
    return _c('option', {
      key: mile,
      domProps: {
        "value": (mile + " miles")
      }
    }, [_vm._v(_vm._s((mile + " miles")))])
  })), _vm._v(" "), _c('div', {
    staticClass: "cm-location-filter__radius-arrow"
  }, [_vm._v("navigatedown")])])])
}
var location_filter_staticRenderFns = []
var location_filter_esExports = { render: location_filter_render, staticRenderFns: location_filter_staticRenderFns }
/* harmony default export */ var components_location_filter = (location_filter_esExports);
// CONCATENATED MODULE: ./app/javascript/components/location-filter.vue
function location_filter_injectStyle (ssrContext) {
  __webpack_require__(295)
}
var location_filter_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var location_filter___vue_styles__ = location_filter_injectStyle
/* scopeId */
var location_filter___vue_scopeId__ = "data-v-2106b028"
/* moduleIdentifier (server only) */
var location_filter___vue_module_identifier__ = null
var location_filter_Component = location_filter_normalizeComponent(
  location_filter,
  components_location_filter,
  location_filter___vue_styles__,
  location_filter___vue_scopeId__,
  location_filter___vue_module_identifier__
)

/* harmony default export */ var javascript_components_location_filter = (location_filter_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/isPlainObject.js
var isPlainObject = __webpack_require__(296);
var isPlainObject_default = /*#__PURE__*/__webpack_require__.n(isPlainObject);

// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__(75);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(300);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(230);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// CONCATENATED MODULE: ./app/javascript/mixins/directory.js
function directory__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }














/* harmony default export */ var mixins_directory = ({
  components: {
    Directory: javascript_components_directory,
    Checkbox: app_javascript_components_checkbox,
    CmSelect: app_javascript_components_select,
    LocationFilter: javascript_components_location_filter
  },

  props: {
    filters: {
      type: Array
    }
  },

  data: function data() {
    return {
      isLoading: true,
      isUpdatedFromUrl: false,

      page: 0,
      size: 24,

      response: null,

      debouncedUpdateUrl: debounce_default()(this.updateUrl, 1000, {
        leading: true,
        trailing: true
      })
    };
  },
  created: function created() {
    var _this = this;

    this.fetchResults().then(function (response) {
      _this.response = response;
    }).catch(function (error) {
      console.error(error);
    }).then(function () {
      _this.isLoading = false;
    });

    window.addEventListener("popstate", this.setFilterValuesFromLocation);
  },


  computed: {
    resultCount: function resultCount() {
      if (this.response) {
        return this.response.hits.total;
      } else {
        return 0;
      }
    },
    isInitialLoad: function isInitialLoad() {
      return this.isLoading && !this.response;
    }
  },

  watch: {
    query: function query() {
      var _this2 = this;

      this.page = 0;
      this.fetchResults().then(function (response) {
        _this2.response = response;
      }).catch(function (error) {
        console.error(error);
      }).then(function () {
        _this2.isLoading = false;
      });
    },


    filterValues: {
      handler: function handler(next, prev) {
        if (this.isUpdatedFromUrl) {
          this.isUpdatedFromUrl = false;
        } else {
          this.debouncedUpdateUrl(next);
        }
      },

      deep: true
    }
  },

  methods: {
    setFilterValuesFromLocation: function setFilterValuesFromLocation() {
      this.isUpdatedFromUrl = true;

      this.filterValues = this.generateFilterValues(this.generateFilters());
    },
    generateDefaultFilterValues: function generateDefaultFilterValues(filters) {
      return filters.reduce(function (obj, filter) {
        obj[filter.key] = filter.default;
        return obj;
      }, {});
    },
    generateFilterValues: function generateFilterValues(filters) {
      return filters.reduce(function (obj, filter) {
        obj[filter.key] = filter.initial || filter.default;
        return obj;
      }, {});
    },
    fetchResults: function fetchResults() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.isLoading = true;

      var promise = elastic_search({
        index: this.index,
        size: this.size,
        from: this.size * page,
        body: this.query
      });

      return promise;
    },
    fetchNextPage: function fetchNextPage() {
      var _this3 = this;

      this.fetchResults(this.page + 1).then(function (response) {
        var _response$hits$hits;

        (_response$hits$hits = _this3.response.hits.hits).push.apply(_response$hits$hits, directory__toConsumableArray(response.hits.hits));

        _this3.page++;
      }).catch(function (error) {
        console.error(error);
      }).then(function () {
        _this3.isLoading = false;
      });
    },
    clearAllFilters: function clearAllFilters() {
      this.clearFilter(this.filterKeys);
    },
    clearFilter: function clearFilter(keys, value) {
      var _this4 = this;

      keys.forEach(function (key) {
        if (value) {
          _this4.filterValues[key] = _this4.filterValues[key].filter(function (el) {
            return el !== value;
          });
        } else {
          _this4.filterValues[key] = _this4.defaultValues[key];
        }
      });
    },
    updateUrl: function updateUrl(filterValues) {
      var url = new URL(window.location);

      this.filterArray.forEach(function (el) {
        var value = filterValues[el.key];
        var key = el.urlKey || el.key;

        if (!isEqual_default()(value, el.default)) {
          if (isArray_default()(value)) {
            url.searchParams.delete(key);
            value.forEach(function (v) {
              url.searchParams.append(key, v);
            });
          } else if (isPlainObject_default()(value)) {
            url.searchParams.set(key, JSON.stringify(value));
          } else {
            url.searchParams.set(key, value);
          }
        } else {
          url.searchParams.delete(key);
        }
      });

      window.history.pushState(null, null, url.href);
      var search = window.location.search;

      var urlParams = new URLSearchParams(search);

      var googleEventString = "";

      Array.from(urlParams.keys()).map(function (key) {
        var param = urlParams.get(key);
        if (param.length > 1) {
          key = key.replace(/_/g, " ");
          googleEventString += key + ": " + param + ", ";
        }
      });

      var eventName = this.unitLabels.singular.toLowerCase();
      window.trackGoogleEvent('search', eventName, googleEventString);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/pages/jobs.vue
function jobs__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function pages_jobs__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// If there's a variable in the template or in the JS that you can't find,
// CHECK THE MIXIN







/* harmony default export */ var pages_jobs = ({
  mixins: [mixins_directory],

  components: {
    Job: javascript_company_job
  },

  data: function data() {
    var filters = this.generateFilters();

    return {
      filterArray: filters,
      defaultValues: this.generateDefaultFilterValues(filters),
      filterValues: this.generateFilterValues(filters),
      unitLabels: {
        singular: "Job",
        plural: "Jobs"
      },
      aggregatedHits: [],

      index: "jobs"
    };
  },


  computed: {
    filterKeys: function filterKeys() {
      return ["remote_friendly", "skill_tag_id", "commitment", "location", "coords", "company_id"];
    },
    activeFilters: function activeFilters() {
      var _this = this;

      var values = this.filterValues;
      var defaults = this.defaultValues;

      return [{
        label: "Remote Friendly",
        keys: ["remote_friendly"],
        value: values.remote_friendly
      }, {
        keys: ["company_id"],
        value: values.company_id,
        label: "from " + (((this.results.find(function (result) {
          return result.company.id === parseInt(values.company_id);
        }) || {}).company || {}).name || "...")
      }].concat(pages_jobs__toConsumableArray(values.skill_tag_id.map(function (filterValue) {
        return {
          keys: ["skill_tag_id"],
          match: filterValue,
          value: filterValue,
          label: (_this.filters.find(function (propsFilter) {
            return propsFilter.id === "skill_tag_id";
          }).options.find(function (option) {
            return option.value === filterValue;
          }) || {}).label
        };
      })), pages_jobs__toConsumableArray(values.commitment.map(function (filterValue) {
        return {
          keys: ["commitment"],
          match: filterValue,
          value: filterValue,
          label: (_this.filters.find(function (propsFilter) {
            return propsFilter.id === "commitment";
          }).options.find(function (option) {
            return option.value === filterValue;
          }) || {}).label
        };
      })), [values.coords.lat && values.coords.lng && {
        keys: ["location", "coords"],
        label: "Within " + values.radius + " of " + values.location
      }]).filter(Boolean).filter(function (filter) {
        return filter.value !== defaults[filter.keys[0]];
      });
    },
    anyfiltersActive: function anyfiltersActive() {
      var values = this.filterValues;
      var defaults = this.defaultValues;

      return [["remote_friendly", values.remote_friendly], ["company_id", values.company_id], values.skill_tag_id.length > 0 && ["skill_tag_id", values.skill_tag_id], values.commitment.length > 0 && ["commitment", values.commitment], values.coords.lat && values.coords.lng && ["location", [values.coords.lat, values.coords.lng]]].filter(Boolean).filter(function (filter) {
        return filter[1] !== defaults[filter[0]];
      }).length > 0;
    },
    noFiltersApplied: function noFiltersApplied() {
      return this.filterValues.input_text.length == 0 && !this.anyfiltersActive;
    },
    results: function results() {
      var _this2 = this;

      if (this.response) {
        var mapSource = function mapSource(el) {
          return el._source;
        };

        var hits = this.response.hits.hits.map(mapSource);

        if (this.noFiltersApplied && this.response.aggregations && this.response.aggregations.top_per_company) {
          if (this.aggregatedHits.length == 0) {
            this.aggregatedHits = this.response.aggregations.top_per_company.buckets.map(function (x) {
              return x.tops.hits.hits;
            }).reduce(function (acc, val) {
              return acc.concat(val);
            }, []).map(mapSource).sort(function () {
              return Math.random() - 0.5;
            });
          }

          var dedupedJobs = hits.filter(function (hit) {
            return !_this2.aggregatedHits.map(function (aggJob) {
              return aggJob.id;
            }).includes(hit.id);
          });

          var aggedResults = [].concat(pages_jobs__toConsumableArray(this.aggregatedHits), pages_jobs__toConsumableArray(dedupedJobs));

          return aggedResults.slice(0, (this.page + 1) * 15);
        } else {
          return hits;
        }
      } else return [];
    },
    query: function query() {
      var filters = this.filterValues;
      var sortValues = function sortValues() {
        return [filters.sort_key === "recently_updated" && {
          updated_at: "desc"
        }, filters.sort_key === "newest" && { created_at: "desc" }, "_score"].filter(Boolean);
      };

      return {
        aggs: {
          top_per_company: {
            terms: {
              field: "company.id",
              size: 10, // 10 companies is 30 jobs total
              order: jobs__defineProperty({}, filters.sort_key, "desc")
            },
            aggs: {
              tops: {
                top_hits: {
                  sort: sortValues(),
                  size: 3
                }
              },
              recently_updated: {
                max: {
                  field: "updated_at"
                }
              },
              newest: {
                max: {
                  field: "created_at"
                }
              }
            }
          }
        },
        sort: sortValues(),
        query: {
          bool: {
            must: [{ match: { visible: true } }, { match: { "company.application_status": "published" } }, filters.commitment.length && {
              terms: { "commitment.id": filters.commitment }
            }, filters.skill_tag_id.length && {
              terms: { "skill_tags.id": filters.skill_tag_id }
            }, filters.company_id && {
              match: { "company.id": filters.company_id }
            }, filters.remote_friendly && {
              bool: {
                should: [{ match: { remote: true } }, { match: { remote_friendly: true } }]
              }
            }, filters.coords.lat && filters.coords.lng && {
              geo_distance: {
                distance: filters.radius,
                coordinates: filters.coords.lat + "," + filters.coords.lng
              }
            }, filters.input_text !== "" && {
              query_string: {
                query: preprocessQueryString(filters.input_text),
                default_operator: "AND",
                fuzziness: 1,
                fuzzy_prefix_length: 0,
                fuzzy_max_expansions: 10
              }
            }].filter(Boolean)
          }
        }
      };
    }
  },

  methods: {
    generateFilters: function generateFilters() {
      return [{
        key: "input_text",
        initial: getURLParams().get("input_text"),
        default: ""
      }, {
        key: "sort_key",
        initial: getURLParams().get("sort_key"),
        default: "newest"
      }, {
        key: "skill_tag_id",
        urlKey: "skill_id",
        initial: getURLParams().getAll("skill_id"),
        default: []
      }, {
        key: "commitment",
        initial: getURLParams().getAll("commitment"),
        default: []
      }, {
        key: "company_id",
        initial: getURLParams().get("company_id"),
        default: null
      }, {
        key: "remote_friendly",
        initial: getURLParams().get("remote_friendly"),
        default: false
      }, {
        key: "radius",
        initial: getURLParams().get("radius"),
        default: "5 miles"
      }, {
        key: "coords",
        initial: JSON.parse(getURLParams().get("coords")),
        default: { lat: null, lng: null }
      }, {
        key: "location",
        initial: getURLParams().get("location"),
        default: null
      }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3c15d5c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/pages/jobs.vue
var pages_jobs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Directory', _vm._b({
    staticClass: "jobs",
    on: {
      "text-input": function($event) {
        _vm.filterValues.input_text = $event
      },
      "clear-all": _vm.clearAllFilters,
      "clear-filter": _vm.clearFilter,
      "more-click": _vm.fetchNextPage
    }
  }, 'Directory', {
    activeFilters: _vm.activeFilters,
    inputText: _vm.filterValues.input_text,
    isLoading: _vm.isLoading,
    results: _vm.results,
    resultCount: _vm.resultCount,
    unitLabels: _vm.unitLabels
  }, false), [_c('div', {
    staticClass: "jobs__filters-list",
    slot: "filters"
  }, [_vm._l((_vm.filters), function(filter) {
    return _c('CmSelect', {
      key: filter.id,
      staticClass: "jobs__filter jobs__filter--select",
      attrs: {
        "name": filter.id,
        "options": filter.options,
        "null-label": filter.nullLabel,
        "label": filter.label,
        "multiple": filter.multiple,
        "include-search": filter.options.length > 12,
        "value": _vm.filterValues[filter.id],
        "compact": ""
      },
      on: {
        "input": function($event) {
          _vm.filterValues[filter.id] = $event
        }
      }
    })
  }), _vm._v(" "), _c('LocationFilter', {
    staticClass: "jobs__filter jobs__filter--select",
    attrs: {
      "location": _vm.filterValues.location,
      "radius": _vm.filterValues.radius
    },
    on: {
      "location": function($event) {
        _vm.filterValues.location = $event
      },
      "coords": function($event) {
        _vm.filterValues.coords = $event
      },
      "radius": function($event) {
        _vm.filterValues.radius = $event
      }
    },
    model: {
      value: (_vm.filterValues.location),
      callback: function($$v) {
        _vm.filterValues.location = $$v
      },
      expression: "filterValues.location"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "jobs__filter jobs__filter--checkbox",
    attrs: {
      "label": "Remote friendly"
    },
    model: {
      value: (_vm.filterValues.remote_friendly),
      callback: function($$v) {
        _vm.filterValues.remote_friendly = $$v
      },
      expression: "filterValues.remote_friendly"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "jobs__list",
    class: {
      'jobs__list--is-loading': _vm.isLoading,
    }
  }, _vm._l((_vm.results), function(result) {
    return _c('Job', {
      key: result.id,
      staticClass: "jobs__job",
      attrs: {
        "job": result,
        "show": {
          date: true,
          motto: true
        },
        "company": result.company,
        "context": "search"
      }
    })
  }))])
}
var pages_jobs_staticRenderFns = []
var pages_jobs_esExports = { render: pages_jobs_render, staticRenderFns: pages_jobs_staticRenderFns }
/* harmony default export */ var javascript_pages_jobs = (pages_jobs_esExports);
// CONCATENATED MODULE: ./app/javascript/pages/jobs.vue
function pages_jobs_injectStyle (ssrContext) {
  __webpack_require__(289)
}
var pages_jobs_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var pages_jobs___vue_styles__ = pages_jobs_injectStyle
/* scopeId */
var pages_jobs___vue_scopeId__ = "data-v-d3c15d5c"
/* moduleIdentifier (server only) */
var pages_jobs___vue_module_identifier__ = null
var pages_jobs_Component = pages_jobs_normalizeComponent(
  pages_jobs,
  javascript_pages_jobs,
  pages_jobs___vue_styles__,
  pages_jobs___vue_scopeId__,
  pages_jobs___vue_module_identifier__
)

/* harmony default export */ var app_javascript_pages_jobs = (pages_jobs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/featured-companies.vue
var featured_companies__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var featured_companies = ({
  components: {
    CompanyCard: javascript_components_company_card
  },

  data: function data() {
    return {
      index: "companies",
      response: null
    };
  },
  created: function created() {
    var _this = this;

    var promise = this.fetchResults();
    promise.then(function (response) {
      _this.isLoading = false;
      _this.response = response;
    });
  },


  computed: {
    results: function results() {
      if (this.response) {
        return this.response.hits.hits.map(function (el) {
          return featured_companies__extends({}, el._source);
        });
      } else return [];
    },
    query: function query() {
      return {
        sort: [{ featured_at: "desc" }],
        query: {
          bool: {
            must: [{ match: { application_status: "published" } }, { match: { featured: "true" } }],
            should: [{ range: { project_count: { "gt": 0 } } }, { match: { is_hiring: true } }]
          }
        }
      };
    }
  },

  methods: {
    fetchResults: function fetchResults() {
      this.isLoading = true;

      var promise = elastic_search({
        index: 'companies',
        size: 6,
        body: this.query
      });

      return promise;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab07b2d8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-companies.vue
var featured_companies_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "companies__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('CompanyCard', {
      key: result.id,
      staticClass: "companies__job",
      attrs: {
        "company": result,
        "mini": ""
      }
    })
  }))
}
var featured_companies_staticRenderFns = []
var featured_companies_esExports = { render: featured_companies_render, staticRenderFns: featured_companies_staticRenderFns }
/* harmony default export */ var components_featured_companies = (featured_companies_esExports);
// CONCATENATED MODULE: ./app/javascript/components/featured-companies.vue
function featured_companies_injectStyle (ssrContext) {
  __webpack_require__(368)
}
var featured_companies_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var featured_companies___vue_styles__ = featured_companies_injectStyle
/* scopeId */
var featured_companies___vue_scopeId__ = "data-v-ab07b2d8"
/* moduleIdentifier (server only) */
var featured_companies___vue_module_identifier__ = null
var featured_companies_Component = featured_companies_normalizeComponent(
  featured_companies,
  components_featured_companies,
  featured_companies___vue_styles__,
  featured_companies___vue_scopeId__,
  featured_companies___vue_module_identifier__
)

/* harmony default export */ var javascript_components_featured_companies = (featured_companies_Component.exports);

// CONCATENATED MODULE: ./app/javascript/lib/math.js
function math__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// inspired by d3-scale's linearScale
var linearScale = function linearScale() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    domain: [0, 100],
    range: [0, 1],
    clamp: false
  };
  return function (value) {
    var result = opts.range[0] + (opts.range[1] - opts.range[0]) * ((value - opts.domain[0]) / (opts.domain[1] - opts.domain[0]));

    if (opts.clamp) {
      var clamps = [].concat(math__toConsumableArray(opts.range)).sort(function (a, b) {
        return a - b;
      });

      result = Math.max(Math.min(clamps[1], result), clamps[0]);
    }

    return result;
  };
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/chapter-box.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * To make the badge type legible at more sizes, we dynamically scale the text size based on the width of the container;
 * starting at 6px (when the viewBox is 190w), the text scales to 9px (when the SVG viewBox is 30w) to make the text slightly larger.
 * The badge has dynamic text, so we determine the SVG's width based on the largest possible size of the text.
 */


var range = [9, 6];
var scale = linearScale({
  domain: [30, 190],
  range: range,
  clamp: true
});

/* harmony default export */ var chapter_box = ({
  data: function data() {
    return {
      range: range,
      badgeWidth: 15,
      fontSize: 7
    };
  },


  props: {
    chapter: {
      type: Object
    },
    badge: {
      type: String
    }
  },

  methods: {
    handleResize: function handleResize(entry) {
      this.fontSize = scale(entry.contentRect.width);
    },
    handleBadgeResize: function handleBadgeResize(entry) {
      // entry.contentRect reports 0px on tspans in firefox?
      this.badgeWidth = entry.target.getBBox().width + 4;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-227bdc78","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/chapter-box.vue
var chapter_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter-box",
    class: ("ch_" + (_vm.chapter.id) + " " + (_vm.badge && 'chapter-box--badge'))
  }, [_c('svg', {
    directives: [{
      name: "resize",
      rawName: "v-resize.border",
      value: (_vm.handleResize),
      expression: "handleResize",
      modifiers: {
        "border": true
      }
    }],
    staticClass: "cm_bg",
    attrs: {
      "width": "15",
      "height": "13",
      "viewBox": "0 0 15 13"
    }
  }, [_c('title', [_vm._v(_vm._s(_vm.chapter.name))]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "7.5",
      "width": "15",
      "y": "7.25"
    }
  }, [_c('tspan', {
    staticClass: "text",
    style: ({
      fontSize: _vm.fontSize + 'px'
    })
  }, [_vm._v(_vm._s(_vm.chapter.abbreviation))])]), _vm._v(" "), _c('polygon', {
    staticClass: "triangle cm_fill",
    attrs: {
      "points": "2,12 2,16 6,12"
    }
  })]), _vm._v(" "), (_vm.badge) ? _c('svg', {
    staticClass: "team-badge",
    attrs: {
      "width": _vm.badgeWidth,
      "height": "13",
      "viewBox": '0 0 ' + _vm.badgeWidth + ' 13'
    }
  }, [_c('text', {
    attrs: {
      "x": _vm.badgeWidth / 2,
      "width": _vm.badgeWidth,
      "y": "7.25"
    }
  }, [_c('tspan', {
    staticClass: "text",
    style: ({
      fontSize: _vm.fontSize + 'px'
    })
  }, [_vm._v(_vm._s(_vm.badge))])]), _vm._v(" "), _c('text', {
    staticClass: "badge-sizing-rect"
  }, [_c('tspan', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.handleBadgeResize),
      expression: "handleBadgeResize"
    }],
    staticClass: "text",
    style: ({
      fontSize: _vm.range[0] + 'px'
    })
  }, [_vm._v(_vm._s(_vm.badge))])])]) : _vm._e()])
}
var chapter_box_staticRenderFns = []
var chapter_box_esExports = { render: chapter_box_render, staticRenderFns: chapter_box_staticRenderFns }
/* harmony default export */ var company_chapter_box = (chapter_box_esExports);
// CONCATENATED MODULE: ./app/javascript/company/chapter-box.vue
function chapter_box_injectStyle (ssrContext) {
  __webpack_require__(371)
}
var chapter_box_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var chapter_box___vue_styles__ = chapter_box_injectStyle
/* scopeId */
var chapter_box___vue_scopeId__ = "data-v-227bdc78"
/* moduleIdentifier (server only) */
var chapter_box___vue_module_identifier__ = null
var chapter_box_Component = chapter_box_normalizeComponent(
  chapter_box,
  company_chapter_box,
  chapter_box___vue_styles__,
  chapter_box___vue_scopeId__,
  chapter_box___vue_module_identifier__
)

/* harmony default export */ var javascript_company_chapter_box = (chapter_box_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/company/individual-card.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var individual_card = ({
  components: {
    ChapterBox: javascript_company_chapter_box
  },

  props: {
    person: {
      type: Object
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    fullName: function fullName() {
      return this.person.firstname + " " + this.person.lastname;
    },

    description: function description() {
      if (this.person.job_title && this.person.company_name) {
        return this.person.job_title + " at " + this.person.company_name;
      } else if (this.person.job_title) {
        return this.person.job_title;
      } else if (this.person.company_name) {
        return this.person.company_name;
      }
    },

    badge_class: function badge_class() {
      if (this.person.chapter) {
        return "ch_" + this.person.chapter.id;
      }
    },

    avatar: function avatar() {
      var i = parseInt(this.person.id.toString().slice(-1));
      var hash = i < 8 ? i < 4 ? i % 4 : i % 2 + 1 : Math.floor(i % 1.5 + 2.5);
      return "/images/avatars/cm-avatar-" + hash + ".svg";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620516f1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/individual-card.vue
var individual_card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "person"
  }, [_c('a', {
    staticClass: "person-link",
    attrs: {
      "href": _vm.person.url
    }
  }, [_vm._v("\n    View Profile\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-wrap",
    class: _vm.badge_class
  }, [_c('img', {
    staticClass: "avatar-bg cm_bg",
    attrs: {
      "src": _vm.person.avatar || _vm.avatar,
      "alt": _vm.fullName,
      "loading": "lazy"
    }
  }), _vm._v(" "), (_vm.person.chapter) ? _c('ChapterBox', {
    attrs: {
      "chapter": _vm.person.chapter,
      "badge": _vm.person.team_badge
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "person-text"
  }, [_c('h1', {
    staticClass: "person-name"
  }, [_vm._v(_vm._s(_vm.fullName))]), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "person-description"
  }, [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.person.location) ? _c('div', {
    staticClass: "person-location"
  }, [_vm._v(_vm._s(_vm.person.location))]) : _vm._e()])])
}
var individual_card_staticRenderFns = []
var individual_card_esExports = { render: individual_card_render, staticRenderFns: individual_card_staticRenderFns }
/* harmony default export */ var company_individual_card = (individual_card_esExports);
// CONCATENATED MODULE: ./app/javascript/company/individual-card.vue
function individual_card_injectStyle (ssrContext) {
  __webpack_require__(370)
}
var individual_card_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var individual_card___vue_styles__ = individual_card_injectStyle
/* scopeId */
var individual_card___vue_scopeId__ = "data-v-620516f1"
/* moduleIdentifier (server only) */
var individual_card___vue_module_identifier__ = null
var individual_card_Component = individual_card_normalizeComponent(
  individual_card,
  company_individual_card,
  individual_card___vue_styles__,
  individual_card___vue_scopeId__,
  individual_card___vue_module_identifier__
)

/* harmony default export */ var javascript_company_individual_card = (individual_card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/featured-individuals.vue
var featured_individuals__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var featured_individuals = ({

  components: {
    IndividualCard: javascript_company_individual_card
  },

  props: {
    isLoggedIn: {
      type: Boolean
    },
    favorites: {
      type: Array
    }
  },

  data: function data() {
    return {
      index: "companies",

      dynamicFavorites: this.favorites,
      response: null
    };
  },
  created: function created() {
    var _this = this;

    var promise = this.fetchResults();
    promise.then(function (response) {
      _this.isLoading = false;
      _this.response = response;
    });
  },


  computed: {
    results: function results() {
      if (this.response) {
        return this.response.hits.hits.map(function (el) {
          return featured_individuals__extends({}, el._source);
        });
      } else return [];
    },
    query: function query() {
      return {
        sort: [{ featured_at: "desc" }],
        query: {
          bool: {
            must: [{ match: { featured: true } }]
          }
        }
      };
    }
  },

  methods: {
    fetchResults: function fetchResults() {
      this.isLoading = true;

      var promise = elastic_search({
        index: 'users',
        size: 4,
        body: this.query
      });

      return promise;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-583ee9f3","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-individuals.vue
var featured_individuals_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "individuals__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('IndividualCard', {
      key: result.id,
      staticClass: "individuals__individual",
      attrs: {
        "person": result
      }
    })
  }))
}
var featured_individuals_staticRenderFns = []
var featured_individuals_esExports = { render: featured_individuals_render, staticRenderFns: featured_individuals_staticRenderFns }
/* harmony default export */ var components_featured_individuals = (featured_individuals_esExports);
// CONCATENATED MODULE: ./app/javascript/components/featured-individuals.vue
function featured_individuals_injectStyle (ssrContext) {
  __webpack_require__(369)
}
var featured_individuals_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var featured_individuals___vue_styles__ = featured_individuals_injectStyle
/* scopeId */
var featured_individuals___vue_scopeId__ = "data-v-583ee9f3"
/* moduleIdentifier (server only) */
var featured_individuals___vue_module_identifier__ = null
var featured_individuals_Component = featured_individuals_normalizeComponent(
  featured_individuals,
  components_featured_individuals,
  featured_individuals___vue_styles__,
  featured_individuals___vue_scopeId__,
  featured_individuals___vue_module_identifier__
)

/* harmony default export */ var javascript_components_featured_individuals = (featured_individuals_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/project-card.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var project_card = ({
  props: {
    project: {
      type: Object
    }
  },

  data: function data() {
    return {};
  },


  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666b94dc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/project-card.vue
var project_card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "project"
  }, [_c('a', {
    staticClass: "project-link",
    attrs: {
      "href": _vm.project.url
    }
  }, [_vm._v("\n    View Project\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "project-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.project.photos[0].url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "project-text"
  }, [_c('h1', {
    staticClass: "project-name h5"
  }, [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('div', {
    staticClass: "project-company"
  }, [_c('img', {
    staticClass: "project-company-logo",
    attrs: {
      "src": _vm.project.company.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "project-company-info"
  }, [_c('h3', {
    staticClass: "project-company-name"
  }, [_vm._v(_vm._s(_vm.project.company.name))]), _vm._v(" "), _c('h3', {
    staticClass: "project-company-location"
  }, [_vm._v(_vm._s(_vm.project.company.location))])])])])])
}
var project_card_staticRenderFns = []
var project_card_esExports = { render: project_card_render, staticRenderFns: project_card_staticRenderFns }
/* harmony default export */ var components_project_card = (project_card_esExports);
// CONCATENATED MODULE: ./app/javascript/components/project-card.vue
function project_card_injectStyle (ssrContext) {
  __webpack_require__(373)
}
var project_card_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var project_card___vue_styles__ = project_card_injectStyle
/* scopeId */
var project_card___vue_scopeId__ = "data-v-666b94dc"
/* moduleIdentifier (server only) */
var project_card___vue_module_identifier__ = null
var project_card_Component = project_card_normalizeComponent(
  project_card,
  components_project_card,
  project_card___vue_styles__,
  project_card___vue_scopeId__,
  project_card___vue_module_identifier__
)

/* harmony default export */ var javascript_components_project_card = (project_card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/cm-masonry-layout.vue
function cm_masonry_layout__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ var cm_masonry_layout = ({
  data: function data() {
    return {
      initialized: false
    };
  },


  render: function render(h) {
    var _this2 = this;

    // if DOMcontent exists && initalize hasn't run already
    if (this.$slots.default && !this.initialized) {
      this.$nextTick(function () {
        return _this2.initialize();
      });
    };

    return h('div', { class: 'cm-masonry-layout' },
    // each child must be wrapped in a div for reliable sizing
    (this.$slots.default || []).map(function (child) {
      return h('div', { class: 'cm-masonry-layout__item' }, [child]);
    }));
  },

  mounted: function mounted() {
    window.addEventListener("resize", this.layoutAllGridItems);
  },
  updated: function updated() {
    this.layoutAllGridItems();
  },


  methods: {
    layoutGridItem: function layoutGridItem(item) {
      var grid = this.$el;
      var style = window.getComputedStyle(grid);
      var rowHeight = parseInt(style.getPropertyValue("grid-auto-rows"));
      var rowGap = parseInt(style.getPropertyValue("grid-row-gap"));
      var rowSpan = Math.ceil((item.children[0].getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
      item.style.gridRowEnd = 'span ' + rowSpan;
    },
    layoutAllGridItems: function layoutAllGridItems() {
      var _this3 = this;

      ;[].concat(cm_masonry_layout__toConsumableArray(this.$el.children)).forEach(function (item) {
        _this3.layoutGridItem(item);
      });
    },
    resizeInstance: function resizeInstance(instance) {
      item = instance.elements[0];
      this.layoutGridItem(item);
    },
    initialize: function initialize() {
      var _this4 = this;

      // only run once
      this.initialized = true;

      var images = [].concat(cm_masonry_layout__toConsumableArray(this.$el.querySelectorAll('img')));

      // checks if promise exists on browser before running
      if (Promise && Promise.hasOwnProperty('allSettled')) {
        // better user-facing solution to laying out items because we continually
        // layout the grid while images are loading, making the reflows seem more natural
        // setInterval uses the wrong `this` so we re-scope it:
        var _this = this;

        // run layout calculator every 0.3s until we cancel it
        var layoutInterval = setInterval(_this.layoutAllGridItems, 300);

        var imageLoadPromises = images.map(function (img) {
          return new Promise(function (resolve, reject) {
            img.addEventListener('load', resolve);
            img.addEventListener('error', reject);
          });
        });

        Promise.allSettled(imageLoadPromises).then(function (results) {
          clearInterval(layoutInterval);

          // run one last time just in case
          _this4.layoutAllGridItems();
        });
      } else {
        // chunkier but simpler method for IE / FF-Android / ?
        images.forEach(function (img) {
          img.addEventListener('load', _this4.layoutAllGridItems);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./app/javascript/components/cm-masonry-layout.vue
function cm_masonry_layout_injectStyle (ssrContext) {
  __webpack_require__(374)
}
var cm_masonry_layout_normalizeComponent = __webpack_require__(7)
/* script */

/* template */
var cm_masonry_layout___vue_template__ = null
/* styles */
var cm_masonry_layout___vue_styles__ = cm_masonry_layout_injectStyle
/* scopeId */
var cm_masonry_layout___vue_scopeId__ = "data-v-4e16c48d"
/* moduleIdentifier (server only) */
var cm_masonry_layout___vue_module_identifier__ = null
var cm_masonry_layout_Component = cm_masonry_layout_normalizeComponent(
  cm_masonry_layout,
  cm_masonry_layout___vue_template__,
  cm_masonry_layout___vue_styles__,
  cm_masonry_layout___vue_scopeId__,
  cm_masonry_layout___vue_module_identifier__
)

/* harmony default export */ var components_cm_masonry_layout = (cm_masonry_layout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/cm-chiclet.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cm_chiclet = ({
  props: {
    type: {
      type: String,
      default: "checkbox"
    },
    value: {
      type: String
    },
    label: {
      type: String
    },
    group: { // the html
      type: String
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ad9bf9e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-chiclet.vue
var cm_chiclet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "cm-chiclet",
    class: {
      checked: _vm.checked
    }
  }, [_c('input', _vm._b({
    staticClass: "cm-chiclet__input"
  }, 'input', {
    type: _vm.type,
    value: _vm.value,
    name: _vm.group,
    checked: _vm.checked
  }, false)), _vm._v(" "), _c('div', {
    staticClass: "cm-chiclet__label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])])
}
var cm_chiclet_staticRenderFns = []
var cm_chiclet_esExports = { render: cm_chiclet_render, staticRenderFns: cm_chiclet_staticRenderFns }
/* harmony default export */ var components_cm_chiclet = (cm_chiclet_esExports);
// CONCATENATED MODULE: ./app/javascript/components/cm-chiclet.vue
function cm_chiclet_injectStyle (ssrContext) {
  __webpack_require__(375)
}
var cm_chiclet_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var cm_chiclet___vue_styles__ = cm_chiclet_injectStyle
/* scopeId */
var cm_chiclet___vue_scopeId__ = "data-v-2ad9bf9e"
/* moduleIdentifier (server only) */
var cm_chiclet___vue_module_identifier__ = null
var cm_chiclet_Component = cm_chiclet_normalizeComponent(
  cm_chiclet,
  components_cm_chiclet,
  cm_chiclet___vue_styles__,
  cm_chiclet___vue_scopeId__,
  cm_chiclet___vue_module_identifier__
)

/* harmony default export */ var javascript_components_cm_chiclet = (cm_chiclet_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/featured-projects.vue
var featured_projects__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var featured_projects = ({
  components: {
    ProjectCard: javascript_components_project_card,
    CmMasonryLayout: components_cm_masonry_layout,
    CmChiclet: javascript_components_cm_chiclet
  },

  props: {
    isLoggedIn: {
      type: Boolean
    },
    favorites: {
      type: Array
    }
  },

  data: function data() {
    return {
      index: "projects",

      skill_tags: [],

      dynamicFavorites: this.favorites,
      response: null
    };
  },
  created: function created() {
    var _this = this;

    var promise = this.fetchResults();
    promise.then(function (response) {
      _this.isLoading = false;
      _this.response = response;
    });
  },


  computed: {
    results: function results() {
      if (this.response) {
        return this.response.hits.hits.map(function (el) {
          return featured_projects__extends({}, el._source);
        });
      } else return [];
    }
  },

  methods: {
    fetchResults: function fetchResults() {
      this.isLoading = true;

      var promise = elastic_search({
        index: 'projects',
        size: 6,
        body: {
          sort: [{ featured_at: "desc" }],
          query: {
            bool: {
              must: [{ match: { featured: true } }]
            }
          }
        }
      });

      return promise;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffd1e35e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-projects.vue
var featured_projects_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "featured-projects"
  }, [_c('header', _vm._l((_vm.skill_tags), function(tag) {
    return _c('CmChiclet', _vm._b({
      key: tag.value
    }, 'CmChiclet', {
      type: 'radio',
      group: 'projects_skill_tags',
      value: tag.value,
      label: tag.label,
      checked: tag.value === _vm.skill_tags,
    }, false))
  })), _vm._v(" "), _c('CmMasonryLayout', {
    staticClass: "projects-list"
  }, _vm._l((_vm.results), function(result) {
    return _c('ProjectCard', {
      key: result.id,
      attrs: {
        "project": result
      }
    })
  }))], 1)
}
var featured_projects_staticRenderFns = []
var featured_projects_esExports = { render: featured_projects_render, staticRenderFns: featured_projects_staticRenderFns }
/* harmony default export */ var components_featured_projects = (featured_projects_esExports);
// CONCATENATED MODULE: ./app/javascript/components/featured-projects.vue
function featured_projects_injectStyle (ssrContext) {
  __webpack_require__(372)
}
var featured_projects_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var featured_projects___vue_styles__ = featured_projects_injectStyle
/* scopeId */
var featured_projects___vue_scopeId__ = "data-v-ffd1e35e"
/* moduleIdentifier (server only) */
var featured_projects___vue_module_identifier__ = null
var featured_projects_Component = featured_projects_normalizeComponent(
  featured_projects,
  components_featured_projects,
  featured_projects___vue_styles__,
  featured_projects___vue_scopeId__,
  featured_projects___vue_module_identifier__
)

/* harmony default export */ var javascript_components_featured_projects = (featured_projects_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/featured-jobs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var featured_jobs = ({
  components: {
    Job: javascript_company_job
  },

  data: function data() {
    return {
      results: window.__DATA__.jobs
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6ab08a6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-jobs.vue
var featured_jobs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "featured-jobs__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('Job', {
      key: result.id,
      staticClass: "featured-jobs__job",
      attrs: {
        "job": result,
        "show": {
          date: false,
          company: true,
          motto: false,
        }
      }
    })
  }))
}
var featured_jobs_staticRenderFns = []
var featured_jobs_esExports = { render: featured_jobs_render, staticRenderFns: featured_jobs_staticRenderFns }
/* harmony default export */ var components_featured_jobs = (featured_jobs_esExports);
// CONCATENATED MODULE: ./app/javascript/components/featured-jobs.vue
function featured_jobs_injectStyle (ssrContext) {
  __webpack_require__(376)
}
var featured_jobs_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var featured_jobs___vue_styles__ = featured_jobs_injectStyle
/* scopeId */
var featured_jobs___vue_scopeId__ = "data-v-d6ab08a6"
/* moduleIdentifier (server only) */
var featured_jobs___vue_module_identifier__ = null
var featured_jobs_Component = featured_jobs_normalizeComponent(
  featured_jobs,
  components_featured_jobs,
  featured_jobs___vue_styles__,
  featured_jobs___vue_scopeId__,
  featured_jobs___vue_module_identifier__
)

/* harmony default export */ var javascript_components_featured_jobs = (featured_jobs_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(81);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(395);

// CONCATENATED MODULE: ./app/javascript/components/mixins/resize-observer.js


/* harmony default export */ var resize_observer = ({
  data: function data() {
    return {
      width: null,
      height: null,

      observer: null
    };
  },
  mounted: function mounted() {
    this.observer = new ResizeObserver_es["a" /* default */](this.handleResize);
    this.observer.observe(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    this.observer.unobserve(this.$el);

    this.unbindDragEvents();
  },


  methods: {
    handleResize: function handleResize(entries, observer) {
      this.width = entries[0].contentRect.width;
      this.height = entries[0].contentRect.height;
      // this.$emit('bounds', {
      //   width: entries[0].contentRect.width,
      //   height: entries[0].contentRect.height,
      // })
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/cm-truncated-text.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// references to width / height properties are from here


/* harmony default export */ var cm_truncated_text = ({
  mixins: [resize_observer],

  props: {
    lines: { type: Number }
  },

  data: function data() {
    return {
      maxLines: null,
      snappedHeight: 0
    };
  },


  watch: {
    height: function height(nextValue) {
      var textBox = this.$el;
      var style = window.getComputedStyle(textBox);
      var lineHeight = parseInt(style.getPropertyValue("line-height"));

      this.maxLines = Math.max(2, this.lines || Math.floor(this.height / lineHeight));
      this.snappedHeight = this.maxLines * lineHeight;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f800db7","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-truncated-text.vue
var cm_truncated_text_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._b({
    staticClass: "cm-truncated-text"
  }, 'div', _vm.$attrs, false), [_c('div', {
    staticClass: "cm-truncated-text__truncator",
    style: ({
      webkitLineClamp: _vm.maxLines,
      height: (_vm.snappedHeight + "px")
    })
  }, [_vm._t("default")], 2)])
}
var cm_truncated_text_staticRenderFns = []
var cm_truncated_text_esExports = { render: cm_truncated_text_render, staticRenderFns: cm_truncated_text_staticRenderFns }
/* harmony default export */ var components_cm_truncated_text = (cm_truncated_text_esExports);
// CONCATENATED MODULE: ./app/javascript/components/cm-truncated-text.vue
function cm_truncated_text_injectStyle (ssrContext) {
  __webpack_require__(394)
}
var cm_truncated_text_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var cm_truncated_text___vue_styles__ = cm_truncated_text_injectStyle
/* scopeId */
var cm_truncated_text___vue_scopeId__ = "data-v-7f800db7"
/* moduleIdentifier (server only) */
var cm_truncated_text___vue_module_identifier__ = null
var cm_truncated_text_Component = cm_truncated_text_normalizeComponent(
  cm_truncated_text,
  components_cm_truncated_text,
  cm_truncated_text___vue_styles__,
  cm_truncated_text___vue_scopeId__,
  cm_truncated_text___vue_module_identifier__
)

/* harmony default export */ var javascript_components_cm_truncated_text = (cm_truncated_text_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/featured-articles.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var featured_articles = ({
  components: {
    CmTruncatedText: javascript_components_cm_truncated_text
  },

  data: function data() {
    return {
      results: null
    };
  },


  computed: {
    articles: function articles() {
      if (this.results) {
        return this.results.data;
      }
    }
  },

  created: function created() {
    var _this = this;

    this.isLoading = true;

    axios_default.a.get('/blog/featured.json').then(function (response) {
      _this.isLoading = false;
      _this.results = response;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30962e94","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-articles.vue
var featured_articles_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-list"
  }, _vm._l((_vm.articles), function(article, i) {
    return _c('article', {
      key: article.id,
      staticClass: "article",
      class: {
        featured: i === 0,
          standard: i !== 0,
          unneeded: i === _vm.articles.length - 1,
      }
    }, [_c('a', {
      staticClass: "article-link",
      attrs: {
        "href": article.url
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "article-image",
      attrs: {
        "src": article.image,
        "loading": "lazy"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "article-text"
    }, [_c('h3', {
      staticClass: "article-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), [(i === 0) ? _c('CmTruncatedText', {
      staticClass: "article-excerpt"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(article.excerpt)
      }
    })]) : _c('p', {
      staticClass: "article-excerpt",
      domProps: {
        "innerHTML": _vm._s(article.excerpt)
      }
    })], _vm._v(" "), _c('div', {
      staticClass: "cta-link"
    }, [_vm._v("Read more")])], 2)])
  }))
}
var featured_articles_staticRenderFns = []
var featured_articles_esExports = { render: featured_articles_render, staticRenderFns: featured_articles_staticRenderFns }
/* harmony default export */ var components_featured_articles = (featured_articles_esExports);
// CONCATENATED MODULE: ./app/javascript/components/featured-articles.vue
var featured_articles_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var featured_articles___vue_styles__ = null
/* scopeId */
var featured_articles___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var featured_articles___vue_module_identifier__ = null
var featured_articles_Component = featured_articles_normalizeComponent(
  featured_articles,
  components_featured_articles,
  featured_articles___vue_styles__,
  featured_articles___vue_scopeId__,
  featured_articles___vue_module_identifier__
)

/* harmony default export */ var javascript_components_featured_articles = (featured_articles_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/pages/companies.vue
var companies__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function companies__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// If there's a variable in the template or in the JS that you can't find,
// CHECK THE MIXIN







/* harmony default export */ var companies = ({
  mixins: [mixins_directory],

  components: {
    CompanyCard: javascript_components_company_card
  },

  props: {
    isLoggedIn: {
      type: Boolean
    },
    favorites: {
      type: Array
    }
  },

  data: function data() {
    var filters = this.generateFilters();

    return {
      filterArray: filters,
      defaultValues: this.generateDefaultFilterValues(filters),
      filterValues: this.generateFilterValues(filters),
      unitLabels: {
        singular: "Company",
        plural: "Companies"
      },
      index: "companies",

      dynamicFavorites: this.favorites
    };
  },


  computed: {
    filterKeys: function filterKeys() {
      return ["skill_tag_id", "industry_id", "size", "is_hiring", "is_favorite", "location", "coords"];
    },
    activeFilters: function activeFilters() {
      var _this = this;

      var values = this.filterValues;
      var defaults = this.defaultValues;

      var sizeFilter = this.filters.find(function (propsFilter) {
        return propsFilter.id === "size";
      });

      return [{
        label: (sizeFilter.options.find(function (option) {
          return option.value === values.size;
        }) ? sizeFilter.options.find(function (option) {
          return option.value === values.size;
        }).label : sizeFilter.nullLabel) + (values.size === "1..1" ? " Person" : " People"),
        keys: ["size"],
        value: values.size
      }, {
        label: "Hiring!",
        keys: ["is_hiring"],
        value: values.is_hiring
      }, {
        label: "My Favorites",
        keys: ["is_favorite"],
        value: values.is_favorite
      }].concat(companies__toConsumableArray(values.skill_tag_id.map(function (filterValue) {
        return {
          keys: ["skill_tag_id"],
          match: filterValue,
          value: filterValue,
          label: _this.filters.find(function (propsFilter) {
            return propsFilter.id === "skill_tag_id";
          }).options.find(function (option) {
            return option.value === filterValue;
          }).label
        };
      })), companies__toConsumableArray(values.industry_id.map(function (filterValue) {
        return {
          keys: ["industry_id"],
          match: filterValue,
          value: filterValue,
          label: _this.filters.find(function (propsFilter) {
            return propsFilter.id === "industry_id";
          }).options.find(function (option) {
            return option.value === filterValue;
          }).label
        };
      })), [values.coords.lat && values.coords.lng && {
        keys: ["location", "coords"],
        label: "Within " + values.radius + " of " + values.location
      }]).filter(Boolean).filter(function (filter) {
        return filter.value !== defaults[filter.keys[0]];
      });
    },
    results: function results() {
      if (this.response) {
        return this.response.hits.hits.map(function (el) {
          return companies__extends({}, el._source);
        });
      } else return [];
    },
    sizeFilterValue: function sizeFilterValue() {
      if (this.filterValues.size) {
        var rangeArray = this.filterValues.size.split("..");
        return { min: rangeArray[0], max: rangeArray[1] };
      } else {
        return this.filterValues.size;
      }
    },
    query: function query() {
      var filters = this.filterValues;
      return {
        query: {
          bool: {
            must: [{ match: { application_status: "published" } }, this.sizeFilterValue && {
              range: {
                size: {
                  gte: this.sizeFilterValue.min,
                  lte: this.sizeFilterValue.max
                }
              }
            }, filters.skill_tag_id.length && {
              terms: {
                "skill_tags.id": filters.skill_tag_id
              }
            }, filters.industry_id.length && {
              terms: {
                "industries.id": filters.industry_id
              }
            }, filters.is_favorite && {
              terms: {
                id: this.dynamicFavorites
              }
            }, filters.remoteFriendly && {
              bool: {
                should: [{ match: { remote: true } }, { match: { remote_friendly: true } }]
              }
            }, filters.is_hiring && {
              match: {
                is_hiring: true
              }
            }, filters.coords.lat && filters.coords.lng && {
              geo_distance: {
                distance: filters.radius,
                coordinates: filters.coords.lat + "," + filters.coords.lng
              }
            }, filters.input_text !== "" && {
              query_string: {
                query: preprocessQueryString(filters.input_text),
                default_operator: "AND",
                fuzziness: 1,
                fuzzy_prefix_length: 0,
                fuzzy_max_expansions: 10
              }
            }].filter(Boolean)
          }
        }
      };
    }
  },

  methods: {
    generateFilters: function generateFilters() {
      return [{
        key: "input_text",
        initial: getURLParams().get("input_text"),
        default: ""
      }, {
        key: "skill_tag_id",
        urlKey: "skill_id",
        initial: getURLParams().getAll("skill_id"),
        default: []
      }, {
        key: "industry_id",
        initial: getURLParams().getAll("industry_id"),
        default: []
      }, {
        key: "size",
        initial: getURLParams().get("size"),
        default: null
      }, {
        key: "is_hiring",
        initial: getURLParams().get("is_hiring"),
        default: false
      }, {
        key: "is_favorite",
        initial: getURLParams().get("is_favorite"),
        default: false
      }, {
        key: "radius",
        initial: getURLParams().get("radius"),
        default: "5 miles"
      }, {
        key: "coords",
        initial: JSON.parse(getURLParams().get("coords")),
        default: false
      }, {
        key: "location",
        initial: getURLParams().get("location"),
        default: ""
      }];
    },
    likeCompany: function likeCompany(id) {
      this.dynamicFavorites.push(id);
    },
    unlikeCompany: function unlikeCompany(id) {
      this.dynamicFavorites = this.dynamicFavorites.filter(function (fave) {
        return fave !== id;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0354100f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/pages/companies.vue
var companies_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Directory', _vm._b({
    staticClass: "companies",
    on: {
      "text-input": function($event) {
        _vm.filterValues.input_text = $event
      },
      "clear-all": _vm.clearAllFilters,
      "clear-filter": _vm.clearFilter,
      "more-click": _vm.fetchNextPage
    }
  }, 'Directory', {
    activeFilters: _vm.activeFilters,
    inputText: _vm.filterValues.input_text,
    isLoading: _vm.isLoading,
    results: _vm.results,
    resultCount: _vm.resultCount,
    unitLabels: _vm.unitLabels,
  }, false), [_c('div', {
    staticClass: "companies__filters-list",
    slot: "filters"
  }, [_c('div', {
    staticClass: "companies__filters-line-1"
  }, [_vm._l((_vm.filters), function(filter) {
    return _c('CmSelect', {
      key: filter.id,
      staticClass: "companies__filter companies__filter--select",
      attrs: {
        "name": filter.id,
        "options": filter.options,
        "null-label": filter.nullLabel,
        "label": filter.label,
        "multiple": filter.multiple,
        "include-search": filter.options.length > 12,
        "value": _vm.filterValues[filter.id],
        "compact": ""
      },
      on: {
        "input": function($event) {
          _vm.filterValues[filter.id] = $event
        }
      }
    })
  }), _vm._v(" "), _c('LocationFilter', {
    staticClass: "companies__filter companies__filter--select",
    attrs: {
      "location": _vm.filterValues.location,
      "radius": _vm.filterValues.radius
    },
    on: {
      "location": function($event) {
        _vm.filterValues.location = $event
      },
      "coords": function($event) {
        _vm.filterValues.coords = $event
      },
      "radius": function($event) {
        _vm.filterValues.radius = $event
      }
    },
    model: {
      value: (_vm.filterValues.location),
      callback: function($$v) {
        _vm.filterValues.location = $$v
      },
      expression: "filterValues.location"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "companies__filter companies__filter--checkbox",
    attrs: {
      "label": "Hiring!"
    },
    model: {
      value: (_vm.filterValues.is_hiring),
      callback: function($$v) {
        _vm.filterValues.is_hiring = $$v
      },
      expression: "filterValues.is_hiring"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "companies__filter companies__filter--checkbox",
    attrs: {
      "label": "My Favorites"
    },
    model: {
      value: (_vm.filterValues.is_favorite),
      callback: function($$v) {
        _vm.filterValues.is_favorite = $$v
      },
      expression: "filterValues.is_favorite"
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "companies__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('CompanyCard', {
      key: result.id,
      staticClass: "companies__job",
      attrs: {
        "liked": _vm.dynamicFavorites.includes(result.id),
        "company": result,
        "is-logged-in": _vm.isLoggedIn
      },
      on: {
        "like": _vm.likeCompany,
        "unlike": _vm.unlikeCompany
      }
    })
  }))])
}
var companies_staticRenderFns = []
var companies_esExports = { render: companies_render, staticRenderFns: companies_staticRenderFns }
/* harmony default export */ var pages_companies = (companies_esExports);
// CONCATENATED MODULE: ./app/javascript/pages/companies.vue
function companies_injectStyle (ssrContext) {
  __webpack_require__(396)
}
var companies_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var companies___vue_styles__ = companies_injectStyle
/* scopeId */
var companies___vue_scopeId__ = "data-v-0354100f"
/* moduleIdentifier (server only) */
var companies___vue_module_identifier__ = null
var companies_Component = companies_normalizeComponent(
  companies,
  pages_companies,
  companies___vue_styles__,
  companies___vue_scopeId__,
  companies___vue_module_identifier__
)

/* harmony default export */ var javascript_pages_companies = (companies_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/pages/individuals.vue
var individuals__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function individuals__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// If there's a variable in the template or in the JS that you can't find,
// CHECK THE MIXIN







/* harmony default export */ var individuals = ({
  mixins: [mixins_directory],

  components: {
    IndividualCard: javascript_company_individual_card
  },

  data: function data() {
    var filters = this.generateFilters();

    return {
      filterArray: filters,
      defaultValues: this.generateDefaultFilterValues(filters),
      filterValues: this.generateFilterValues(filters),
      unitLabels: {
        singular: "Individual",
        plural: "Individuals"
      },
      index: "users"
    };
  },


  computed: {
    filterKeys: function filterKeys() {
      return ["skill_tag_id", "is_single", "is_student", "for_hire", "location", "coords"];
    },
    activeFilters: function activeFilters() {
      var _this = this;

      var values = this.filterValues;
      var defaults = this.defaultValues;

      return [{
        label: "For Hire",
        keys: ["for_hire"],
        value: values.for_hire
      }, {
        label: "Student",
        keys: ["is_student"],
        value: values.is_student
      }, {
        label: "Single",
        keys: ["is_single"],
        value: values.is_single
      }].concat(individuals__toConsumableArray(values.skill_tag_id.map(function (filterValue) {
        return {
          keys: ["skill_tag_id"],
          match: filterValue,
          value: filterValue,
          label: _this.filters.find(function (propsFilter) {
            return propsFilter.id === "skill_tag_id";
          }).options.find(function (option) {
            return option.value === filterValue;
          }).label
        };
      })), [values.coords.lat && values.coords.lng && {
        keys: ["location", "coords"],
        label: "Within " + values.radius + " of " + values.location
      }]).filter(Boolean).filter(function (filter) {
        return filter.value !== defaults[filter.keys[0]];
      });
    },
    results: function results() {
      if (this.response) {
        return this.response.hits.hits.map(function (el) {
          return individuals__extends({}, el._source);
        });
      } else return [];
    },
    query: function query() {
      var filters = this.filterValues;

      return {
        sort: [{ has_avatar: "desc" }, filters.sort_key === "recently_updated" && {
          updated_at: "desc"
        }, filters.sort_key === "newest" && { created_at: "desc" }, "_score"].filter(Boolean),
        query: {
          bool: {
            must: [{ match: { status: "active" } }, { match: { unlisted: false } }, filters.skill_tag_id.length && {
              terms: {
                "skill_tags.id": filters.skill_tag_id
              }
            }, filters.is_single && { match: { is_single: true } }, filters.is_student && { match: { is_student: true } }, filters.for_hire && { match: { for_hire: true } }, filters.coords.lat && filters.coords.lng && {
              geo_distance: {
                distance: filters.radius,
                coordinates: filters.coords.lat + "," + filters.coords.lng
              }
            }, filters.input_text !== "" && {
              query_string: {
                query: preprocessQueryString(filters.input_text),
                default_operator: "AND",
                fuzziness: 1,
                fuzzy_prefix_length: 0,
                fuzzy_max_expansions: 10
              }
            }].filter(Boolean)
          }
        }
      };
    }
  },
  methods: {
    generateFilters: function generateFilters() {
      return [{
        key: "input_text",
        initial: getURLParams().get("input_text"),
        default: ""
      }, {
        key: "sort_key",
        initial: getURLParams().get("sort_key"),
        default: "recently_updated"
      }, {
        key: "skill_tag_id",
        urlKey: "skill_id",
        initial: getURLParams().getAll("skill_id"),
        default: []
      }, {
        key: "is_single",
        initial: getURLParams().get("is_single"),
        default: false
      }, {
        key: "is_student",
        initial: getURLParams().get("is_student"),
        default: false
      }, {
        key: "for_hire",
        initial: getURLParams().get("for_hire"),
        default: false
      }, {
        key: "radius",
        initial: getURLParams().get("radius"),
        default: "5 miles"
      }, {
        key: "coords",
        initial: JSON.parse(getURLParams().get("coords")),
        default: { lat: null, lng: null }
      }, {
        key: "location",
        initial: getURLParams().get("location"),
        default: ""
      }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a7b3ea4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/pages/individuals.vue
var individuals_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Directory', _vm._b({
    staticClass: "individuals",
    on: {
      "text-input": function($event) {
        _vm.filterValues.input_text = $event
      },
      "clear-all": _vm.clearAllFilters,
      "clear-filter": _vm.clearFilter,
      "more-click": _vm.fetchNextPage
    }
  }, 'Directory', {
    activeFilters: _vm.activeFilters,
    inputText: _vm.filterValues.input_text,
    isLoading: _vm.isLoading,
    results: _vm.results,
    resultCount: _vm.resultCount,
    unitLabels: _vm.unitLabels
  }, false), [_c('div', {
    staticClass: "individuals__filters-list",
    slot: "filters"
  }, [_vm._l((_vm.filters), function(filter) {
    return _c('CmSelect', {
      key: filter.id,
      staticClass: "individuals__filter individuals__filter--select",
      attrs: {
        "name": filter.id,
        "options": filter.options,
        "null-label": filter.nullLabel,
        "label": filter.label,
        "multiple": filter.multiple,
        "include-search": filter.options.length > 12,
        "value": _vm.filterValues[filter.id],
        "compact": ""
      },
      on: {
        "input": function($event) {
          _vm.filterValues[filter.id] = $event
        }
      }
    })
  }), _vm._v(" "), _c('LocationFilter', {
    staticClass: "individuals__filter individuals__filter--select",
    attrs: {
      "location": _vm.filterValues.location,
      "radius": _vm.filterValues.radius
    },
    on: {
      "location": function($event) {
        _vm.filterValues.location = $event
      },
      "coords": function($event) {
        _vm.filterValues.coords = $event
      },
      "radius": function($event) {
        _vm.filterValues.radius = $event
      }
    },
    model: {
      value: (_vm.filterValues.location),
      callback: function($$v) {
        _vm.filterValues.location = $$v
      },
      expression: "filterValues.location"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "individuals__filter individuals__filter--checkbox",
    attrs: {
      "label": "Single"
    },
    model: {
      value: (_vm.filterValues.is_single),
      callback: function($$v) {
        _vm.filterValues.is_single = $$v
      },
      expression: "filterValues.is_single"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "individuals__filter individuals__filter--checkbox",
    attrs: {
      "label": "Student"
    },
    model: {
      value: (_vm.filterValues.is_student),
      callback: function($$v) {
        _vm.filterValues.is_student = $$v
      },
      expression: "filterValues.is_student"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "individuals__filter individuals__filter--checkbox",
    attrs: {
      "label": "For Hire"
    },
    model: {
      value: (_vm.filterValues.for_hire),
      callback: function($$v) {
        _vm.filterValues.for_hire = $$v
      },
      expression: "filterValues.for_hire"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "individuals__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('IndividualCard', {
      key: result.id,
      staticClass: "individuals__individual",
      attrs: {
        "person": result
      }
    })
  }))])
}
var individuals_staticRenderFns = []
var individuals_esExports = { render: individuals_render, staticRenderFns: individuals_staticRenderFns }
/* harmony default export */ var pages_individuals = (individuals_esExports);
// CONCATENATED MODULE: ./app/javascript/pages/individuals.vue
function individuals_injectStyle (ssrContext) {
  __webpack_require__(397)
}
var individuals_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var individuals___vue_styles__ = individuals_injectStyle
/* scopeId */
var individuals___vue_scopeId__ = "data-v-4a7b3ea4"
/* moduleIdentifier (server only) */
var individuals___vue_module_identifier__ = null
var individuals_Component = individuals_normalizeComponent(
  individuals,
  pages_individuals,
  individuals___vue_styles__,
  individuals___vue_scopeId__,
  individuals___vue_module_identifier__
)

/* harmony default export */ var javascript_pages_individuals = (individuals_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/cm-button.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cm_button = ({
  name: "CMButton",
  props: {
    href: { type: String },
    to: { type: String },
    size: { type: String, default: 'medium' },
    width: { type: String, default: 'narrow' }
  },
  computed: {
    buttonOrLink: function buttonOrLink() {
      if (!!this.href) return "a";
      if (!!this.to) return "router-link";
      return "button";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ed41e6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-button.vue
var cm_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.buttonOrLink, {
    tag: "component",
    staticClass: "cm-button",
    class: ( _obj = {
      light: _vm.light
    }, _obj[_vm.size] = true, _obj[_vm.width] = true, _obj ),
    attrs: {
      "v-bind": _vm.$attrs,
      "href": _vm.href
    }
  }, [_vm._t("default")], 2)
  var _obj;
}
var cm_button_staticRenderFns = []
var cm_button_esExports = { render: cm_button_render, staticRenderFns: cm_button_staticRenderFns }
/* harmony default export */ var components_cm_button = (cm_button_esExports);
// CONCATENATED MODULE: ./app/javascript/components/cm-button.vue
function cm_button_injectStyle (ssrContext) {
  __webpack_require__(398)
}
var cm_button_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var cm_button___vue_styles__ = cm_button_injectStyle
/* scopeId */
var cm_button___vue_scopeId__ = "data-v-36ed41e6"
/* moduleIdentifier (server only) */
var cm_button___vue_module_identifier__ = null
var cm_button_Component = cm_button_normalizeComponent(
  cm_button,
  components_cm_button,
  cm_button___vue_styles__,
  cm_button___vue_scopeId__,
  cm_button___vue_module_identifier__
)

/* harmony default export */ var javascript_components_cm_button = (cm_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/checkout.vue
var checkout__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var checkout = ({
  components: {
    CmMarkdown: javascript_components_markdown,
    CmSelect: app_javascript_components_select
  },
  props: {
    plan: {
      type: Object
    },
    initialBillingPeriod: {
      type: String
    },
    braintreeLocale: {
      type: String
    },
    braintreeClientToken: {
      type: String
    }
  },

  data: function data() {
    return {
      discount_code_unapplied: "",
      discount_code: "",
      billing_period: this.initialBillingPeriod,

      discountLoading: false,

      discountResponse: null,
      error: null
    };
  },
  mounted: function mounted() {
    var form = document.querySelector("form.edit_company");
    var button = form.querySelector("input[type=submit]");

    var _this = this;

    braintree.dropin.create({
      authorization: _this.braintreeClientToken,
      container: "#dropin-container",
      paypal: { flow: "vault" },
      locale: _this.braintreeLocale
    }, function (createErr, instance) {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
          if (requestPaymentMethodErr) {
            _this.error = requestPaymentMethodErr;
            // An appropriate error will be shown in the UI
          } else {
            // Submit payload.nonce to your server
            _this.$refs.nonceInput.value = payload.nonce;
            form.submit();
          }
        });
      });
    });
  },


  computed: {
    isYearly: function isYearly() {
      return this.billing_period === "yearly";
    },
    monthlySubTotal: function monthlySubTotal() {
      return this.plan.price;
    },
    subTotal: function subTotal() {
      return this.monthlySubTotal * (this.isYearly ? 12 : 1);
    },
    subTotalWithYearlySavings: function subTotalWithYearlySavings() {
      if (this.isYearly) {
        return this.subTotal - this.subTotal * 2 / 12;
      }
      return this.subTotal;
    },
    totalDiscount: function totalDiscount() {
      var billingCycleCount = (this.discount.number_of_billing_cycles || 12) / (this.isYearly ? 12 : 1);

      var amount = Math.min(this.subTotal / (this.isYearly ? 12 : 1), this.discount.amount);
      if (this.isYearly) amount *= 10;
      if (billingCycleCount < 1) amount *= billingCycleCount;

      return amount;
    },
    total: function total() {
      if (this.discount) {
        return Math.max(this.subTotalWithYearlySavings - this.totalDiscount, 0);
      } else {
        return this.subTotalWithYearlySavings;
      }
    },
    discountApplied: function discountApplied() {
      return this.discountResponse && this.discountResponse.success;
    },
    discountInvalid: function discountInvalid() {
      return this.discountResponse && this.discountResponse.success === false;
    },
    discountUnchanged: function discountUnchanged() {
      return this.discount_code_unapplied.toLowerCase() === this.discount_code.toLowerCase();
    },
    discount: function discount() {
      if (this.discountApplied) {
        var item = this.discountResponse.item;
        return checkout__extends({}, item, {
          amount: parseFloat(item.amount)
        });
      }
    },
    nextBillingPeriod: function nextBillingPeriod() {
      return this.isYearly ? "monthly" : "yearly";
    },
    applyButtonLabel: function applyButtonLabel() {
      if (this.discountLoading) return "...";

      if (this.discountUnchanged) {
        if (this.discountApplied) return this.I18n.t('creativeguild.checkout.discount_code_applied');
        if (this.discountInvalid) return this.I18n.t('creativeguild.checkout.discount_code_invalid');
      }

      return this.I18n.t('creativeguild.checkout.apply_discount');
    }
  },

  watch: {
    plan: function plan(next, prev) {
      if (this.discount_code === "") {
        this.discountResponse = null;
      } else {
        this.checkDiscount();
      }
    },
    discount_code: function discount_code(next, prev) {
      if (this.discount_code === "") {
        this.discountResponse = null;
      } else {
        this.checkDiscount();
      }
    }
  },

  methods: {
    checkDiscount: function checkDiscount() {
      var _this2 = this;

      this.discountLoading = true;
      this.$http.get("/discounts/" + this.plan.value + "/" + this.discount_code).then(function (response) {
        _this2.discountResponse = response.body;
        _this2.discountLoading = false;
      });
    },
    formatMoney: function formatMoney(value) {
      return this.I18n.toCurrency(value, { unit: '$' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd239044","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/checkout.vue
var checkout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-checkout"
  }, [(_vm.error) ? _c('p', {
    staticClass: "message message-error ss-alert"
  }, [_vm._v(_vm._s(_vm.error.message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "guild guild--with-columns guild--borderless"
  }, [_c('div', {
    staticClass: "guild__column"
  }, [_c('div', {
    staticClass: "plan-card"
  }, [_c('div', {
    staticClass: "plan-card__inner"
  }, [_c('div', {
    staticClass: "plan-card__plan"
  }, [_vm._v("\n            " + _vm._s(_vm.I18n.t('creativeguild.pricing.your_cycle_plan_based_on_company_size', {
    cycle: _vm.I18n.t(_vm.billing_period)
  })) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card__frequency"
  }, [_c('span', {
    staticClass: "plan-card__frequency-notice"
  }, [_c('button', {
    staticClass: "plan-card__period-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.billing_period = _vm.nextBillingPeriod
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.I18n.t(("creativeguild.pricing.switch_to_" + _vm.nextBillingPeriod))) + "\n              ")]), _vm._v(" "), (_vm.billing_period === 'monthly') ? _c('span', {
    staticClass: "plan-card__frequency-savings"
  }, [_vm._v("\n                , " + _vm._s(_vm.I18n.t('creativeguild.checkout.save_num', {
    num: _vm.formatMoney(_vm.monthlySubTotal * 2)
  })) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('CmMarkdown', {
    attrs: {
      "input": _vm.I18n.t(("creativeguild.pricing.tier_" + (_vm.plan.value) + "_body"))
    }
  }), _vm._v(" "), _c('footer', [_c('table', {
    staticClass: "plan-card__price-table"
  }, [(_vm.discountApplied || _vm.isYearly) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.I18n.t("creativeguild.checkout.subtotal")))]), _vm._v(" "), _c('td', {
    staticClass: "plan-card__price plan-card__price--subtotal"
  }, [_vm._v("\n                  " + _vm._s(_vm.formatMoney(_vm.subTotal)) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.isYearly) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.I18n.t("creativeguild.checkout.yearly_savings")))]), _vm._v(" "), _c('td', {
    staticClass: "plan-card__price plan-card__price--subtotal"
  }, [_vm._v("\n                  " + _vm._s(_vm.formatMoney(_vm.monthlySubTotal * -2)) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.discountApplied) ? _c('tr', {
    staticClass: "plan-card__price-row",
    class: {
      'plan-card__price-row--is-loading': _vm.discountLoading
    }
  }, [_c('td', [_vm._v("\n                  " + _vm._s(_vm.I18n.t("creativeguild.checkout.discount")) + "\n                  "), _c('button', {
    staticClass: "plan-card__current-discount-button",
    attrs: {
      "title": "Remove"
    },
    on: {
      "click": function($event) {
        _vm.discount_code = ''
      }
    }
  }, [_vm._v("\n                    (" + _vm._s(_vm.discount_code.toUpperCase()) + ")\n                  ")])]), _vm._v(" "), _c('td', {
    staticClass: "plan-card__price plan-card__price--discount"
  }, [_vm._v("\n                  " + _vm._s(_vm.formatMoney(_vm.totalDiscount * -1)) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.I18n.t("creativeguild.checkout.total")))]), _vm._v(" "), _c('td', {
    staticClass: "plan-card__price plan-card__price--total"
  }, [_vm._v("\n                  " + _vm._s(_vm.formatMoney(_vm.total)) + "\n                ")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "checkout-disclaimer"
  }, [_c('div', {
    staticClass: "secure ss-lock"
  }, [_vm._v("\n          " + _vm._s(_vm.I18n.t('this_is_a_secure_transaction')) + "\n        ")]), _vm._v(" "), _c('small', {
    staticClass: "terms"
  }, [_c('CmMarkdown', {
    attrs: {
      "input": _vm.I18n.t('creativeguild.checkout.terms', {
        period: ("<span class='checkout-disclaimer__period'>" + (_vm.billing_period.replace('ly', '')) + "</span>"),
        amount: ("<span class='checkout-disclaimer__price'>" + (_vm.formatMoney(_vm.total)) + "</span>")
      })
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "guild__column"
  }, [_c('div', {
    attrs: {
      "id": "dropin-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "discount_code_unapplied"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("activerecord.attributes.company.discount_code")))]), _vm._v(" "), _c('div', {
    staticClass: "discount-field-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_code_unapplied),
      expression: "discount_code_unapplied"
    }],
    staticClass: "cm-field",
    attrs: {
      "id": "discount_code_unapplied",
      "type": "text",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.discount_code_unapplied)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.discount_code = _vm.discount_code_unapplied
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_code_unapplied = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "cm-button",
    class: {
      "button--success": _vm.discountApplied && !_vm.discountLoading && _vm.discountUnchanged,
        "button--failure": _vm.discountInvalid && !_vm.discountLoading && _vm.discountUnchanged
    },
    attrs: {
      "disabled": (_vm.discountApplied || _vm.discountInvalid) && _vm.discountUnchanged,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.discount_code = _vm.discount_code_unapplied
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.applyButtonLabel) + "\n          ")])])])])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "company[plan]"
    },
    domProps: {
      "value": _vm.plan.value
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "company[billing_period]"
    },
    domProps: {
      "value": _vm.billing_period
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "company[discount_code]"
    },
    domProps: {
      "value": _vm.discount && _vm.discount.name
    }
  }), _vm._v(" "), _c('input', {
    ref: "nonceInput",
    attrs: {
      "type": "hidden",
      "name": "company[nonce]"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "cm-button guild__button--continue",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.I18n.t('creativeguild.checkout.button')
    }
  })])
}
var checkout_staticRenderFns = []
var checkout_esExports = { render: checkout_render, staticRenderFns: checkout_staticRenderFns }
/* harmony default export */ var components_checkout = (checkout_esExports);
// CONCATENATED MODULE: ./app/javascript/components/checkout.vue
function checkout_injectStyle (ssrContext) {
  __webpack_require__(399)
}
var checkout_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var checkout___vue_styles__ = checkout_injectStyle
/* scopeId */
var checkout___vue_scopeId__ = "data-v-fd239044"
/* moduleIdentifier (server only) */
var checkout___vue_module_identifier__ = null
var checkout_Component = checkout_normalizeComponent(
  checkout,
  components_checkout,
  checkout___vue_styles__,
  checkout___vue_scopeId__,
  checkout___vue_module_identifier__
)

/* harmony default export */ var javascript_components_checkout = (checkout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/onboarding/preview-card.vue
//
//
//
//
//
//



/* harmony default export */ var preview_card = ({
  components: {
    CompanyCard: javascript_components_company_card
  },

  data: function data() {
    return {
      company: {
        name: "Carolyn Sewell",
        location: "Raleigh, NC",
        motto: "Lettering and Illustration Deep-Fried in Butter and Hugs.",
        banner: "https://media.creativemornings.com/uploads/sponsor/banner/5970/large_OverlapTanglesWallMockup_2560x900.jpg",
        logo: "https://media.creativemornings.com/uploads/sponsor/logo/5970/square_Carolyn_Sewell_LogoSquare.png"
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afa68a8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/onboarding/preview-card.vue
var preview_card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-preview-card"
  }, [_c('CompanyCard', {
    attrs: {
      "company": _vm.company
    }
  })], 1)
}
var preview_card_staticRenderFns = []
var preview_card_esExports = { render: preview_card_render, staticRenderFns: preview_card_staticRenderFns }
/* harmony default export */ var onboarding_preview_card = (preview_card_esExports);
// CONCATENATED MODULE: ./app/javascript/onboarding/preview-card.vue
var preview_card_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var preview_card___vue_styles__ = null
/* scopeId */
var preview_card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var preview_card___vue_module_identifier__ = null
var preview_card_Component = preview_card_normalizeComponent(
  preview_card,
  onboarding_preview_card,
  preview_card___vue_styles__,
  preview_card___vue_scopeId__,
  preview_card___vue_module_identifier__
)

/* harmony default export */ var javascript_onboarding_preview_card = (preview_card_Component.exports);

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/index.js + 14 modules
var esm_browser = __webpack_require__(401);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/cm-nav-chapter-dropdown.vue
var cm_nav_chapter_dropdown__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var cm_nav_chapter_dropdown = ({
  props: {
    currentChapterAbbr: {
      type: String
    }
  },

  data: function data() {
    return {
      response: null,
      textInput: "",
      selectedChapterAbbr: null,
      isListVisible: false,
      uid: Object(esm_browser["a" /* v4 */])()
    };
  },
  created: function created() {
    var _this = this;

    axios_default.a.post("/cities.json?sort_key=closest").then(function (response) {
      _this.response = response;
    });
  },


  computed: {
    chapters: function chapters() {
      var _this2 = this;

      return this.response && this.response.data.map(function (chapter) {
        return cm_nav_chapter_dropdown__extends({}, chapter, {
          link: "/cities/" + chapter.abbreviation,
          uid: _this2.uid + "-chapter-" + chapter.abbreviation
        });
      }) || [];
    },
    filteredChapters: function filteredChapters() {
      var _this3 = this;

      return this.chapters.filter(function (chapter) {
        return chapter.name.toLowerCase().includes(_this3.textInput.toLowerCase());
      });
    },
    selectedChapter: function selectedChapter() {
      return this.findChapter(this.selectedChapterAbbr);
    },
    currentChapter: function currentChapter() {
      return this.findChapter(this.currentChapterAbbr);
    }
  },

  watch: {
    selectedChapterAbbr: function selectedChapterAbbr(newChapter) {
      var _this4 = this;

      this.$nextTick(function () {
        var element = _this4.$el.querySelector("[aria-selected=\"true\"]");
        if (element) {
          element.scrollIntoView({
            block: "nearest"
          });
        }
      });
    }
  },

  methods: {
    findChapter: function findChapter(chapterAbbr) {
      if (!chapterAbbr) {
        return null;
      }
      return this.chapters.find(function (chapter) {
        return chapter.abbreviation.toLowerCase() === chapterAbbr.toLowerCase();
      });
    },
    onArrow: function onArrow(event, direction) {
      var _this5 = this;

      this.isListVisible = true;
      event.preventDefault(); // prevent caret from jumping to start/end

      var index = this.filteredChapters.findIndex(function (chapter) {
        return chapter.abbreviation === _this5.selectedChapterAbbr;
      });
      var newIndex = void 0;

      // navigate to the previous/next chapter in the list
      if (this.selectedChapterAbbr) {
        newIndex = (index + direction + this.filteredChapters.length) % this.filteredChapters.length;
      } else {
        if (direction === -1) {
          newIndex = this.filteredChapters.length - 1;
        } else {
          newIndex = 0;
        }
      }

      this.selectedChapterAbbr = this.filteredChapters[newIndex].abbreviation;
    },
    onEnter: function onEnter() {
      if (this.filteredChapters.length === 1) {
        window.location = this.filteredChapters[0].link;
      } else if (this.selectedChapterAbbr) {
        window.location = this.findChapter(this.selectedChapterAbbr).link;
      }
    },
    handleFocusOut: function handleFocusOut(e) {
      if (!this.$el.contains(e.relatedTarget)) {
        this.isListVisible = false;
      }
    },
    onEscape: function onEscape() {
      this.isListVisible = false;
      this.selectedChapterAbbr = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-142899d4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-nav-chapter-dropdown.vue
var cm_nav_chapter_dropdown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-nav-chapter-dropdown",
    class: _vm.currentChapter && ("ch_" + (_vm.currentChapter.id)),
    on: {
      "focusout": _vm.handleFocusOut
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cm-nav-chapter-dropdown__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textInput),
      expression: "textInput"
    }],
    ref: "input",
    staticClass: "cm-nav-chapter-dropdown__input is-boxed",
    attrs: {
      "type": "text",
      "placeholder": _vm.currentChapter ? _vm.currentChapter.name : 'Find your city',
      "autocomplete": "off",
      "role": "combobox",
      "aria-haspopup": "listbox",
      "aria-autocomplete": "list",
      "aria-controls": (_vm.uid + "-results"),
      "aria-label": "Find your city",
      "spellcheck": "false",
      "aria-expanded": _vm.isListVisible,
      "autocapitalize": "off",
      "aria-activedescendant": _vm.selectedChapter ? _vm.selectedChapter.uid : null
    },
    domProps: {
      "value": (_vm.textInput)
    },
    on: {
      "focus": function($event) {
        _vm.isListVisible = true
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        (function (e) { return _vm.onArrow(e, -1); })($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        (function (e) { return _vm.onArrow(e, 1); })($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.onEscape($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "main-menu nav__mobile-menu mobile",
    attrs: {
      "id": "menu--chapters"
    }
  }, _vm._l((_vm.filteredChapters), function(chapter) {
    return _c('li', {
      key: ("mobile-" + (chapter.uid)),
      staticClass: "cm-nav-chapter-dropdown__city",
      class: ("ch_" + (chapter.id)),
      attrs: {
        "role": "option"
      }
    }, [_c('a', {
      attrs: {
        "href": chapter.link,
        "id": chapter.uid
      }
    }, [_c('span', {
      staticClass: "cm-nav-chapter-dropdown__title"
    }, [_vm._v(_vm._s(chapter.name))])])])
  })), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isListVisible),
      expression: "isListVisible"
    }],
    staticClass: "cm-nav-chapter-dropdown__list desktop",
    attrs: {
      "id": (_vm.uid + "-results"),
      "role": "listbox"
    }
  }, _vm._l((_vm.filteredChapters), function(chapter) {
    return _c('li', {
      key: ("desktop-" + (chapter.uid)),
      staticClass: "cm-nav-chapter-dropdown__city",
      class: ("ch_" + (chapter.id)),
      attrs: {
        "aria-selected": chapter.abbreviation === _vm.selectedChapterAbbr,
        "role": "option"
      }
    }, [_c('a', {
      attrs: {
        "href": chapter.link,
        "tabindex": "-1",
        "id": chapter.uid
      }
    }, [_c('span', {
      staticClass: "cm-nav-chapter-dropdown__title"
    }, [_vm._v(_vm._s(chapter.name))])])])
  }))])])
}
var cm_nav_chapter_dropdown_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "cm-nav-chapter-dropdown__toggle nav__toggle",
    attrs: {
      "aria-controls": "menu--chapters",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "nav__icon ss-icon"
  }, [_vm._v("navigate")])])
}]
var cm_nav_chapter_dropdown_esExports = { render: cm_nav_chapter_dropdown_render, staticRenderFns: cm_nav_chapter_dropdown_staticRenderFns }
/* harmony default export */ var components_cm_nav_chapter_dropdown = (cm_nav_chapter_dropdown_esExports);
// CONCATENATED MODULE: ./app/javascript/components/cm-nav-chapter-dropdown.vue
function cm_nav_chapter_dropdown_injectStyle (ssrContext) {
  __webpack_require__(400)
}
var cm_nav_chapter_dropdown_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var cm_nav_chapter_dropdown___vue_styles__ = cm_nav_chapter_dropdown_injectStyle
/* scopeId */
var cm_nav_chapter_dropdown___vue_scopeId__ = "data-v-142899d4"
/* moduleIdentifier (server only) */
var cm_nav_chapter_dropdown___vue_module_identifier__ = null
var cm_nav_chapter_dropdown_Component = cm_nav_chapter_dropdown_normalizeComponent(
  cm_nav_chapter_dropdown,
  components_cm_nav_chapter_dropdown,
  cm_nav_chapter_dropdown___vue_styles__,
  cm_nav_chapter_dropdown___vue_scopeId__,
  cm_nav_chapter_dropdown___vue_module_identifier__
)

/* harmony default export */ var javascript_components_cm_nav_chapter_dropdown = (cm_nav_chapter_dropdown_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/cm-chapter-dropdowns.vue
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var cm_chapter_dropdowns = ({
  components: {
    CmSelect: app_javascript_components_select
  },

  data: function data() {
    return {
      chapter: null,
      response: null
    };
  },
  created: function created() {
    var _this = this;

    axios_default.a.get('/cities.json').then(function (response) {
      _this.response = response;
    });
  },


  computed: {
    chapters: function chapters() {
      return this.response && this.response.data || [];
    }
  },

  watch: {
    chapter: function chapter(nextAbbreviation, prevAbbreviation) {
      window.location = '/cities/' + nextAbbreviation;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ec4712","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-chapter-dropdowns.vue
var cm_chapter_dropdowns_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-chapter-dropdowns"
  }, [_c('CmSelect', {
    attrs: {
      "nullLabel": "City",
      "includeSearch": "",
      "options": _vm.chapters.map(function (chapter) { return ({
        label: chapter.name,
        value: chapter.abbreviation
      }); })
    },
    model: {
      value: (_vm.chapter),
      callback: function($$v) {
        _vm.chapter = $$v
      },
      expression: "chapter"
    }
  })], 1)
}
var cm_chapter_dropdowns_staticRenderFns = []
var cm_chapter_dropdowns_esExports = { render: cm_chapter_dropdowns_render, staticRenderFns: cm_chapter_dropdowns_staticRenderFns }
/* harmony default export */ var components_cm_chapter_dropdowns = (cm_chapter_dropdowns_esExports);
// CONCATENATED MODULE: ./app/javascript/components/cm-chapter-dropdowns.vue
function cm_chapter_dropdowns_injectStyle (ssrContext) {
  __webpack_require__(402)
}
var cm_chapter_dropdowns_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var cm_chapter_dropdowns___vue_styles__ = cm_chapter_dropdowns_injectStyle
/* scopeId */
var cm_chapter_dropdowns___vue_scopeId__ = "data-v-73ec4712"
/* moduleIdentifier (server only) */
var cm_chapter_dropdowns___vue_module_identifier__ = null
var cm_chapter_dropdowns_Component = cm_chapter_dropdowns_normalizeComponent(
  cm_chapter_dropdowns,
  components_cm_chapter_dropdowns,
  cm_chapter_dropdowns___vue_styles__,
  cm_chapter_dropdowns___vue_scopeId__,
  cm_chapter_dropdowns___vue_module_identifier__
)

/* harmony default export */ var javascript_components_cm_chapter_dropdowns = (cm_chapter_dropdowns_Component.exports);

// CONCATENATED MODULE: ./app/javascript/lib/worldmap.js
/* harmony default export */ var worldmap = ('M92.92,87.75C92.76,87.79,92.7,87.81,92.92,87.75L92.92,87.75z M171.32,86.32C171.38,86.46,171.38,86.45,171.32,86.32 L171.32,86.32z M170.99,86.48c0.56,0.3,0.79,1.22,0.48,1.9c-0.08-0.17-0.18-0.39-0.25-0.56c-0.05,0.34-0.19,0.63-0.19,1 c-0.87-0.2-0.7-1.65-1.45-0.99c0.05-0.03-0.1-0.2-0.14-0.21c-0.13,0.14-0.29,0.35-0.37,0.44c0.05-0.56,0.8-1.37,0.98-0.61 C170.55,87.03,170.89,87.06,170.99,86.48L170.99,86.48z M168.96,88.24C169.26,88.3,169.22,88.29,168.96,88.24L168.96,88.24z M168.46,88.67C168.65,88.61,168.81,88.57,168.46,88.67L168.46,88.67z M171,89.88C171.12,90.07,171.14,90.1,171,89.88L171,89.88z M171.75,89.42C171.8,89.62,171.85,89.82,171.75,89.42L171.75,89.42z M172.76,90.48c-0.04,0.16,0.18,0.27-0.12,0.34 C172.54,90.59,172.72,90.62,172.76,90.48L172.76,90.48z M158.84,91.2C158.57,91.15,158.78,91.19,158.84,91.2L158.84,91.2z M157.54,90.99C157.4,90.73,157.46,90.84,157.54,90.99L157.54,90.99z M157.74,91.05C157.99,91.2,158.06,91.23,157.74,91.05 L157.74,91.05z M159.15,91.34C159.05,91.47,159.08,91.43,159.15,91.34L159.15,91.34z M155.67,87.4 C155.7,87.49,155.72,87.61,155.67,87.4L155.67,87.4z M153.05,87.86C153.07,88.03,153.09,88.22,153.05,87.86L153.05,87.86z M154.17,90.42c0.02,0.01,0.28,0.07,0.39,0.24C154.42,90.6,154.3,90.48,154.17,90.42L154.17,90.42z M154.98,91.2 c0.11,0.08,0.4,0.06,0.4,0.44C155.26,91.54,155.13,91.33,154.98,91.2L154.98,91.2z M104.83,89.83c0.02,0.13,0.31,0.1,0.03,0.31 C104.6,90.05,104.85,90.01,104.83,89.83L104.83,89.83z M103.63,91.8C103.65,91.88,103.67,91.98,103.63,91.8L103.63,91.8z M90.97,85.7C90.8,85.77,90.81,85.76,90.97,85.7L90.97,85.7z M62.56,81.38C62.63,81.96,61.21,81.47,62.56,81.38L62.56,81.38z M63.19,81.43C63.15,81.5,63.13,81.53,63.19,81.43L63.19,81.43z M63.25,81.82C63.31,81.87,63.26,81.83,63.25,81.82L63.25,81.82z M60.86,85C61.16,85.36,60.71,84.83,60.86,85L60.86,85z M61.25,85.01C61.4,85.24,61.22,84.98,61.25,85.01L61.25,85.01z M63.77,85.65 c-0.04,0.03,0.03,0.2-0.24,0.13C63.57,85.63,63.63,85.76,63.77,85.65L63.77,85.65z M65.11,85.07C65,85.21,65.02,85.18,65.11,85.07 L65.11,85.07z M65.4,84.42C65.37,84.6,65.38,84.54,65.4,84.42L65.4,84.42z M65.46,84C65.46,84.21,65.46,84.24,65.46,84L65.46,84z M65.3,83.49C65.49,83.81,65.49,83.81,65.3,83.49L65.3,83.49z M65.23,83.07C65.28,83.34,65.26,83.3,65.23,83.07L65.23,83.07z M65.18,82.55c-0.04,0.08,0.05,0.21-0.2,0.28C64.97,82.57,65.09,82.72,65.18,82.55L65.18,82.55z M64.95,82.18 C64.98,82.29,64.98,82.28,64.95,82.18L64.95,82.18z M64.41,82.01C64.37,82.14,64.4,82.05,64.41,82.01L64.41,82.01z M65.69,85.55 C65.51,85.68,65.53,85.67,65.69,85.55L65.69,85.55z M65.45,85.85c-0.17,0.25,0.07,0.53-0.46,0.42 C64.98,85.87,65.2,86.04,65.45,85.85L65.45,85.85z M56.27,81.4c0.23,0.12,0.36,0.11,0.49,0.33c-0.47,0.1-0.77,0.07-1.16-0.24 C55.83,81.3,55.98,81.39,56.27,81.4L56.27,81.4z M58.59,81.11C58.55,81.22,58.55,81.23,58.59,81.11L58.59,81.11z M35.89,81.61 C35.89,81.59,35.88,81.57,35.89,81.61v-0.01V81.61L35.89,81.61z M168.13,84.36c0.52,0.04,0.79,0.14,0.48,0.71 C168.5,84.81,168.22,84.54,168.13,84.36L168.13,84.36z M168.97,84.41C169.08,84.36,169.14,84.34,168.97,84.41L168.97,84.41z M169.04,84.92C168.92,84.74,169.28,85.27,169.04,84.92L169.04,84.92z M169.29,84.92C169.42,84.97,169.46,84.99,169.29,84.92 L169.29,84.92z M169.62,84.53C169.79,84.73,169.85,84.8,169.62,84.53L169.62,84.53z M169.99,84.81 C170,84.85,170.09,85.03,169.99,84.81L169.99,84.81z M169.76,84.85c0.17,0.16,0.37,0.19,0.44,0.46c-0.16-0.03-0.35-0.1-0.44-0.12 C169.76,85.16,169.79,84.9,169.76,84.85L169.76,84.85z M170.36,84.88c0.55-0.06,0.79,0.27,0.79,0.85 C170.77,85.57,170.57,85.3,170.36,84.88L170.36,84.88z M169.01,85.25c0.25,0.05,0.39,0.19,0.65,0.2c-0.17,0.32-0.25,0.47-0.61,0.64 C169.07,85.84,168.98,85.46,169.01,85.25L169.01,85.25z M169.42,85.94C169.39,86.07,169.37,86.12,169.42,85.94L169.42,85.94z M170.41,85.37C170.43,85.39,170.59,85.5,170.41,85.37L170.41,85.37z M170.36,85.47c0.25,0.18,0.44,0.23,0.52,0.71 c-0.14,0.01-0.09,0-0.14,0.12C170.57,85.99,170.48,85.82,170.36,85.47L170.36,85.47z M158.86,86.06 C158.89,86.33,158.88,86.21,158.86,86.06L158.86,86.06z M155.76,85.29C155.7,85.52,155.74,85.38,155.76,85.29L155.76,85.29z M155.61,85.31C155.59,85.43,155.57,85.53,155.61,85.31L155.61,85.31z M155.67,84.79C155.7,85.03,155.68,84.98,155.67,84.79 L155.67,84.79z M152.58,84.3c0.01,0.3-0.05,0.82-0.15,1.14C152.4,85.08,152.49,84.69,152.58,84.3L152.58,84.3z M130.76,84.85 c-0.02,0-0.24,0.21-0.56,0.06C130.38,84.76,130.48,84.89,130.76,84.85L130.76,84.85z M90.8,75.2c-0.13,0.13-0.08,0.5-0.35,0.15 C90.54,75.31,90.74,75.26,90.8,75.2L90.8,75.2z M91.12,75.45c0.03,0.11,0.3,0.08,0.06,0.27C90.9,75.7,91.17,75.6,91.12,75.45 L91.12,75.45z M92.14,75.11c-0.11,0.18,0.04,0.33-0.29,0.39C91.91,75.39,92.11,75.16,92.14,75.11L92.14,75.11z M92.39,74.79 C92.13,75.04,92.17,75,92.39,74.79L92.39,74.79z M55.73,76.29c0.07-0.03-0.15,0.17-0.51,0.08C55.37,76.33,55.6,76.34,55.73,76.29 L55.73,76.29z M56.29,76.6c0.11-0.08,0-0.01-0.07,0.27C56.15,76.53,56.32,76.58,56.29,76.6L56.29,76.6z M56.15,77.41 C55.96,77.29,56.17,77.43,56.15,77.41L56.15,77.41z M55.73,77.39c-0.01,0.17,0.23,0.21,0.09,0.44 C55.49,77.56,55.73,77.38,55.73,77.39L55.73,77.39z M55.91,77.86C55.89,77.91,55.83,78.12,55.91,77.86L55.91,77.86z M55.89,78.06 C55.91,78.06,56.15,78.15,55.89,78.06L55.89,78.06z M56.79,77.31c0-0.06,0.02,0.25,0.02,0.32C56.66,77.49,56.78,77.47,56.79,77.31 L56.79,77.31z M57.24,77.84c0.15,0.16-0.07-0.02-0.17-0.21C57.12,77.53,57.14,77.74,57.24,77.84L57.24,77.84z M57.76,77.95 C57.76,77.97,57.77,78.15,57.76,77.95L57.76,77.95z M57.32,78.31c0.07,0.16,0.13,0.29,0.21,0.42C57.41,78.59,57.4,78.47,57.32,78.31 L57.32,78.31z M58,78.88c-0.11,0.04-0.15-0.23,0.01,0.19C57.69,79.27,58.05,78.86,58,78.88L58,78.88z M58.75,79.08 C58.5,79,58.57,79.02,58.75,79.08L58.75,79.08z M59.06,79.3c0.09,0.04,0.25,0.03,0.36,0.15C59.25,79.42,58.94,79.25,59.06,79.3 L59.06,79.3z M58.59,79.65c-0.12,0.11,0,0.31-0.34,0.27C58.35,79.69,58.41,79.81,58.59,79.65L58.59,79.65z M55.76,79.11 c0.07,0.11,0.23,0.09,0.17,0.22C55.78,79.24,55.71,79.02,55.76,79.11L55.76,79.11z M52.95,79.34c0.01,0.1,0.37,0.09,0.05,0.26 C52.73,79.52,52.97,79.48,52.95,79.34L52.95,79.34z M50.81,80.12C50.61,80.32,50.66,80.27,50.81,80.12L50.81,80.12z M44.85,77.27 C44.84,77.38,44.84,77.48,44.85,77.27L44.85,77.27z M45.11,75.59c0.08-0.04,0.17-0.17,0.27-0.2C45.19,75.65,44.9,75.68,45.11,75.59 L45.11,75.59z M33.01,74.93C32.98,74.92,33.16,74.96,33.01,74.93L33.01,74.93z M34.79,75.57C34.78,75.38,34.76,75.33,34.79,75.57 L34.79,75.57z M35.98,74.92c-0.06-0.07-0.21-0.18-0.27-0.34C35.84,74.7,35.9,74.83,35.98,74.92L35.98,74.92z M36.32,74.92 C36.32,74.91,36.58,75.1,36.32,74.92L36.32,74.92z M168.72,77.27c0.42,0.44-0.06,1.44-0.35,2.04 C167.72,78.66,167.97,77.75,168.72,77.27L168.72,77.27z M170.03,77.8C170.1,77.9,170.09,77.89,170.03,77.8L170.03,77.8z M170.24,77.81C170.35,77.76,170.29,77.79,170.24,77.81L170.24,77.81z M172.33,76.48c-0.01,0,0.2-0.2,0.23-0.21 c-0.07,0.14-0.13,0.23-0.23,0.38C172.15,76.8,172.32,76.48,172.33,76.48L172.33,76.48z M172.98,75.68 C173.05,75.76,172.83,75.55,172.98,75.68L172.98,75.68z M173.23,75.28C173.23,75.28,173.31,75.5,173.23,75.28L173.23,75.28z M170.92,77.55C170.89,77.53,171.06,77.71,170.92,77.55L170.92,77.55z M164.49,79.12C164.43,79.11,164.44,79.12,164.49,79.12 L164.49,79.12z M151.28,78.86C151.34,78.97,151.47,79.22,151.28,78.86L151.28,78.86z M128.59,76.67 C128.42,76.97,128.59,76.67,128.59,76.67L128.59,76.67z M131.76,76.23c-0.19,0.09-0.26,0.22-0.51,0.27 C131.39,76.3,131.58,76.32,131.76,76.23L131.76,76.23z M90.46,72.4C90.44,72.45,90.35,72.6,90.46,72.4L90.46,72.4z M90.78,72.2 C90.71,72.34,90.75,72.26,90.78,72.2L90.78,72.2z M32.13,71.56C32.24,71.61,32.38,71.68,32.13,71.56L32.13,71.56z M32.92,72.01 C32.91,72,33.07,72.17,32.92,72.01L32.92,72.01z M32.86,72.27C32.97,72.41,33.03,72.5,32.86,72.27L32.86,72.27z M178.45,68.62 c-0.06,0.16,0.07,0.26-0.13,0.34C178.25,68.77,178.41,68.72,178.45,68.62L178.45,68.62z M176,72.1c-0.31,0.12-0.55-0.27-0.67,0.38 c-0.14-0.08-0.42-0.31-0.49-0.44C175.29,71.6,176.67,71.03,176,72.1L176,72.1z M176.44,71.21C176.3,71.53,176.29,71.54,176.44,71.21 L176.44,71.21z M173.66,72.63C173.65,72.78,173.65,72.94,173.66,72.63L173.66,72.63z M174.21,73.85 C173.89,74.3,174.33,73.67,174.21,73.85L174.21,73.85z M173.88,74.03C173.94,74.26,173.88,74.01,173.88,74.03L173.88,74.03z M174.09,69.14C174.08,69.16,174.07,69.24,174.09,69.14L174.09,69.14z M172.92,72.46C172.84,72.6,172.84,72.61,172.92,72.46 L172.92,72.46z M173.14,72.31C172.93,72.41,173.13,72.31,173.14,72.31L173.14,72.31z M173.43,71.71 C173.44,71.81,173.44,71.81,173.43,71.71L173.43,71.71z M173.17,71.41C173.14,71.57,173.14,71.59,173.17,71.41L173.17,71.41z M173.24,71.17C173.27,71.37,173.28,71.46,173.24,71.17L173.24,71.17z M171.5,72.04c0.16,0.04,0.23-0.19,0.35,0.01 C171.52,72.28,171.51,72.04,171.5,72.04L171.5,72.04z M119.24,70.59c0.11-0.02,0.25-0.12,0.35-0.16c-0.27,0.56-0.81,0.98-1.31,0.47 C118.6,70.74,118.85,70.62,119.24,70.59L119.24,70.59z M114.98,68.04c-0.12-0.07-0.17-0.03-0.38-0.06 C114.96,67.63,114.88,67.97,114.98,68.04L114.98,68.04z M114.67,68.64c0.01-0.04-0.04-0.18-0.05-0.28 C114.89,68.42,114.69,68.5,114.67,68.64L114.67,68.64z M115.87,70.17c-0.02-0.04-0.37,0.06,0.07-0.24 C116.07,70.02,115.84,70.1,115.87,70.17L115.87,70.17z M114.16,70.66c0.24,0.03,0.42,0.14,0.69,0.08c-0.36,0.33-0.99,0.16-1.55,0.04 C113.44,70.42,113.7,70.53,114.16,70.66L114.16,70.66z M114.09,69.06C113.96,68.76,114,68.84,114.09,69.06L114.09,69.06z M114.36,69.58C114.44,69.37,114.43,69.4,114.36,69.58L114.36,69.58z M112.43,68.59c0.38,0.15,0.63,0.29,0.82,0.65 c-0.19-0.02-0.19-0.06-0.41-0.09c0.12,0.25,0.12,0.51,0.2,0.78c-0.02-0.01-0.29-0.19-0.23-0.23c-0.11,0.07-0.08,0.24-0.18,0.24 c-0.06-0.07-0.12-0.32-0.18-0.43c-0.06,0.05-0.09,0.12-0.09,0.2C111.96,69.29,111.78,68.77,112.43,68.59L112.43,68.59z M111.7,68.76 C111.46,68.51,111.54,68.57,111.7,68.76L111.7,68.76z M113.87,68.76c-0.11-0.02-0.64-0.34-0.91-0.55 C113.34,68.18,113.74,68.46,113.87,68.76L113.87,68.76z M108.77,68.6c0,0.01-0.25,1.14-0.23,1.13c-0.11,0.06-1.44-0.6-1.47-0.72 C106.96,68.5,108.29,68.81,108.77,68.6L108.77,68.6z M108.1,70.26C108.14,70.28,108.31,70.39,108.1,70.26L108.1,70.26z M106.05,71.68C105.99,71.86,106.02,71.79,106.05,71.68L106.05,71.68z M100.87,68.02C100.83,68.1,100.74,68.3,100.87,68.02 L100.87,68.02z M101.83,67.4c-0.08,0.23,0.21,0.14-0.04,0.49c-0.16-0.07-0.29-0.15-0.4-0.21C101.48,67.55,101.78,67.44,101.83,67.4 L101.83,67.4z M68.09,61.79C68.11,62.1,68.11,62.08,68.09,61.79L68.09,61.79z M63.73,59.39c0.45,0.11,0.99,0.34,1.29,0.69 C64.43,60.17,63.38,59.65,63.73,59.39L63.73,59.39z M63.75,61.87c0.01,0.41,0.49,0.61,1.1,0.47c-0.04,0.07-0.16,0.28-0.21,0.36 C64.14,62.59,63.53,62.42,63.75,61.87L63.75,61.87z M59.07,66.48c0.01,0.01-0.31,0.25,0.15,0.11c-0.35,0.15-0.86,0.29-1.13,0.33 C58.33,66.69,58.71,66.58,59.07,66.48L59.07,66.48z M187.63,59.66C187.52,59.98,187.52,59.99,187.63,59.66L187.63,59.66z M187.26,60.31C187.23,60.39,187.16,60.55,187.26,60.31L187.26,60.31z M186.21,61.79c-0.09,0.11-0.07,0.24-0.27,0.27 C186,61.96,186.14,61.86,186.21,61.79L186.21,61.79z M184.31,63.21c-0.23,0.14-0.76,0.52-1.07,0.75 C183.52,63.46,183.92,63.15,184.31,63.21L184.31,63.21z M183.17,64.45C183.16,64.46,182.92,64.67,183.17,64.45L183.17,64.45z M182.76,63.97c0,0-0.08,0.4-0.34,0.61C182.45,64.38,182.62,64.17,182.76,63.97L182.76,63.97z M179.94,63.35 C179.96,63.45,179.97,63.49,179.94,63.35L179.94,63.35z M113.95,66.91C113.9,66.78,113.9,66.78,113.95,66.91L113.95,66.91z M108.17,63.35C108.27,63.63,108.23,63.52,108.17,63.35L108.17,63.35z M108.05,63.41c0-0.01,0.07,0.29,0.09,0.38 C108.02,63.6,108.09,63.59,108.05,63.41L108.05,63.41z M109.24,64.78C109.55,64.88,109.49,64.86,109.24,64.78L109.24,64.78z M109.38,65.12C109.69,65.13,109.64,65.13,109.38,65.12L109.38,65.12z M105.25,65.08c0.11,0.41,0.12,0.83-0.07,1.25 C104.72,65.9,104.77,65.4,105.25,65.08L105.25,65.08z M96.48,51.16c-0.06,0.35-0.07,0.52-0.44,0.74 C95.94,51.43,96.14,51.42,96.48,51.16L96.48,51.16z M95.98,52.04C95.76,52.12,95.81,52.09,95.98,52.04L95.98,52.04z M98.47,50.6 c-0.18-0.08-0.36,0.1-0.32-0.22C98.24,50.47,98.38,50.56,98.47,50.6L98.47,50.6z M98.2,50.74C98.09,50.65,98.08,50.64,98.2,50.74 L98.2,50.74z M99.34,58.73C99.35,58.72,99.15,58.88,99.34,58.73L99.34,58.73z M97.52,55.32c-0.05,0.12,0.1,0.25-0.21,0.32 C97.36,55.51,97.48,55.43,97.52,55.32L97.52,55.32z M97,54.05C97.06,54.19,97.16,54.4,97,54.05L97,54.05z M96.52,53.84 C96.39,54.1,96.39,54.12,96.52,53.84L96.52,53.84z M96.76,53.63c-0.06,0.11-0.07,0.23-0.17,0.3C96.62,53.82,96.75,53.65,96.76,53.63 L96.76,53.63z M96.43,53.41c0.11-0.1,0.16-0.14,0.07-0.31c0.08,0.06,0.18,0.13,0.27,0.25C96.67,53.41,96.36,53.47,96.43,53.41 L96.43,53.41z M96.43,51.98c0.12,0.23,0.12,0.38,0.34,0.48c-0.03,0.05-0.05,0.09-0.06,0.15C96.25,52.47,96.23,52.29,96.43,51.98 L96.43,51.98z M53.51,56.52c0.38,0.09,0.62-0.15,0.69,0.43C53.9,56.87,53.61,56.62,53.51,56.52L53.51,56.52z M26.78,56.76 C26.91,57.05,26.91,57.06,26.78,56.76L26.78,56.76z M23.54,52.39c0.08,0.28,0.13,0.77,0.04,1.09c-0.04-0.23-0.01-0.42-0.03-0.64 c-0.21-0.08-0.3-0.23-0.34-0.72C23.32,52.21,23.43,52.32,23.54,52.39L23.54,52.39z M23.72,52.03c-0.12-0.79,0.14-0.65,0.45,0.03 c-0.08-0.16-0.17-0.39-0.25-0.51c0.01,0.05,0,0.06-0.03,0.06c0.28,0.5,0.26,0.81-0.15,0.97C23.82,52.26,23.72,52.12,23.72,52.03 L23.72,52.03z M23.96,53.04c0.01-0.08-0.2-0.08-0.1-0.24c0.04,0.01,0.06,0,0.07-0.04c0.2,0.36,0.16,0.27,0.14,0.81 c-0.13-0.21,0.01-0.15-0.09-0.07C23.97,53.21,23.97,53.19,23.96,53.04L23.96,53.04z M24.2,52.76c0.03-0.01,0.19-0.3,0.42,0.27 c-0.02,0.03-0.13-0.22-0.18-0.18c0.01,0.08,0.17,0.28,0.11,0.37c-0.05-0.02-0.17-0.01-0.23,0.02C24.27,53.03,24.19,52.75,24.2,52.76 L24.2,52.76z M24.73,52.88c0.02,0.14,0.16,0.17,0.05,0.27C24.67,53.04,24.73,52.87,24.73,52.88L24.73,52.88z M24.78,53.27 C24.67,53.38,24.65,53.4,24.78,53.27L24.78,53.27z M25.16,53.37C25.17,53.36,24.93,53.44,25.16,53.37L25.16,53.37z M23.44,51.54 c0.01-0.01,0.01,0.21,0.01,0.29c-0.05,0.01-0.34-0.07-0.34-0.07c0.21,0.14,0.25,0.23,0.41,0.35c-0.03,0.01-0.03,0.04-0.01,0.07 c-0.19-0.04-0.31-0.24-0.45-0.33c-0.02,0.1,0.13,0.3,0.05,0.39c-0.28-0.29-0.39-0.45-0.38-0.85C22.87,51.35,23.14,51.4,23.44,51.54 L23.44,51.54z M24.75,53.67c0.13,0.31,0.14,0.3,0.33,0.55c-0.07-0.01-0.13-0.09-0.19-0.13c0.31,0.34,0.2,0.45,0.3,0.86 c-0.03-0.03-0.09-0.05-0.14,0.01c-0.18-0.25-0.28-0.34-0.54-0.62c0.12-0.38,0.15-0.03-0.1-0.31c0.01-0.16,0.08-0.29,0.08-0.49 c0.06,0.02-0.27,0.19-0.29,0.2c0.03-0.18,0.16-0.26,0.07-0.42C24.54,53.41,24.53,53.49,24.75,53.67L24.75,53.67z M25.54,54.39 c-0.06-0.06,0.16-0.31,0.02-0.26c-0.09,0.02-0.08,0.11-0.13,0.22c0-0.74,0.32-0.66,0.35,0.19C25.67,54.41,25.58,54.41,25.54,54.39 L25.54,54.39z M24.62,54.67c0,0,0.11,0.25,0.1,0.31C24.45,54.48,24.67,54.51,24.62,54.67L24.62,54.67z M25.42,54.39 C25.55,54.69,25.55,54.69,25.42,54.39L25.42,54.39z M25.18,55.62c0.03,0.05,0.18,0.33-0.01,0.78c-0.18-0.01,0.02-0.12-0.18,0.07 c-0.15-0.21-0.29-0.57-0.4-0.97c0.34,0.04,0.1,0.1,0.25,0.19c-0.01-0.05,0.13-0.16,0.17-0.15c-0.05,0.29-0.04,0.17-0.16,0.43 c0.05,0.02,0.15-0.05,0.09,0.06C25.11,55.94,25.11,55.8,25.18,55.62L25.18,55.62z M25.13,56.87c-0.04-0.22,0-0.22-0.15-0.33 c0.11-0.05,0.19-0.13,0.3-0.19c0.01-0.02,0.1,0.17,0.1,0.16c-0.17,0.16-0.08,0.47,0.26,0.89C25.41,57.23,25.32,57.07,25.13,56.87 L25.13,56.87z M25.97,55.69C26.15,55.69,26.24,55.67,25.97,55.69L25.97,55.69z M12.31,53.14C12.35,53.18,12.47,53.28,12.31,53.14 L12.31,53.14z M12.62,53.16C12.58,53.07,12.58,53.06,12.62,53.16L12.62,53.16z M13.21,52.55c0.01,0.03-0.21,0.16-0.04-0.1 C13.51,52.46,13.2,52.51,13.21,52.55L13.21,52.55z M12.28,52.3c0.02-0.01,0.19-0.27,0.43-0.31c0.02,0.03,0.07,0.17,0.12,0.25 c-0.02-0.2,0.02-0.32-0.04-0.5c0.06,0.02,0.22,0.12,0.18,0.21c0.01-0.01,0.34-0.31,0.2-0.28c0.31,0.1,0.03,0.16,0.37,0.04 c0.04,0.41,0.03,0.12,0.2,0.33c-0.02,0.05-0.05,0.1-0.08,0.15c-0.21-0.01-0.21-0.04-0.38,0c0.08,0.03,0.27,0.01,0.2,0.16 c-0.3,0.07-0.48,0.15-0.82,0.54c0.01-0.39-0.06-0.15-0.15-0.4c0.04,0.14,0.09,0.09,0.02,0.27C12.47,52.61,12.39,52.44,12.28,52.3 L12.28,52.3z M13.05,51.51C13.2,51.52,13.32,51.53,13.05,51.51L13.05,51.51z M13.43,51.32c0.12-0.12,0.14-0.28,0.37,0.07 c-0.35,0.11-0.33,0.06-0.58,0.04C13.21,51.27,13.41,51.39,13.43,51.32L13.43,51.32z M13.5,50.93C13.61,51.02,13.67,51.07,13.5,50.93 L13.5,50.93z M4.07,56.81c0.23-0.35,0.32-0.59,0.69-0.69C4.62,56.37,4.31,56.61,4.07,56.81L4.07,56.81z M4.92,56.33 c0.06-0.08,0.37-0.34,0.48-0.4c-0.02,0.05-0.14-0.19-0.14-0.2c0.24-0.01,0.23-0.01,0.4-0.06C5.66,56.04,5.4,56.17,4.92,56.33 L4.92,56.33z M5.89,55.41C5.95,55.65,5.95,55.63,5.89,55.41L5.89,55.41z M6.5,55.05c0.36-0.47,0.71-0.54,1-0.09 C7.09,55.19,6.77,55.16,6.5,55.05L6.5,55.05z M7.71,55.2C7.73,55.2,7.94,55.28,7.71,55.2L7.71,55.2z M8.9,54.27 C8.94,54.37,9,54.26,9,54.5C8.76,54.48,8.94,54.36,8.9,54.27L8.9,54.27z M8.87,50.72c-0.03,0.04-0.03,0.19-0.13,0.28 C8.61,50.81,8.78,50.86,8.87,50.72L8.87,50.72z M-1.08,57.63c-0.03-0.02,0.28,0.03,0.34,0.05c-0.04,0.07-0.08,0.12-0.12,0.2 C-0.96,57.82-0.96,57.7-1.08,57.63L-1.08,57.63z M-0.73,57.84c0.11-0.06,0.27-0.16,0.33-0.2C-0.47,57.87-0.57,57.76-0.73,57.84 L-0.73,57.84z M-0.3,57.73c0.14-0.01,0.12-0.27,0.3,0.03C-0.22,57.95-0.24,57.73-0.3,57.73L-0.3,57.73z M1.17,57.19 c-0.01,0.05,0.23,0.18-0.2,0.26C1.07,57.41,1.15,57.32,1.17,57.19L1.17,57.19z M1.34,57.41c0.03,0,0.41,0.04,0.52,0.07 C1.63,57.56,1.52,57.44,1.34,57.41L1.34,57.41z M2.16,57.16C2.27,57.33,2.23,57.27,2.16,57.16l-0.03,0.05L2.16,57.16L2.16,57.16z M3.39,52.47C3.42,52.47,3.5,52.47,3.39,52.47L3.39,52.47z M197.53,56.69c0.09,0.01,0.29-0.08,0.48,0.06 C197.7,56.91,197.78,56.73,197.53,56.69L197.53,56.69z M193.04,50.36c-0.05,0.23-0.07,0.52-0.57,0.79 C192.56,50.64,192.71,50.63,193.04,50.36L193.04,50.36z M193.95,54.39c0.08,0.13,0.26,0.35,0.35,0.57 C194.02,54.83,194,54.49,193.95,54.39L193.95,54.39z M194.7,54.83c0.11,0.12,0.19,0.19,0.32,0.33 C194.88,55.1,194.82,54.96,194.7,54.83L194.7,54.83z M188.6,58.61C188.34,58.89,188.57,58.65,188.6,58.61L188.6,58.61z M188.35,58.72c-0.11,0.19-0.02,0.48-0.45,0.58C188,59.09,188.15,58.94,188.35,58.72L188.35,58.72z M177.74,54.87 c0.1-0.04,0.15-0.25,0.17-0.36C178.27,55.14,177.91,54.85,177.74,54.87L177.74,54.87z M112.95,50.94c-0.07,0.18-0.22,0.45-0.56,0.7 c-0.04-0.12-0.07-0.42-0.07-0.6C112.54,51.01,112.69,50.99,112.95,50.94L112.95,50.94z M112.61,50.56c0.04,0.03,0.21-0.25,0.33,0.1 C112.4,50.83,112.6,50.55,112.61,50.56L112.61,50.56z M109.16,53.42c0.09-0.4,0.18-0.78,0.39-1.13 C109.46,52.68,109.31,53.06,109.16,53.42L109.16,53.42z M110.17,52.72c-0.07-0.42,0.08-0.82,0.49-1.01 C110.63,52.1,110.48,52.41,110.17,52.72L110.17,52.72z M108.45,54.69c-0.11-0.11-0.3,0.02-0.19-0.27 C108.44,54.47,108.35,54.59,108.45,54.69L108.45,54.69z M107.61,55.23c0.02,0,0,0.24-0.27,0.1c0.02-0.08,0.04-0.07,0.01-0.17 c0.05-0.06,0.14,0.08,0.17,0.05c-0.04-0.09-0.11-0.08-0.09-0.18C107.54,55.03,107.64,55.24,107.61,55.23L107.61,55.23z M102.83,56.46C102.49,56.91,102.89,56.37,102.83,56.46L102.83,56.46z M102.26,57.78C102.22,57.76,102.61,57.91,102.26,57.78 L102.26,57.78z M102.13,57.84C102.26,57.86,102.36,57.87,102.13,57.84L102.13,57.84z M102.04,57.98 C102.06,58.05,102.07,58.12,102.04,57.98L102.04,57.98z M103.04,49.73C102.98,49.5,102.96,49.43,103.04,49.73L103.04,49.73z M102.95,50.37C102.92,50.27,102.87,50.04,102.95,50.37L102.95,50.37z M95.95,47.02C95.7,46.99,95.73,46.99,95.95,47.02L95.95,47.02 z M96.12,47.15c-0.03-0.05-0.2-0.19-0.28-0.28c0.02-0.04,0.03-0.07,0.04-0.11C96.07,46.86,96.06,47.06,96.12,47.15L96.12,47.15z M96.18,47.03c-0.04-0.08-0.16-0.17-0.19-0.29C96.15,46.81,96.15,46.96,96.18,47.03L96.18,47.03z M96.31,46.78 C96.14,46.87,96.23,46.82,96.31,46.78L96.31,46.78z M96.21,47.39C96.11,47.27,96.07,47.22,96.21,47.39L96.21,47.39z M96.05,47.57 C96.15,48.01,96.07,47.63,96.05,47.57L96.05,47.57z M61.33,48.88c0.02,0.02,0.14-0.34,0.22,0.02 C61.17,49.24,61.38,48.93,61.33,48.88L61.33,48.88z M63.11,47.45c0.01,0.1,0.22,0.08,0.16,0.38c-0.16-0.04-0.27-0.11-0.42-0.19 C62.87,47.49,63.11,47.43,63.11,47.45L63.11,47.45z M56.71,38.59c0.55-0.06,1.22,1.07,0.37,1.52C55.98,40.7,56.01,39.02,56.71,38.59 L56.71,38.59z M57.6,39.05c0,0,0.24-0.22,0.25-0.23c0.17,0.15,0.35,0.28,0.46,0.53C57.88,39.54,57.84,39.26,57.6,39.05L57.6,39.05z M55.5,45.38c0.23,0.07,0.58-0.2,0.36,0.39C55.76,45.67,55.64,45.44,55.5,45.38L55.5,45.38z M56.1,44.99 c0.19,0.16,0.38,0.07,0.43,0.37C56.22,45.35,56.27,45.14,56.1,44.99L56.1,44.99z M59.74,46.15c0.16,0.1,0.3,0.01,0.34,0.23 C59.79,46.44,59.87,46.23,59.74,46.15L59.74,46.15z M58.02,46.26c0.06,0-0.19,0.05-0.41,0C57.75,46.21,57.91,46.27,58.02,46.26 L58.02,46.26z M50.89,38.64c0.01,0.23,0.1,0.49,0.03,0.75C50.57,39.01,50.81,38.82,50.89,38.64L50.89,38.64z M51.36,42.22 c0.17,0.08,0.44,0.17,0.52,0.72c0.52-0.45,2.28,1.67,2.65,1.95c-0.65,0.67-1.18-0.02-1.57-0.23c-0.05-0.13,0.01-0.14,0-0.28 c-0.37,0.33-1.72,2.25-1.57,0.38c-0.27,0.28-0.39,0.19-0.76,0.42C50.97,44.34,51.01,43.24,51.36,42.22L51.36,42.22z M52.45,41.98 c0.08,0.15,0.21,0.34,0.31,0.47c-0.31-0.22-0.41-0.31-0.64-0.68C52.31,41.77,52.31,41.93,52.45,41.98L52.45,41.98z M53.22,45.96 c0.45,0.33-0.22,0.85-0.74,1C52.54,46.44,52.82,46.21,53.22,45.96L53.22,45.96z M45.07,36.64c0.4,0.39,0.68,0.91,0.98,1.13 c-0.77,1.06-1.61-0.2-2.22,0.04c-0.21-0.51,0.36-0.83,0.52-1.14C44.43,35.92,44.81,36.08,45.07,36.64L45.07,36.64z M16.82,48.99 c0.05-0.01,0.05-0.17,0.32-0.04C16.93,49.18,16.93,48.96,16.82,48.99L16.82,48.99z M7.96,40.61c0.03,0.04,0.2,0.05,0.23,0.3 C7.9,40.87,8.02,40.7,7.96,40.61L7.96,40.61z M6.31,48.67c0.37-0.03,0.72-0.36,0.37,0.34C6.61,48.75,6.5,48.76,6.31,48.67 L6.31,48.67z M2.03,48.81C2.25,49.1,2.19,49.01,2.03,48.81L2.03,48.81z M139.78,41.03c0.21-0.1,0.42-0.19,0.63-0.31 c0,0.07,0.06,0.2,0.09,0.28C140.17,41.28,140.02,41.04,139.78,41.03L139.78,41.03z M112.31,49.26 C112.23,49.2,112.13,49.12,112.31,49.26L112.31,49.26z M112.73,49.38c-0.02-0.09-0.32-0.05,0.05-0.25 C112.9,49.15,112.71,49.27,112.73,49.38L112.73,49.38z M108.81,37.61c0.01,0.11,0.2,0.23,0.07,0.53c0.15-0.16,0.19-0.24,0.25-0.44 c0.15,0.46,0.02,0.58-0.35,0.86c-0.08,0.01-0.04-0.24-0.04-0.24c-0.4,0.37-0.28,0.25-0.7,0.45 C108.33,38.52,108.74,38.13,108.81,37.61L108.81,37.61z M108.15,37.99c0.13-0.24,0.21-0.15,0.35-0.43c0.16,0.42,0.08,0.3-0.08,0.6 c0-0.02-0.01-0.24,0.07-0.23C108.28,38.11,108.23,38.06,108.15,37.99L108.15,37.99z M108.89,37.18c-0.02-0.04,0.09-0.19,0.23-0.12 c-0.14,0.29-0.16,0.28-0.35,0.46C108.76,37.42,108.9,37.2,108.89,37.18L108.89,37.18z M108.42,39.34c-0.15,0,0.13-0.15,0.2-0.17 C108.39,39.58,108.31,39.34,108.42,39.34L108.42,39.34z M109.56,37.18c0.03-0.18,0.13-0.4,0.28-0.6 C110.37,36.92,109.7,37.65,109.56,37.18L109.56,37.18z M110.29,36.37c0.19-0.08,0.28,0.01,0.28-0.26 C110.54,36.74,110.46,36.5,110.29,36.37L110.29,36.37z M104.74,45.16c0.13-0.03,0.21-0.12,0.38-0.16c0,0.05,0.01,0.09,0.04,0.15 C105.01,45.25,104.77,45.16,104.74,45.16L104.74,45.16z M102.75,48.14C102.6,48.41,102.71,48.21,102.75,48.14L102.75,48.14z M102.79,48.67C102.78,48.53,102.78,48.53,102.79,48.67L102.79,48.67z M45.21,30.56c-0.07-0.05-0.45,0.22-0.12-0.36 C45.26,30.29,45.18,30.54,45.21,30.56L45.21,30.56z M44.09,28.93c-0.17-0.01-0.22,0-0.44-0.1c0.28-0.23,0.53-0.37,0.89-0.46 C44.5,28.72,44.28,28.74,44.09,28.93L44.09,28.93z M46.13,28.37c0.44-0.16,1.3-0.26,1.56,0.25c0.69-0.3,1.55,0.24,0.68,0.74 c-0.15,1.35-0.51,1.57-1.87,1.67c0.84,0.41,0.19,1.47-0.47,1.31c0.07-0.31-0.01-0.52,0.16-0.99c-0.64-0.19-0.47-1.76-0.33-2.42 c0.16,0.14,0.41,0.25,0.5,0.34C45.96,28.95,46.04,28.7,46.13,28.37L46.13,28.37z M40.52,30.36c-0.08,0.14-0.12,0.28-0.22,0.38 c-0.27-0.52-1.11-1.04-0.77-1.5C40.13,28.4,41.03,29.51,40.52,30.36L40.52,30.36z M179.78,28.23c-0.04,0.14-0.2,0.46-0.23,0.51 C179.2,28.31,179.25,27.7,179.78,28.23L179.78,28.23z M176.99,28.41c-0.01,0.14,0.16,0.16,0.11,0.37c-0.16-0.23-0.33-0.49-0.44-0.74 C176.74,28.12,176.88,28.31,176.99,28.41L176.99,28.41z M177.57,33.09c0.15,0.06,0.36,0.09,0.53,0.14 C177.59,33.49,177.62,33.15,177.57,33.09L177.57,33.09z M178.13,33.25c0.66-0.17,0.58,0.15-0.09,0.32 C178.07,33.48,178.15,33.29,178.13,33.25L178.13,33.25z M163.96,27.45c0.48,0.8-0.52,1.09-0.83,0.3c-0.07,0.11,0.23-0.35,0.25-0.37 C163.6,27.5,163.75,27.44,163.96,27.45L163.96,27.45z M160.56,18.62c0.14,0.06,0.26,0.07,0.43,0.06c-0.01,0.01-0.08,0.29-0.1,0.34 c-0.18-0.04-0.39-0.19-0.59-0.22C160.33,18.77,160.55,18.67,160.56,18.62L160.56,18.62z M154.49,21.7 c-0.12,0.14-0.17,0.29-0.36,0.34c-0.01,0,0.1-0.18,0.11-0.21c-0.15,0-0.22,0.18-0.4,0.09c0.19-0.19,0.41-0.4,0.62-0.57 C154.52,21.44,154.53,21.79,154.49,21.7L154.49,21.7z M150.65,20.93c-0.03,0.15,0.02,0.27,0,0.45c-0.15-0.04-0.04-0.02-0.16-0.01 C150.35,21.03,150.61,21.11,150.65,20.93L150.65,20.93z M146.5,25.48c-0.05,0.14-0.02,0.23-0.08,0.49 c-0.08-0.12-0.04-0.22-0.07-0.36c-0.07,0.05-0.13,0.01-0.17-0.07c-0.05,0.13,0.06,0.28,0.04,0.4c-0.07-0.29-0.08-0.34-0.02-0.59 c-0.01,0.06,0.01,0.1,0.06,0.13c0.04-0.16,0.04-0.22,0.05-0.23C146.63,25.21,146.41,25.36,146.5,25.48L146.5,25.48z M146.58,35.21 c-0.03-0.03,0.29-0.15,0.19,0.4C146.62,35.51,146.67,35.28,146.58,35.21L146.58,35.21z M139.74,30.48 c-0.04-0.91,0.47-0.99,0.76-0.32C140.11,30.31,139.91,30.45,139.74,30.48L139.74,30.48z M141.98,30.48c0.04,0.01,0.19-0.19,0.39,0 c-0.01,0.03-0.09,0.27-0.12,0.35C142.18,30.78,141.98,30.48,141.98,30.48L141.98,30.48z M144.85,30.49 c0.06,0.25,0.18,0.36,0.09,0.65C144.35,30.81,144.73,30.71,144.85,30.49L144.85,30.49z M143.77,31.47c0.71-0.06,0.51,0.36-0.19,0.5 C143.54,31.71,143.7,31.67,143.77,31.47L143.77,31.47z M130.4,30c0.52-0.26,1.21-0.18,1.59,0.36c-0.12,0.06-0.23,0.04-0.36,0.1 c0.03,0.01,0.27,0.08,0.29,0.04c-0.03,0.06-0.31,0.15-0.4,0.18c0.13,0.06,0.2-0.05,0.34-0.04c-0.14,0.13-0.3,0.28-0.45,0.41 c0.28,0.7-0.43,2.83,1.2,3.63c-0.12,0.18-0.21,0.14-0.44,0.19c0.05,0,0.2,0.08,0.23,0.06c-0.11-0.06-0.07,0.09-0.1,0.11 c-0.17-0.18-0.19-0.21-0.25-0.4c0,0.01-0.28,0.1-0.25,0.11c-0.01,0.15,0.24,0.01,0.15,0.16c-0.5-0.1-0.74-0.03-0.88-0.32 c-0.75,0.04-0.85-0.37-0.34-0.56c-0.4-0.39-0.29-0.05-0.19-0.66c-0.11,0.04-0.26,0.21-0.3,0.33c-0.01-0.04,0.01-0.44,0-0.45 c-0.16,0.03-0.2,0.2-0.35,0.18c-0.07-0.15,0.02-0.24-0.11-0.36c0.01-0.02-0.14,0.32-0.1,0.29c-0.6,0.13-0.77-1.38-0.08-1 c0.17-0.42,0.23-0.61,0.4-1.03c-0.37-0.13-0.4-0.36,0.18-0.65C129.9,30.43,130.2,30.35,130.4,30L130.4,30z M129.58,33.67 c0.39,0.05,0.58,0.1,0.47,0.71C129.98,33.99,129.75,33.94,129.58,33.67L129.58,33.67z M112.08,17.4c1.1-0.08-0.11,2.17-0.68,0.38 C111.69,17.65,111.82,17.47,112.08,17.4L112.08,17.4z M112.92,18.32c0.28,0.42-0.04,1.26,0.75,1.08c0.17,0.12,0.28,0.36,0.4,0.48 c-0.65,0.22-0.83,0.87-1.25,1.19c-0.01-0.12-0.04-0.05-0.1-0.02c0.08-0.2,0.1-0.49,0.2-0.73c-0.12,0.03-0.07,0.04-0.13,0.14 c-0.06-0.01,0.02-0.15-0.1-0.2c-0.99,0.92-0.62-0.05-0.55-0.71c0.06-0.58-0.56-0.34-0.06-0.91 C112.18,18.5,112.75,18.46,112.92,18.32L112.92,18.32z M114.92,17.13c-0.05,0.02,0.02-0.3,0.03-0.31c0.15,0.23,0.15,0.32,0.19,0.51 C115.08,17.31,114.91,17.13,114.92,17.13L114.92,17.13z M116.37,16.73c-0.15-0.14-0.28-0.15-0.35-0.09 c-0.15,0.1-0.15,0.17-0.32,0.17c0.05-0.19,0.02-0.06,0.11-0.19c0.32-0.17,0.54-0.2,0.87-0.08C116.63,16.78,116.5,16.68,116.37,16.73 L116.37,16.73z M111.67,35.52c0,0.03,0.07,0.18,0.01,0.32C111.47,35.73,111.65,35.69,111.67,35.52L111.67,35.52z M112.83,35.5 c-0.02-0.11-0.29-0.11-0.07-0.21C113.01,35.39,112.83,35.48,112.83,35.5L112.83,35.5z M112.62,34.78c0.15-0.02,0.12-0.01,0.29-0.11 c-0.04,0.37-0.02,0.31-0.36,0.44C112.35,34.78,112.59,34.94,112.62,34.78L112.62,34.78z M113.2,35.32 c-0.07-0.13-0.43-0.08,0.02-0.39C113.39,35.11,113.16,35.23,113.2,35.32L113.2,35.32z M113.51,35.01c0.01,0.03-0.13-0.2-0.11-0.36 C113.6,34.77,113.5,34.92,113.51,35.01L113.51,35.01z M114.59,34.07c-0.07,0.09,0.16,0.29-0.24,0.23c-0.07-0.22,0.07,0.03-0.08-0.14 C114.4,34.04,114.56,34.1,114.59,34.07L114.59,34.07z M105.92,16.63c0.37,0.54,0.7,1.25,0.92,1.93 C106.38,18.08,105.94,17.38,105.92,16.63L105.92,16.63z M110.66,27.57c0.06,0.02,0.25-0.25,0.14,0.19 C110.62,27.84,110.8,27.63,110.66,27.57L110.66,27.57z M91.92,96.45C91.89,96.45,91.88,96.46,91.92,96.45L91.92,96.45z M49.36,92.4 C49.28,92.47,49.16,92.6,49.36,92.4L49.36,92.4z M48.17,92.16C48.09,92.28,48.09,92.29,48.17,92.16L48.17,92.16z M48.6,92.09 C48.56,92.21,48.55,92.24,48.6,92.09L48.6,92.09z M48.8,92.28C48.82,92.25,48.67,92.41,48.8,92.28L48.8,92.28z M201.42,96.78 C201.38,96.9,201.4,96.83,201.42,96.78L201.42,96.78z M190.96,96.74c0.11,0.14,0.38,0.5,0.48,0.7 C191.14,97.27,191.12,97.02,190.96,96.74L190.96,96.74z M190.65,97.08C190.73,97.11,190.9,97.16,190.65,97.08L190.65,97.08z M184.97,93.37C185.22,93.43,185.28,93.45,184.97,93.37L184.97,93.37z M185.44,93.46c0.51,0.25,1.47,0.62,1.14,1.2 C186.48,94.03,185.94,93.69,185.44,93.46L185.44,93.46z M187.49,94.79C187.51,94.9,187.57,95.13,187.49,94.79L187.49,94.79z M187.57,95.06C188.54,95.72,188.08,96.15,187.57,95.06L187.57,95.06z M188.57,95.72c0.17,0.11,0.42,0.21,0.57,0.39 C188.83,96.1,188.79,95.89,188.57,95.72L188.57,95.72z M188.6,96.23C188.74,96.46,188.73,96.45,188.6,96.23L188.6,96.23z M188.92,96.44C188.83,96.67,188.93,96.41,188.92,96.44L188.92,96.44z M189.01,96.62c0.09,0.01,0.17-0.2,0.33,0.17 C189.25,96.74,189.12,96.63,189.01,96.62L189.01,96.62z M189.02,96.83C189.09,96.75,189.04,96.8,189.02,96.83L189.02,96.83z M189.39,96.87C189.43,96.85,189.5,96.81,189.39,96.87L189.39,96.87z M189.73,96.24c0.28,0.16,0.57,0.28,0.74,0.54 C190.16,96.64,189.96,96.42,189.73,96.24L189.73,96.24z M186.44,97.03C186.67,97.24,186.67,97.24,186.44,97.03L186.44,97.03z M185.27,97.25c0.1,0.09,0.22,0.01,0.25,0.2C185.25,97.49,185.36,97.33,185.27,97.25L185.27,97.25z M183.03,93.1 c0.13,0.07,0.31-0.1,0.23,0.12C183.08,93.26,183.11,93.14,183.03,93.1L183.03,93.1z M184.72,92.72 C184.8,92.85,184.83,92.88,184.72,92.72L184.72,92.72z M183.31,94.94C183.38,95.05,183.41,95.08,183.31,94.94L183.31,94.94z M183.73,95.09C183.88,95.21,183.94,95.26,183.73,95.09L183.73,95.09z M176.69,92.4c0.06,0.03,0.31,0.03,0.48,0.23 C176.9,92.64,176.92,92.5,176.69,92.4L176.69,92.4z M176.75,92.9c0.21,0.03,0.52,0.03,0.71,0.13C177.19,93.06,177,92.94,176.75,92.9 L176.75,92.9z M173.81,92.04c0.03,0.01,0.32,0.02,0.47,0.12C174.03,92.24,173.9,92.07,173.81,92.04L173.81,92.04z M173.98,92.53 C174.13,92.62,174.24,92.69,173.98,92.53L173.98,92.53z M175.32,95.02C175.31,94.97,175.38,95.36,175.32,95.02L175.32,95.02z M176.02,95.24c0.1,0.05,0.34-0.26,0.23,0.33C176.08,95.46,176.1,95.28,176.02,95.24L176.02,95.24z M175.97,95.48 C175.93,95.45,176.44,95.75,175.97,95.48L175.97,95.48z M175.94,95.49c0.04,0.18,0.25,0.12,0.12,0.38c-0.04,0.03-0.08,0.03-0.12,0 C175.96,95.64,176,95.78,175.94,95.49L175.94,95.49z M174.25,96.37c0.07-0.06,0.13-0.27,0.23-0.38 C174.59,96.47,174.3,96.33,174.25,96.37L174.25,96.37z M173.38,96.44C173.48,96.46,173.53,96.47,173.38,96.44L173.38,96.44z M172.78,96.03C172.77,96.03,172.89,96.03,172.78,96.03L172.78,96.03z M171.26,96.51c0.14-0.07,0.19-0.33,0.54-0.17 C171.61,96.49,171.44,96.41,171.26,96.51L171.26,96.51z M170.46,96.6c0.11,0.04,0.24-0.03,0.35,0.04 C170.55,96.87,170.56,96.63,170.46,96.6L170.46,96.6z M170.19,96.75C170.36,96.62,170.32,96.66,170.19,96.75L170.19,96.75z M169.81,96.78c0.12-0.09,0.02-0.17,0.23-0.19C170.06,96.85,169.91,96.72,169.81,96.78L169.81,96.78z M168.97,94.91 C169.05,94.95,169.2,95.04,168.97,94.91L168.97,94.91z M169.26,94.63c0.05,0.09,0.31-0.01,0.15,0.38c-0.02-0.05-0.05-0.05-0.09,0 C169.15,94.88,169.34,94.79,169.26,94.63L169.26,94.63z M169.51,94.79c0.07-0.06,0.05-0.27,0.1-0.36c0.04,0.41,0.06,0.35-0.1,0.74 C169.37,95.01,169.57,94.92,169.51,94.79L169.51,94.79z M169.63,94.23C169.7,94.29,169.8,94.39,169.63,94.23L169.63,94.23z M169.65,92.62C169.62,92.73,169.54,92.97,169.65,92.62L169.65,92.62z M169.74,92.75C170.02,92.81,169.81,92.77,169.74,92.75 L169.74,92.75z M170.42,92.92c0.16,0.04,0.35,0.02,0.48,0.08C170.56,93.19,170.53,92.94,170.42,92.92L170.42,92.92z M170.99,93 c0.08,0,0.35-0.01,0.5-0.02C171.29,93.1,171.14,93,170.99,93L170.99,93z M171.26,93.1C171.29,93.21,171.38,93.5,171.26,93.1 L171.26,93.1z M171.34,93.71C172.2,93.85,171.96,94.29,171.34,93.71L171.34,93.71z M172.08,92.17c0.07,0.08,0.22,0.14,0.25,0.29 C172.11,92.43,172.2,92.32,172.08,92.17L172.08,92.17z M172.11,92.79c0.14,0.04,0.27-0.07,0.43,0.09 C172.26,93.03,172.2,92.82,172.11,92.79L172.11,92.79z M172.48,94.12c0.12-0.13,0.16-0.19-0.03-0.02L172.48,94.12L172.48,94.12z M165.8,93.83c0,0.18,0.13,0.28-0.04,0.42C165.69,94.06,165.8,93.9,165.8,93.83L165.8,93.83z M166.27,96.72 c0.23,0.04,0.42,0.09,0.64,0.11c-0.02-0.06-0.17-0.2-0.22-0.26c0.41,0.05,0.52,0.13,0.77,0.3 C167.05,96.98,166.07,97.38,166.27,96.72L166.27,96.72z M165.71,96.75C166.09,97.01,165.97,96.93,165.71,96.75L165.71,96.75z M165.11,96.54c0.19,0.17,0.56,0.03,0.12,0.41c-0.15-0.1-0.18-0.22-0.39-0.3C164.83,96.36,165.05,96.65,165.11,96.54L165.11,96.54z M163.84,95.88c0.29,0,0.5-0.09,0.71,0.07C164.2,96.12,164.04,95.93,163.84,95.88L163.84,95.88z M165.25,95.81 C165.52,95.92,165.38,95.86,165.25,95.81L165.25,95.81z M159.49,93.06c0.17-0.17,0.26-0.18,0.43-0.22c0.25,0.32,0.35,0.61,0.41,0.88 C160.09,93.49,159.7,93.3,159.49,93.06L159.49,93.06z M160.92,93.43C161.18,93.83,161.17,93.81,160.92,93.43L160.92,93.43z M155.85,92.52c0.03,0.05,0.28,0.23,0.31,0.44C155.82,92.93,155.95,92.69,155.85,92.52L155.85,92.52z M131.26,94.55 C131.29,94.49,131.26,94.55,131.26,94.55L131.26,94.55z M126.27,97.29C126.32,97.24,126.16,97.4,126.27,97.29L126.27,97.29z M122.57,94.85C122.35,94.92,122.58,94.84,122.57,94.85L122.57,94.85z M122.27,95.22c0.01,0.05,0.09,0.28,0.14,0.38 C122.2,95.49,122.31,95.38,122.27,95.22L122.27,95.22z M200.64,101.94C201.47,102.46,199.88,102.62,200.64,101.94L200.64,101.94z M201.18,101.37c0.12-0.05,0.43-0.12,0.62-0.17c-0.01,0.04-0.21,0.24-0.25,0.29c-0.01-0.01,0.17-0.1,0.17-0.11 c-0.03,0.02,0.02,0.15,0.02,0.17C201.23,101.65,201.02,101.74,201.18,101.37L201.18,101.37z M194.21,100.35 c0.11,0.12,0.06,0.39,0.25,0.13c0.02,0.31,0.14,0.17-0.13,0.38C194.28,100.73,194.3,100.46,194.21,100.35L194.21,100.35z M194.56,101.02c0.1,0.12,0.25,0.19,0.31,0.36c-0.04-0.01-0.14,0-0.17,0.01C194.68,101.24,194.64,101.12,194.56,101.02 L194.56,101.02z M195.11,100.79C195.15,100.98,195.19,101.16,195.11,100.79L195.11,100.79z M195.11,101.15 C195.08,101.29,195.07,101.34,195.11,101.15L195.11,101.15z M195.27,102.01C195.21,102.16,195.19,102.2,195.27,102.01L195.27,102.01 z M195.72,103.09C195.79,103.19,195.81,103.25,195.72,103.09L195.72,103.09z M191.33,97.77c0.17,0.1,0.4,0.12,0.55,0.33 C191.58,98.12,191.55,97.92,191.33,97.77L191.33,97.77z M173.72,98.34C174.47,98.49,174.41,98.69,173.72,98.34L173.72,98.34z M177.22,98.5C177.28,98.3,177.32,98.16,177.22,98.5L177.22,98.5z M177.21,99.82c0.08,0.09,0.19-0.08,0.27,0.25 C177.1,100.21,177.33,99.96,177.21,99.82L177.21,99.82z M179,101.35c0,0.01,0.09,0.12-0.16,0.2 C178.76,101.33,178.94,101.45,179,101.35L179,101.35z M169.56,98.14c0.07-0.04,0.18-0.17,0.29-0.23 C169.83,98.14,169.67,98.07,169.56,98.14L169.56,98.14z M124.38,98.43c0,0,0.14,0.18,0.15,0.32 C124.36,98.65,124.45,98.58,124.38,98.43L124.38,98.43z M193.4,104.32c-0.27-0.21-0.49-0.4-0.61-0.71c0.64,0.2,1.12,0.86,1.65,1.24 c-0.03,0-0.1,0.05-0.08,0.1C194.02,104.78,193.69,104.6,193.4,104.32L193.4,104.32z M194.53,103.95 C194.68,104.15,194.72,104.22,194.53,103.95L194.53,103.95z M194.93,104.33C194.98,104.35,195.21,104.43,194.93,104.33 L194.93,104.33z M186.66,106.38c0,0.07,0.11,0.33-0.05,0.55C186.59,106.72,186.66,106.57,186.66,106.38L186.66,106.38z M186.86,107.98C186.87,108.07,186.9,108.27,186.86,107.98l-0.02,0.06L186.86,107.98L186.86,107.98z M131.17,104.06 c0.08,0.04,0.25-0.12,0.32,0.24C131.25,104.32,131.32,104.13,131.17,104.06L131.17,104.06z M177.29,113.59 c0.39-0.09,0.57-0.2,0.88,0.07C177.81,113.81,177.57,113.7,177.29,113.59L177.29,113.59z M58.12,117.9 C58.83,119.05,57.28,119.51,58.12,117.9L58.12,117.9z M58.61,119.95C58.57,120.36,58.56,120.48,58.61,119.95L58.61,119.95z M57.89,120.14C58.08,120.21,58.08,120.21,57.89,120.14L57.89,120.14z M57.92,120.46C57.89,120.49,58.17,120.22,57.92,120.46 L57.92,120.46z M57.96,120.52c-0.03-0.01,0.15-0.02,0.23,0.05C58.16,120.72,58.1,120.55,57.96,120.52L57.96,120.52z M57.97,120.6 C58.01,120.63,58.26,120.81,57.97,120.6L57.97,120.6z M58.13,121.06C58.22,121.26,58.16,121.1,58.13,121.06L58.13,121.06z M57.89,122.69C57.7,122.5,57.73,122.53,57.89,122.69L57.89,122.69z M57.5,122.62C57.34,122.72,57.27,122.77,57.5,122.62 L57.5,122.62z M57.41,122.96C57.59,123.1,57.71,123.2,57.41,122.96L57.41,122.96z M57.24,123.02c-0.07-0.08,0.16,0.1,0.18,0.38 C57.37,123.29,57.32,123.11,57.24,123.02L57.24,123.02z M57.54,123.23C57.8,123.45,57.75,123.4,57.54,123.23L57.54,123.23z M57.23,123.4C57.42,123.29,57.18,123.43,57.23,123.4L57.23,123.4z M57.2,124.35C57.18,124.33,57.53,124.53,57.2,124.35L57.2,124.35 z M195.03,121.83c-0.01,0.2,0.22,0.29-0.21,0.44C194.83,122.11,195.03,121.84,195.03,121.83L195.03,121.83z M183.85,116.9 C183.94,116.88,184.17,116.83,183.85,116.9l0.09,0.02L183.85,116.9L183.85,116.9z M181.95,117.08c1.01,0.68,2.29-0.51,2.03,1.25 c-0.04-0.06,0.01-0.19-0.04-0.28c-0.33,1.29-1.25,1.61-1.75,0.12c-0.01-0.01,0.15,0.22,0.15,0.22 C182.16,118.11,181.99,117.55,181.95,117.08L181.95,117.08z M66.86,125.78c0.55,0.17,0.53,0.44-0.22,0.5 c0.03,0.08,0.22,0.11,0.16,0.24c0.03-0.02-0.25-0.07-0.28-0.07c0.02,0.05,0.03,0.1,0.04,0.15c0.03,0.01,0.06,0,0.09-0.02 c-0.25,0.07-0.15,0.09-0.22,0.13C66.24,126.3,66.45,125.93,66.86,125.78L66.86,125.78z M60.8,129.24c-0.08,0-0.26,0.07-0.37,0.07 c0-0.01-0.01-0.11-0.02-0.13C60.56,129.13,60.69,129.23,60.8,129.24L60.8,129.24z M60.36,129.42c0.41-0.08,0.64-0.23,0.96-0.05 c-0.08,0-0.3-0.03-0.37-0.02c0.04,0.02,0.39,0.12,0.4,0.13c0,0.03,0.01,0.05,0.02,0.07c0,0.01-0.19-0.01-0.2,0.02 c0.18,0.17,0.21,0.12,0.34,0.38c-0.25-0.22-0.45-0.27-0.73-0.44c0,0.02,0.12,0.27,0.12,0.29c-0.28-0.25-0.28,0.02-0.2-0.34 C60.47,129.59,60.45,129.49,60.36,129.42L60.36,129.42z M63.49,129.05c0.11,0.01,0.29-0.04,0.41-0.04c0,0.02-0.01,0.04-0.01,0.06 C63.64,129.13,63.3,129.02,63.49,129.05L63.49,129.05z M65.48,126.23c0.03,0-0.04,0.23-0.14-0.12 C65.29,126.3,65.37,126.24,65.48,126.23L65.48,126.23z M57.28,124.87c-0.02,0,0.18-0.13,0.28-0.13c-0.01,0.09-0.03,0.18-0.04,0.3 C57.43,124.99,57.28,124.87,57.28,124.87L57.28,124.87z M57.81,125.2c0-0.05-0.15-0.15-0.1-0.28 C57.99,125.25,57.82,125.39,57.81,125.2L57.81,125.2z M57.83,125.46c0.01,0.01-0.19,0.29-0.23-0.28 C57.77,125.22,57.73,125.41,57.83,125.46L57.83,125.46z M57.55,125.88C57.79,125.64,57.71,125.73,57.55,125.88L57.55,125.88z M57.56,126.52c0-0.09-0.07-0.25,0.01-0.41C57.63,126.26,57.56,126.39,57.56,126.52L57.56,126.52z M58.02,126.1 C57.98,126.55,58.04,125.9,58.02,126.1L58.02,126.1z M58.22,125.97C58.07,126.13,58.24,125.95,58.22,125.97L58.22,125.97z M58.32,126.6c0.15-0.06,0.25-0.1,0.34,0.1c0.03-0.13,0.07-0.12,0.05-0.28c-0.15,1.14,1.17,0.38,0.22,1.39 c-0.03-0.07-0.31-0.23-0.37-0.3c0.16-0.02,0.16,0.08,0.24-0.06c-0.06-0.03-0.09-0.08-0.1-0.15 C58.32,127.36,58.29,127.07,58.32,126.6L58.32,126.6z M58.22,126.8C58.09,127.14,58.16,126.98,58.22,126.8L58.22,126.8z M57.68,127.1c0.28,0.15,0.64,0.42,0.89,0.59C58.15,127.61,57.98,127.45,57.68,127.1L57.68,127.1z M57.7,126.15 c-0.01,0.09,0.05,0.21-0.04,0.36C57.63,126.37,57.7,126.24,57.7,126.15L57.7,126.15z M58.28,127.69 C59.54,127.74,58.61,129.08,58.28,127.69L58.28,127.69z M59.26,128.14c0.24,0.14,0.36,0.21,0.45,0.48 C59.17,128.59,59.24,128.45,59.26,128.14L59.26,128.14z M60.01,127.89c0.03,0.11,0.08,0.33,0.09,0.48c-0.01,0.01-0.13-0.1-0.14-0.1 c-0.01,0.2,0.09,0.17,0.18,0.29C59.69,128.3,59.96,128.21,60.01,127.89L60.01,127.89z M59.76,129.35 C59.92,129.28,59.92,129.28,59.76,129.35L59.76,129.35z M60.11,129.52C59.98,129.31,60,129.35,60.11,129.52L60.11,129.52z M194.06,125.13c-0.05,0.18,0.04,0.2-0.04,0.32c-0.04,0.01-0.08-0.01-0.1-0.04C193.92,125.32,194.06,125.11,194.06,125.13 L194.06,125.13z M134.49,9.46C135.55,10.32,133.16,10.12,134.49,9.46L134.49,9.46z M135.94,8.65c0.97-1.03,0.66,0.67,1.11,1.2 c-0.54-0.15-1.02,0.19-1.19,0.8C135.17,10.1,135.34,9.19,135.94,8.65L135.94,8.65z M135.94,7.1c-0.13,0.41-0.39,0.24-0.63-0.11 c0.03,0,0.05,0,0.07-0.03C135.56,6.89,135.69,7,135.94,7.1L135.94,7.1z M129.99,11.97c0.29,0.22,0.41,0.48,0.25,0.8 C129.62,12.81,129.54,12.36,129.99,11.97L129.99,11.97z M132.11,12.06c0.12,0.24,0.17,0.58,0.09,0.96 c-0.15,0.03-0.51-0.01-0.64-0.07C131.55,12.36,131.79,12.08,132.11,12.06L132.11,12.06z M132.87,11.62 c0.21,0.14,0.45,0.43,0.55,0.58c-0.04,0-0.06,0.02-0.07,0.06c-0.5-0.04-0.72,0.16-0.65,0.68c-0.45-0.17-0.35-0.7-0.39-1.31 C132.51,11.72,132.79,11.61,132.87,11.62L132.87,11.62z M133.05,6.73C134.04,7.31,132.05,7.32,133.05,6.73L133.05,6.73z M132.62,7.73c0.7,0.67-0.03,0.81-0.55,0.45C132.14,7.82,132.35,7.82,132.62,7.73L132.62,7.73z M131.98,8.34 c0.3,0.06,0.43,0.22,0.67,0.23c0.01-0.02,0.04,0.16,0.04,0.15c-0.48,0.28-1.05,0.67-1.34,0.02c0.19,0.09,0.41,0.1,0.56,0.15 C131.89,8.73,131.98,8.39,131.98,8.34L131.98,8.34z M133.2,10.24c-0.12,0.32-0.01,0.6-0.53,0.34C132.83,10.3,133,10.36,133.2,10.24 L133.2,10.24z M131.73,10.71c0.92,0.37-0.12,0.58-0.4,0.17C131.51,10.77,131.59,10.77,131.73,10.71L131.73,10.71z M130.89,10.21 c0.35,0.12,0.32,0.22,0.59,0.25c0,0.06,0.03,0.09,0.09,0.1c-0.4,0.27-0.64,0.21-0.99-0.02c-0.02-0.09,0.01-0.18-0.02-0.29 C130.65,10.27,130.82,10.25,130.89,10.21L130.89,10.21z M131.59,9.82c0.72,0.17,1.42,1.1,0.32,0.69 C131.17,10.24,130.34,9.1,131.59,9.82L131.59,9.82z M132.14,9.56c1.24,0.69,0.37,1.08-0.36-0.12 C131.92,9.52,131.97,9.51,132.14,9.56L132.14,9.56z M126.3,10.21c0.46,0,0.95,0.21,1.36,0.63c-1,0.28-1.87-0.71-1.6,0.94 c-0.43-0.42-0.16-0.12-0.53-0.12c-0.15-0.05-0.18-0.18-0.48-0.19C124.86,10.76,125.63,10.66,126.3,10.21L126.3,10.21z M118.91,12.46 c-0.23,0.23-0.81,0.52-1.15,0.58c0.05-0.07-0.03-0.11-0.06-0.13C118.11,12.69,118.55,12.5,118.91,12.46L118.91,12.46z M71.62,91.96 c-0.01-0.09-0.28-0.05-0.08-0.23C71.84,91.92,71.62,91.97,71.62,91.96L71.62,91.96z M48.22,91.92c0.09,0.38,0.48,0.53-0.03,0.66 C48.23,92.36,48.22,92.05,48.22,91.92L48.22,91.92z M169.36,86.34c0.16-0.31,0.13-0.54,0.53-0.52c-0.01,0.29-0.14,0.83-0.25,1.05 C169.37,86.7,169.42,86.51,169.36,86.34L169.36,86.34z M171.12,86.35c-0.01-0.14-0.14-0.23,0.01-0.25 C171.13,86.14,171.13,86.56,171.12,86.35L171.12,86.35z M169.82,86.4c0.1-0.27,0.25-0.55,0.38-0.79 C170.15,86.23,170,86.43,169.82,86.4L169.82,86.4z M170.17,86.35c-0.02-0.01,0.27-0.11,0.34-0.09 C170.28,86.73,170.22,86.37,170.17,86.35L170.17,86.35z M167.99,89.1C167.62,89.02,168.12,89.13,167.99,89.1L167.99,89.1z M168,95.14c-0.83-0.2-0.65-3.07-0.01-3.59c0.77-0.62,1.92,0.36,2.84-0.54c-0.15,1.54-1.82,0.15-2.51,0.7 c-1.45,1.14,1.1,0.63,1.51,0.57c0.07,0.05,0.08,0.12,0.05,0.2c-0.33,0.14-0.74,0.41-1.15,0.5c0.49,0.53,0.54,0.96,0.83,1.4 c-1.14,0.98-0.6-0.82-1.02-0.86C167.91,93.46,168.22,94.77,168,95.14L168,95.14z M172.4,91.94c0.07,0.22,0.06,0.37,0.25,0.52 c-0.47-0.46-0.73-1.19-0.23-1.74c-0.06,0.27-0.05,0.46-0.17,0.77c0.58-0.49,0.59-0.18,0.67,0.35 C172.54,91.62,172.53,91.91,172.4,91.94L172.4,91.94z M162.28,92.73c-0.5-0.52-0.91-1.36-0.19-1.96c0.84,0.65,3.35-1.89,3.98-2.72 c0.09,0.01-0.02,0.19,0.01,0.23c0.49-0.17,0.68,0.5,1.42,0.75c-0.21,0.12-0.36,0.13-0.57,0.18c-0.09,0.15,0.22,0.21,0.18,0.28 c-0.33,0.05-0.42,0.1-0.65,0.19c0.01-0.03,0.21,0.14,0.21,0.19c-0.05,0.02-0.31,0.03-0.33,0.09c0.25,0.52,0.48,1.07,0.98,1.49 c-0.16-0.04-0.37-0.04-0.53-0.09c-0.22,0.49-0.66,1.71-0.76,1.87c-0.28,0.43-0.36,0.91-1.1,1.08c-0.43-1.09-1.38,0.07-1.7-0.79 C162.61,93.89,162.19,93.46,162.28,92.73L162.28,92.73z M167.07,86.41c0.33-0.42,0.49-0.46,0.56-0.88c0.11,0.74-0.65,1.35-1.29,1.68 C166.53,86.89,166.77,86.65,167.07,86.41L167.07,86.41z M156.52,92.16c-0.54-0.5-0.83-1.3-1.31-1.81c-0.46-0.49-1.16-0.81-1.35-1.53 c1.17,0.32,4.58,2.42,4.28,3.01c0.36-0.08,1.08,0.88,1.14,1.47c1.01,0.06,0.59,1.16,0.56,1.94c-0.23-0.01-0.44-0.03-0.65-0.14 c0.03,0.05,0.05,0.1,0.07,0.16C158.08,94.34,157.46,93.33,156.52,92.16L156.52,92.16z M145.29,86.83c-0.01-0.22,0.26-0.23-0.07-0.36 c0.47,0.16,1.32,1.07,1.02,1.72C145.64,89.53,144.92,87.57,145.29,86.83L145.29,86.83z M60.35,80.7c0.11,0.14,0.23,0.21,0.41,0.23 c-0.06,0.06-0.12,0.07-0.2,0.04c1.54,0.57-0.67,0.32-1.1,0.91c-0.46-0.53-1.1-0.19-1.63-0.46c0.24,0,0.77-0.11,1.12-0.08 c-0.28-0.33-0.23-0.51-0.58-0.71C58.98,80.61,59.69,80.46,60.35,80.7L60.35,80.7z M54.7,79.46c-0.45-0.23-0.79-0.34-1.26-0.38 c0.05-0.12,0.17-0.01,0.24-0.12c-0.74-0.22-1.25,0.43-1.86,0.4c1.53-1.97,4.66,0.34,6.11,0.97c-0.53,0.29-1.31,0.2-1.96,0.26 c0.06-0.07,0.16-0.27,0.28-0.39C55.67,79.92,55.39,79.54,54.7,79.46L54.7,79.46z M167.92,85.35 C167.83,85.15,167.88,85.26,167.92,85.35L167.92,85.35z M167.95,83.26c-0.04-0.19-0.12-0.36-0.14-0.56 c0.06,0.01,0.26,0.08,0.31,0.09c-0.05-1.03,0.1-1.64,1.03-1.44c0.16,0.75-0.35,1.22-0.33,1.76c0.03,1.02,0.28,0.72,0.89,1.06 c0.19-0.1,0.09-0.2,0.41,0.01c0.01,0.06,0.07,0.46,0.07,0.69c-0.11-0.17-0.03-0.08-0.03-0.2c-0.23-0.19-0.57-0.37-0.84-0.59 c0.04,0.09,0.09,0.3,0.12,0.4c-0.54-0.55-1.29-0.02-1.07-0.89c-0.04,0.05-0.06,0.08-0.14,0.19 C168.08,83.65,168.06,83.35,167.95,83.26L167.95,83.26z M162.21,80.49c0.85-0.2,0.54,0.72-0.04,0.95 C161.4,81.73,161.32,80.7,162.21,80.49L162.21,80.49z M32.05,71.67C31.88,71.55,31.99,71.63,32.05,71.67L32.05,71.67z M179.19,67.38 c0.05-0.34,0.18-0.63,0.37-0.89c0.09,0.07,0.07,0.2,0.15,0.29c-0.02,0.08,0.39-0.38,0.29-0.34c-0.06,0.06-0.13,0.1-0.21,0.1 c0.47-0.83,0.47,1.39,0.45,1.72c-0.04,0.51-0.43,2.37-0.98,2.75c0.03-0.18,0.07-0.35,0.11-0.52c-0.25,0.28-0.45,0.36-0.71,0.68 c-0.03-0.09-0.03-0.18,0-0.28c-0.4,0.34-0.47,0.18-0.98,0.33c-0.04-0.06-0.1-0.13-0.16-0.32c0.02,0.28-0.08,0.23,0.02,0.57 c-0.42,0.42-1.07,0.65-0.82-0.32c-1.02-0.06-1.67,0.55-2.57,0.44c0.7-0.82,1.25-0.72,2.25-1.13c0.66-0.27,0.66-0.71,1.38-1.27 c-0.12,0.25-0.11,0.22-0.15,0.51C178.5,69.45,179.58,68.19,179.19,67.38L179.19,67.38z M173.6,72c1.08-0.98,1.29,0.84,0.44,1.6 c-0.04-0.12,0.04-0.33,0.02-0.41c-0.07,0.08-0.14,0.08-0.11,0.34c-0.16-0.45-0.02-0.82-0.18-1.35c-0.06,0.17,0.05,0.23,0,0.35 c-0.13-0.02-0.17-0.09-0.29,0.04c-0.01-0.09-0.02-0.18-0.04-0.28c0.07-0.01,0.11,0.02,0.12,0.1C173.36,72.15,173.49,72.13,173.6,72 L173.6,72z M111.32,67.76c0,0-0.17-0.03-0.23-0.21C111.28,67.52,111.2,67.65,111.32,67.76L111.32,67.76z M102.27,67.43 C102.32,67.41,102.51,67.26,102.27,67.43L102.27,67.43z M104.77,67.39c-0.11-0.21-0.1-0.53-0.15-0.74 C106.47,65.24,104.42,69.81,104.77,67.39L104.77,67.39z M99.93,56c0.03,0.09,0.25,0.33,0.1,0.79c1.23-0.54,0.84,0.9,0.33,1.21 c0.05,0.04,0.07,0.09,0.06,0.15c0.11,0.04,0.31,0.02,0.41,0.05c-0.74,0.92-3.08,0.7-3.98,1.14c0.54-0.78,1.23-0.92,1.71-1.55 c-0.58,0.45-1.08,0.04-1.52-0.12c0.56-0.22,0.77-0.45,0.63-0.99c-0.13-0.03-0.19,0.11-0.32,0.09c0.73-0.32,1.15-0.59,1.09-1.31 c-0.54,0.02-0.53-0.18-0.2-0.7c-0.49,0.05-0.89,0.16-1.05,0.3c-0.01-0.38,0.07-0.87,0.15-1.32c-0.01,0-0.14-0.08-0.15-0.09 c0.12,0.07-0.16,0.2-0.18,0.21c0.02-0.09,0.09-0.27,0.08-0.36c-0.09,0.28-0.27,0.63-0.36,0.89c0.06-0.49,0.13-0.81,0.27-1.34 c-0.41,0.13-0.11-0.03-0.46-0.04c0.14-0.21,0.25-0.59,0.35-0.75c-0.39-0.34,0.27-1.5,1.34-1.29c-0.19,0.26-0.28,0.52-0.57,0.74 c-0.09,0.17,0.17,0.06,0.15,0.1c-0.08,0.07-0.2,0.12-0.25,0.19c0.15,0,0.04-0.01,0.1,0.12c1.27-0.71,1.5,0.42,0.65,1.1 c-0.03,0.04,0.17,0.18,0.18,0.23c-0.23,0.07-0.23,0.08-0.37,0.23C99.01,53.62,100.07,55.81,99.93,56L99.93,56z M66.01,62.51 c-0.09,0.86-1.32,0.47-0.37-0.63c0.02,0.05,0.04,0.05,0.05,0c-0.02,0.18,0.02,0.5-0.05,0.73C65.87,62.56,65.92,62.57,66.01,62.51 L66.01,62.51z M67.85,59.43c-0.07,0.03,0.37-0.03,0.7-0.01c-0.07,0.1-0.24,0.06-0.32,0.2c0.26,0.24,0.23,0.1,0.51,0.1 c0.01,0.05-0.12,0.25-0.1,0.27c0.5-0.18,0.6-0.03,1.07-0.01c-0.21,0.28-0.14,0.49-0.3,0.71c0.15-0.07,0.32-0.12,0.48-0.18 c-0.14,0.15-0.19,0.26-0.43,0.39c0.08,0.14,0.15,0.35,0.14,0.48c0.11-0.14,0.25-0.31,0.42-0.46c-0.03,0.17-0.06,0.48-0.09,0.62 c0.04-0.08,0.09-0.16,0.14-0.24c0.04,0.5-0.1,0.63-0.38,0.94c-0.1-0.11-0.04-0.36-0.07-0.47c-0.11,0.13-0.12,0.27-0.29,0.25 c0.06-0.34,0.02-0.54,0.03-0.88c-0.19,0.38-0.56,0.77-1.04,0.84c0.18-0.15,0.4-0.37,0.61-0.55c-0.25,0.05-0.49,0.02-0.74,0.08 c0.13-0.13,0.17-0.1,0.2-0.3c-0.61,0.32-2.76,0.51-1.53-0.49c-0.04-0.01-0.34-0.04-0.39-0.07c0.25-0.13,0.36-0.35,0.62-0.47 c0.01-0.39,0.12-0.58,0.41-0.97c-0.07-0.58,0.31-1.14,1-1.31C68.28,58.44,68.11,58.67,67.85,59.43L67.85,59.43z M27.95,59.38 c-0.11-0.05-0.25-0.21-0.43-0.44c0.08-0.02,0.25,0.04,0.25,0.04c-0.2-0.11-0.2-0.23-0.49-0.25c0.77-0.34,1.73,0.51,2.22,1.14 c0.59,0.78,0.48,1.16-0.13,0.47c-0.22-0.03-0.2,0.11-0.12-0.15c-0.17-0.01-0.3-0.03-0.48-0.06c0.04,0.05-0.28-0.28-0.45-0.43 c0.09-0.05,0.21,0,0.3-0.08C28.35,59.51,28.19,59.44,27.95,59.38L27.95,59.38z M184.93,62.93c-0.02,0.15-0.21-0.05,0.29-0.4 C185.19,62.71,184.99,62.76,184.93,62.93L184.93,62.93z M180.52,59.37c0.06-0.98-0.34-1.63-0.21-2.59c0.09-0.74,0.72-0.56,0.27-1.37 c0.01,0,0.19-0.05,0.19-0.09c0.59,1.71,0.25,3.42,1.18,5.13c-0.61-0.92-1.11-0.34-1.19,0.53c-0.06,0.74,0.53,1,0.48,1.68 c-0.26-0.66-0.51-0.59-0.74,0.09C180.18,62.06,180.28,60.18,180.52,59.37L180.52,59.37z M179.26,65.77 c-0.01-0.28,0.14-0.62,0.28-0.89c0.88,0.18,0.67-1.15,0.84-1.72c0.43,0.63,1.19,1.52,1.91,0.96c0.06,0.58,0.09,0.37,0.31,0.66 c-0.55,0.4-1.25,0.32-1.46,1.13c-0.49-0.47-1.2-0.54-1.65-0.3c0.14,0.11,0.3,0.28,0.47,0.38c-0.1,0.08-0.49,0.25-0.62,0.3 C179.36,66.1,179.28,65.93,179.26,65.77L179.26,65.77z M99.3,49.45c-0.08-0.13-0.2-0.31-0.05-0.76 C99.4,48.97,99.33,49.15,99.3,49.45L99.3,49.45z M94.43,57.51c-0.13-0.07-0.21,0.04-0.24-0.1c0.33-0.16,0.49-0.3,0.91-0.43 c-0.05,0.01-0.15-0.07-0.1-0.15c-0.18,0.11-0.3,0.15-0.5,0.21c0.19-0.18,0.29-0.39,0.47-0.57c-0.61-0.17-0.59-0.08-0.35-0.58 c-0.04-0.03-0.32-0.08-0.32-0.17c0.33-0.21,0.71-0.25,1.09-0.63c-0.05-0.04-0.25,0-0.32-0.06c0.26-0.28,0.31-0.39,0.65-0.55 c0.02,0.03,0,0.21,0.03,0.23c-0.02,0-0.02,0.01-0.01,0.04c0.02-0.09,0.06-0.27,0.11-0.37c0.3,0.08,0.08,0.1,0.11,0.28 c0.61-0.22,0.87,0.19,0.91,0.65c-0.02-0.05-0.04-0.09-0.08-0.12c-0.77,0.91,0.21,2.26-1.5,2.48c-0.25,0.23-0.4,0.29-0.77,0.38 c0.02-0.08,0.14-0.12,0.11-0.2c-0.05,0.01-0.26,0.12-0.31,0.09c0-0.03,0.22-0.21,0.22-0.22C94.12,57.83,94.27,57.76,94.43,57.51 L94.43,57.51z M26.36,56.37c-0.1-0.14-0.23-0.23-0.33-0.38C26.26,56.11,26.44,56.48,26.36,56.37L26.36,56.37z M26.36,56.02 c0.01-0.06-0.12-0.23-0.13-0.27c0.23,0.29,0.24,0.35,0.35,0.66C26.53,56.31,26.46,56.1,26.36,56.02L26.36,56.02z M16.24,49.46 c0.12-0.15,0.23-0.3,0.33-0.48c-0.01,0.08,0.07,0.07,0.1,0.07C16.39,49.58,16.21,49.47,16.24,49.46L16.24,49.46z M5.27,49.43 c-0.06-0.12-0.17-0.15-0.2-0.29C6.31,48.63,6.37,49.96,5.27,49.43L5.27,49.43z M54.74,46.66c0.19,0.28,0.3,0.51-0.01,0.97 C54.35,47.25,54.46,46.95,54.74,46.66L54.74,46.66z M195.15,35.89C196.64,36.21,195.08,37.05,195.15,35.89L195.15,35.89z M111.29,49.04c-0.07,0.09-0.03,0.3-0.02,0.37C110.88,48.99,111.22,49.13,111.29,49.04L111.29,49.04z M179.26,29.81 c-0.3-0.98,1.92-1.77,1.97,0.27C180.53,29.99,179.92,29.63,179.26,29.81L179.26,29.81z M111.32,35.75c-0.06-0.05-0.22,0.1-0.3-0.27 C111.18,35.58,111.16,35.63,111.32,35.75L111.32,35.75z M190.54,97.57c-0.01-0.1-0.25-0.11-0.22-0.32c0.27,0.05,0.46,0.09,0.73,0.24 C190.91,97.66,190.8,97.53,190.54,97.57L190.54,97.57z M184.96,95.54c-0.37-0.08-0.67-0.15-0.94-0.46c0.47-0.05,0.66-0.14,1.01-0.27 c0.25,0.45,0.84,0.12,0.84-0.45C186.92,94.58,185.7,95.47,184.96,95.54L184.96,95.54z M185.69,97.61 C185.61,97.6,185.27,97.56,185.69,97.61L185.69,97.61z M183.85,96.52c0.34,0.49,0.61,0.72,1.14,0.94c-0.06-0.04,0.29,0.28,0.49,0.36 c-0.09,0.08-0.21-0.02-0.3,0.02c0.06,0.01,0.12,0.03,0.16,0.08c-1.68-0.04-2.42-1.64-3.89-1.67c-0.17,0.3-0.11,0.19-0.44,0.46 c0.23,0.71-0.56,0.49-1.14,0.39c-0.12-0.02-0.92-0.47-1.05-0.53c0.03,0.02-0.63,0.15-0.79,0.17c0.39-0.43,0.13-0.41,0.68-0.49 c-0.25-0.62-0.38-0.97-1.14-1.46c-0.8-0.51-1.72-0.15-1.8-1.13c-0.29,0.91-0.65,0.5-1.07-0.01c0.38-0.06,0.85-0.28,1.09-0.5 c-0.7,0.37-1.21-0.15-1.68-0.36c0.74-1.28,1.88-0.24,1.99,0.76c0.02-0.04,0.03-0.09,0.03-0.14c0.56,1.06,1.01-0.27,1.59-0.43 c0.56-0.16,1.35,0.17,1.97,0.39c0.52,0.18,1.35,0.38,1.88,0.69c0.58,0.34,1.96,1.19,2.19,1.71c-0.16,0.03-0.33,0.06-0.46,0.1 C183.42,96.15,183.59,96.35,183.85,96.52L183.85,96.52z M173.61,93.15c0.03-0.08-0.25-0.17,0.14-0.21 C173.9,93.17,173.64,93.04,173.61,93.15L173.61,93.15z M173.6,93.93c-0.45-0.08-0.89-0.08-1.16,0.03c0.23-0.65,1.49-0.47,1.59,0.21 C173.9,94.1,173.73,93.96,173.6,93.93L173.6,93.93z M170.65,97.57c-0.25,0.15-0.41,0.31-0.71,0.21c0.32-0.72,1.25-1.15,2.07-1.02 C171.55,97.09,171,97.18,170.65,97.57L170.65,97.57z M168.37,97.59c-0.27,0.14-0.64,0.07-0.96-0.28 C167.88,97.13,168.01,97.32,168.37,97.59L168.37,97.59z M162.25,96.36c-1.1,0.02-1.88-0.29-2.64-0.69c0.72-0.5,5.18-0.03,5.21,1.29 C163.96,96.52,163.12,96.78,162.25,96.36L162.25,96.36z M190.7,98.56C190.16,98.53,191.31,98.6,190.7,98.56L190.7,98.56z M180.78,98.21c0.15,0.71,0.61,1.5,0.86,1.9c0.11,0.18,0.46,0.58,0.63,0.88c0.22,0.4,0.21,0.88,0.43,1.28 c0.62,1.1,1.61,1.25,2.06,2.71c0.1-0.08,0.05-0.13,0.16-0.23c0.28,0.09,0.07,0.28,0.32,0.12c0.01,1.09,1.29,1.98,1.42,3.01 c0.16,1.21,0.16,2.14-0.37,3.3c-0.38,0.85-0.94,1.66-1.3,2.66c-0.3,0.83-0.01,0.68-0.61,1.17c-0.29,0.25-1.3,0.55-1.59,0.72 c0.04,0.08,0.1-0.04,0.19-0.06c-0.01,0-0.09,0.29-0.1,0.28c-0.2-0.27-0.39-0.44-0.56-0.65c0.02,0.01-0.37,0.04-0.38,0.04 c0-0.01,0.12-0.11,0.15-0.25c0.02-0.01-0.35,0.09-0.37,0.09c0,0.03,0.15,0.06,0.15,0.12c-1.34,1.49-2.74-1.01-3.03-1.98 c-0.19,0.09-0.51,0.07-0.65,0.14c0.14-0.5-0.01-0.54-0.04-0.97c-0.18,0.67-0.23,0.51-0.7,0.68c0.33-0.44,0.74-1.22,0.51-1.84 c-0.11,0.79-1.01,1.02-1.02,1.7c-0.17-0.07-0.39-0.25-0.48-0.4c0.01-0.01,0.16,0.11,0.16,0.12c-0.16-1.6-1.83-2.11-3.42-2.06 c-0.79,0.02-2.02,0.56-2.72,0.87c-0.42,0.19-0.44,0.48-0.89,0.63c-0.47,0.15-0.91-0.07-1.41,0.06c-1.02,0.27-2.61,1.61-3.05-0.23 c0.05,0.21,0.35-0.81,0.35-0.86c-0.01-0.55-0.28-1.03-0.44-1.55c-0.26-0.84-0.51-1.71-1-2.42c0.12,0.11,0.19,0.21,0.3,0.3 c-0.04-0.13-0.1-0.44-0.17-0.64c0.19,0.36,0.18,0.27,0.35,0.51c0.08-0.99-0.39-1.71,0.02-2.86c-0.03,0.19-0.01,0.34,0.01,0.46 c0.89-1.1,1.9-1.01,3.05-1.5c1.45-0.62,1.14-1.18,1.91-2.13c0.1,0.2,0.28,0.46,0.35,0.66c-0.03-0.3,0.1-0.51,0.06-0.83 c0.15,0.1,0.32,0.13,0.49,0.22c-0.02-0.46,0.15-0.75,0.48-0.81c0.15-0.43,0.21-0.24,0.4-0.67c0.25-0.07,1.49-0.03,1.06,0.96 c0.18-0.51,0.54-0.58,1-0.25c-0.28-0.62,0.29-1.42,0.74-1.42c0.23-0.29,1.42-0.32,0.45-0.83c0,0,0.16-0.04,0.13-0.07 c0.03,0.01,0.06,0.17,0.05,0.18c0.5-0.15,1.34,0.6,2.16,0.28c0.02,0.19,0,0.06,0.05,0.34c0.13-0.13,0.13-0.21,0.24-0.36 c0.12,0.15,0.05,0.25,0.27,0.23c-0.18,0.33-0.29,0.54-0.4,0.66c-0.03,0.01-0.06-0.13-0.13-0.12c-0.11,0.55-0.21,1.11,0.28,1.58 c1.46,0.08,2.49,2.11,2.94-0.52C180.25,99.96,180.04,97.86,180.78,98.21L180.78,98.21z M173.58,98.69 C173.77,98.51,173.8,98.49,173.58,98.69L173.58,98.69z M127.53,103.43c-0.3,0.92-0.45,2.69-1.24,3.15c-1.37,0.8-2.01-1.05-1.82-2.11 c0.08-0.43,0.58-0.84,0.66-1.29c0.09-0.55-0.44-0.95-0.17-1.54c0.29-0.62,0.78-0.79,1.34-0.52c0.12-0.6,0-0.16,0.35-0.34 c0.05-0.14-0.01-0.28,0.1-0.47c0.04,0.06,0.04,0.13,0.01,0.2c0.11-0.15,0.14-0.17,0.31-0.21c-0.14-0.34-0.01-0.23-0.02-0.65 c0.09,0,0.14,0.05,0.15,0.15c0.17-0.41,0.28-0.3,0.32-0.8c0.75-0.13,0.93,1.27,0.86,2.01c-0.05-0.05-0.23-0.21-0.29-0.27 C128.11,101.62,127.86,102.61,127.53,103.43L127.53,103.43z M132.56,103.46c-0.06,0.17,0.16,0.29-0.15,0.32 C132.35,103.54,132.52,103.57,132.56,103.46L132.56,103.46z M200.11,116.58c-0.28,0.66-0.74,1.48-1.25,0.86 c0.31-0.28,0.16-0.51,0.12-0.92c-0.01-0.07-0.63-0.23-0.64-0.39c-0.03-0.35,0.47-0.22,0.47-0.57c0.01-0.72,0.27-0.95-0.23-1.5 c0.08-0.02,0.12,0.01,0.01-0.25c-0.11-0.05-0.08,0.16-0.08,0.16c-0.18-0.31-0.28-0.51-0.33-0.74c0.02,0.03-0.3-0.35-0.44-0.56 c0,0,0.11-0.01,0.1-0.03c0.32,0.48,0.73,0.35,0.94,0.99c0.01-0.02-0.14-0.1-0.16-0.07c0.09,0.34,0.2,0.48,0.21,0.76 c0.23,0.05,0.24,0.14,0.42,0.25c0.01-0.09-0.04-0.42-0.03-0.47c0.56,1.23,2.35,0.36,1.44,1.93 C200.17,115.84,200.14,116.15,200.11,116.58L200.11,116.58z M183.93,116.56C183.97,116.55,183.48,116.6,183.93,116.56L183.93,116.56 z M57.81,124.53c-0.07-0.05-0.3-0.23-0.45-0.54c0.02-0.11,0.14,0.04,0.14,0.02c0.01-0.25-0.09-0.28,0.1-0.56 C57.82,123.79,57.83,124.12,57.81,124.53L57.81,124.53z M196.24,121.48c-0.68,0.56-1.15-0.02-1.91-0.1c0-0.05,0.14-0.17,0.12-0.2 c-0.05,0.01-0.07,0.14-0.14,0.12c-0.02-0.24,0.11-0.01-0.07-0.08c0.27-0.35,0.09-0.35,0.39-0.54c0.03-0.34-0.09-0.14,0.14-0.21 c0.17-0.81,1.18-1.02,1.77-1.6c0.53-0.52,0.78-1.29,1.16-1.84c0.12,0.19,0.22,0.35,0.32,0.57c0.14-0.11,0.25-0.21,0.41-0.26 c-0.06,0-0.05,0.25-0.06,0.24c0.1-0.08,0.09-0.13,0.17-0.21c0.2,0.86-1.04,1.45-0.6,2.2c-0.33-0.11-0.51,0.05-0.88,0.09 C196.94,120.37,196.73,121.12,196.24,121.48L196.24,121.48z M66.01,126.14c-0.19-0.13-0.22-0.16-0.31-0.32 c0.11-0.01,0.66,0,0.68,0.01c0.01,0.03,0.03,0.04,0.06,0.04c-0.26,0.52-0.65,0.77-0.97,0.57C65.79,126.35,65.67,126.32,66.01,126.14 L66.01,126.14z M61.08,127c0.07,0.16,0.22,0.29,0.29,0.49c0.14-0.14-0.31,0.04-0.19,0.01c0.38,0.67,1.11,1.32,1.89,1.42 c-0.38,0.56-2.59,0.24-3.25,0.14c0.02,0.02,0.03-0.18,0.05-0.14c-0.1-0.08-0.19,0.04-0.28,0c0.03-0.09,0.01-0.09-0.03-0.16 c0.08-0.1,0.27-0.08,0.38-0.14c0.02-0.13-0.2-0.09-0.14-0.25c0.14,0.1,0.31,0.21,0.43,0.35c0.02-0.04,0.05-0.06,0.09-0.06 c-0.08,0-0.17-0.14-0.05-0.14c0.08,0.05,0.23,0.17,0.32,0.16c0-0.06,0.04-0.08,0.11-0.05c-0.54-0.32-0.5-0.63,0.02-0.9 c-0.59,0.01-0.7-0.32-0.61-0.63c0.28-0.12,0.28-0.09,0.57-0.26C60.83,127.01,60.92,126.97,61.08,127L61.08,127z M195.57,102.64 C195.66,102.8,195.7,102.87,195.57,102.64L195.57,102.64z M61.4,129.26C61.92,129.23,62.07,129.79,61.4,129.26L61.4,129.26z M62.24,129.47C62.36,129.54,62.33,129.52,62.24,129.47L62.24,129.47z M53.69,87.65C53.55,87.94,53.64,87.77,53.69,87.65 L53.69,87.65z M10.16,53.36c0.01,0.02,0.12,0,0.05,0.25C10.11,53.65,10.21,53.49,10.16,53.36L10.16,53.36z M3.77,53.08 C3.72,53.07,4.01,53.15,3.77,53.08L3.77,53.08z M3.75,45.73c-0.61-0.19-1.14-0.2-1.1-0.85c0.68,0.12,1.06,0.4,1.71,0.6 C4.22,45.73,3.99,45.72,3.75,45.73L3.75,45.73z M32.06,27.97c0.1,0.12,0.11,0.26,0.06,0.45c0.06-0.06,0.15-0.29,0.19-0.38 c0.05,0.02,0.1,0.03,0.15,0.02c-0.02,0.1-0.05,0.38-0.02,0.45c0.2-1.15,1.64-0.3,1.88,0.56c0.25,0.91-0.21,0.75-1.03,1.45 c-0.49,0.43-1.3,1.18-1.44,1.5c-0.27,0.57-0.19,1.86-0.87,1.22c-0.84,1.52-1.47-0.63-1.85-0.74c-0.16-0.01-0.28-0.04-0.49,0 c0.35-1.18,1.4-3.07,0.69-4.85c0.51-0.2,0.64-0.25,0.91,0.06C30.59,27.06,31.53,27.33,32.06,27.97L32.06,27.97z M37.63,31.39 c0-0.1,0.01-0.18-0.1-0.29c0.02,0.06,0.2-0.01,0.19-0.01c-0.12-0.2-0.23-0.37-0.36-0.56c1.15,0.28,0.96,1.53,1.37,2.5 c0.7-0.53-0.14-2.61,0.02-3.18c0.22,0.12,0.44,0.19,0.65,0.38c0-0.02-0.02-0.24-0.04-0.24c1.01,0.7,1.14,1.97,1.46,3.24 c0.2,0.83,0.19,1.01,0.82,1.62c0.43,0.42,1.33,0.55,1.14,1.54c-0.18-0.17-0.14-0.13-0.25-0.43c-0.03,0.11-0.04,0.39-0.12,0.47 c-0.08-0.16-0.09-0.21-0.23-0.44c-0.21,0.27-0.24,0.2-0.28,0.61c-0.1,0.06-0.24-0.12-0.35-0.02c0.03,0.17,0.06,0.31,0.05,0.48 c0.33-0.36,0.4-0.18,0.64-0.31c-0.01,0.15-0.11,0.28-0.14,0.41c0.05,0.01,0.19-0.17,0.34-0.02c-0.37,0.89-1.22,0.55-2.07,0.42 c-0.03-0.06,0.09-0.25,0.1-0.31c-0.51-0.03-0.73-0.09-0.89-0.59c-0.27,1.32-2.61,1.6-3.74,1.62c-0.11-1.71-1.21-0.6-1.99-1.67 c-1.18-1.63,2.24-1.03,2.65-1.36c-0.71-0.67-1.5-0.32-2.33-0.45c-1.56-0.25-1.08-1.05,0.28-1.27c0.03-0.07-0.21-0.07-0.21-0.07 c0.1-0.08,0.25-0.1,0.31-0.21c-0.72,0.1-1.07,0.21-1.54,0.25c0.13-0.17,0.13-0.28,0.23-0.47c-1.18,0.35-0.16-1.82,0.32-2.33 c1.1-1.16,2.45-0.68,1.5,0.62c0.48-0.1,0.51-0.89,0.89-0.86c0.8,0.06,1.2,0.8,0.61,1.35c0.16-0.01,0.3-0.16,0.39-0.27 c0.03,0.01-0.06,0.21-0.06,0.21c0.02-0.02,0.11,0.04,0.12,0.04c0.35-0.6,0.16-0.27,0.55-0.29C37.5,31.31,37.5,31.34,37.63,31.39 L37.63,31.39z M43.39,30.27c-0.07-0.03-0.18-0.28-0.22-0.34c-0.46,0.07-0.31,0.19-0.6-0.36c0.07,0.03,0.34,0.19,0.41,0.2 c-0.32-0.42-0.45-0.8,0.25-0.62c0,0.01-0.1-0.33-0.15-0.28c0.52,0.23,2.57-0.31,1.59,0.68c0.15,0.16,0.11,0.09,0.2,0.34 c-0.32,0.26-0.45,0.45-0.64,0.87c0.54-0.33,0.73-0.04,0.71,0.54c0.17-0.1,0.17-0.15,0.28-0.27c0.22,0.82,0.3,2.18-0.8,2.07 c0.06,1.38-1.5-0.74-1.75-1.03c-0.47-0.54-1-1-0.35-1.38c0.17-0.1,0.72,1.23,0.84,0.07c0-0.02,0.12,0.18,0.15,0.08 c-0.14-0.22-0.1-0.4-0.2-0.66C43.19,30.21,43.34,30.29,43.39,30.27L43.39,30.27z M51.49,35.93c-0.3-0.29-0.6-0.22-0.6-0.78 c-0.68,0.59-1.54-0.05-1.63-1.05c0.5,0.23,0.8,0.18,1.3,0.12c-0.86-0.8-2.34-0.55-1.4-2.13c-0.25-0.38-0.16-0.82,0.21-1.09 c-0.39-1.23,2.14-2.97,2.19-1.55c0.03,0.76-0.97,1.17-0.59,2.16c0.29,0.77,0.36,1.38,0.82,2.1c-0.35,0.1-0.58,0.33-0.94,0.47 c0.21-0.13,0.64-0.17,0.9-0.28c0.02,0.12,0.03,0.3,0.04,0.41c0.48-1.32-1.12-1.74,0.07-2.6c-0.8-0.15-0.63-1.55,0.45-0.71 c-0.28-0.16-0.56-0.41-0.84-0.58c0.25,0.02,0.55,0,0.94,0.12c-0.54-0.31-0.49-0.29-0.53-0.69c-0.01,0,0.18,0.24,0.23,0.27 c0.29-0.43-0.27-0.48,0.39-0.15c-0.2-1.02,1.85-1.19,1.29,0.12c0.87,0.6,0.37,1.9,0.3,2.5c0.29-0.43,0.47-0.58,0.6-1.1 c0.09,0.48,0.41,0.54,0.87,0.31c-0.37-1.15,2.13-0.71,1.8,0.44c0.51,0.28,0.68,0.28,0.09,0.81c0.09-0.03,0.31-0.11,0.15,0.1 c0.28-0.2,0.38-0.19,0.68-0.34c-0.1,0.13-0.19,0.43-0.3,0.61c-0.06-0.03,0.28-0.31,0.25-0.18c0.03,0.3,0.03,0.35,0.2,0.45 c0-0.15-0.02-0.27-0.04-0.42c0.21-0.18,0.22,0.11,0.44-0.29c0.68,0.23,1.23,0.96,0.26,1.16c0.32-0.04,0.5,0.06,0.84,0.02 c-0.06,0.21-0.03,0.46-0.14,0.68c0.17-0.11,0.4-0.21,0.54-0.34c-0.12,0.16-0.2,0.4-0.28,0.57c0.44-0.58,0.98-0.4,1.08,0.22 c-0.04,0.01-0.37,0.25-0.65,0.34c0.11,0.03,0.34-0.02,0.55-0.03c-0.01,0.02-0.18,0.4-0.18,0.39c0.13-0.18,0.35-0.23,0.48-0.56 c0.42,0.31,0.49,0.51,0.53,0.94c-0.43-0.01-0.55,0.15-0.91,0.3c0.72,0.12,1.84,1.06,0.46,0.42c-0.09,0.16-0.04,0.14-0.28,0.16 c0.09,0.06,0.29,0.18,0.45,0.3c-0.21,0.4-0.04,0,0.03,0.48c-0.19,0.08-0.18,0.01-0.36,0.11c0.6,0.2,0.9,0.45,1.21,0.6 c0.03,0.31-0.04,0.22,0.14,0.5c0.19-0.11,0.33-0.14,0.55-0.23c0.14,0.38,0.58,0.63,0.41,1.12c0.15,0.01,0.16,0.04,0.03,0.11 c0.21-0.05,0.47-0.02,0.65-0.1c-0.07,0.15-0.09,0.38-0.15,0.56c0.85-0.36,1.18,0.35,0.91,0.92c-0.16-0.03-0.41-0.06-0.51-0.09 c0.25,0.18,0.12,0.11,0,0.32c0.03,0.03,0.21,0.02,0.3,0.09c-0.1,0.18-0.24,0.35-0.36,0.6c-0.1-0.06-0.29-0.18-0.4-0.23 c0.1,0.52-0.05,0.65-0.09,1.14c-0.53-0.28-0.88-0.67-1-1.47c-0.51-0.06-0.8-0.54-1.12-0.87c0.06,0.2,0,0.17,0.07,0.42 c-0.14-0.06-0.23-0.21-0.4-0.21c0.04,0.13,0.04,0.15-0.13,0.1c0.19,0.13,0.38,0.45,0.57,0.61c-0.54,0.2-0.12,0.13-0.43,0.51 c0.16,0.01,0.16-0.08,0.37-0.04c0.02,0.44,0.13,0.57,0.33,1.09c0.2-0.19,0.05-0.07,0.33-0.17c-0.04,0.06-0.08,0.11-0.12,0.17 c0.13,0,0.21-0.03,0.38-0.07c0.06,0.05,0,0.29,0.03,0.35c0.28-0.04,0.73,0.94,0.62,1.69c-0.07-0.09-0.15-0.17-0.24-0.23 c0.14,0.29,0.14,0.57,0.28,0.78c-0.04,0.05-0.2-0.12-0.27-0.13c0.01,0.04,0.11,0.43,0.1,0.47c-0.42-0.6-1.04-0.35-1.64-1.25 c0.04,0.01-0.5-0.15-0.7-0.2c0.47,0.78,1.58,1.34,1.62,2.27c-0.49-0.13-1.23-0.28-1.55-0.71c-0.15-0.07-0.3-0.06-0.39-0.42 c-0.31,0.11-0.14,0.07-0.28-0.13c-0.47,0.28-0.99-0.19-1.21-0.78c0.06-0.01,0.28-0.04,0.42-0.08c-0.17-0.05-0.22-0.13-0.34-0.3 c-0.05,0.06-0.08,0.13-0.07,0.21c-0.63-0.43-1.01-1.24-1.48-1.55c-0.04,0.06-0.09,0.09-0.17,0.1c0.07,0.14,0.13,0.21,0.23,0.38 c-0.1-0.02-0.1,0.03-0.08,0.13c-0.69-0.41-2.67,0.71-1.55-1.37c0.89,0.35,1.48-0.02,2.15-0.02c-0.73-1.02,0.01-1.11,0.36-1.96 c0.5-1.23-0.32-1.67-0.52-2.73c-0.07-0.02-0.14-0.04-0.2-0.06c-0.02,0.01,0.01,0.28,0.01,0.3c-0.11-0.25-0.29-0.47-0.37-0.65 c0.11-0.03,0.22-0.06,0.34-0.09c-0.53,0-0.88,0.21-1.32,0.54c0.03-0.21-0.03-0.39-0.04-0.59c0.91-0.06,0.39-0.7-0.23-0.95 c-0.11-0.16,0.29-0.41-0.21-0.2c-0.01-0.21-0.11-0.49-0.1-0.76c-0.27-0.13-0.71-0.26-1.06-0.25c1.45,0.99-0.64,0.56-1.21,0.42 c0.09,0.1,0.27,0.44,0.43,0.61c-0.68-0.35-1.64-0.27-2.81-0.49C51.54,35.84,51.61,36.03,51.49,35.93L51.49,35.93z M55.34,37.1 c0.13-0.03,0.01-0.23,0.24-0.15c-0.14,0.34-0.29,0.49-0.62,0.73C55.04,37.43,55.19,37.32,55.34,37.1L55.34,37.1z M54.51,36.22 c0.16,0.05,0.28,0.09,0.46,0.1c-0.18,0.24-0.13,0.11-0.36,0.15c0,0.09,0,0.18,0,0.27C54.31,36.47,54.48,36.36,54.51,36.22 L54.51,36.22z M54.6,29.2c1.07,0.09,3.25,1.7,1.33,1.57c-1.07-0.07-0.72,0.51-1.41-0.4C54.18,29.91,53.82,29.33,54.6,29.2L54.6,29.2 z M75.07,49.25C75.23,49.41,75.15,49.33,75.07,49.25L75.07,49.25z M89.91,25.4c0.02,0.17,0.19,0.29-0.12,0.42 C89.72,25.64,89.89,25.57,89.91,25.4L89.91,25.4z M89.92,28.02c-0.02,0.22,0.23,0.34-0.2,0.49C89.71,28.31,89.85,28.18,89.92,28.02 L89.92,28.02z M89.35,30.54v-0.04c0.01,0.33,0.01,0.66,0.05,0.99c-0.1-0.52-0.24-0.95-0.2-1.34C89.31,30.29,89.3,30.41,89.35,30.54 L89.35,30.54z M89.78,32.51c0.07,0.17-0.3,0.42,0.28,0.26c0.01-0.02-0.07,0.35-0.09,0.32C88.92,33.13,89.22,32.2,89.78,32.51 L89.78,32.51z M87.64,33.94c0.46-0.07,0.7-0.12,0.88,0.24C88.05,34.39,87.47,34.4,87.64,33.94L87.64,33.94z M85.44,35.59 c0.35-0.38,0.91-0.3,1.28,0.01c-0.3-0.06-0.57-0.08-0.86-0.12c0.37,0.05,0.69,0.16,1.08,0.19C86.47,35.92,85.73,35.88,85.44,35.59 L85.44,35.59z M87.48,36.05c-0.02,0.1-0.22,0.09,0.01,0.22c-0.42-0.1-1-0.26-1.48-0.34C86.54,35.8,87.07,35.83,87.48,36.05 L87.48,36.05z M86.9,36.26c0.28,0.12,0.48,0.29,0.6,0.45c0.04-0.02-0.5,0.03-0.45,0.02c0.21,0.19,0.21,0.11,0.32,0.33 C86.73,36.82,85.54,35.54,86.9,36.26L86.9,36.26z M85.54,38.63c-0.02,0.52-0.78,0.43-1.48,0.5C84.26,38.7,85.1,38.31,85.54,38.63 L85.54,38.63z M60.92,29.2c0.46-0.35,1.26-0.31,1.72,0.07C62.04,29.38,61.53,29.29,60.92,29.2L60.92,29.2z M55.76,26.35 c-0.01,0.13-0.11,0.17,0.09,0.29c-0.31,0.02-0.2,0.06-0.49,0.01C55.43,26.41,55.67,26.38,55.76,26.35L55.76,26.35z M45.3,26.58 c-0.09,0.09-0.11,0.21-0.14,0.28c-0.04-0.01-0.07,0-0.1,0.02c0.04-0.28,0.05-0.21,0.29-0.46c0.07,0.09,0.1,0.19,0.15,0.26 C45.32,26.78,45.33,26.58,45.3,26.58L45.3,26.58z M46.39,23.79c-0.55-0.01-0.89,0.04-1.03,0.25c-0.36-0.2-0.81-0.52,0.03-0.55 c-0.68-0.11-0.91-0.39-0.78-0.74c0.09-0.23-0.45-0.47,0.39-0.42c0.48,0.03,0.79,0.37,0.79,0.55C46.83,22.91,46.51,23.54,46.39,23.79 L46.39,23.79z M46.39,24.07c0.33-0.03,1.69,0.13,0.94,0.45c-0.42,0.17-2.17-0.1-1.23-0.53C46.18,24.07,46.26,24.05,46.39,24.07 L46.39,24.07z M46.12,26.47c0.28,0.18,0.49,0.26,0.53,0.52c0.83,0.21,0.17,1.31-0.77,0.82c-0.17-0.2-0.17-0.1-0.26-0.37 c-0.04,0.04-0.06,0.03-0.06-0.03c-0.05-0.01,0.01,0.17-0.1,0.14c-0.08-0.41-0.18-0.27,0.22-0.48c-0.1-0.15,0-0.09,0.05-0.25 c-0.08-0.03-0.14-0.01-0.17,0.05C45.65,26.73,45.81,26.62,46.12,26.47L46.12,26.47z M42.31,23.85c0.21,0.04,0.48,0.06,0.63,0.23 C42.31,24.16,41.76,24.09,42.31,23.85L42.31,23.85z M40.49,23.43c0.12,0.14,0.56,0.72,0.3,0.72c-0.52,0.02-0.72-0.7-0.84-1.06 C40.23,23.16,40.32,23.29,40.49,23.43L40.49,23.43z M41.06,25.05c0.45,0.14,0.74,0.46-0.17,0.44c0.04,0.03-0.07-0.21-0.06-0.32 C40.67,25.03,40.8,25.01,41.06,25.05L41.06,25.05z M42.75,24.83c0,0.01,0.3,0.16-0.38,0.25C42.46,24.99,42.66,24.92,42.75,24.83 L42.75,24.83z M41.62,25.49C42.56,26.15,39.38,25.72,41.62,25.49L41.62,25.49z M41.61,25.89c0.15,0.01,0.18-0.08,0.37-0.01 c-0.27,0.11-0.49,0.21-0.87,0.27C41.2,26.01,41.4,25.97,41.61,25.89L41.61,25.89z M41.6,26.12c0.14-0.03,0.3-0.11,0.45-0.14 c0.04,0.03,0.06,0.06,0.08,0.09c-0.36,0.25-0.31,0.21-0.73,0.27C41.41,26.27,41.59,26.17,41.6,26.12L41.6,26.12z M41.02,26.83 C41.75,27.71,39.81,27.23,41.02,26.83L41.02,26.83z M33.11,25.95c0.03-0.01,0.17-0.09,0.32-0.1C33.1,27.11,31.76,26.46,33.11,25.95 L33.11,25.95z M35.42,24.55c0.27,0.34,0.12,0.32-0.46,0.13C35.09,24.59,35.26,24.62,35.42,24.55L35.42,24.55z M34.91,22.76 c0.09-0.05,0.15-0.08,0.3-0.18C35.97,23.13,35.1,23.32,34.91,22.76L34.91,22.76z M88.95,19.17c0.14,0.07,0.44,0.04,0.48,0.34 C89.22,19.44,89.12,19.3,88.95,19.17L88.95,19.17z M88.86,23.1c0.11,0.25,0.43,0.28-0.18,0.49C88.6,23.37,88.75,23.27,88.86,23.1 L88.86,23.1z M88,18.07c0.29,0.27,0.5,0.59,0.61,0.91C88.1,18.81,87.83,18.44,88,18.07L88,18.07z M72.55,16.66 c0.48-0.22,0.98-0.13,1.36,0.27c0.59,0.62-0.1,0.91,0.1,1.51C73.69,17.78,72.88,17.35,72.55,16.66L72.55,16.66z M72.95,15.64 c0.12,0.04,0.28,0.02,0.44,0.15c-0.34-0.4-0.18-0.21-0.04-0.58c0.31,0.19,0.52,0.44,0.6,0.75C73.46,16.03,73.22,15.91,72.95,15.64 L72.95,15.64z M75.87,14.91c0.35,0.12,0.68,0.37,0.91,0.68C76.37,15.5,76.04,15.24,75.87,14.91L75.87,14.91z M76.38,15.01 c0.37-0.07,0.6,0.14,0.56,0.52C76.72,15.37,76.54,15.2,76.38,15.01L76.38,15.01z M69.54,17.59c0.36,0.32,0.69,0.7,1.07,1.05 C69.87,18.65,69.23,18.11,69.54,17.59L69.54,17.59z M75.32,49.23c0-0.01-0.3,0.03-0.2-0.11c0.13,0,0.25,0.04,0.38,0.05 C75.54,49.11,75.33,49.17,75.32,49.23L75.32,49.23z M55.43,27.59C55.38,27.88,54.96,27.87,55.43,27.59L55.43,27.59z M31.98,24.33 c0.29-0.36,0.62-0.56,1.14-0.56c-0.03,0.07-0.03,0.14,0.01,0.22c0.21-0.05,0.05-0.11,0.13-0.21c0.37,0.13,0.23,0.13,0.56,0.01 c-0.04-0.06-0.16-0.07-0.23-0.17c1.12-0.52,0.45,0.71,0.71,0.93c0,0.05-0.28-0.16-0.25-0.01c0.64,0.69-1.59,1.46-0.79,0.16 c-0.29,0.21-0.35,0.13-0.44,0.49c-0.03-0.07-0.09-0.1-0.18-0.1c0.14,0.28-0.01,0.37-0.06,0.7c-0.02-0.03-0.05-0.03-0.09,0.01 c-0.06-0.13-0.12-0.25-0.17-0.39c-0.02,0.07-0.07,0.07-0.12,0.02c0.04,0.29-0.06,0.23-0.1,0.39c0.11,0.28,0.24,0.27-0.19,0.25 c0.01,0.06-0.01,0.12-0.06,0.18c-0.07-0.25-0.21-0.37-0.27-0.62c-0.06,0.13-0.25,0.3-0.31,0.44c-0.16-0.19-0.23-0.13-0.35-0.34 c-0.3,0.37-0.4,0.44-0.35-0.01c-0.04-0.01-0.27,0-0.22,0.09c0.05-0.59,0.71-0.4,0.91-0.93C31.65,24.83,31.91,24.6,31.98,24.33 L31.98,24.33z M36.6,22.59c0.83-0.17,1.87,0.18,0.51,0.35c1.09,0.15,0.12,1.06-0.78,0.82C35.41,23.5,35.88,22.7,36.6,22.59 L36.6,22.59z M37.81,22.11c-0.36-0.08-0.64-0.01-0.92-0.24c-0.02,0.11-0.01,0.19,0,0.27c-0.44-0.21-0.51-0.21-0.8,0.01 C34.7,21.74,39.43,20.83,37.81,22.11L37.81,22.11z M43.45,20.43c0.54-0.53,0.91,0.19,0.66,0.59C43.75,20.77,43.6,20.67,43.45,20.43 L43.45,20.43z M43.52,23.94c-0.6-0.07-0.27-0.35-0.67-0.57c-0.19-0.1-0.81-0.1-1.05-0.24c-0.86,0.44-1.83-0.21-0.34-0.32 c-0.02-0.04-0.28-0.01-0.35-0.03c0.13-0.07,0.29-0.1,0.31-0.23c-0.25,0.03-0.2,0.01-0.43,0.01c0.04-0.12,0.02-0.22,0.04-0.33 c-0.11,0.07-0.37,0.19-0.5,0.28c0.04-0.08,0.07-0.24,0.13-0.35c-0.93,0.09-0.56-0.37,0.1-0.47c0.97-0.14,1.28,0.32,1.2,0.7 c0.06-0.18,0.23-0.23,0.36-0.38c0.47,0.15,0.65,0.31,0.59,0.53C43.75,22.45,44.35,23.79,43.52,23.94L43.52,23.94z M43.57,26.74 c-0.61,0.07-2.4,0.31-1.35,0.04c-0.03-0.26,0.15-0.23,0.66-0.17c-0.35-0.1-0.11-0.04-0.25-0.26c-0.49-0.04-0.68-0.56,0.03-0.47 c0.47,0.07,0.26,0.51,0.98,0.49c-0.11-0.08-0.14-0.24-0.13-0.24c-0.1-0.04-0.24-0.05-0.4-0.08c0.02-0.03,0.22-0.06,0.29-0.07 c-1.12-0.27,0.19-0.63,0.6-0.19c0.02-0.03,0.07-0.07,0.14-0.01c0.03-0.22,0.13-0.09,0.2-0.24c0-0.02-0.17-0.01-0.18-0.03 c0.2,0.03,0.23,0.04,0.39,0.13c-0.04-0.02-0.09-0.03-0.14-0.01c0.52,0.21,0.55,0.72,0.27,1.03c0.14,0.13,0.17,0.19,0.28,0.44 c-0.07-0.09-0.12-0.18-0.2-0.25c-0.02,0.03-0.06,0.03-0.12,0.02c0,0.01,0.05,0.14,0.05,0.14c-0.22,0.04-0.21,0.19,0.05,0.44 c-0.12,0.04-0.15-0.07-0.28-0.08c-0.01,0.06,0.12,0.15,0.09,0.2c-0.48,0.04-0.71,0.03-0.82-0.09c-0.59,0.13-0.76,0.06-0.34-0.18 c-0.25-0.07-0.1-0.02-0.31-0.07c0.07-0.08,0.07-0.11-0.05-0.17c0.34-0.02,0.31-0.07,0.53-0.1c-0.08,0-0.16,0.01-0.24,0.02 c0.22-0.12,0.31-0.17,0.5-0.29C43.78,26.69,43.59,26.74,43.57,26.74L43.57,26.74z M69.08,39.69c-0.35-0.85,1.26-0.08,1.35,0.2 c0.13,0.47-0.59,0.73-1.12,0.41c0.21-0.03,0.25-0.02,0.38-0.08c-0.22-0.01-0.5-0.12-0.8-0.2c0.09-0.04,0.19-0.03,0.29,0.02 c-0.03-0.03-0.3-0.19-0.3-0.19C69.21,39.79,69.08,39.78,69.08,39.69L69.08,39.69z M77.27,14.94c-0.14,0.38-0.87-0.38-0.87-0.7 C76.66,14.49,77.01,14.71,77.27,14.94L77.27,14.94z M88.64,45.95c-0.41-0.27-1-0.39-1.53-0.27c0.04-0.04-0.01-0.22-0.03-0.25 c0.56-0.06,0.33-0.22,0.33-0.23c0.04-0.05,0.2-0.21,0.2-0.27c-0.15-0.11-0.72-0.34-1.21-0.21c0-0.03,0.01-0.07,0.01-0.1 c0.53-0.05,0.92-0.15,1.23-0.34c-0.16,0-0.19,0.06-0.44,0.05c0.08-0.05,0.3-0.22,0.39-0.3c-0.35-0.23-0.95-0.08-1.52-0.02 c0.24-0.16,0.08-0.07,0.44-0.12c-0.01-0.06-0.21-0.12-0.23-0.27c0.22,0.09,0.32,0.12,0.52,0.16c-0.02-0.02-0.1-0.13-0.01-0.13 c-0.42-0.17-0.06-0.01-0.33-0.27c0.02-0.02,0.11-0.09,0.13-0.11c0.25,0.16,0.39,0.15,0.56,0.34c0.02-0.12,0.05-0.12,0.09,0.01 c0-0.3-0.02-0.19-0.27-0.39c-0.07-0.23,0.21,0.07,0.25-0.05c-0.17-0.09-0.14-0.09-0.38-0.08c0.03-0.02,0.06-0.11,0.02-0.14 c0.45,0.06,1.3,0.55,0.78,0.76c0.12,0.25,0.12,0.27,0.3,0.55c0.16-0.2,0.17-0.23,0.25-0.46c0.09-0.09,0.13,0.17,0.17,0.16 c0-0.17,0.12-0.49,0.12-0.64c0.09,0.12,0.36,0.31,0.43,0.41c0.1-0.4,0.23-0.21,0.44-0.48c0.09,0.16,0.27,0.34,0.35,0.57 c-0.05-0.16-0.03-0.36-0.09-0.54c0.51,0.18,0.97,0.16,0.97-0.34c0.15,0.09,0.44,0.1,0.65,0.34c0.14-0.12,0.35-0.12,0.48-0.2 c-0.41,0.34-0.23,0.29-0.11,0.68c0.29-0.02,0.33,0.03,0.43,0.04c0.11,0.16,0.29,0.51,0.25,0.47c-0.21,0.3-0.14,0.4-0.54,0.55 c0.04,0.03,0.03,0.05-0.03,0.08c0.07,0.02,0.13,0.01,0.18-0.05c-0.11,0.11-0.33,0.31-0.39,0.42c-0.14-0.05-0.11-0.14-0.25-0.18 C90.9,45.63,89.39,46.28,88.64,45.95L88.64,45.95z M62.55,14.36c0.07-0.04,0.69-0.15,0.77,0.01c0.18,0.35-0.87,0.57-1.24,0.83 c0.75-0.1,1.25-0.36,1.85-0.58c0.04,0.1,0.12,0.17,0.17,0.28c0.02-0.18,0.13-0.29,0.2-0.44c0.06,0.13,0.16,0.22,0.22,0.33 c0.16-0.1,0.19-0.14,0.35-0.18c-0.17,0.42,0.56,0.62,0.24,1.05c0.56-0.47,1.43,0.03,1.2,0.54c-0.14,0.32-1.42,0.86-1.79,0.88 c-0.29,0.1-0.45,0.13-0.98,0.23c0.1,0.02,0.25-0.02,0.33,0.01c-0.54,0.13-1.05,0.15-1.67,0.09c-0.11,0.01-0.25,0.1-0.68-0.19 c0.12,0.12,0.28,0.27,0.37,0.36c-0.1,0.02-0.16,0.01-0.21-0.03c-0.01,0.05-0.01,0.1,0.01,0.15c0.4-0.07,0.88-0.03,1.24-0.05 c-0.56,0.22-1.03,0.53-1.68,0.53c-0.29,0.1-0.29,0.13-0.68,0.2c0.2,0.11,0.21,0.08,0.52,0.05c-0.07,0.04-0.11,0.08-0.09,0.13 c0.74-0.35,2.31-0.9,3.39-0.97c0,0.43-1.28,1-1.78,1.33c-0.49,0.32-1.51,1.31-1.84,0.85c0.09,0.14,0.09,0.34,0.19,0.49 c-0.54,0.01-1.06,0.1-1.37,0.25c0.35-0.07,0.76-0.05,1.08-0.07c-0.19,0.1-0.36,0.3-0.56,0.39c0.1-0.02,0.19-0.02,0.28,0.01 c-0.68,0.66-1.39-0.04-2.06,0.12c1.19,0.08,0.62,0.55-0.16,0.5c-0.22,0.14-0.8,0.05-1.27-0.06c0.29,0.06,0.56,0.22,0.71,0.27 c-0.28-0.06-0.59-0.1-0.8-0.15c0,0,0.14,0.14,0.12,0.17c-0.14,0.02-0.33-0.06-0.45,0.02c0.14,0.11,0.15,0.1,0.2,0.17 c0.61-0.1,1.19-0.08,1.78-0.03c0.28,0.65-1.18-0.04-1.96,0.11c0.35,0.02,0.79,0.11,1.03,0.15c-0.35-0.02-0.67,0.03-1.02,0.03 c0,0.03,0.01,0.14,0.03,0.21c0.43-0.14,1.41-0.29,0.92,0.05c1.22-0.12,1.18,0.68-0.09,0.61c1.34,0.13,0.38,0.51-0.37,0.48 c0.27,0.02,0.55,0.07,0.83,0.11c-0.07,0.07-0.19,0.17-0.23,0.24c-0.31,0.04-0.82,0.07-1.34-0.01c0.45,0.66-0.8,1.57-1.97,0.7 c0.05,0.12,0.1,0.16,0.22,0.25c-0.08,0.03-0.47,0.04-0.48,0.05c0.03,0.05,0.18,0.19,0.13,0.24c0.46-0.23,0.44-0.12,0.99-0.17 c0,0.01-0.12,0.17-0.12,0.17c0.79-0.25,0.79,0.06,0.86,0.33c0.16-0.09,0.22-0.13,0.42-0.2c0.26,0.3,0.1,0.56-0.42,0.72 c-0.02-0.06-0.04-0.11-0.07-0.17c-0.2,0.27-0.65,0.45-1.2,0.52c0.19-0.41-0.42-0.47-0.91-0.68c0.37,0.58-0.43,0.36-0.56-0.1 c0.21,0.43,0.03,0.53-0.49,0.16c-0.53,0.28,0.21,0.18-0.48,0.1c0.13,0.12,0.13,0.24,0.35,0.36c-0.68,0.06-1.25-0.04-1.25-0.42 c-0.06,0.08-0.16,0.22-0.18,0.31c-0.14-0.08-0.3-0.15-0.43-0.25c-0.29,0.49-0.63,0.01-0.54-0.33c0,0.14-0.05,0.32-0.06,0.47 c-0.02,0.01-0.04-0.17-0.05-0.17c-0.04,0.03-0.03,0.18-0.17,0.2c-1.02-0.64,0.91-0.97,1.3-0.93c-0.01-0.02,0.02-0.06,0.06-0.07 c-0.02-0.03-0.23-0.01-0.24-0.01c0.06-0.06,0.15-0.19,0.16-0.26c-0.48,0.01-1.27-0.6-0.39-0.73c0.99-0.14,1.02,0.68,1.89,0.78 c0.11-0.03-0.07-0.12-0.06-0.13c0.11,0.02,0.52,0.04,0.62,0.03c-0.03-0.22,0.47-0.62,0.65-0.93c-0.2,0.13-1.64,1.32-1.36,0.41 c-0.01,0.01-0.16,0.2-0.16,0.2c-0.26-0.17-0.1-0.11-0.1-0.31c-0.01,0.01-0.19,0.04-0.2,0.03c-0.01-0.02-0.01-0.04,0-0.06 c0.22-0.02,0.27-0.07,0.4-0.09c-0.64,0.04-0.7-0.02-0.08-0.16c0.14-0.1,0.01-0.13,0.51-0.21c-0.11-0.01-0.28-0.02-0.46-0.01 c0.02-0.06,0.17-0.24,0.16-0.27c0,0.02-0.07-0.2-0.04-0.34c-0.13,0.35-0.29,0.72-0.83,0.78c0.03-0.13-0.03-0.28,0.11-0.44 c-0.15,0.26-0.46,0.4-0.96,0.35c0.05-0.06,0.24-0.08,0.26-0.1c-0.03-0.01-0.27-0.06-0.26-0.01c-0.04-0.29-0.11-0.36,0.33-0.55 c-0.47-0.85,2.14-0.32,2.72,0.04c-0.03-0.18,0.05-0.16,0.07-0.24c-0.31-0.04-0.36-0.1-0.62-0.16c0.54,0.07,0.96,0.02,1.02-0.3 c-0.5,0.3-1.3,0.15-1.86-0.05c0.03-0.04-0.15-0.11,0.07-0.19c0.32,0.12,0.54,0.12,0.73,0.15c-0.27-0.12-0.2-0.15-0.37-0.31 c-0.06,0-0.09,0.09-0.22,0.08c-0.13-0.49-1.95-1.53-0.63-1.25c-1.21-0.19-0.82-0.83,0.32-0.62c0.85,0.15,1.66,0.8,1.75,1.23 c0,0,0.51,0.08,0.61,0.09c0.07-0.03,0.45-0.23,0.5-0.26c-1,0.21-0.98-0.31-1.22-0.52c-0.82-0.75-0.56-0.7,1-0.84 c-0.03-0.05-0.13-0.07-0.16-0.11c0.4-0.03,1-0.12,1.36-0.18c-0.4,0.02-0.81-0.02-1.21,0.02c0.73-0.35,1.56-0.52,2.31-0.4 c0.23-0.17,0.16-0.14,0.63-0.31c-0.25,0.06-1.95,0.25-2.13,0.18c-0.6-0.23,0.36-0.86,0.86-1.2c-0.52,0.18-0.97,0.49-1.12,0.78 c-0.11-0.08-0.2-0.12-0.31-0.2c0.04,0.12,0.04,0.35,0.12,0.5c-0.02-0.06,0.01-0.07,0.07-0.03c-0.41,0.78-3.47,1.18-1.33,0.3 c-0.03-0.04-0.06-0.08-0.15-0.2c-0.16,0.2-0.43,0.43-0.94,0.56c0.01-0.09,0.01-0.23,0.05-0.32c-0.12,0.34-0.76,0.85-0.87,0.34 c-0.83,0.37-0.72-0.24-0.29-0.53c0.47-0.32,1.36-0.31,2.1-0.48c-1.14,0.11-1.67,0.13-2.48,0.52c-0.72,0.35,0.08,0.48-0.79,0.41 c-0.38-0.03-0.77-0.33-1.01-0.47c0.9-0.39,1.95-0.18,2.88-0.77c-0.78,0.12-1.13,0.41-1.92,0.47c-1.02,0.08-1.93-0.28-0.61-0.41 c-0.21-0.02-0.36-0.07-0.57-0.1c0.49-0.39,1.25-0.42,1.93-0.45c-0.94-0.16-1.44,0.01-2.25,0.35c-0.18-0.25,0-0.35,0.53-0.53 c-0.01-0.01-0.37-0.17-0.37-0.17c-0.21,0.13-0.48,0.18-0.77,0.32c-0.08-0.04-0.33-0.16-0.4-0.2c0.24-0.33,0.95-0.88,1.41-0.36 c0.02-0.05,0.02-0.22-0.02-0.28c0-0.01,0.29,0.13,0.24,0.14c-0.45-0.53,0.92-0.7,1.18-0.16c0.01-0.4,0.43-0.28,0.79,0.05 c-0.04,0.03-0.1-0.25-0.07-0.22c-0.03-0.01,0.48,0.12,0.37,0.13c-0.03-0.09-0.06-0.1,0.07-0.16c-1.99-0.18-0.28-0.47-0.78-0.87 c0.32-0.07,0.39-0.11,0.77-0.08c0.23,0.17,0.91,0.35,0.83,0.8c0.14,0.01,0.28-0.01,0.42,0.01c-0.22-0.15-0.23-0.21-0.38-0.41 c0.53,0.11,0.94,0.47,1.53,0.66c-0.09-0.25-2.33-1.15-0.73-1.15c-0.98-0.38,0.15-0.41,0.6,0.03c0.04-0.24-0.33-0.54-0.46-0.81 c0.41,0.14,0.57,0.08,0.85,0.37c0-0.04,0-0.09-0.03-0.14c0.13,0.01,0.25,0.02,0.36,0.03c-0.91-0.42,0.02-0.94,0.34-0.37 c0.09-0.07,0.25-0.12,0.33-0.23c0.76,0.2,1.44,0.83,1.27,1.23c0.89-0.37-0.52-1-0.89-1.41c1.69-0.25,1.59,0.16,2.77,0.64 c-0.86-0.58,0.65-1.25,0.95-0.61c0.59-0.59,2.03,0.11,2.31,0.48C62.4,14.63,62.49,14.5,62.55,14.36L62.55,14.36z M50.54,26.99 c0.15,0.05,0.31-0.05,0.41,0.19c0.02-0.09,0.11-0.23,0.11-0.31c0.14,0.09,0.17,0.14,0.26,0.24c-0.01,0.01,0.36-0.14,0.29-0.15 c0.13,0,0.04,0.14,0.11,0.15c0.04-0.02,0.07-0.15,0.11-0.19c0.1,0.08,0.45,0.19,0.6,0.23c-0.05,0.02-0.12,0.04-0.18,0.06 c0.14,0,0.57,0,0.72-0.02c-0.11-0.06-0.29-0.08-0.35-0.17c0.39-0.06,0.29-0.03,0.56-0.01c0.19-0.18-0.05-0.07,0.4-0.15 c0.28-0.42,1.36-0.23,1.42,0.12c0.67,0.04,0.34,0.09,0.36,0.39c-0.01-0.13-0.33,0.79-0.2,0.72c-0.88,0.46-1.8-0.15-2.18-0.36 c0.7,0.34-0.38,0.65-0.69,0.24c-0.03,0.05-0.12,0.2-0.11,0.24c-0.11-0.04-0.11-0.16-0.21-0.2c-0.2,0.34-0.06,0.15-0.42,0.09 c-0.22,0.09-0.02,0.16-0.31,0c-0.18,0.18,0.04,0.12-0.31,0.04c-0.51,0.19-0.87,0.05-0.88-0.32c0.06-0.01-0.11,0.17-0.11,0.19 c0-0.01-0.17-0.19-0.15-0.19c-0.02,0.27-0.62,0.54-0.91,0.09c0,0.05,0,0.1,0,0.15c-0.14-0.15-0.13-0.08-0.05-0.24 c-0.51,0.42-0.93-0.01-0.55-0.31c-0.27-0.02-0.5-1.12-0.87-1.58c-0.22,0.12-0.18,0.11-0.23,0.18c-0.17,0-0.85-0.01-0.7,0 c-0.37-0.31-0.86-0.58-1.12-0.81c0.15,0.05,0.15,0.06,0.34,0.07c-0.21-0.07-0.15-0.15-0.34-0.29c0.94-0.36,2.42,0.14,1.87,0.77 c0.48-0.31,1.46-0.56,1.88-0.04c-0.27-0.03-0.35-0.02-0.63-0.06c0.36,0.13,0.82,0.21,1.33,0.26c-0.19,0.23-0.47,0.26-0.67,0.27 c-0.23-0.06-0.42-0.09-0.64-0.19c0.04,0.04,0.04,0.09-0.06,0.13c0.35,0.06,0.43,0.11,0.69,0.18c-0.46,0.16-0.2,0.07-0.51,0.28 c0.13-0.05,0.16-0.15,0.28-0.2c0.18-0.04,0.29-0.02,0.59-0.09c0.14,0.1,0.09,0.13,0.11,0.25c0.08-0.01,0.11-0.09,0.11-0.09 c0.13,0.26,0.28,0.1-0.11,0.35c0.08,0.03,0.21-0.04,0.03,0.02c0.04,0.02,0.35,0.13,0.46,0.16c0.03-0.01,0.06-0.01,0.1,0 c-0.01-0.12,0.03-0.23,0.02-0.3C50.29,26.95,50.59,27.02,50.54,26.99L50.54,26.99z M68.39,37.62c0.19-0.11,0.36-0.24,0.53-0.38 c-0.28,0-0.18-0.03-0.41-0.07c0.59-0.34,0.87-1.2-0.05-1.36c0.19-0.22,0.07-0.28,0.29-0.49c-0.05-0.01-0.19,0.13-0.27,0.09 c-0.19-0.59-0.14-0.91-0.59-1.42c0.08,0,0.15,0,0.23,0c-0.05-0.14-0.11-0.12-0.34-0.14c0.03-0.03,0.27-0.06,0.33-0.09 c-0.38-0.4-1.09-1.04-1.3-1.3c0.15-0.35,0.07-0.6-0.2-0.83c0,0.08-0.04,0.12-0.14,0.13c-0.02-0.01,0.02-0.22,0-0.25 c-0.11,0.09-0.29,0.16-0.36,0.21c0-0.15,0.04-0.16,0.01-0.28c-0.23,0.02-0.19,0.01-0.51-0.14c0.01,0.05,0.01,0.1,0,0.16 c-0.32-0.47-1.41-0.67-1.75-0.26c-0.01-0.01-0.13-0.29-0.12-0.28c-0.24,0.24-0.5,0.27-0.74,0.51c-0.06-0.2-0.11-0.18-0.08-0.41 c-0.1-0.02-0.2-0.04-0.31-0.07c-0.11,0.05-0.09,0.22-0.14,0.29c-0.49-0.23-0.13-0.08-0.57-0.06c0.21,0.14,0.33,0.29,0.52,0.45 c-1.11-0.22-2.47-0.86-1.04-1.38c-0.73,0.11-1.19-0.16-0.92-0.59c-0.25,0.5-0.61,0.4-0.95,0.09c0.3-0.55,1.47-0.55,2.23-0.41 c1.35,0.26,0.81-0.4,0.79-0.94c-0.18-0.04-0.16,0.12-0.3,0.14c-0.01,0.02,0.12-0.19,0.11-0.2c-0.41,0.37-0.95,0.46-1.3,0.12 c-0.04,0.45-0.38,0.39-0.79,0.11c0.06-0.07,0.21-0.14,0.28-0.21c-0.08,0-0.44,0.06-0.54,0.09c0.05-0.06,0.25-0.26,0.28-0.33 c-0.73,0.25-1.84-0.38-1.34-0.83c-0.33-0.32,0.22-0.7,0.82-0.64c0.24-0.31,0.69-0.5,1.14-0.5c-0.48-0.83,1.32-0.32,1.57-0.44 c0.95-0.42,0.81-1.83,0.64-1.92c0.35-0.15,0.39-0.33,0.76-0.42c0,0.01-0.28-0.32-0.29-0.33c-0.19,0.47-0.24,0.3-0.64,0.42 c-0.13,0.11-0.11,0.21-0.35,0.29c-0.12-0.05-0.17-0.21-0.26-0.29c-1.11,0.29-0.48-1.44,0.55-1.22c-0.08-0.52,0.53-1.06,1.01-1.48 c0.34-0.29,0.73,0.4,1.09,0.18c0.1-0.06,0.21-0.77,0.22-0.91c0.02-0.29-0.83-1.21,0.37-1.28c0.47-0.03,1.53,1.18,1.74,1.46 c-0.07-0.6-0.66-0.7-0.86-1.32c-0.14-0.45-0.62-0.09,0.02-0.6c0.28-0.22,1.12-0.25,1.21-0.24c0.39-0.21,0.09-0.2,0.61-0.22 c0.09-0.7,0.77,0.04,0.94,0.56c0.16,0.49-0.07,1.03,0.11,1.45c0.12-0.42,0.39-0.85,0.3-1.32c0.63,0.22,1.15,0.55,1.64,0.88 c-0.21-0.19-0.36-0.46-0.58-0.67c1.46,0.46,0.13-0.51,0.07-1.07c-0.11-0.99,0.28-0.66,1.08-0.21c0.71,0.4,1.15,1.1,1.85,1.44 c1.59,0.78-0.5-0.76,1.04-0.52c-1.15-0.24-0.37-1.1,0.48-0.42c0.04-0.04,0.08-0.05,0.14-0.05c-0.74-0.27-1.44-1.11-1.74-1.71 c1.18,0.04,2.22-0.19,2.06,0.96c0.02-0.25,0.08-0.63,0.04-0.88c0.47,0.32,0.83,0.66,1.05,1.09c0.41-1.54-2.32-0.96-2.42-1.73 c0.19,0.12,0.14,0.12,0.4,0.13c-0.39-0.11-0.61-0.39-0.57-0.74c0.08-0.02-0.06,0.11,0.09-0.03c0.05,0.04,0.04,0.17,0.1,0.22 c0.03-0.07-0.09-0.22,0-0.27c0.08,0.06,0.22,0.23,0.29,0.28c0.05-0.05,0.05-0.1,0-0.16c0.06,0.06,0.12,0.09,0.19,0.16 c-0.13-0.15-0.18-0.26-0.3-0.39c0.22-0.33,1.33-0.42,0.98,0.34c0.01-0.01,0.21-0.13,0.17-0.19c0.52,0.63,1.53,0.55,1.71,1.25 c-0.36-0.46-0.23-0.91,0.64-0.78c-0.21-0.02-0.46-0.07-0.71-0.08c0.19-0.08,0.59-0.32,0.87-0.37c-0.83-0.06-1.18-0.45-0.93-1.01 c0.13,0.08,0.45,0.15,0.53,0.19c-0.06-0.24,0.04-0.25,0.06-0.46c0.21,0.17,0.55,0.34,0.74,0.55c-0.65-0.73,0.54-0.88,1.04-0.69 c-0.13-0.17,0.26,0.17,0.31,0.29c-0.27-0.85,2.37-0.47,2.76-0.04c0,0,0.01-0.07,0.19-0.11c0,0.37-0.16,0.14,0.39,0.29 c-0.09,0.01-0.16-0.02-0.22-0.08c1.51-0.35,2.18,0.82,0.28,1.04c-0.8,0.09-2.59,0.4-3.11-0.03c1.02,0.51-0.39,0.67-1.16,0.85 c0-0.02,0.07,0.19,0.11,0.27c0.36-0.33,0.67-0.4,0.8,0.06c0.07-0.5,0.81-0.64,1.25-0.37c0.22-0.55,1.7-1,1.85-0.29 c0.73-0.24,3.51-0.51,1.81,0.49c0.05-0.04-0.12,0.22-0.43,0.35c0.57-0.11,1.02-0.36,1.6-0.44c-0.03,0.16,0.05,0.29,0.03,0.44 c0.12-0.08,0.23-0.19,0.34-0.27c1.71,0.62,1.05,1.21-0.45,1.79c-1.39,0.54-3.23,0.27-4.74,0.24c1.94,0.07-0.93,0.74-0.65,1.47 c0.48-0.33,1.38-0.81,1.74-0.59c0.42-0.37,2.68-0.7,2.72-0.01c0.03,0.49-1.33,0.77-1.19,1.11c0.11,0.29,1.5-0.53,1.65-0.67 c0.2-0.2,0.62-1.52,1.52-0.73c0.52,0.46,0,1.73-0.59,1.98c0.1,0.01,0.17-0.02,0.29-0.06c-0.28,0.73-0.72,1.38-0.97,2.06 c0.95-0.85,1.17-2.45,2.6-3.13c-0.08,0.23-0.02,0.39-0.06,0.63c0.5-0.32,0.36-0.22,0.85-0.11c0-0.04,0-0.09-0.01-0.14 c0.09,0.03,0.36,0.12,0.42,0.15c0.16-0.25,0.06-0.14,0.14-0.2c-0.03-0.17,0.01-0.24-0.07-0.49c0.25-0.09,0.15,0.11,0.31,0.09 c-0.2-0.58,0.81-0.72,1.59-0.58c1.28,0.23,1.29,0.7,0.9,1.37c-0.14,0.24-0.32,0.36-0.49,0.59c-0.09,0.12-0.44,0.47-0.46,0.5 c-0.35,0.31-0.85,0.96-1.73,0.48c-0.35,0.61-1.33,0.22-2.02,0.56c0.23,0.03,0.21,0.11,0.35,0.17c0.51-0.52,3.55-0.23,2.3,0.5 c-0.84,0.49-2.9-0.25-1.94,1.21c0.07-0.03,0.13-0.06,0.19-0.1c-0.31-0.64,1.96-1.17,1.11-0.01c-0.27,0.37-0.85-0.16-0.93,0.37 c-0.06,0.37-0.08,0.69-0.15,1.06c0.1-0.09,0.11-0.24,0.14-0.35c0.1-0.02,0.19,0,0.29,0.03c-0.01,0.01-0.11,0.24-0.1,0.24 c0-0.04,0-0.09,0-0.14c-0.34,0.22-0.11,0.22-0.38,0.3c0.18,0.68-0.61,0.53-0.79,0.98c0.25,0.3-0.03,1.11-0.28,1.48 c0.02-0.2,0.01,0.32,0.04,0.42c0.07-0.12,0.42-0.4,0.53-0.58c0.41,0.25,1.02,0.42,0.86,0.76c-0.29-0.14-0.46-0.17-0.74-0.29 c-0.03,0.27,0,0.11,0.21,0.34c-0.02,0.01-0.29,0.04-0.28,0.09c0.12,0.07,0.17,0.07,0.27,0.16c-0.07,0.01-0.14,0.02-0.21,0.03 c0.3,0.13,0.59,0.19,0.83,0.3c0.05-0.05,0.11-0.17,0.15-0.24c0.27,0.11,0.64,0.55,0.35,0.84c-0.32,0.32-1.27-0.14-1.96-0.11 c0.19,0.04,0.4,0.09,0.57,0.12c-0.15,0-0.4,0.04-0.55,0.06c0.12,0.06,0.36,0.03,0.47,0.09c-0.21,0.06-0.36,0.14-0.51,0.27 c-0.43-0.22-0.5-0.3-0.44,0.21c0.28,0.02,0.14,0.06,0.4,0.16c-0.15-0.06-0.32-0.02-0.45-0.01c0.53,0.16,0.52,0.15,0.84,0.45 c-0.02-0.05-0.04-0.09-0.07-0.14c0.09,0.07,0.2,0.18,0.35,0.18c-0.02-0.07-0.18-0.19-0.22-0.24c0.88,0.16,0.75,0.46-0.01,0.56 c0.68,0.04,0.79,0.29,0.88,0.73c0.23,1.14-0.63,0.04-1.38-0.09c0,0.01,0.19,0.14,0.23,0.16c-0.11-0.01-0.23-0.02-0.35-0.02 c0.44,0.13,0.56,0.33,0.86,0.55c-0.32,0.02-0.32,0.14-0.55,0.21c0.66-0.12,0.52,0.14,0.32,0.48c0.45-0.04,1.43,0.09,0.91,0.57 c-0.11,0.1-1.12-0.36-1.5-0.37c-0.04,0.28-0.15,0.2-0.25,0.37c0,0.04,0.11,0.16,0.05,0.36c2.64,0.05-0.47,2.02-0.92,0.39 c-0.2,0.09-0.19,0.04-0.23,0.29c-0.04-0.01-0.32-0.11-0.3-0.12c-0.01,0.42-0.53,0.63-1.09,0.49c0.08,0.02,0.16,0.05,0.25,0.07 c0.03-0.01-0.3,0.16-0.29,0.13c0.4-0.06,0.66,0.06,1.11,0.16c-0.38,0.21-0.43,0.28-0.96,0.3c-0.01,0.06,0.16,0.09-0.06,0.16 c0.34-0.06,0.06,0.01,0.23,0.1c0.58-0.39,1.34-0.03,0.49,0.24c-0.01,0.07,0.01,0.28,0.02,0.44c0.28-0.83,1.12,0.02,1.66,0.23 c-0.12,0.13-0.19,0.3-0.33,0.42c0.12-0.06,0.29-0.16,0.38-0.24c0.03,0.01-0.04,0.24-0.09,0.25c0.14-0.04,0.18-0.14,0.34-0.18 c-0.15,0.19-0.18,0.36-0.29,0.55c0.16-0.16,0.29-0.17,0.46-0.26c-0.04,0.23-0.09,0.35-0.18,0.53c0.16,0.17,0.19,0.46,0.27,0.72 c-0.25-0.17-0.36-0.06-0.53-0.42c-0.02,1.16-0.79-0.18-1.03-0.37c-0.55-0.45-1.21-0.48-1.85-0.86c-0.05,0.22,0.02,0.09-0.09,0.24 c0.5,0.22,0.92,0.09,1.26,0.51c-0.1,0.13-0.66,0.42-1.19,0.21c-0.17,0.14,0.09,0.12-0.32,0.12c-0.11,0.34-0.05,0.27-0.4,0.58 c0.43,0.04,1,0.1,1.37,0.15c-0.43,0.12-0.79,0.29-1.18,0.35c0.76,0.01,1.25-0.27,1.86-0.29c0.44-0.01,1.13,0.37,1.85,0.17 c-0.31,0.24-0.43,0.31-0.52,0.42c-0.11,0.03-0.28,0.01-0.51,0.07c-0.01,0.13,0.13,0.06,0.06,0.22c-0.19-0.03-0.13-0.12-0.34-0.03 c0.08,0.01,0.12,0.04,0.14,0.1c-0.11,0.06-0.01-0.08-0.01,0.07c-0.29,0.04-0.35,0.15-0.66,0.21c0.05,0.09,0.11,0.02,0.15,0.15 c-0.16,0.04-0.16-0.04-0.33,0c-0.04,0.51-1.91,0.96-2.41,0.75c-0.17,0.17-0.12,0.14-0.19,0.33c-0.16-0.11-0.06-0.14-0.3-0.19 c0.04,0.09,0.14,0.12,0.13,0.21c-0.16,0.01-0.23-0.09-0.35-0.12c-0.06,0.06,0.08,0.1,0.07,0.14c-0.48-0.02-0.36-0.06-0.38-0.22 c-0.3-0.25-0.25-0.18-0.51-0.41c0.01,0.11,0.04,0.08-0.1,0.11c0.61,0.52-0.36,1.45-0.83,1.99c0.02-0.01-0.06-0.09-0.1-0.13 c-0.15,0.4-0.17,0.28-0.38,0.31c-0.1,0.06-0.11,0.12-0.01,0.19c-0.16-0.07-0.25-0.06-0.41-0.17c0.04,0.3-0.09,0.26-0.11,0.51 c-0.1-0.01-0.23-0.14-0.18-0.14c-0.19,0.04-0.04,0.16-0.17,0.22c-0.1-0.08-0.16-0.16-0.32-0.27c-0.13,0.17-0.01,0.14-0.03,0.27 c-0.23-0.33-0.3-0.06,0.06-0.49c-0.21-0.04-0.24,0.06-0.39-0.1c0,0.11-0.04,0.13-0.13,0.06c0.02,0.18-0.03,0.2,0.01,0.41 c-0.07,0.07-0.17-0.06-0.21-0.05c0.1,0.19,0.04,0.21,0.07,0.36c-0.46-0.04-0.62,0.02-1.08,0.13c0.27,0.38-0.05,0.53-0.51,0.38 c-0.03,0.06-0.06,0.12-0.1,0.18c0.17,0.09,0.34,0.34,0.55,0.48c-0.16,0-0.48,0.09-0.66,0.08c0.5,0.18,0.24,0.2,0.53,0.5 c-0.08-0.01-0.4-0.06-0.48-0.05c0.44,0.24,0.29,0.29,0.11,0.52c-0.09-0.01-0.16-0.03-0.21-0.08c-0.07,0.1,0.05,0.16,0.12,0.23 c-0.13-0.02-0.3-0.07-0.41-0.08c0.12,0.11,0.23,0.09,0.36,0.12c-0.18,0.05-0.48,0.25-0.74,0.29c0.63,0.38,0.29,1.69-0.47,1.78 c0.16,0.12,0.19,0.21,0.33,0.32c-0.28-0.02-0.42-0.08-0.55-0.11c-0.54,0.2-0.64,0.22-0.48-0.22c-0.04,0.05-0.11,0.09-0.19,0.09 c-0.05-0.03,0.01-0.14,0.02-0.18c-0.11-0.03-0.12,0.11-0.19,0.15c-0.03-0.3-0.14-0.06,0.1-0.37c-0.12,0.05-0.3,0.12-0.48,0.15 c0.14-0.09,0.12-0.06,0.34-0.19c-0.13-0.03-0.29,0.1-0.18-0.07c-0.52,0.08-0.83,0.12-1.25,0.2c0.08-0.07,0.23-0.13,0.32-0.18 c-0.41-0.11-0.47-0.23-0.8-0.29c0.15-0.03,0.3-0.08,0.45-0.11c-0.19,0.03-0.43-0.02-0.6-0.03c0.14-0.21-0.03-0.19,0.17-0.46 c-0.08,0.02-0.25,0.07-0.37,0.09c0-0.03-0.01-0.06-0.05-0.08c0.06-0.01,0.11-0.02,0.16-0.06c-0.21-0.14-0.23-0.24-0.38-0.55 c-0.62-0.19-1.39-1.29-0.07-1.5c0.03,0.17-0.41-0.19-0.32-0.14c0.19-0.09,0.18-0.01,0.41-0.02c-0.44-0.24-0.84,0.07-1.14,0.37 c0.04-0.21,0.03-0.33,0.12-0.54c-0.21-0.14-0.11-0.18-0.23-0.45c0,0.09-0.14,0.09,0.02-0.12c-0.23-0.14-0.16-0.01-0.3-0.29 c-0.07,0.04-0.14,0.06-0.23,0.06c0.02-0.06,0.16-0.19,0.16-0.24c0.14,0.1-0.36-0.05-0.33-0.04c0.07-0.08,0.19-0.16,0.27-0.24 c-0.49-0.09-0.35-0.12-0.12-0.32c0.01-0.12-0.04-0.21,0.07-0.4c-0.89-0.13-0.23-1.11,0.13-1.14c-0.15-0.1-0.14-0.11-0.35-0.13 c0.43-0.01,0.91,0.04,1.39,0.02c-0.13-0.19-0.09-0.09-0.32-0.19c0.04-0.03,0.23-0.07,0.2-0.15c0.03-0.01-0.23-0.03-0.23-0.03 c-0.18,0.18-0.28,0.14-0.71,0.23c0.17-0.4,0.56-0.37,1.05-0.58c-0.09-0.14-0.02-0.18-0.03-0.45c0.21,0.03,0.13,0.09,0.35,0.11 c-0.02-0.03-0.01-0.26,0.01-0.27c-0.53-0.07-0.13-0.42,0-0.81c-0.39,0.05-2.5-0.32-2.33-0.8c0.19-0.51,1.86,0.36,2.17,0.42 c-0.13-0.11-0.13-0.17-0.35-0.31c0.42-0.04,0.07,0.01,0.09-0.17c0.07,0.02,0.15,0.04,0.22,0.06c-0.22-0.14-0.41-0.32-0.68-0.45 c0.09,0.03,0.19,0.06,0.29,0.09c-0.01-0.01-0.06-0.19,0-0.21c-0.04-0.02-0.38,0.04-0.45,0.04c0.06-0.06,0.27-0.19,0.3-0.27 c-0.16,0.05-0.35,0.14-0.49,0.22c0.13-0.14,0.21-0.23,0.36-0.36c-0.24,0.04-0.38,0.04-0.62,0.05c0.21-0.08,0.43-0.24,0.63-0.33 c-0.83-0.01-0.36,0.06-0.6-0.29c-0.05,0.04-0.11,0.08-0.16,0.12c-0.07-0.04-0.15-0.19-0.17-0.25C69.45,37.6,68.77,38.52,68.39,37.62 L68.39,37.62z M37.67,26.69c0.21,0.03,0.42,0.03,0.63,0.09c0.03-0.31-0.28-0.53-0.66-0.62c0.75-0.31,0.11-0.51-0.25-0.88 c0.5-0.21,0.55-0.72,1.1-0.46c0.19,0.09,0.15,0.87-0.03,1.03c0.57,0.18,0.46,0.01,0.34,0.45c0.59-0.19,0.2-0.22,0.63,0.15 c-0.12-0.79,0.78-0.51,0.78,0.2c0,0.46-0.73,1.22-1.26,0.68c-0.27,0.08-0.34,0.11-0.58,0.17c0.02-0.07,0.1-0.1,0.01-0.21 c-0.62,0.38-1.64,0.99-2.6,0.96c-1.73-0.05,1.25-1.09,1.31-1.21c-0.43,0.19-0.58,0.05-0.77,0.05c-0.18,0.06-0.09,0.09-0.2-0.03 c-0.23,0.3-0.19,0.17-0.67,0.36c0.09-0.24,0-0.35,0.28-0.61c-0.41,0.11-0.27,0.06-0.49,0.33c0-0.08-0.06-0.13-0.16-0.14 c0.03,0.29-0.01,0.24-0.15,0.48c-0.09-0.08-0.1-0.15-0.19-0.25c-0.17,0.16-0.15,0.03-0.23,0.27c-0.16-0.15-0.25-0.17-0.38-0.34 c-0.5,0.12-0.99,0.03-0.56-0.4c0.13-0.14,0.91-0.04,1.18-0.35c-0.37,0.19-0.71,0.17-1.13,0.24c0.25-0.23,0.44-0.42,0.85-0.54 c-0.17,0.05-0.35,0.09-0.53,0.13c-0.14-0.42,0.13-0.62,0.79-0.52c-0.09-0.05-0.74-0.4-0.17-0.45c1.24-0.12,0.34,0.17,0.85,0.33 c0.57,0.18,0.79,0.03,1.35,0.54c-0.12,0.09-0.17,0.06-0.25,0.16c0.08,0.02,0.32-0.03,0.39-0.04C36.78,26.66,37.09,26.79,37.67,26.69 L37.67,26.69z M114.29,67.51C114.17,67.38,114.17,67.39,114.29,67.51L114.29,67.51z M102.74,47.32 C102.81,47.28,102.91,47.23,102.74,47.32L102.74,47.32z M110.8,35.82c0.06,0.11,0.01,0.14,0.23,0.09 C110.57,36.08,110.54,35.98,110.8,35.82L110.8,35.82z M109.33,13.11c0,0.15,0.01,0.31,0.01,0.47c0.05-0.04,0.11,0.04,0.16,0.06 c-0.01,0.01,0.1-0.23,0.11-0.25c0.71,0.55,0.3,1.22,0.29,1.88c0.08-0.32,0.26-0.53,0.36-0.85c0.55,0.64,0.47,1.26,1.01,1.94 c0.91,1.12,0.77,0.1,0.08,1.03c-0.41,0.56-0.55,0.9-0.74,1.69c-0.07,0.34-0.17,1.38-0.7,1.52c-0.04,0.5-0.12,2.17-0.7,2.21 c-0.24-0.39-0.59-0.87-0.06-0.83c0.07-0.06,0.1-0.14,0.08-0.22c-1.08,0.03-1.45-1.54-1.01-1.21c0.32-0.04,0.33-0.13,0.79-0.04 c-0.11-0.05-0.46-0.38-0.64-0.46c0.48-0.22,0.82-0.35,1.18-0.36c-0.06-0.21-0.05-0.15-0.04-0.32c-0.35,0.14-0.97,0.41-1.22,0.36 c-0.43-0.09-0.88-0.72-0.27-0.49c0.15-0.32,0.49-0.59,0.8-0.68c0.14-0.39,0.52-0.49,0.98-0.59c-0.59,0.12-0.59-0.33-0.43-0.89 c-0.1,0.45-0.34,0.52-0.57,0.84c-0.06-0.36-0.2-0.73-0.09-1.14c-0.07,0.22-0.13,0.44-0.21,0.66c-0.07-0.09-0.08-0.3-0.17-0.37 c-0.03,0.42-0.12,0.61-0.04,1.01c-0.55,0.71-0.95,0.55-1.25-0.3c0.31-0.01,0.23-0.11,0.41-0.22c-0.58,0.04-0.96-0.29-0.69-0.79 c-0.13-0.11-0.27-0.2-0.35-0.37c0.15,0.05,0.41,0.1,0.58,0.2c-0.29-0.22-0.45-0.64-0.2-1.16c-0.27,0.21-0.06,0.01-0.38,0.01 c0.02,0.29,0.02,0.24-0.05,0.54c-0.15-0.46-0.19-0.44-0.19-0.71c0.01,0.02-0.06,0.09-0.06,0.08c0-0.68,0-0.62-0.02-1.21 c0.09,0.09,0.15,0.16,0.28,0.25c-0.04-0.6,0.05-0.25,0.2-0.66c0.09,0.14,0.12,0.33,0.21,0.48c-0.01-0.15,0.12,0.01,0.11-0.01 c-0.04-0.13-0.04-0.35-0.04-0.49c0.67,0.28,1.42,0.12,0.13,0.91c0.15-0.02,0.43-0.02,0.61-0.06c-0.12,0.23-0.1,0.3-0.07,0.56 c0.05-0.08,0.07-0.16,0.08-0.27c0.12,0.29,0.28,0.54,0.44,0.79c-0.31-0.6-0.23-1.26,0.12-1.8c0.62,0.39,0.58,1.33,0.54,2.01 c-0.03-0.04,0.44,0.52,0.59,0.69C108.9,15.63,108.54,13.1,109.33,13.11L109.33,13.11z M111.33,14.78c-0.35-0.56,0.18-0.35,0.57-0.19 c-0.02-0.02-0.04-0.14-0.04-0.14c-0.06-0.04-0.16-0.01-0.26-0.08c0.34-0.12,0.79-0.19,0.79-0.6c-0.7,0.11-1.6,0.46-1.93,0.2 c-0.21-0.45-0.12-0.72,0.2-0.92c-0.44-0.03-0.4-0.15-0.75-0.32c0.21-0.16,0.51-0.2,0.66-0.2c0.1,0.19,0.28,0.37,0.36,0.61 c0.07-0.17,0.14-0.4,0.14-0.4c-0.23-0.35-0.17-0.31-0.3-0.77c0.13,0.28,0.28,0.4,0.4,0.61c0.04-0.27,0.06-0.52,0.05-0.72 c-0.08-0.05-0.03,0.09-0.08-0.06c-0.03-0.06-0.03,0.14-0.07,0.12c-0.02-0.22,0.06-0.29,0.05-0.26c0.04-0.06-0.01-0.17,0.02-0.24 c0.2,0.41,0.44,0.57,0.61,1.03v-0.01c0.33-0.11,0.42,0.09,0.61-0.18c-0.07,0.16-0.07,0.36-0.18,0.57c-0.04-0.05,0.3,0.29,0.43,0.42 c0.01-0.05,0.02-0.1,0.08-0.07c-0.02-0.38-0.03-0.96-0.03-1.37c0.02,0,0.09,0,0.09-0.02c-0.03,0.04,0.03,0.23,0.05,0.29 c0.03-0.15,0.06-0.42,0.07-0.64c0.34,0.31,0.24,0.85,0.14,1.38c0.12-0.02,0.07-0.16,0.14-0.21c0.12,0.15-0.04,0.13,0.07-0.03 c0.04,0.03,0.04,0.25,0.1,0.25c0.04-0.24,0.1-0.34,0.1-0.57c0.16,0.12,0.1,0.1,0.14-0.03c0,0,0.1,0.11,0.12,0.12 c0.04-0.03-0.07-0.14-0.04-0.15c0.32-0.11,0.09,0.26,0.43-0.16c-0.09,0.28-0.08,0.47-0.22,0.74c0.22-0.28,0.31-0.23,0.51-0.41 c0,0.03-0.16,0.16-0.02,0.22c0.17-0.05,0.14-0.12,0.25,0.1c2.55-0.46-1.98,5.05-1.75,2.38c-0.16,0-0.57-0.04-0.68-0.03 C111.9,15.27,111.65,15.14,111.33,14.78L111.33,14.78z M127.52,36.78c0.23,0.02,0.89,0.35,0.81,0.27c0.08,0.15,0.1,0.29,0.1,0.45 c-0.23,0.17-1.08,0.49-1.1,0.49C127.17,37.51,127.35,37.21,127.52,36.78L127.52,36.78z M133.98,36.41c-0.23-0.1-0.34-0.22-0.59-0.39 c0,0,0.11,0.3,0.11,0.31c-0.17-0.25-0.29-0.52-0.38-0.8c0.06,0.05,0.12,0.06,0.19,0.02c-0.02-0.2-0.18-0.16,0.08-0.4 C133.79,35.6,134.47,36.12,133.98,36.41L133.98,36.41z M133.49,24.26c0.14,0.05,0.25,0.16,0.65-0.08c-0.04-0.07-0.25-0.07-0.24-0.04 c-0.06,0.02,0.5-0.29,0.41-0.21c-0.06,0.08-0.1,0.19-0.12,0.3c0.63-1.1,1.7-0.22,2.91-1.24c0.43-0.36,0.51-1.5,1.53-1.04 c0.83,0.38,0.23,1.37,0.06,1.86c-0.97,0.12-2.04,1.31-2.74,1.05c-0.27,0.52-1.25,1.63-1.76,1.44c0.11,0.48-0.01,0.83-0.54,0.71 c0.06,0.12,0.15,0.35,0.25,0.45c-0.19-0.12-0.31-0.17-0.48-0.22c0.01,0.05,0.01,0.33,0.1,0.28c-0.22,0.05,0,0.4-0.54-0.11 c0.32,0.57,0.23,0.93,0,1.16c-0.02-0.02-0.05-0.01-0.08,0.02c-0.13-0.15-0.2-0.33-0.32-0.53c0.01,0.14-0.01,0.36-0.16,0.39 c0.33,0.33,0.15,0.25,0.29,0.62c-0.21-0.14-0.29-0.11-0.57-0.19c0.35,0.32,0.21,0.31,0.32,0.59c-0.04-0.08-0.18-0.21-0.28-0.23 c0.51,1.3-0.87,0.42-1.55,0.62c0.21-0.24,0.25-0.42,0.55-0.68c-0.56,0.14-0.38,0.05-0.79-0.23c0.42-0.34,0.75-0.77,1.38-0.44 c-0.21-0.16-0.34-0.3-0.58-0.43c0.07-0.05,0.3,0.12,0.32-0.11c0.02-0.12-0.27-0.04-0.23-0.21c0.09-0.07,0.32-0.04,0.45-0.07 c-0.19-0.23-0.22-0.16-0.28-0.47c0.12,0,0.45-0.08,0.64-0.09c-0.19-0.08-0.43-0.18-0.6-0.22c0-0.07,0.19-0.23,0.18-0.34 c-0.04-0.04-0.16-0.27-0.2,0c-0.02-0.21,0.03-0.29,0.03-0.49C132.25,26.48,132.99,24.99,133.49,24.26L133.49,24.26z M133.91,11.89 c-1.4-0.36,0.79-2.18,1.21-1.68c0.33,0.39-0.31,1.01-0.38,1.11C134.43,11.73,134.73,12.22,133.91,11.89L133.91,11.89z M133.74,13.16 C133.6,14.11,132.64,12.99,133.74,13.16L133.74,13.16z M128.76,10.17c0.04-0.06-0.21,0.56-0.28,0.69c1.06-0.55,0.43,0.55-0.27,0.74 c0.41,0.57-0.21,0.57-0.72,0.41c0.25,0.39,0.23,0.58,0.03,0.85c-0.08,0.03-0.12-0.13-0.19-0.14c-0.03,0.11,0.05,0.28-0.02,0.36 c-0.16,0.09-0.03-0.13-0.12-0.13c-0.08,0.12-0.15,0.22-0.25,0.35c0.15-0.41,0-0.49,0.02-0.73c-0.17,0.11-0.27,0.12-0.43,0.2 c-0.23-0.35-0.14-0.89,0.42-0.85c-0.22-0.33-0.17-0.37-0.61-0.46c0.19-0.54,1.46-0.46,2-0.89c-0.08-0.13-0.22-0.28-0.27-0.32 c0.21-0.03,0.25-0.11,0.42-0.15c0,0.01-0.06,0.27-0.07,0.25C128.57,10.35,128.67,10.17,128.76,10.17L128.76,10.17z M145.22,10.25 C146.37,10.28,145.13,11.1,145.22,10.25L145.22,10.25z M150.91,9.1C152.34,8.44,151.48,10.29,150.91,9.1L150.91,9.1z M151.66,13.14 c-0.02-0.24,0.78-0.35,1.03,0.07c0.41,0.68-0.43,1.34-1,0.8c0.23,0.04,0.26,0.06,0.5,0.05C151.79,13.83,151.59,13.54,151.66,13.14 L151.66,13.14z M153.69,9.34c0.44-1.22,1.21,1.1,1.65,1.49c-0.41,0.31-0.33,0.94-0.32,0.93c-0.3,0.45-0.17,0.19-0.63,0.58 c-0.74,0.63-2.02,1.09-2.16-0.06c-0.39-0.02-0.15-0.07-0.51,0.04c0.12-0.44,0.37-0.46,0.43-0.66c0.02-0.06,0.25-0.99,0.19-0.91 C152.73,10.12,153.53,9.86,153.69,9.34L153.69,9.34z M153.51,13.2c0.14-0.14,0.25-0.06,0.2-0.32c0.15,0.01,1.18-0.37,1.44-0.19 c0.68,0.46,0.2,1.14-0.33,1.41c0.54-0.11,0.88-0.54,0.84-1.09c0.75,0.01,0.79,0.87,1.05,1.25c-0.28,0.32-0.4,0.79-0.36,1.29 c-0.13-0.06-0.23-0.16-0.36-0.2c1.34,2.18-1.66,1.78-1.86,0.45c-0.1,0.19-0.27,0.32-0.38,0.49c-0.53-0.62-0.35-1.49-0.93-1.65 c-0.16,0.1-0.03,0.15-0.15,0.28c-0.06-0.18-0.06-0.18-0.18-0.32C153.08,14.2,153.39,13.82,153.51,13.2L153.51,13.2z M156.62,19.18 c-0.13,0.03-0.13,0.17-0.35,0.08c-0.11-0.42,0.36-1.7,0.62-2.38c0.11,0.04,0.16,0.13,0.3,0.16c-0.33-0.78,0.13-1.17,0.37-1.82 c0.07,0.24,0.15,0.25,0.25,0.4c0.07-0.59,0.13-0.85,0.41-0.26c0-0.06,0.03-0.11,0.07-0.15c-0.04,0.25-0.01,0.69-0.06,1.02 c0.1-0.2,0.23-0.44,0.31-0.59c0.15,0.04,0.05,0.34,0.15,0.36c0.07-0.03,0.07-0.27,0.11-0.28c0.06,0.16,0.13,0.36,0.18,0.6 c-0.01,0.01,0.07-0.23,0.12-0.21C160.74,19.1,157.77,17.76,156.62,19.18L156.62,19.18z M179.23,31.52c0.12,0.02,0.31,0.01,0.42-0.01 c-0.02,0.13-0.07,0.29-0.13,0.41c0,0-0.03-0.19-0.01-0.19c-0.21,0.19-0.29,0.3-0.6,0.35c-0.05-0.04-0.1-0.08-0.13-0.14 C178.87,31.56,179.05,31.61,179.23,31.52L179.23,31.52z M182.8,25.15c0.35,0.32,0.9,0.44,1.31,0.51c0-0.01-0.2,0.16-0.21,0.17 c0.63-0.1,1.07,0.1,1.62,0.35C185.09,28.16,183.22,26.16,182.8,25.15L182.8,25.15z M177.04,25.42c-0.13,0.03-0.09,0.21-0.3,0.13 c0.01-0.33,0.05-0.78,0.14-1.08C177.08,24.87,177.04,25.07,177.04,25.42L177.04,25.42z M180.8,24.78c-0.7,0.07-0.18,1.44,0.54,1.76 c-0.47,0.23-0.97,0.42-0.83-0.13c-0.44,0.17-1,0.35-1.37,0.37c0-0.05-0.03-0.06-0.07-0.29c0.14,1.45-1.32-0.26-1.62-0.79 c0.16-0.13,0.14,0.04,0.34-0.06c-0.21-0.23-0.06-0.14-0.27-0.51c0.05-0.03,0.09,0.07,0.11,0.1c0.14-0.56,0.24-1.31,1.15-1.56 c0.08,0.18,0.65,1.25,0.69,1.26c0.8,0.19-0.17-1.04,0.75-0.77c-0.06-0.13-0.15-0.35-0.19-0.42c0.59,0.9,1.53,0.91,2.32,1.59 c-0.23,0.17-0.49,1.06-0.89,1.07C180.53,26.42,180.78,25.06,180.8,24.78L180.8,24.78z M159.14,92.34c-0.03-0.06-0.17,0.05-0.1-0.17 C159.22,92.15,159.09,92.24,159.14,92.34L159.14,92.34z M169.57,96.63c0.01,0.3-1.05,0.41-1.72,0.29 C168.3,96.42,168.96,96.97,169.57,96.63L169.57,96.63z M167.86,85.01C168.03,85.15,168.12,85.22,167.86,85.01L167.86,85.01z M168.99,83.44C168.98,83.42,169.15,83.81,168.99,83.44L168.99,83.44z M193.82,98.12C193.96,98.04,194.03,98,193.82,98.12 L193.82,98.12z M114.16,73.24c1.25-0.13,2.02,0.7,3.19,0.04c-0.08,0-0.14,0.04-0.17,0.1c0.42-0.06,0.52-0.04,0.96,0.03 c0.07-0.01-0.14-0.08-0.15-0.08c0.05,0.03-0.02,0.03-0.02,0.04c0.01,0.01,0.01,0.01,0,0.01c0.01,0.01,0.01,0.02-0.01,0.01 c0.04,0,0.17,0.07,0.21,0.15c-0.01-0.02,0-0.02,0.02-0.02c0.01-0.06-0.04,0.01-0.05-0.05c0.05,0.03,0.08,0.02,0.11,0.03 c0,0-0.05-0.15-0.08-0.09c0.59,1.37,0.75,3.27,2.03,4.71c-0.26,0.33,1.76,4.35,2.29,5.23c0.07-0.04-0.03-0.19,0.06-0.23 c0.57,0.48,2.55,1.67,1.55,2.36c0.58,0.1,0.86,0.45,1.48,0.52c0.7,0.08,1.15-0.53,1.68-0.13c0.87-0.46,1.75-1.12,1.72,0.21 c-1.23,1.64-1.88,3.45-3.63,4.9c-1.26,1.05-3.14,2.67-3.34,4.34c-0.11,0.97,0.77,2.07,0.93,2.98c0.32,1.97-0.13,2.51-1.53,3.59 c-0.56,0.44-1.5,0.85-1.72,1.5c-0.25,0.78,0.52,1.56,0.2,2.6c0.02-0.07,0.06-0.13,0.11-0.19c-0.25,0.8-1.19,0.72-1.67,1.33 c0.11,0.06,0.28,0.08,0.24,0.06c-0.2,2.48-2.57,3.96-4.07,5.22c-0.95-0.02-1.9,0.23-2.8,0.23c-0.49,0-1.28-0.03-1.32-0.02 c-0.4-1.12-0.05-1.82-0.83-3.15c-0.53-0.91-1.01-1.53-1.25-2.61c-0.25-1.12-0.31-2-0.88-3.04c-0.41-0.74-1.03-1.47-0.92-2.36 c0.05,0.01,0.07,0.04,0.06,0.09c0.09-1.98,1.52-2.8,0.91-4.69c-0.23-0.74-0.49-1.74-0.91-2.37c-0.6-0.89-2.08-1.55-1.38-2.67 c0.13,0.03,0.18,0.08,0.32,0.06c-0.74-0.62,0.34-1.88-0.91-2.66c-1.6,0.69-1.22-0.78-2.98-0.83c-0.85-0.03-1.31,0.45-2.06,0.64 c-0.91,0.23-1.6-0.02-2.57,0.09c-1.08,0.12-1.13,0.51-2.21,0.02c-0.46-0.21-1.02-0.79-1.33-1.06c-0.69-0.62-1.44-1.45-1.83-2.32 c-0.35-0.09-0.51-0.18-0.08-0.56c-0.7,0.25-1.18-0.12-1.01-0.86c-0.02,0.02,0.12,0.13,0.16,0.11c-0.77-0.85,0.22-3.1,0.06-4.24 c-0.1-0.66-0.52-0.77,0.2-1.87c0.57-0.85,0.9-1.98,1.65-2.64c0.67-0.58,1.44-0.68,1.89-1.61c0.11-0.22,0.06-0.83,0.23-1.16 c0.31-0.65,0.7-0.64,1.12-1.14c1.17-1.41,0.53-1.23,2.07-1.07c1.07,0.11,1.5-0.31,2.39-0.68c1.89-0.81,4.5-0.56,5.88-0.57 c-0.44,0.61,0.07,0.83-0.03,1.48c-0.1,0.65-0.71,0.24-0.47,0.87c0.12,0.34,2.48,1.01,2.89,1.22c0.41,0.21,1.17,0.81,1.68,0.81 c1.25,0.02,0.32-0.27,0.88-0.83C112.12,72.07,113.23,72.54,114.16,73.24L114.16,73.24z M120.34,89.43 c-0.07,0.49,0.09,0.93,0.43,1.22C120.65,90.24,120.5,89.78,120.34,89.43L120.34,89.43z M119.23,91.84c-1.02-0.09-1.54,0.47-1.2,1.68 c0.16-0.06,0.12-0.18,0.22-0.28c0.02,0.02,0.41,0.38,0.35,0.36c0.16-0.14,0.32-0.21,0.51-0.39c-0.05-0.05-0.21,0-0.26-0.07 c0.29-0.37,0.47-0.67,0.83-1.02C119.2,92.29,119.42,91.96,119.23,91.84L119.23,91.84z M108.22,84.71c0.72-0.62-1.9-1.38-0.33,0.19 C107.99,84.79,108.1,84.76,108.22,84.71L108.22,84.71z M117.28,96.57c0.11,0.17-0.04,0.26,0.24,0.36c0-0.88-0.65-2.13-0.95-3.05 C116.26,94.88,116.76,95.71,117.28,96.57L117.28,96.57z M119.53,98.21c-0.04-0.35,0.15-0.52-0.21-0.84 c0.09,0.84-0.42,2.41,0.58,2.83C119.43,99.53,119.83,98.78,119.53,98.21L119.53,98.21z M54.91,86.93c-0.38-0.85,1.2,0,1.5,0.56 c0.04-0.43,0.72-1.46,1.16-1.75c-0.04,0.03,1.8-0.76,1.66-0.78c0.66,0.09,0.04,0.64,0.02,1.24c-0.03,1.12,0.28,0.23,0.38,0.16 c0.2-0.14-0.23-0.88,0.78-0.86c-0.23-0.3,0.01-0.19-0.07-0.46c0.59,0.86,2.44,1.57,3.54,1c-0.09-0.03-0.23,0-0.32-0.03 c0.36-0.08,0.89-0.12,1.3-0.09c-0.18,0.03-0.36,0.09-0.57,0.12c0.38,0.33,1.44,0.57,1.14,1.14c0.64-0.08,1.27,0.22,1.38,0.97 c0.39,0.18,0.49,0.28,0.83,0.57c0.52-0.05,1.4-0.22,1.71,0.17c0.48-0.11,1.16,0.3,1.38,0.8c0.15,0,0.86,0.99,0.86,1.27 c0,0.6-0.74,1.02-0.7,1.69c0.5-0.33,0.9-0.77,1.67-0.52c-0.29,0.51-0.48,0.75-0.53,1.27c0.52-0.87,1.44-1.64,2.24-0.47 c0.43-0.06,0.33-0.12,0.37,0.21c0.06,0.23,0.23-0.06,0.11,0.39c1.27-0.78,3.41,0.52,4.45,1.34c0.52,0.41,0.72-0.1,0.97,0.82 c0.15,0.56,0.01,1.03-0.25,1.53c-0.38,0.7-1.13,1.23-1.58,1.95c-0.64,1.03-0.5,2.76-1.07,4.15c-0.25,0.62-0.74,1.61-1.21,1.88 c-0.56,0.32-1.12-0.17-1.36,0.23c-0.75,0.32-2.98,1.25-2.14,2.47c-0.07,1.06-1.54,2.58-2.3,3.52c-0.97,1.2-1.88,2.18-3.41,0.91 c0.41,0.83,1.17,1.45,0.72,2.43c-0.41,0.89-2.02,1.36-2.91,0.91c0.1,0.9-0.16,2.63-1.5,1.42c-0.23,0.56,0.08,1.53,0.38,1.14 c0.11,0.02,0.21-0.01,0.3-0.1c0.15,0.66-0.34,0.61-0.7,0.56c0.12,0.03,0.32,0.08,0.43,0.15c-0.71,0.37-0.37,1.09-0.7,1.56 c-0.43,0.61-1.21,0.1-1.02,1.31c0.09,0.59,0.88,0.18,0.93,0.78c0.04,0.48-0.38,0.44-0.57,0.82c-0.33,0.62-0.66,1.45-1.13,1.09 c0.08,0.39-0.07,0.75-0.41,1.15c0.03,0.17,0.03,0.32,0.01,0.48c0.23,0.19,0.37,0.47,0.58,0.7c-1.37-0.27-1.53,1.97-2.22,0.92 c0.83,0.06,0.61-0.95-0.27-0.72c0.25-0.4,0.18-0.75-0.25-1.02c0.09,0.14,0.24,0.16,0.32,0.32c-0.03-0.01-0.25-0.04-0.24-0.09 c-0.02,0.06-0.01,0.21-0.03,0.28c-0.05,0-0.11-0.32-0.14-0.37c0.02,0.1,0.03,0.34,0.06,0.43c-0.3-0.43-0.42-0.91-0.25-1.23 c-0.18-0.04-0.24,0-0.08-0.14c-0.44-0.42-0.35-0.52,0.04-0.85c-0.11-0.1-0.07-0.27,0-0.42c-0.17,0.07-0.09,0.19-0.2,0.3 c-0.14-0.62-0.07-0.58,0.21-0.74c-0.29-0.17-0.16-0.22-0.41-0.53c0.03,0.02,0.24,0.14,0.17,0.21c0.09-0.01,0.14-0.18,0.47-0.02 c-0.41-0.29-0.33-0.4-0.63-0.66c0.61-0.6-0.37-0.64-0.6-0.4c0.12-0.36,0.16-0.35,0.44-0.6c0.04-0.15-0.19-0.02-0.15-0.24 c0.6,0.12,0.38-0.05,0.51,0.43c0.02-0.01,0.2-0.09,0.17-0.15c0.02,0-0.01,0.2-0.01,0.23c0.14-0.19,0.21-0.31,0.32-0.55 c-0.02,0.03-0.15,0.28-0.18,0.28c0.05-0.28,0.07-0.19,0.2-0.35c-0.01-0.12-0.08-0.02,0.04-0.2c-0.01-0.03-0.2,0.05-0.2,0.07 c0.22-0.16,0.07-0.2,0.4-0.11c-0.07-0.09-0.18-0.1-0.32-0.17c0.37-0.32,0.31-1.73,0.41-2.35c0.09,0,0.14,0.05,0.13,0.16 c0.05-0.31-0.04-0.25-0.19-0.38c0.06-0.08,0.21-0.17,0.25-0.26c-1.17,0.45-0.89-2.07-0.74-3.05c0.06-0.44,0.66-1.23,0.89-1.98 c0.29-0.98,0.14-1.76,0.19-2.78c0.06-1.22,0.52-2.69,0.65-4.03c0.23-2.31,0.45-3.34-1.66-4.69c-1.71-1.1-1.99-2.41-2.88-4.19 c-0.42-0.85-1.53-1.59-1.48-2.37c0.05-0.72,0.95-0.89,0.74-1.53c-0.94,0.75-0.34-1.23-0.1-1.64c0.38-0.65,1.25-0.94,1.76-1.81 c-0.14-0.04-0.72-2.21-0.63-2.5C55.54,87.1,55.22,86.94,54.91,86.93L54.91,86.93z M70.93,109.69c-0.06,0.62-0.43,0.9-0.47,1.35 c0.34-0.22,0.77-0.84,0.88-1.13C70.94,110.1,71.12,109.77,70.93,109.69L70.93,109.69z M60.39,100.99c0.23,0.16,0.43,0.32,0.68,0.33 c-0.11-0.31-0.24-0.44-0.64-0.68C60.14,100.82,60.38,100.83,60.39,100.99L60.39,100.99z M49.95,82.98c0.63,0.02,1.81-0.37,2.39,0.08 c0.97,0.77-0.14,1.62,0.14,2.59c0.41,1.37,1.25,0.77,1.88,1.18c0.58,0.4,0.29-0.14,0.25,0.91c-0.66,0.22-0.84-0.48-1.63-0.36 c-0.13-0.16-0.1-0.21-0.28-0.35c0.03,0.04,0.05,0.08,0.06,0.13c-0.26-0.31-0.63-0.74-1.05-0.94c0.02-0.06,0.07,0.25,0.07,0.27 c-0.52-0.43-0.85-1.23-1.44-1.94c0.03-0.05,0.13,0.1,0.17,0c-0.58-0.34-1.86-0.36-2.68-0.83c-0.39-0.23-0.62-0.78-1.07-0.9 c-0.53-0.14-0.65,0.18-1.08,0.14c-1-0.09-1.94-0.55-2.87-0.93c-0.73-0.3-2.06-0.79-2.48-1.53c-0.18-0.33,0.13-0.75-0.1-1.33 c-0.15-0.39-0.55-0.79-0.84-1.08c-0.4-0.43-0.73-0.79-1.04-1.09c-0.45-0.7-2.26-3.58-3.45-4.03c0.36,1.34,1.06,2.38,1.88,3.49 c-0.05,0.02-0.07-0.17-0.06-0.17c0.25,0.38,1.09,1.64,1.13,1.82c0.25,1.23-0.87-0.34-1.37-0.51c0.17-0.57-0.15-1.03-0.51-1.39 c-0.4,0.03-0.82-0.21-1.05-0.55c0.16,0,0.34,0.01,0.47,0.02c0.13-0.62-0.61-1.11-0.95-1.61c-0.36-0.53-0.54-1.52-1.01-2.06 c-0.49-0.57-1.25-0.6-1.73-1.07c-0.48-0.47-0.85-1.41-1.05-2.03c0.02-0.01,0.17,0.2,0.23,0.21c0.01-0.31-0.29-0.25,0.06-0.42 c0,0-0.4,0.16-0.34,0.14c-1.07-0.84-1.6-6.07-0.38-6.31c-0.32-0.08-0.31-0.29-0.47-0.39c0.08,0.04,0.01,0.17,0.08,0.17 c-0.05-0.49-0.4-0.93-0.39-1.64c0.27,0.02,0.83,0.15,1.06,0.23c-0.07,0.15-0.1,0.46-0.18,0.62c0.08-0.05,0.07-0.12,0.04-0.09 c0.09-0.07,0.41-0.29,0.35-0.23c0.01-0.31,0.02-0.71,0.01-0.78c-0.1-0.12-0.3-0.25-0.43-0.34c0.05-0.09,0.22-0.04,0.25-0.07 c-0.38-0.21-0.17-0.07-0.38-0.47c0,0-0.14,0.24-0.15,0.25c-0.03-0.16-0.12-0.35-0.25-0.53c-0.28,0.23-0.31,0.18-0.39-0.34 c-0.31-0.03-0.61-0.14-1.03-0.13c0.08-0.06,0.22-0.05,0.3-0.1c0,0-0.27-0.14-0.27-0.15c0.01,0,0.11-0.01,0.12-0.04 c-0.46,0.04-0.83,0.02-0.7-0.36c0.01-0.11-0.19-0.01-0.19-0.07c0.08-0.04,0.19-0.04,0.27-0.09c-0.11-0.04-0.15-0.17-0.13-0.24 c0.04,0.03-0.17,0.13-0.18,0.13c0.08-0.85-0.95-1.55-1.2-2.44c-0.24-0.36-0.31-0.34-0.07-0.81c-0.16,0.1-0.44,0.21-0.49,0.24 c0.24-0.4,0-0.81-0.11-1.33c-0.24,0.25-0.38,0.27-0.54,0.6c0.1-0.25,0.08-0.44,0.28-0.71c-0.37-0.3-0.52-0.51-0.83-0.85 c0.02-0.07,0.13,0.14,0.16,0.14c-0.04-0.06-0.06-0.12-0.05-0.19c-0.17-0.05-0.22-0.04-0.39-0.12c-0.03-0.14,0.19,0.01,0.2-0.12 c-0.18-0.16-0.21-0.15-0.27-0.37c0.13,0.06,0.23,0.14,0.34,0.21c-0.21-0.33-0.1-0.29-0.11-0.43c-0.24-0.13-0.2,0.09-0.3,0.09 c0.04-0.09,0.04-0.19,0.1-0.32c-0.17,0.08-0.06,0.03-0.04-0.09c-0.13,0.05-0.07,0.09-0.17,0.18c-0.45-0.36-0.78-0.81-0.88-1.5 c0.03,0.36,0.11,0.83,0.12,1.29c-0.08-0.08-0.09-0.19-0.18-0.3c0.13,0.11-0.16,0.11-0.19,0.09c-0.01-0.21-0.08-0.36-0.12-0.56 c0,0-0.36-0.09-0.46-0.09c0.08,0.08-0.01,0.1-0.06,0.13c1.49,0.87-1.33,0.66-0.41-0.66c0.02,0-0.18-0.16-0.18-0.15 c0.01,0.25-0.14,0.3-0.33,0.55c-0.17-0.06-0.52-0.31-0.66-0.43c0.11-0.19,0.09-0.32,0.2-0.52c0.1,0.14,0.03,0.32,0.11,0.47 c0.01-0.07-0.04-0.36,0.12-0.34c-0.12-0.02-0.22-0.14-0.29-0.25c-0.45,0.51-2.75,0.19-3.11-0.47c-0.35,0.04-0.36-0.08-0.72-0.19 c0.05-0.06,0.09-0.12,0.14-0.18c-0.1,0.03-0.29,0.06-0.38,0.1c0.02-0.02,0.27-0.19,0.27-0.19c-0.01-0.03-0.18,0.1-0.25,0.04 c0.07-0.14,0.13-0.23,0.2-0.33c-0.58,0.11-0.43,0.03-0.76-0.03c-0.04,0.22-0.03,0.21-0.14,0.33c0.01-0.11,0.01-0.3,0.07-0.44 c-0.25,0.19-0.13,0.21-0.37,0.31c-0.01,0.04,0.01,0.05-0.11,0.24c0.05,0,0.07,0.03,0.04,0.08c0.06,0.01,0.16-0.02,0.18-0.01 c0,0.18-0.16,0.15-0.18,0.3c0.16,0,0.14-0.1,0.27-0.13c0.05,0.49-0.26,0.77-0.73,0.57c-0.04,0.13-0.03,0.31-0.09,0.44 c-0.03-0.09-0.05-0.19-0.06-0.28c-0.11,0.29-0.18,0.35-0.38,0.65c0.03-0.08,0.04-0.15,0.03-0.23c-0.38,0.39-0.49,0.25-0.9,0.36 c0.23-0.2,0.2-0.33,0.54-0.57c-0.65,0.21-0.32-1.72,1.1-1.28c-0.63-0.35-0.52-0.14-0.24-0.73c-0.9,0.68-0.54-0.3-0.43-0.92 c-0.15,0.94-0.82,2.18-1.62,2.34c0.27,0.51,0.15,0.11-0.09,0.49c-0.04,0.06-0.41,0.38-0.57,0.89c1.01,0.23-1.7,2.42-2.15,2.63 c0.13-0.03,0.12-0.03,0.09,0.07c-0.39-0.02-0.41,0.05-0.69-0.01c0.31,0.43,0.1,0.67-0.31,0.94c-0.05-0.06,0.06-0.2-0.03-0.28 c-0.41,0.29-0.57,0.23-1,0.46c0,0,0.06-0.2,0.03-0.25c-0.45,0.49-0.29,0.38-0.67,0.36c-0.17,0.24,0.09,0.32-0.3,0.15 c0,0-0.08,0.2-0.1,0.23c0.03-0.12,0-0.19-0.07-0.23c0.64-0.36,1.18-1.23,1.81-0.69c-0.2-0.57,1.45-1.67,1.67-2.58 c0.04-0.11,0.16-0.61,0.32-0.88c-0.41,0.45-0.79,0.67-0.96,0.11c-0.05,0.22-0.25,0.38-0.25,0.65c-0.02-0.01-0.03-0.01-0.04,0.01 c-0.47-0.42-0.61-0.46-0.73-0.96c-0.31,0.43-0.58,0.59-1.04,0.71c0.08-0.09,0.23-0.1,0.31-0.19c-0.08-0.15-0.1-0.12,0.01-0.31 c-0.16-0.32-0.73-1.46,0.05-1.97c-0.59,0.33-0.62,1.86-1.5,1.08C7,49.54,7.23,49.5,7.24,49.47c-0.58-0.07-0.39-0.61,0.01-1.01 c-0.33-0.02-0.47-0.2-0.47-0.2c-0.42-0.03-0.37,0.1-0.45-0.43c-0.07-0.05-0.12,0.16-0.28,0c0.02-0.17,0.15-0.11,0.19-0.21 c-0.03,0.01,0-0.1,0-0.1c-0.1,0.04-0.2,0.12-0.29,0.19c0.05-0.46,0.26-0.98,0.74-1.33c-0.28-1.15,1.01-0.31,1.47-1.1 c0.06,0.05-0.08,0.1-0.09,0.13c1.04-0.03,0.92-1.03,0.45-1.46c0.82-0.41-0.23-0.62-0.7,0.31c-0.09-0.2-0.32-0.34-0.39-0.44 c0.15,0.11,0.1,0.18,0.15,0.29c-0.79-0.45-2.1,0.32-2.11-1.14c0.07,0,0.14-0.03,0.38-0.04c-0.41,0.01-0.77-0.16-1.1-0.54 c0.03-0.04,0.07-0.06,0.12-0.07c-0.02,0.05-0.04,0.09-0.07,0.13c0.52-0.35,0.74-0.66,1.41-0.68c-0.04-0.44,0.46-0.67,1.07-0.66 c-0.13,0.15-0.04,0.28-0.26,0.57c0.48,0.23,0.83,0.14,1.29,0.34c0.08-0.06,0.12-0.34,0.18-0.44c0.03,0,0.35,0.17,0.23,0.2 c-0.18-0.12,0.01-0.29-0.4-0.22c-0.05-0.1-0.13-0.37-0.15-0.54c0.41,0.43,0.94,0.47,1.45,0.15c-0.11-0.1-0.3,0.08-0.38,0.07 c0.04-0.03,0.32-0.18,0.34-0.25c-0.39,0.02-0.73,0.02-0.94-0.01c-0.08,0-0.01,0.17-0.06,0.21c-0.04-0.4-0.27-0.15-0.1-0.6 c-0.25-0.16-0.28-0.1-0.55-0.01c-0.02,0.05,0.03-0.32,0.08-0.29c-0.11,0.12-0.2,0.07-0.27,0.28c-0.79-0.49-1.29-1.52-2.29-2.08 c-0.04-0.01,0.21-0.18,0.21-0.18c0,0.01-0.07,0.17-0.11,0.15c0,0,0.28-0.19,0.31-0.19c-0.02-0.07-0.05-0.36-0.05-0.59 c0.44,0.07,1.56,0.01,1.72-0.91c-0.09,0.05,0.1,0.12,0.1-0.3c0.04,0,0.18,0.11,0.23,0.11c-0.03-0.06-0.19-0.18-0.22-0.25 c0.07-0.06,0.31-0.03,0.39-0.05C8,36.2,7.76,36.24,7.7,36.19c0.55-0.16,0.05-0.3,0.7-0.14c-0.23-0.42-0.05-0.42-0.06-0.64 c-0.03-0.03-0.1,0.24-0.1,0.23c0.21-0.12,0.83-0.64,0.7-0.5c-0.02,0,0.41-0.22,0.39-0.21c-0.01,0.13-0.08,0.25-0.09,0.39 c0.11,0,0.11-0.04,0.14,0.14c0.05-0.36,0.13-0.23,0.28-0.44c-0.02-0.03-0.27-0.14-0.35-0.23c0.16-0.2,0.37-0.31,0.61-0.45 c-0.07,0.06-0.28,0.17-0.28,0.3c0.06,0.03,0.12,0.07,0.17,0.11c0.35-0.28,1.13-0.52,1.42-1.17c0.63,0.19,0.74,0.51,0.2,0.88 c0.27,0.14,0.38,0.15,0.6,0.19c-0.13-0.89,0.9-0.43,1.35-0.08c0.05-0.07,0.08-0.07,0.1,0c0.27,0.01,0.15-0.11,0.43,0.34 c-0.07,0-0.15,0-0.22,0.01c0.09,0.06,0.34,0.06,0.45,0.04c0,0.07-0.03,0.12-0.1,0.15c0.36,0.02,0.84,0.11,0.79,0.1 c0.97-0.4,3.01,0.61,3.85,0.64c0.36-0.21,0.85,0.2,1.25,0.61c0.97-0.56,1.96,1.53,2.67,1.1c0.25,0.16,0.59,0.3,0.81,0.45 c-0.2-0.21-0.36-0.42-0.54-0.6c-0.04,0.01,0.23,0.09,0.23,0.08c-0.03-0.07-0.23-0.19-0.19-0.31c0.03-0.02,0.06-0.05,0.07-0.09 c0.05,0.06,0.09,0.12,0.14,0.19c0.01-0.09-0.09-0.17-0.11-0.28c-0.12-0.05,0.49,0.18,0.15,0.11c-0.1-0.31,0.1-0.08,0.23-0.04 c0-0.1-0.21-0.14-0.23-0.23c0.11,0.01,0.5-0.08,0.64-0.09c-0.05-0.16-0.01-0.02-0.05-0.02c0.01-0.09,0.08-0.3,0.06-0.43 c0.23,0.17,0.27,0.21,0.38,0.28c-0.06,0.14-0.12,0.36-0.21,0.52c0.94-0.62,1.64-1.14,2.52-1.65c0.11,0.7-0.77,0.72-0.7,1.54 c0.18-0.54,0.64-0.87,1.13-1.09c-0.03,0.17-0.06,0.27-0.14,0.44c0.35-0.3,0.56-0.56,0.85-0.87c-0.26-0.31-0.11-0.29-0.21-0.53 c0.68,0.57,0.58,2.08,1.61,1.88c0.03,0.02-0.32-0.14-0.27-0.04c0.01-0.01,0.28-0.2,0.28-0.16c0-0.16-0.1-0.31-0.04-0.51 c-0.05,0.27,0.22-0.21,0.24-0.25c-0.13-0.02-0.09,0.11-0.18,0.08c0.15-0.18,0.03-0.21,0.28-0.03c0.01-0.08,0.05-0.11,0.12-0.1 c0.03,0.01-0.14-0.14-0.14-0.15c0.05-0.01,0.1-0.01,0.15-0.02c0.11,0.42,0.12,0.5,0.23,0.69c-0.09,0.12-0.35,0.49-0.25,0.39 c-0.02,0.05-0.03,0.11-0.02,0.16c1.01,0.09,0.67-0.9,1.96-0.51c0.97,0.3,1.89,1.15,2.87,1.36c-0.01-0.16-0.09-0.1-0.14-0.25 c0.66-0.07,1.19,0.53,1.27,1.06c-0.17-0.03-0.29,0.04-0.57,0c0.05-0.04-0.23,0.29-0.32,0.49c0.64,0.52,2.13,0.43,2.53,0.09 c-0.06,0.02,0.31-0.01,0.59-0.23c0.32,0.42,0.06,0.33,0.63,0.42c0.02,0.18,0.02,0.34,0.06,0.51c-0.01-0.08,0-0.08,0.02-0.01 c0.05-0.1,0.07-0.2,0.06-0.32c0.29,0.28,0.5,0.59,0.17,0.84c0.08,0.12,0.29,0.35,0.34,0.46c0.17-0.1,0.05-0.15,0.34-0.25 c-0.31-1.3-0.47-1.62,0.51-1.99c0.15-0.3,0.16-0.37,0.25-0.6c-0.25,0.12-0.37,0.14-0.52,0.25c0.15,0.23,0.08,0.05,0.06,0.34 c-0.28-0.15-0.31-0.02-0.71-0.03c0.01,0.07,0.17,0.12,0.16,0.17c-2.08,0.58,1.95-2.36,1.15-0.4c0.42,0.41,0.84,0.85,1.15,0.41 c0.61,1.14,1.89,0.52,2.96,0.63c-0.08-0.18-0.11-0.31-0.15-0.46c0.23,0.5,0.68,0.99,0.84,0.2c-0.21,0.08-0.21,0.01-0.43,0.17 c-0.24-0.37-0.29-0.45-0.43-0.87c0.12-0.02,0.36,0,0.55,0.03c0-0.01-0.16-0.25-0.17-0.23c0.22,0.06,0.12,0.11,0.34,0.2 c0.1-0.03,0.25,0.06,0.51,0.12c0,0.15-0.08,0.32-0.08,0.43c0.06-0.08,0.1-0.07,0.12,0.03c0.09-0.17,0.11-0.19,0.23-0.37 c-0.12,0.61-0.17,1.09,0,1.44c0,0,0.29-0.17,0.3-0.17c0.1,0.19-0.17,0.13,0.09,0.26c-0.08-0.46-0.04-0.85-0.15-1.27 c0.71,0.18,1.38-0.79,0.9-1.41c-0.01,0.03-0.04,0.25-0.04,0.27c0.05-0.02,0.09-0.06,0.11-0.11c-0.08,0.07-0.44,0.27-0.46,0.29 c0.09-0.5,0.19-0.72,0.52-1.08c-0.06-0.05-0.05,0.37-0.04,0.39c0.04-0.23,0.13-0.28,0.09-0.53c-1.38,0.21-2.12-2.08-1.29-3.17 c0.05,0.06,0.13,0.21,0.19,0.25c-0.13-0.72,0.55-1.85,0.69-0.78c0.25-0.17,0.1-0.03,0.4-0.13c0.36,0.98,0.57,1.66,0.94,2.56 c0.03,0.04,0.1-0.09,0.09-0.11c-0.02,0.06,0.15,0.3,0.2,0.36c-0.13-0.02-0.36-0.02-0.51-0.05c0,0.03,0.01,0.15-0.02,0.15 c-0.01,0.41,0.06,0.05-0.14,0.55c0.04,0.04,0.04,0.07,0.01,0.11c0.45,0.14,0.33,0.21,0.77,0.08c0.15,0.14-0.02,0.23,0.27,0.19 c0.03-0.02-0.06,0.36-0.05,0.34c-0.04,0-0.14-0.13-0.23-0.08c0.47,0.43,0.57,1.04,0.6,1.63c0.14-0.3,0.29-1.5,0.6-1.53 c0.46-0.05,0.79,1.33,0.7,1.61c-0.18-0.09,0.01-0.16-0.12-0.24c-0.23,0.62,0.08,1.3,0.51,1.77c0.52-0.39,0.65-2.36,1.49-2.32 c-0.07-0.41-0.07-0.03,0.03-0.34c-1.79-1.22,1.25-1.79,1.11-0.75c0.45,0.25,0.9,0.46,0.43,0.96c0.37,0.36,0.41,0.19,0.03,0.71 c-0.21-0.09-0.13-0.1-0.36-0.19c0.01,0.05-0.01,0.07-0.05,0.08c0.19,0.26,0.09,0.26,0.17,0.48c0.06-0.04,0.12-0.07,0.19-0.1 c-0.05,0.91,0.44,1.01,0.1,1.79c-0.28,0.62-0.84,1.15-1.25,0.45c-0.01,0.03-0.04,0.05-0.06,0.06c0.1,0.2,0.13,0.47,0.21,0.68 c-0.08-0.02-0.33-0.23-0.43-0.3c-0.01,0.08-0.01,0.16,0.01,0.25c-0.33-0.3-0.3,0-0.48-0.52c-1.27-0.01-0.11,0.33-0.61,1.11 c-0.8,1.24-1.22-0.35-2.12-0.05c0.5,0.62,1.13,0.78,1.85,0.83c-0.33,0.74-0.72,1.79-1.47,1.55c-0.04-0.02-0.2-0.12-0.23-0.13 c0.11,1.12-1.16,0.58-2.02,0.09c0,0.01-0.07,0.16-0.09,0.16c-0.08-0.01,0.39,0.08,0.18-0.01c0.27,0.21,0.41,0.27,0.66,0.28 c0.09,0.06-0.12,0.1-0.09,0.19c0.95-0.36,1.4,1.3-0.09,0.95c0.1,0.19,0.09,0.17,0.25,0.3c-0.44,0.37-0.14,0.01-0.34,0.64 c-0.52-0.11-0.38,0.55-1.14,0.83c0.42,0.81-0.44,2.33,0.15,3.23c0.75-1.04,1.14,1.13,0.85,1.67c0.85-0.35,1.55-0.15,2.51,0.43 c0.53,0.33,1.89,0.98,1.52,1.69c0.34-0.63,1.62-0.57,1.93-0.14c0.52,0.72-0.35,1.8,0.49,2.56c-0.18,0.03-0.25,0.1-0.4,0.19 c0.65-0.12,1.17,0.38,0.57,0.95c0.51-0.1,0.31-0.06,0.77-0.04c0.09-0.53,0.11-0.61,0.44-0.17c-0.03-0.2,0.17-0.15-0.03-0.53 c0.28-0.11,0.32-0.28,0.63-0.36c-0.87-0.25-0.32-1.58-1.02-2.2c0.53-0.25,1-0.58,1.39-1.03c-0.05,0.08-0.12,0.14-0.2,0.18 c0.35-0.45,0.37-0.6,0.77-0.76c0,0-0.09-0.34-0.12-0.41c-0.04,0.07-0.06,0.27-0.13,0.31c-0.08-0.84-0.61-1.66-0.77-2.21 c-0.27-1.02-0.2-0.47,0.17-1.37c0.17-0.01,0.19,0.11,0.39,0.04c-0.2-0.29-0.17-0.09-0.07-0.44c-0.06-0.02-0.19,0.06-0.31,0.01 c0.05-0.25,0-0.61,0.13-0.86c-0.52-0.15-0.27-0.67-0.07-1.18c-0.18-0.18-0.25-0.52-0.02-1.03c0.23,0.04,0.87,0.21,1.19,0.39 c-0.05,0.04-0.09,0.09-0.14,0.13c0.45-0.02,0.3-0.07,0.74,0.06c0.17-0.58,1.07-0.31,1.01,0.32c0.06-0.06,0.09-0.04,0.09,0.05 c0,0-0.04-0.19,0.02-0.17c0.27,0.25,0.15,0.29,0.23,0.43c0.01,0,0.21-0.12,0.11-0.13c-0.01-0.07,0.25,0.17,0.23,0.16 c-0.05,0.07-0.13,0.04-0.19,0.16c0.19,0.28,0.57,0.5,0.97,0.4c0.04,0.01,0.01,0.25,0.02,0.25c0.15-0.08,0.16-0.15,0.27-0.21 c0.04,0.4,0.07,0.68,0.13,1.11c-0.31,0.02-0.69,0.14-1.04,0.04c0.63-0.03,1.15,0.15,0.9,0.8c0.04,0.03,0.26-0.04,0.26,0.04 c-0.06,0.28-0.13,0.11-0.02,0.36c-0.16-0.03-0.22,0-0.44-0.01c-0.06,0.07-0.28,0.38-0.45,0.6c1.01-0.84,2.15,0.18,0.87,0.65 c0.46-0.33,0.48-0.36,0.77-0.83c-0.05,0.4,0.07,0.08,0.11,0.55c0.26-0.35,0.51-0.44,0.74-0.81c0.17,0.3,0.15,0.07,0.2,0.44 c0.05-0.31,0.13-0.23-0.04-0.52c0.29-0.1,0.14-0.01,0.24-0.42c0.62-1.05,0.57-1.31,0.99-0.1c0.19,0.11,0.16,0.09,0.35,0.16 c-0.09,0.04-0.36,0.23-0.5,0.3c0.17-0.06,0.39-0.06,0.59-0.1c0,0.34,0.1,0.19,0.2,0.46c-0.11,0.02-0.32,0.12-0.4,0.16 c0.15,0.03,0.36,0.01,0.52,0.01c-0.15,0.25-0.1,0.19-0.34,0.49c0.12-0.03,0.25-0.08,0.37-0.14c0.14,0.14-0.06,0.25-0.01,0.3 c0.27,0.29,0.43,0.04,0.09,0.49c0.57,0.1,0.74,0.71,0.03,0.61c-0.1,0.1,0.12,0.13,0.12,0.13c-0.13-0.01-0.29,0.06-0.42,0.06 c0.21,0.01,0.43,0.03,0.63,0.05c-0.06,0.19-0.02,0.2-0.09,0.4c0.38,0.15,0.17,0.11,0.36,0.3c0.54,0.18,0.56,0.1,0.49,0.63 c0.53,0.17,0.28-0.21,0.42,0.37c0.1-0.08,0.22-0.21,0.31-0.32c0.26,0.33,0.26,0.21,0.63,0.25c0.14,0.11,0.16,0.27,0.36,0.38 c-0.31,0.19-0.8,0.42-1.21,0.56c0.14-0.05,0.35-0.08,0.48-0.12c-0.46,0.33-0.87,0.44-1.35,0.31c0.06,0.08,0.36,0.44,0.43,0.51 c0.43-0.39,0.9-0.77,1.47-0.78c-0.11-0.11-0.29-0.06-0.41-0.04c0.66-0.21,0.83,0.09,0.65,0.69c0.41-0.5,0.74-0.31,0.9,0.22 c-0.17,0.07-0.17-0.04-0.34-0.01c0.28,0.35,0.16,0.36,0.17,0.58c0.14,0.08,0.13,0.02,0.21,0.17c-0.08,0-0.15-0.01-0.23-0.04 c0.2,0.56-2.2,1.83-2.34,1.79c-0.93,0.61-2.48-0.15-3.55,0.28c-1.14,0.46-1.65,1.97-2.67,2.76c0.89-0.43,2.61-3.21,3.92-1.63 c-0.07,0.43-0.73,0.68-1.33,0.66c0.63,0.01,1.2,0.08,0.73,0.75c0.29,0.62,1,1.37,1.88,1.02c0.15,0.09,0.44,0.33,0.54,0.46 c-0.51,0.21-1.2,0.47-1.44,0.67c-0.23-0.08-1.76,1.57-1.32-0.08c-0.04,0.06-0.09,0.1-0.16,0.13c0.42-0.53,1.06-0.65,1.59-0.79 c-0.28,0.04-0.54,0.03-0.82,0.06c0.05-0.08,0.18-0.25,0.24-0.39c-0.03,0.02-0.16,0.02-0.11-0.07c-0.37,0.44-0.87,0.67-1.43,0.59 c-0.02,0.53-0.56,0.74-0.96,0.53c-0.04,0.07-2.09,2.51-0.71,1.96c-0.28,0.34-0.29,0.25-0.7,0.19c-0.45,0.4-1.13,0.29-1.58,0.71 c-0.22,0.21-0.02,0.89-0.47,1.33c-0.1-0.14-0.24-0.27-0.37-0.46c0.34,0.57,0.21,1.22-0.18,1.75c0.05-0.68-0.41-1.11-0.09-1.73 c-0.32,0.36-0.39,0.67-0.2,1.06c-0.09-0.08-0.16-0.11-0.25-0.18c-0.01,0.02-0.03,0.02-0.06,0c0.33,0.33,0.45,0.71,0.21,0.97 c0.33,0.21,0.21,0.25,0.41,0.65c-0.18-0.04-0.34-0.05-0.49-0.13c-0.02,0.08-0.02,0.15,0,0.23c0.33,0.01,0.18,0.06,0.37,0.15 c0.02-0.07,0.06-0.12,0.11-0.17c-0.23,0.3-0.04,0.25-0.35,0.3c0,0.09-0.17,0.07-0.2,0.07c0.21,0.2,0.12,0.07,0.07,0.33 c0.01-0.08,0.12-0.06,0.16-0.03c-0.95,0.68-2.71,1.49-2.88,2.61c-0.12,0.87,1.35,2.91,0.61,3.64c-0.54,0.54-1.2-1.19-1.27-1.6 c0.01-0.11-0.08,0.12-0.11,0.08c0.19-1.09-0.49-1.12-1.01-1.36c-0.22-0.1-1.32-0.42-1.39-0.42c-0.11,0-0.41,0.15-0.52,0.21 c0.04-0.12,0-0.32-0.04-0.45c-0.29,0.52-0.91,0.38-1.37,0.49c0.25-0.03,0.39,0.04,0.63,0.05c0.03,0.22,0.05,0.42,0.07,0.63 c-0.03,0.03-0.07,0.04-0.1,0.05c-0.56-0.28-2.11-0.77-3.04-0.28c0.06-0.08,0.05-0.08-0.01-0.21c-0.13,0.5-0.24,0.63-0.74,0.9 c0.04-0.08,0.23-0.08,0.24-0.16c-0.28-0.04-0.27,0.06-0.46,0.01c-0.2,0.23-0.48,0.65-0.58,0.91c0.06,0.25,0.13,0.74,0.2,1.05 c0.04-0.01,0.07-0.12,0.08-0.1c-0.89,0.71-0.31,3.34,0.64,4.08c0.57,0.46,0.95,0.38,1.66,0.3c1.38-0.16,0.53-0.56,1.42-1.42 c0.53-0.52,1.81-0.64,2.03-0.07c0.02,0.06-0.53,1.55-0.6,1.79c-0.06-0.21-0.1-0.35-0.14-0.49c-0.08,0.52,0.04,1.18-0.41,1.74 c0.05,0.02,0.16,0.05,0.15,0.12C49.78,82.79,49.81,83.01,49.95,82.98L49.95,82.98z M57.09,63.89c-0.21,0.07-0.62,0.33-0.88,0.35 c0.03-0.06,0.12,0.14,0.13,0.16c-0.56-0.15-1.2-0.01-1.58,0.48C56.2,64.76,56.61,64.92,57.09,63.89L57.09,63.89z M53.2,65.39 c-0.04,0.08-0.25-0.01-0.18,0.22C53.38,65.68,53.15,65.52,53.2,65.39L53.2,65.39z M35.93,66.06c0.43,1.21,0.92,0.28,0.35,0.32 C36.18,66.14,36.1,66.09,35.93,66.06L35.93,66.06z M44.47,55.37c-0.09-0.04-0.12-0.14-0.33-0.02c0.09,0.06,0.23,0.08,0.29,0.11 c0.02,0.25-0.04,0.28,0.09,0.5c-0.73-0.25-0.88,0.3-0.31,0.61c-0.14,0.38,0.03,0.75,0.37,1.09c0.06-0.02,0.09-0.2,0.14-0.23 c0.11,0.16,0.14,0.39,0.22,0.61c0.03-0.02,0.13-0.3,0.18-0.25c0.08,0.21,0.04,0.23,0.03,0.5c0-0.01,0.14-0.03,0.11-0.09 c-0.1,0.33-0.1,0.46-0.12,0.82c0.88-0.54-0.62-2.44-0.43-3.32c-0.15-0.03-0.09,0-0.28-0.01C44.6,55.45,44.53,55.44,44.47,55.37 L44.47,55.37z M54.82,65.19c-0.86,0.14-1.4,0.61-2.12,0.88c0.74,0.47,2.16-0.28,2.58-0.91C55.2,65.22,55.01,65.19,54.82,65.19 L54.82,65.19z M54.7,63.55c-0.28-1.21-1.81-0.67-2.5-1.32l-0.02,0.04c0.08,0.17,0.11,0.3,0.24,0.46c-0.53-0.02-0.93-0.05-1.52,0.3 c0-0.07,0-0.13,0.01-0.2c-0.33,0.28-0.6,0.62-0.77,1.05c0.19-0.22,0.32-0.34,0.49-0.57c-0.12,0.38-0.89,3.26,0.16,2.67 c0.73-0.42-0.04-1.91,0.63-2.56c0.04-0.01,0.02,0.21,0.05,0.22c0.27-1.32,1.85-0.28,0.98,0.91c0.47-0.42,0.74-0.22,0.82,0.48 c0.48-0.35,0.62-1.14,0.47-1.74c0.04,0.06,0.38,0.28,0.35,0.24c0.04,0.1,0,0.18,0.04,0.3C54.57,63.87,54.69,63.76,54.7,63.55 L54.7,63.55z M49.04,61.17c-0.45,0.27-0.87,0.59-1.23,0.98c0.18-0.04,0.39-0.06,0.64-0.19c0,0.01,0.13,0.31,0.05,0.3 c0.62-0.06,1.15-0.51,1.73-0.74c-0.2,0.15-0.28,0.42-0.4,0.59c0.67,0.19,1.72-0.1,2.29,0.21c-0.09-0.34-0.16-0.77-0.26-1.25 c-0.59-0.03-0.78-0.39-1.23-0.67c0,0.13,0,0.27,0,0.41c-0.31-0.67-0.57-0.67-0.81-0.1c0-0.04,0.02-0.31,0.04-0.33 c-0.07,0.14-0.09,0.33-0.23,0.4c-0.03-0.06-0.03-0.13-0.02-0.2C49.47,60.89,49.3,61,49.04,61.17L49.04,61.17z M37.68,50.6 c0.7-0.22,1.34-0.37,2.04-0.39c-0.59-0.15-0.82-0.2-1.39-0.07c-0.01-0.03,0.07-0.22,0.12-0.19c-0.05-0.14-0.23,0.05-0.3,0.03 c0.12-0.2,0.15-0.27,0.36-0.43c-0.2-0.03-0.37,0.02-0.54,0.03c-0.05,0.27-0.61,0.95-1,1.25C37.47,51.03,37.44,50.79,37.68,50.6 L37.68,50.6z M37.73,46.54c-0.04-0.03-0.19-0.17-0.29-0.21c0.01,0.05,0.18-0.05,0.17-0.04c0,0.01-0.25-0.05-0.27-0.06 c0.27,0.07,0.42,0.09,0.62,0.21c0-0.01,0.18-0.17,0.2-0.17c-1.08-0.93-2.18,1.4-2.49,0.41c-0.25,0-0.35,0.05-0.54-0.58 c0.04,0.95-0.57,0.24-0.72-0.25c-0.14,0.03-0.24,0.05-0.39,0.05c0.28,0.43,0.66,0.79,0.77,1.09c0.13,0.05,0.23,0.04,0.33,0.11 c-0.23,0.12-0.07,0.02-0.06,0.23c-0.45,0.12-0.36,0.21-0.67,0.44c-0.03,0.1,0.03,0.12-0.01,0.29c-0.63-0.09-1.01-0.37-1.63-0.17 c-0.06,0.01,0.36,0.11,0.34,0.09c0.16-0.09,1.3,0.46,2.04,0.29c0.72-0.16,1.62-1.05,1.96-1.75C37.34,46.6,37.47,46.49,37.73,46.54 L37.73,46.54z M32.03,40.53c-0.79,0.58-3.02,0.86-2.78,1.56c0.21-0.35,0.57-0.39,0.97-0.17c0,0,0.11-0.29,0.05-0.25 c0.53,0,0.81,0.11,0.99,0.42c-0.16-0.05-0.5-0.04-0.68-0.08c0.21,0.45-0.03,0.87-0.53,1.13c0.78,0.76,0.81-0.35,1.25-0.35 c0.77-0.01,0.27,0.42-0.03,0.9c0.37-0.32,0.78-0.61,1.05-0.78c-0.44-0.74,0.38-0.52,0.9-0.55c-0.14-0.01-0.21,0.09-0.34,0.07 c0.29-0.4,0.47-0.7,0.58-1.16c-0.01-0.01-0.1,0.15-0.15,0.11c0.01-0.11,0.1-0.22,0.07-0.32c-0.42,0.49-1.07,0.62-1.62,0.31 c0.19-0.1,0.48-0.47,0.78-0.61C32.34,40.67,32.17,40.56,32.03,40.53L32.03,40.53z M51.96,85.69c-0.18-0.24-0.31-0.46-0.61-0.6 C51.31,85.65,51.59,85.57,51.96,85.69L51.96,85.69z M-1.97,34.22c-0.06-0.31,0-0.68,0-0.99C-0.61,32.94-0.38,34.78-1.97,34.22 L-1.97,34.22z M-1.97,37.64c0.29,0.18,1.07,0.72,0.91,0.62c0.17,0.2,0.1,0.2,0.17,0.41c0.51,0.08,0.48,0.1,0.58,0.46 c0.17,0.07,0.35,0.07,0.52,0.14c0.04,0.17-0.16,0.13-0.18,0.25c0.18,0.13,0.43,0.2,0.59,0.37c-0.09-0.15-0.21-0.29-0.3-0.47 c0.29,0.18,0.43,0.36,0.63,0.66c0.01-0.08-0.02-0.14-0.09-0.19c0.08,0.68,0.32,1.2,0.54,1.6c0.01-0.07,0.05-0.1,0.11-0.08 c-0.06-0.5-0.17-0.88-0.42-0.96c0.21-0.08,0.27-0.06,0.42,0.07c0.02,0,0.07-0.19,0.03-0.19c0.02,0.05,0.2,0.13,0.29,0.15 C1.8,40.35,1.8,40.8,1.8,40.78c0.09-0.1,0-0.12,0.04-0.23c0.13-0.01,0.23,0.16,0.42,0.14c0.01-0.08-0.16-0.19-0.18-0.14 c0.72-0.01,1,0.66,1.29,1.12c0.22,0,0.18,0.07,0.49,0.12c-0.21,0.25-0.32,0.4-0.52,0.7c-0.15-0.1-0.27-0.18-0.42-0.33 c0.06,0.17,0.03,0.25,0.19,0.44C2.62,42.69,2.54,42.86,2.18,43c0.04,0.05,0.26,0.18,0.34,0.26c-0.32,0.14-0.29,0.19-0.58,0.35 c0.19,0.13,0.07,0.16,0.42,0.48c-0.18,0.09-0.2-0.1-0.41-0.08c0,0.15,0.2,0.14-0.03,0.33c-0.02-0.1-0.12-0.27-0.12-0.45 c-0.25,0.62-0.65-0.08-0.74-0.54c-0.11,0.34-0.06,0.09-0.17,0.16c-0.22,0.2,0.03,0.07,0.01,0.17c-0.56-0.26-0.56-0.82-1.01-1.14 c-0.48-0.35-1.06,0.43-1.29-0.66c0.15-0.14,0.1-0.17,0.24-0.41c-0.07,0.03-0.17,0.2-0.22,0.28c-0.09-0.07-0.13-0.15-0.14-0.25 c0,0.12-0.04,0.13-0.11,0.02c-0.21,0.16,0.03,0.17-0.32,0.29c0.32,0.47,0.44,1-0.04,1.44c0-1.84,0-3.68,0-5.52 C-1.97,37.66-1.97,37.65-1.97,37.64L-1.97,37.64z M201.9,33.23C202.26,35.08,200.06,34.11,201.9,33.23L201.9,33.23z M99.96,59.95 c0.08-0.08,0.28-0.11,0.37-0.14c-0.01-0.02-0.24-0.08-0.21-0.08c1.1-0.4,0.94-1.54,2.32-1.6c0.02-0.02-0.25-0.05-0.27-0.05 c0.09-0.02,0.51-0.19,0.6-0.27c-0.57-0.1-0.37-0.62,0.04-1.14c0.07,1.41,0.28-1.09,1.41-0.23c-0.38-0.71,0.47-0.43,0.64-0.12 c0.14-0.39,0.05-0.27,0.25-0.54c-0.18-0.37-0.19-0.53-0.23-1.02c-0.54-1.45-0.18-1.73,0.98-2.85c-0.04,0.53-0.13,1.06-0.15,1.31 c0.67,0.02-0.53,0.74-0.27,1.56c-0.01,0.03-0.14-0.07-0.15,0.05c0.21,0.35,0.43,0.49,0.9,0.48c-0.06,0.17-0.11,0.24-0.12,0.43 c0.43-0.13,0.69-0.27,1.07-0.53c-0.03-0.04-0.17,0.14-0.18,0.17c0.46-0.02,0.81,0.23,1.18,0.57c0-0.01-0.09-0.3-0.1-0.18 c0.69-0.28,1.74-1.2,2.56-0.79c-0.1,0.13-0.14-0.1-0.2-0.05c0.48,0.86,1.27-0.32,1.52-0.96c-0.08,0.25-0.16,0.55-0.23,0.74 c0.03-0.02,0.28,0.04,0.28,0.03c0.02-0.37,0.07-0.62-0.06-1c0.01,0.08,0.01,0.16,0.02,0.24c-0.25-0.98,0.71-2.83,1.16-1.68 c0.21,0.28,0.32,0.34,0.55,0.4c0.1-0.48,0.17-1,0.21-1.51c-0.54,0.03-0.4-0.04-0.43-0.42c-0.8-1.11,2.31-0.75,2.44-1.11 c0.3-0.1,0.78-0.2,1.25-0.19c-0.36-0.13-0.76-0.38-1.01-0.69c0.05,0.01,0.08,0.04,0.09,0.09c-0.02-0.03,0-0.28,0.01-0.31 c-0.69,0.38-2.45,0.89-3,0.77c-0.12,0.15-0.1,0.18-0.27,0.24c0.07-0.25-0.03-0.22-0.04-0.57c-0.78-0.07-1.03-0.68-0.73-1.34 c-0.33-1.38,0.68-3.92,2.18-4.16c0.16-0.51-0.22-1.24-0.74-1.49c0.1-0.07-0.08,0.25-0.06,0.23c-0.44-0.14-0.62-0.06-0.86-0.18 c-0.07,0.16-0.07,0.23-0.09,0.4c-0.01,0-0.2-0.17-0.21-0.16c-0.07,0.46-0.53,1.21-0.29,1.92c0.02-0.05,0.02-0.11,0-0.16 c-0.47,1.02-1.26,1.2-1.85,1.82c-0.06,0.21,0.08,0.19-0.22,0.09c-0.11,0.56,0.01,0.27-0.27,0.49c0.08,0.37-0.03,0.66,0.04,1.05 c-0.05-0.03-0.1-0.06-0.15-0.09c-0.04,0.79,0.39,1.51-0.51,1.84c0.25-0.19,0.45-0.28,0.7-0.56c1.51,0.78,0.23,1.22-0.65,1.31 c0.45,0.2,0.73,0.25,1.25,0.11c-0.21,0.28-0.33,0.33-0.57,0.36c-0.35,0.24-0.32,0.31-0.79,0.47c0.14,0.02,0.27,0.11,0.39,0.13 c-0.04,0.07-0.2,0.09-0.25,0.04c0.19,0.41,0.25,1.31-0.08,1.91c-0.25,0.45-1.38,1.41-1.93,1.28c-0.23-1.02-0.43-2.18-0.74-3.11 c0.01,0.02-0.04,0.14-0.08,0.15c0-0.71-0.34-1.18-0.41-1.76c0,0-0.08,0.05-0.08,0.03c-0.03,0.1-0.03,0.32-0.04,0.37 c0.01,0.02-0.05-0.24-0.08-0.2c0.17,0.64-0.01,0.49-0.38,0.7c-0.36,0.91-1.12,1.12-1.63,1.08c0.03-0.1,0.03-0.2,0.02-0.32 c-0.48-0.03-0.57-0.1-0.62-0.68c0.22-0.12,0.29-0.26,0.37-0.6c-0.31,0.15-0.34,0.12-0.52,0.25c0.16-0.17,0.23-0.43,0.55-0.6 c0.03,0.02-0.33,0.01-0.33,0.01c0.21-0.33,0.47-0.51,0.51-0.54c0.03-0.17,0.04-0.15,0.2-0.25c-0.45,0.05-0.54,0.25-0.85,0.71 c-0.02-0.04,0.01-0.28,0.03-0.41c-0.03,0.05-0.08,0.09-0.13,0.12c0.04-0.34,0.02-0.24,0.21-0.58c-0.42,0-0.1,0.13-0.39-0.12 c-0.01-0.08,0.16,0.1,0.18,0.07c-0.26-0.55,0.57-0.5,0.9-0.17c0.12-0.11,0.32-0.24,0.43-0.44c-0.02-0.1-0.17,0.06-0.18,0.02 c0.05-0.06,0.08-0.31,0.07-0.38c-0.42,0.64-0.15,0.28-0.5,0.16c-0.75,0.8-1.14-0.28-0.45-0.57c-0.01,0-0.27-0.01-0.05-0.1 c-0.05,0-0.23,0.05-0.28,0.07c0.01-0.03,0-0.28,0-0.28c0.08-0.02,0.12,0.12,0.25,0.13c0.09-0.17,0.03-0.28,0.2-0.46 c0.01,0.03,0.02,0.06,0.05,0.07c-0.07,0.28-0.03,0.1,0.05,0.33c-0.02-0.41-0.13,0,0.09-0.36c0.04,0.08,0.07,0.16,0.11,0.25 c0.06-0.04-0.09-0.19-0.08-0.25c0.24,0.04,0.19,0.02,0.4,0.12c-0.15-0.04-0.43-0.26-0.62-0.32c0.06-0.02,0.28-0.17,0.5-0.25 c0.02,0.01,0.05,0.13,0.28,0.22c-0.08-0.05-0.1-0.17,0.03-0.23c-0.22,0-0.23,0.03-0.41-0.05c0.06-0.06,0.11-0.08,0.19-0.02 c0.31-0.43,0.63-0.54,1.14-0.88c0.01,0,0.01,0.2,0.06,0.21c0.18-0.35,0.09-0.39,0.41-0.07c0.25-0.14,0.56-0.28,0.84-0.6 c-0.44,0.35-0.78,0.41-0.97,0.1c0.27-0.64,0.79-1.04,1.15-1.34c-0.1-0.09-0.11,0.09-0.23,0.06c0.28-0.33,0.4-0.58,0.57-0.8 c-0.12,0.04,0,0.11-0.15,0.09c0.08-0.07,0.16-0.23,0.12-0.36c0.08,0.07,0.1,0.18,0.21,0.25c-0.07-0.58,0.04-0.42,0.26-0.67 c-0.06-0.07-0.08-0.15-0.07-0.23c-0.06-0.01-0.21,0.12-0.29,0.15c0.19-0.23,0.3-0.42,0.52-0.56c-0.29-0.25,0.57-1.75,1.32-1.81 c-0.03,0-0.31-0.01-0.31-0.01c0.14-0.35,0.26-0.59,0.45-0.87c0.04,0.12,0.01,0.27,0.06,0.39c-0.01-0.38,0.04-0.82,0.65-0.59 c-0.1-0.15,0.1-0.21,0.17-0.21c-0.14-0.02-0.39-0.09-0.61-0.11c0.46-0.22,0.51-0.41,0.75-0.52c-0.1-0.32,0.01-0.5,0.2-0.99 c0.13,0.28,0.16,0.16,0.26,0.35c0.04-0.03,0.07-0.06,0.1-0.1c-0.03-0.1-0.16-0.18-0.2-0.31c0.11,0.11,0.43,0.32,0.56,0.49 c-0.24-0.61-0.32-0.51,0.09-0.91c-0.02,0.15-0.02,0.4,0.01,0.54c0.08-0.32,0.25-0.54,0.36-0.78c-0.04,0.36-0.01,0.62-0.12,0.97 c0.15-0.39,0.35-0.64,0.53-0.97c-0.05,0.09-0.07,0.15,0,0.21c0.19-0.14,0.05-0.22,0.14-0.38c0.14,0.16,0.26,0.37,0.43,0.52 c-0.11-0.45-0.09-0.59-0.27-0.97c0.06,0.05,0.11,0.17,0.14,0.24c-0.03-0.1-0.02-0.17,0.05-0.22c0.02,0.06,0.05,0.06,0.09,0 c0.03,0.01,0.11,0.22,0.17,0.28c0.31,0.07,0.24-0.2,0.49,0.25c0.13-0.75,0.81-0.83,0.61-1.43c0.1-0.08,0.2-0.16,0.37-0.27 c0.04,0.01,0.12,0.31,0.13,0.32c0.17-0.06,0.18-0.15,0.35-0.08c-0.29,0.42-0.46,0.87-0.49,1.34c0.29-0.39,0.46-0.97,0.97-1.48 c-0.05,0.37,0.02,0.57-0.04,0.94c0.33-0.29,0.5-0.68,0.58-1.22c0.59,0.12,0.46,0.44,0.09,0.81c0.04,0.08,0.23-0.1,0.25-0.11 c0,0.05-0.16,0.36-0.16,0.35c0.67-0.38,0.35-0.52,1.02-0.27c0.81,0.31,0.59,1.34-0.59,0.77c0.01,0.03,0,0.06-0.02,0.08 c0.51,0.19,0.8,0.41,0.51,0.79c0.37-0.11,1.35,0.06,1.32-0.44c0.23,0.1,0.5,0.2,0.68,0.33c-0.39,0.12-0.07,0.19-0.53,0 c-0.03,0.1-0.05,0.19-0.07,0.3c0.19,0.12,0.07,0.05,0.18,0.2c0.46,0,0.1,0.03,0.32,0.19c0.07-0.05,0.13-0.1,0.2-0.16 c0.05,0.08,0.02,0.19,0.08,0.3c1.38-0.15,2,0.6,3.12,1.52c-0.03-0.06-0.05-0.12-0.08-0.18c0.32,0.41,0.43,0.34,0.59,0.36 c1.18,1.05,1.04,2.99-1.03,2.95c-1.59-0.03-2.26-1.31-3.39-1.37c0.82,1.31,2.06,1.73,1.52,3.6c0.63,0.12,1.29,1,2.03,0.72 c-0.04-0.2-0.11-0.53-0.2-0.73c-0.61,0.04-0.87-0.39-0.55-0.95c0.28,0.14,0.62,0.26,0.82,0.46c-0.22,0.11-0.11,0.09-0.12,0.31 c0.53-0.25,0.96,0.03,1.55,0.19c-0.81-1.81-0.12-1.44,0.81-2.83c0.45,0.3,0.55,0.17,0.63,0.66c0.12,0.08,0.23-0.15,0.43,0.25 c-0.05-1.09,0.49-3.33-0.52-4.09c0.98,0.43,1.66,0.18,1.93,1.3c-1.26,0.05-0.94,1.31-0.08,1.41c0,0.1,0.03,0.2,0.07,0.3 c0.58-0.32,2.14-3.45,3.23-2.5c0.06-0.28,0.17-0.13,0.03-0.36c-0.06,0.02,0.33-0.34,0.31-0.25c0.12,0.15-0.13,0.13,0.19,0.17 c0.27-0.37,0.19-0.37,0.75-0.56c-0.2,0.02-0.38,0.2-0.49,0.27c0.05,0,0.07-0.03,0.04-0.09c-0.03,0.49,0.09,0.96,0.59,1.12 c0.1-0.59,2.04-1.25,2.36-1.2c0.66,0.09-0.45,1.22,0.47,0.52c0.55-0.43,0.36-0.63,0.5-0.97c0.26-0.64-0.54-0.68,0.4-0.92 c0.36-0.09,1.17,0.27,1.51,0.43c0.74,0.37,2,1.22,2.36,2.06c0.63-0.79-0.04-2.48-0.74-2.07c-0.04-0.28-0.12-0.54-0.04-0.85 c0.21-0.13,0.23-0.69,0.22-1.28c-0.2-0.03-0.2,0.08-0.38,0.12c0.06-0.16,0.09-0.5,0.23-0.7c0.02,0-0.19,0.16-0.19,0.14 c0.29-0.66,1.5-3.32,1.72-3.4c2.45-0.9,1.16,1.68,1.17,2.43c0.01,0.63,0.49,1.29,0.52,2.08c0.02,0.41-0.17,1.09-0.07,1.6 c0.15,0.77,0.83,3.7-0.68,3.43c0.09,0.05,0.15,0.21,0.38,0.24c-0.44,0.31-0.85,0.42-1.29,0.35c0.05,1.25,1.44,0.47,1.84,0.05 c0.23-0.23,0.87-1.02,0.94-1.36c0.07-0.34-0.31-0.96-0.22-1.11c1.26-2.56,1.55,1.58,2.6,1.27c-1.44-0.07-0.1-1.16-0.68-1.96 c-0.93-1.24-2.25,0.51-2.33-1.41c-0.02-0.53,0.45-0.94,0.43-1.45c-0.02-0.49-0.79-1.28-0.74-1.64c0.12-0.93,1.13-1.3,1.14-2.42 c0.51,0.66,0.24,1.62,0.26,2.41c0.02,0.74,1,0.52,1.66,1.06c-0.05-0.32-0.19-0.56-0.28-0.75c-0.57,0.23-1.08-0.46-0.98-1.04 c0.04,0.07,0.29,0.35,0.38,0.48c0.7-0.25,0.67-0.33,0.3-0.66c0.44-0.97,1.14-0.35,1.83-0.04c-0.23-0.1,1.57,1.11,1.3,0.59 c0.28,0.52-1.21,2.65,0.2,2.94c0.07-0.14-0.08-0.22-0.04-0.38c0.31-0.15,0.41-1.88,0.28-2.27c-0.18-0.56-0.81-0.83-1.11-1.33 c-0.39-0.62-0.99-1.76-0.5-2.21c-0.02-0.03-0.14,0.13-0.15-0.13c1.2-0.57,2.91-0.18,3.59-1.04c-0.46-0.36-0.74-0.73-0.17-0.9 c-0.16-0.11-0.12-0.23-0.51-0.33c0.06-0.11,0.14-0.28,0.11-0.42c0.08,0.11,0.31,0.33,0.43,0.43c0.18-0.4,0.3-0.59,0.57-0.84 c-0.16-0.03-0.32-0.13-0.47-0.16c0.9,0.13,1.04-0.82,1.84-0.9c0.24-0.3,1.05-0.38,1.37-1.04c-0.07-0.01-0.03,0.07-0.04,0.11 c-0.2-0.22,0.06-0.05-0.13-0.07c0,0-0.02-0.29,0-0.27c0.18-0.02,0.93-0.57,0.79,0.42c0.1-0.07,0.11-0.22,0.2-0.32 c-0.01,0.05,0.01,0.08,0.06,0.08c0.02,0.04-0.08,0.22-0.04,0.23c0.12-0.09,0.07-0.18,0.19-0.32c0.04,0.03-0.03,0.15,0,0.18 c0.14-0.35,0.23-0.32,0.42-0.79c0.07,0.11,0.06,0.19,0.16,0.33c0-0.15,0.13-0.12,0.23-0.05c-0.06-0.03-0.07-0.07-0.04-0.12 c0.03,0.05-0.22-0.09-0.2-0.08c0.03-0.03,0.03-0.07,0.01-0.11c0.34-0.07,0.3-0.01,0.46,0.1c0.31-0.03,0.23-0.27,0.23,0.21 c0-0.02,0.03-0.28-0.03-0.33c-0.04,0.17,0.06,0.13-0.12,0.13c0,0.07,0.11,0.16,0.11,0.23c-0.09-0.06-0.2-0.12-0.38-0.03 c0.12,0.08,0.18,0.02,0.27,0.08c-0.08,0.12-0.19,0.38-0.32,0.63c0.21-0.29,0.27-0.25,0.48-0.43c-0.01,0.06-0.11,0.16,0.07,0.09 c-0.01,0.11-0.13,0.23-0.16,0.34c0.01-0.01,0.01-0.03,0-0.04c0.14-0.15,0.24-0.15,0.43-0.36c0-0.06-0.28,0.11-0.27,0.01 c0.07-0.04,0.32-0.19,0.37-0.25c-0.16,0.24-0.04,0.12,0.03,0.18c-0.04,0.19-0.13,0.06-0.15,0.24c-0.01,0.01,0.06,0,0.06,0 c0.14-0.19,0.08-0.02,0.35-0.09c0.01-0.1-0.16-0.23-0.17-0.18c0,0,0.19-0.16,0.17-0.13c0.02,0.16,0.09,0.05,0.22,0.02 c-0.03-0.06-0.13,0-0.17-0.07c0.12-0.1,0.32-0.16,0.52-0.34c0.11,0.14-0.1,0.08,0.27,0.13c0.02,0.05-0.08,0.13-0.08,0.12 c0.08,0.07,0.23-0.03,0.23-0.02c0.01,0.07-0.02,0.12-0.09,0.15c0.2,0.03,0.07-0.12,0.23,0.12c-0.17-0.39-0.35-0.79-0.5-1.1 c0.57,0.25,1.12,0.21,1.19-0.37c-0.01-0.01,0.12,0.16,0.14,0.1c-0.82-0.98,1.54-4.07,2.67-1.77c-0.39,0.09-0.68,0.51-1.01,0.97 c0.32-0.19,0.63-0.32,0.84-0.48c0.02,0.12-0.06,0.2-0.04,0.32c0.52-0.13,1.03,0.01,0.74,0.62c0.03,0,0.13-0.15,0.16-0.18 c-0.28,0.29-0.44,0.6-0.68,0.87c0.03,0.01,0.04,0.03,0.02,0.07c0.73,0.14,1.06-0.32,1.14-0.71c0.17,0.08-0.04,0.05,0.02,0.18 c1.4-0.13,2.19-0.03,2.67,1.44c0.06-0.14,0.01-0.19,0.04-0.31c0.03-0.02,0.06-0.04,0.1-0.05c0.3,0.56,0.46,0.99,0.12,1.52 c-0.12-0.17-0.39-0.35-0.61-0.61c0.05,0.18,0.13,0.42,0.25,0.61c0.84-0.2,0.25,1.12-0.21,1.53c-0.04,0.03-0.05-0.02-0.08,0.11 c-0.31,0.23-0.23,0.02-0.34,0.4c-0.98,0-1.12,1.35-1.97,2.17c-0.05,0.05-0.54,0.07-0.61,0.14c-0.25,0.27-0.4,0.47-0.61,0.7 c-0.39,0.43-0.59,0.84-1.03,1.16c0.46-0.12,0.86-0.82,1.56-0.58c-0.87-0.6,0.9-0.87,1.37-1.07c-0.04-0.06-0.11-0.18-0.12-0.23 c0.45,0.2,0.51,0.04,0.98-0.25c-0.02-0.06-0.04-0.12-0.07-0.18c-0.13,0.08-0.44,0.09-0.58,0.13c0.04,0.04,0.03,0.12-0.01,0.15 c-0.19-0.65,0.1-0.89,0.63-0.59c0.12-0.19,0.16-0.23,0.4-0.29c-0.44,0.62,0.74,1.17,0.72,0.06c0.28,0.44,0.34,1.12,0.41,1.4 c-0.01,0.19-0.12,0.05-0.21,0.15c0.29-0.1,0.45,0.05,0.63,0.05c0-0.07,0-0.14,0-0.2c0.04,0.11,0.22,0.31,0.22,0.31 c-0.23-0.16-0.43-0.49-0.62-0.68c1.17-0.22,1.92-0.37,3.06,0.08c-0.86,0.52,0.66,1.03,1.19,1.05c1.49,0.05,1-0.55,1.31-1.69 c-0.06,0.02,0.22,0.17,0.25,0.19c0.05-0.07-0.04-0.25,0.03-0.3c0.75,0.34,0.99,0.43,1.56,0.87c0.86-0.71,1.39,0.59,1.53,1.18 c0.17,0.68-0.42,1.85-0.1,2.11c0.13,0.72,0.53,1.32,0.98,1.26c0.08,0.16,0.17,0.3,0.27,0.42c0.4-0.71,0.32-1.56,0.79-2.25 c0.1,0.69,0.64,1.1,1.19,1.14c0.14-1.19,1.07-0.01,1.59,0.09c0.43,0.09,0.81-0.46,1.33-0.29c-0.26-0.72,0.41-2.38,0.78-2.52 c0.53-0.2,2.56,0.54,3.05,0.83c-0.72-0.14-1.45-0.49-1.45,0.44c0.52-0.03,0.97-0.18,1.46-0.35c-0.09,0.26-0.29,0.56-0.48,0.74 c0.02-0.14,0-0.39-0.01-0.53c0.01,0.07,0.04,0.12,0.09,0.17c0.05-0.06,0.07-0.12,0.04-0.19c-0.3,0.25-0.31,0.36-0.66,0.51 c0,0.19,0.1,0.07,0.23,0.17c-0.3,0.36-0.25,0.13-0.08,0.47c0.73-0.54,0.78-1.45,1.67-1.4c1.12,0.05,1.17,0.96,0.45,1.25 c0.6-0.04,2.2,0.66,1.57,1.24c0.94,0.58,2.26-0.36,3.46-0.02c0.92,0.25,0.85,0.54,1.22,1.29c0.15,0.3-0.21,0.5,0.02,0.83 c0.18,0.27,0.61,0.24,0.77,0.58c0.54-0.87,1.11-0.4,1.79-0.31c0.36,0.05,1.55-0.2,1.59-0.19c0.45,0.15,0.29,0.52,0.92,0.95 c1.03,0.71,1.53-0.4,0.6-0.85c0.28-1.59,5.15-0.11,5.63,1.56c0.1,0.38,0,0.95,0,1.34c0,1.27,0.51,3.96-0.81,4.44 c-0.2-0.11-0.92-0.49-1.26-0.79c-0.04,0.06-0.06,0.12-0.06,0.19c0.32,0.13,0.32,0.18,0.52,0.33c-0.17-0.11-0.48-0.2-0.68-0.28 c0.21,0.43,0.15,0.93-0.25,1.29c0.32-0.51,0.44-0.88,1.07-0.94c0.21,0.59,0.22,0.35,0.52,0.49c0.06,0.32,0,0.29-0.02,0.38 c0.15,0.29,0.42,0.84,0.63,1.27c-0.04,0.09-0.19-0.02-0.25,0.05c0.6,0.8-0.24,1.04-0.82,0.43c0.04,0.04,0.05,0.08,0.04,0.14 c-0.04-0.06-0.24-0.23-0.33-0.38c0.03,0.12,0.05,0.23,0.13,0.37c-0.4,0.25-0.95,0.5-1.13,0.49c-0.3,0.37-0.63,0.48-0.99,0.52 c-0.28,0.44-0.46,0.7-0.81,0.78c-0.23,0.54-0.83,0.56-0.97,1.32c-0.65-1.25-1.82-0.65-2.39,0.14c0.08-0.27,0-0.59,0.03-0.8 c-0.24,0.33-0.56,0.48-0.75,0.79c-0.59-0.58-1.87,1.6-1.42,2.28c0.78-0.38,0.28,2.6,0.35,1.25c-0.87,0.41-0.16,1.25-0.45,1.73 c-0.35,0.57-1.67,0.28-1.21,1.58c-1.02-0.09-0.99,1.34-1.8,2.06c-0.19-1.06-0.47-2.15-0.59-3.23c-0.06-0.59-0.18-1.2-0.02-1.79 c0.18-0.68,0.83-0.96,0.65-1.68c1.23-0.01,1.92-1.84,2.78-2.62c0.48-0.44,0.91-0.71,1.15-1.24c0.31-0.64-0.24-1.36,0.64-1.51 c-0.9-0.49-1.19,0.6-1.06,1.18c-0.08-0.07-0.08-0.09-0.16-0.21c-0.5,0.37-0.98,0.96-1.49,1.35c-0.04-0.2,0.09-0.34,0.14-0.52 c-0.08,0.01-0.29,0.16-0.33,0.05c0.08-0.35,0.07-0.78,0.19-1.17c-0.46,0.37-1.24,0.13-2,0.77c-0.55,0.45-1.4,1.61-1.39,2.11 c0.35,0.1,0.31,0.2,0.52,0.35c-0.74-0.04-1.64,0.59-2.25,0.09c0.19-0.02,0.43-0.07,0.63-0.12c-0.47-0.39-2-0.91-1.91-0.06 c-0.83-0.04-1.49-0.28-2.2-0.16c-1.56,0.24-1.85,0.82-2.87,1.93c-0.56,0.62-1.4,1.33-1.93,2.08c-0.59,0.85-0.48,0.38-0.32,1.02 c0.03,0.11,0.66,0,0.48,0.77c0.12-0.24,0.36-0.34,0.49-0.52c-0.14,0.28-0.1,0.38-0.21,0.68c0.33-0.1,0.41-0.06,0.68-0.34 c0,0.02-0.09,0.38-0.07,0.4c0.02-0.19,0.19-0.49,0.21-0.74c0.67-0.09,2.3,1.48,0.67,1.05c1.36,0.2,0.4,3.56-0.09,4.56 c-0.36,0.74-3.64,5.63-4.18,3.91c-0.23-0.08-0.16,0.21-0.28-0.13c-0.32,0.6-0.79,1.28-1.21,1.79c-0.9,1.09-1.3,0.63-0.9,1.69 c0.45,1.19,1.14,1.54,0.33,2.59c-0.21,0.27-0.62,0.19-0.85,0.42c-0.09,0.01,0.08-0.12,0.05-0.16c-0.31,0.19-0.37,0.23-0.59,0.3 c0.05-0.34,0.41-1,0.05-1.64c0.06,0.08,0.05,0.13-0.02,0.15c-0.01-0.08-0.04-0.11-0.11-0.1c0.23-0.08,0.11-0.18,0.45-0.15 c-0.05-0.48-0.27-0.73-0.71-0.83c-0.22,0.2-0.23,0.29-0.22-0.06c-0.02-0.02-0.2,0.05-0.27,0.02c0.16-0.19,0.19-0.3,0.37-0.46 c0.27-1.58-1.7-0.34-2.42-0.07c0.14-0.39,0.06-0.32,0.09-0.52c0.81-0.68,0.52-1.11-0.33-0.74c-0.26,0.11-1.72,1.29-1.72,1.3 c-0.23,1.71,3.14,0.27,2.61,1.39c-0.47-0.15-1.46,0.5-1.54,1c-0.07,0.47,0.79,1.92,1.3,2.5c-0.37-0.11-0.77-0.11-0.99-0.15 c0.47,0.03,0.73,0.19,1,0.66c-0.33,0.11-0.66,0.39-0.97,0.47c0.45-0.08,0.6,0.05,1.02,0.17c-0.08,0.1-0.23,0.16-0.3,0.25 c0.05,0.02,0.17-0.03,0.2-0.07c-0.13,0.7-0.69,1.09-1.09,1.95c0.18-0.13-0.25-0.08-0.2-0.08c0.28,1.71-2.4,2.19-3.15,2.66 c-0.06-0.06-0.16-0.21-0.25-0.3c-0.03,0.11,0.03,0.28-0.05,0.36c-0.09,0-0.16-0.21-0.21-0.23c-0.23,0.9-1.71,0.32-1.52,1.36 c-0.23-0.27-0.35-0.19-0.42-0.71c-0.61-0.03-1.72,0.04-2.09,1.03c-0.42,1.15,0.91,1.72,1.32,2.36c0.43,0.67,0.76,1.74,0.49,2.31 c-0.34,0.69-1.38,0.71-1.52,1.35c-0.05-0.04-0.2-0.2-0.26-0.21c-0.06,0.49-0.15,0.4-0.62,0.78c0.15-0.62,0-1.18-0.75-1.13 c-0.08-0.15,0.11-0.16-0.03-0.32c-0.05-0.02-0.1,0.13-0.19,0.13c-0.09-0.55-0.64-1.11-1.26-0.99c-0.27-1.22-0.69,0.04-0.79,0.73 c-0.15,1-0.15,1.05,0.47,1.83c1.05,1.31,1.84,2,2.16,3.84c-0.2,0.01-0.32,0.03-0.41,0.04c-0.93-0.81-1.23-1.27-1.73-2.34 c-0.21-0.45-0.49-0.89-0.7-1.36c-0.31-0.67-0.25-0.3-0.33-1.22c-0.09-1.21,0.09-3.46-1.07-4.33c-0.1,0.56-0.79,1.2-1.28,0.86 c-0.14-0.1,0.07-1.32-0.32-1.86c0,0.01-0.06-0.04-0.06-0.1c-0.43-0.45-1.17-2.08-1.73-2.19c-0.06-0.01-0.63,0.86-1.21,0.68 c-0.13-0.09-0.18,0.3-0.29-0.18c-0.52,0.31-1.41,1.24-1.87,1.79c-0.6,0.7-1.5,1.15-2.05,1.71c-0.64,0.65-0.99,2.19-0.79,3.46 c-0.85,0.59-1.25,1.93-2.01,0.15c-0.44-1.02-1.1-2.36-1.43-3.16c-0.41-1.02-1.1-3.35-0.52-4.05c-0.14,0.01-0.25-0.04-0.37-0.07 c0.06,1.46-1.42,0.98-1.83,0.04c0.39-0.11,0.49-0.28,0.78-0.49c-1.13,0.83-1.48-1.03-2.08-1.31c-0.93-0.42-2.63,0.02-3.63-0.04 c-0.35-0.02-0.78-0.02-1.07-0.16c-0.2-0.1-0.73-0.66-0.73-0.66c-0.66-0.18-1.28,0.06-2.04-0.12c-1.13-0.28-1.54-1.97-2.54-2.29 c-0.27,0.32-0.08,0.11-0.54,0.28c-0.04,0.08-0.03,0.18-0.15,0.43c0.68,0.78,1.28,1.72,1.66,2.64c0.08-0.22,0.23-0.44,0.32-0.64 c0.24,1.02-0.11,1.15,0.81,1.22c1.05,0.08,1.39-0.51,2.09-1.31c-0.42,1.74,2.13,1.4,1.72,2.9c-0.23,0.85-1.75,2.36-2.58,2.78 c-1.37,0.69-2.83,1.38-4.38,2.03c-1.6,0.68-2.12,0.58-2.52-1.05c-0.35-1.41-1.3-2.31-1.99-3.61c-0.58-1.08-1.25-3.78-2.56-4.15 c0.06-0.25,0.08-0.66,0.18-0.89c-0.4,2.05-1.48-0.1-1.48-1.15c1.65,0.9,2.04-3.32,2.14-3.86c-0.36,0.02-0.95,0.45-1.29,0.45 c-0.56,0-0.85-0.4-1.31-0.4c-0.58,0-0.53,0.31-1.2,0.35c-0.28,0.02-0.17-0.45-0.74-0.23c0.03-0.19-0.17-0.07-0.34-0.01 c0.17-0.07,0.34-0.2,0.5-0.3c-0.18,0-0.36,0.07-0.54,0.04c0.03-0.14,0.05-0.33,0.02-0.46c-0.26-0.12-0.47-0.41-0.54-0.74 c0.23,0.21,0.07,0.12,0.38,0.18c-0.01-0.15-0.11-0.63-0.15-0.83c-0.11-0.02-0.28,0.05-0.41,0.04c0.15-0.54,0.61-0.78,0.9-0.76 c0.25,0.06,0.43,0.06,0.76,0.07c-0.25,0.06,0.32-0.15,0.44-0.2c-0.39-0.17-0.18-0.16-0.36-0.4c1.1,0.42,1.72-0.52,2.86-0.56 c0.97-0.03,1.43,0.75,2.55,0.7c3.65-0.16-0.34-2.39-1.21-3.23c0.32-0.21,0.74-0.52,1.05-0.72c-0.14-0.11-0.33-0.42-0.4-0.47 c0.46-0.07,0.43-0.2,0.9-0.38c-0.74-0.26-1.91,0.33-2.43,0.85c0.19-0.15,0.04-0.19,0.04-0.3c-0.04,0.2-0.1,0.28-0.12,0.5 c0,0-0.14-0.23-0.12-0.23c-0.15-0.04-0.14,0.13-0.33-0.16c-0.1,0.14-0.01,0.19-0.23,0.1c0.57,0.29,0.72,0.98,1.62,0.61 c-0.68,1.22-1.6,0.49-2.29,0.07c0.22-0.13,0.38-0.36,0.68-0.46c-0.25-0.05-0.65-0.22-1.1-0.22c0.23-0.31,0.02-0.02-0.11-0.21 c0.13-0.06,0.21,0.02,0.34,0c-0.02-0.02-0.21-0.19-0.19-0.26c-0.27,0.14-0.74,0.33-1,0.35c-0.11,0.54-0.01,0.35-0.3,0.43 c0.09,0.53-0.04,0.8-0.46,1.12c0.01-0.13,0.1-0.24,0.1-0.41c-0.32,0.96-1.43,2.35,0.02,2.87c-0.43,0.13-1.18,0.38-1.62,0.88 c0.08-0.07,0.21-0.3,0.35-0.42c-0.62-0.12-1.21-0.38-1.8,0.04c0.13,0.11,0.25,0.19,0.37,0.31c-0.04,0-0.23-0.11-0.28-0.13 c0.01,0.13,0.07,0.13,0.08,0.31c-0.1-0.02-0.16-0.18-0.28-0.21c0.07,0.1,0.07,0.17,0.06,0.23c-0.13-0.17-0.3-0.38-0.38-0.5 c-0.04,0.02-0.09,0.04-0.14,0.05c0.12,0.39,0.1,0.64,0.36,1.02c-0.09,0-0.1-0.04-0.21-0.12c-0.13,0.24,0.16,0.24-0.21,0.29 c0.47,0.14,0.78,0.44,0.85,0.91c-0.26-0.15-0.35-0.14-0.62-0.24c-0.08-0.37-0.86-0.07-1.24-0.62c0.07,0.02,0.14,0.02,0.2-0.01 c-1-0.86-0.59-2.61-2.29-3.09c0.11-0.04,0.16,0,0.27,0.06c-0.49-0.36-1.25-0.6-1.21-1.08c-0.11-0.32-0.38-0.58-0.61-0.8 c-0.08,0.1-0.18,0.32-0.24,0.41c-0.01-0.26-0.16-0.44-0.12-0.72c-1.79,0.07,0.05,2.53,0.86,3.05c0.23-0.07,1.79,0.68,1.78,1.47 c-0.9-1.2-0.74,0.9-1.46,1.4c0.74-1.45-0.74-1.91-1.63-2.53c-0.7-0.49-0.91-1.41-1.47-1.81c-0.93-0.66-0.71-0.28-1.6,0 c-0.45,0.14-0.65,0.34-1.07,0.43c-0.55,0.12-0.71-0.42-1.35,0.14c-0.18,0.17,0.23,0.66,0.09,0.84c-0.33,0.4-0.91,0.41-1.23,0.71 c-0.46,0.44-1.02,1.16-0.47,1.62c-0.62,0.99-1.45,1.63-2.68,1.6c-0.24-0.01-0.35,0.33-0.5,0.32c-0.34-0.04-0.39-0.53-0.51-0.55 c-0.48-0.08-0.8-0.3-1.42-0.14c0.09-0.31-0.02-0.72,0.09-1.05c-0.78-0.16-0.05-1.16,0.03-1.87c0.1-0.94-0.7-1.52,0.27-1.96 c1.87-0.85,3.87,1.68,4.05-1.48c0.07,0,0.12,0.2,0.18,0.21c-0.09-0.67-0.91-1.17-0.6-1.62c-0.52-0.18-1.03-0.34-1.65-0.67 c0.01,0.03,0.11-0.21,0.15-0.28c-0.07,0.01-0.14,0.02-0.21,0.03c0.52-0.6,1.24-0.27,1.9-0.3c-0.12-0.26-0.14-0.62-0.28-0.89 C99.3,59.78,99.58,59.78,99.96,59.95L99.96,59.95z M175.13,63.66C174.68,63.18,174.93,63.55,175.13,63.66L175.13,63.66z M142.37,62.04c-0.83,0.32-1.08,1.14-0.33,1.63c-0.33-0.62,0.07-1.17,0.54-1.49c0.63,0.13,1.8,0.48,2.15-0.07 C144.08,62.31,143.19,62.16,142.37,62.04L142.37,62.04z M162.02,54.02c-0.47,0.87-0.85,1.83-1.5,2.62c0.15-0.08,0.31-0.17,0.46-0.27 c-0.74,0.5-1.28,1.49-2.21,1.52c0.66,0.55,1.39-0.2,1.81-0.74c0.44-0.56,1.23-0.96,1.14-1.04C162.01,55.49,162.2,54.57,162.02,54.02 L162.02,54.02z M115.52,50.52c-0.25,0.29-0.35,0.51,0.06,1C115.71,51.12,115.6,50.8,115.52,50.52L115.52,50.52z M107.78,50.71 c-0.04-0.69-0.25-0.82-0.4-0.08c-0.33,0.1-0.23-0.09-0.49,0.56c0.04-0.07,0.08-0.06,0.12,0.01 C107.32,51.03,107.47,50.96,107.78,50.71L107.78,50.71z M128.36,67.02c-0.26,0.29-0.52,0.43-0.5,1c-0.72,0.08,0.12,0.94,0.41,1.18 c0.64,0.55,1.22,0.69,2.08,0.33c-0.04,0.06-0.1,0.08-0.19,0.07c0.63-0.1,0.36-1.46,0.03-1.81c0.06-0.05,0.22-0.09,0.28-0.17 c0,0-0.25-0.11-0.28-0.15c-0.2-0.05,0.39-0.02,0.29-0.01c-0.19,0-0.28-0.16-0.58-0.07c-0.06-0.26-0.06-0.62,0.01-0.87 c0.33,0.32,0.48,0.13,0.9,0.29c-0.07,0.11,0.11-0.18,0.17-0.3c-0.37-0.7-1.05-0.98-1.09-0.07c-0.22-1.12-0.57-1.81-1.52-2.59 c0.16,0.04,0.54-0.03,0.76,0.01c-0.22-0.95,1.05-0.63,1.81-0.46c-0.08-0.35-0.67-1.48-1.14-1.67c-0.75-0.3-1.44,0.43-2.31,0.48 c0.08,0.05,0.15,0.1,0.23,0.15c-0.51,0.38-0.42,0.49-0.89,0.04c0.13,0.89-0.72,1.25-0.01,2.16c0.03-0.07,0.06-0.14,0.09-0.21 C126.7,65.3,128.09,67,128.36,67.02L128.36,67.02z M134.05,62.56c-0.25,0-0.31-0.15-0.48,0.29c-0.56-0.11-1.11,1.82,0.2,1.74 c1.62-0.09,0.4-1.8,1.09-2.52c-0.14,0.02-0.31,0.15-0.41,0.26c-0.15-0.06-0.14-0.17-0.35-0.14c0.16,0.23,0.02,0.19,0.31,0.39 C134.19,62.61,134.22,62.53,134.05,62.56L134.05,62.56z M117.52,47.48c-0.17,0.08-0.54,0.36-0.63,0.44 c0.28,0.42,0.54,0.94,0.62,1.57C118.7,49.18,118.73,48.19,117.52,47.48L117.52,47.48z M53.45,62.81c0.09,0.05,0.19,0.02,0.16,0.23 c-0.02-0.04,0.1-0.2,0.1-0.2c-0.37,0.15-0.31,0.15-0.86-0.03C53.06,62.81,53.25,62.81,53.45,62.81L53.45,62.81z M33.98,48.04 c0.07,0.11,0.19,0.09,0.2,0.25C33.92,48.24,34.02,48.1,33.98,48.04L33.98,48.04z M35.94,47.29c0.13-0.01,0.37-0.12,0.5-0.18 C36.38,47.59,36.23,47.28,35.94,47.29L35.94,47.29z M36.96,46.29c0.07,0.11,0.24-0.13,0.34,0.06c-0.21,0.07-0.37,0.12-0.57,0.2 C36.72,46.52,36.94,46.24,36.96,46.29L36.96,46.29z');
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/cities-map.vue
var cities_map__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var cities_map = ({
  data: function data() {
    return {
      worldmapD: worldmap,
      cities: null,
      events: null,
      width: 204,
      height: 130,
      hoveredNodeID: null,
      textWidth: null,
      textPadding: 2
    };
  },

  props: {
    type: {
      type: String, // cities, events
      required: false,
      default: "cities"
    }
  },

  created: function created() {
    this.fetchCities();
    if (this.type === "events") this.fetchEvents();
  },


  computed: {
    // {id: number; label: string; url: string; color: string;}[]
    nodes: function nodes() {
      var _this = this;

      switch (this.type) {
        case "cities":
          return (this.cities || []).map(function (city) {
            return cities_map__extends({
              id: city.id,
              label: city.name
            }, _this.getCoords(city.latitude, city.longitude), {
              url: "/cities/" + city.abbreviation,
              color: city.color
            });
          });
        case "events":
          var chaptersUsed = [];
          return (this.events || []).map(function (event) {
            var chapter = (_this.cities || []).find(function (city) {
              return city.id === event.chapter_id;
            });
            if (chaptersUsed.includes(event.chapter_id)) {
              return null;
            } else {
              chaptersUsed.push(event.chapter_id);
            }
            if (!chapter) return null;

            return cities_map__extends({
              id: event.id,
              label: chapter.name + ": " + new Date(event.starts_at).toLocaleDateString("en-US", {
                weekday: "short",
                month: "short",
                day: "numeric"
              })
            }, _this.getCoords(chapter.latitude, chapter.longitude), {
              url: "/talks/" + event.slug,
              color: chapter.color
            });
          }).filter(Boolean);
      }
    },
    activeNode: function activeNode() {
      var _this2 = this;

      return this.nodes.find(function (node) {
        return node.id === _this2.hoveredNodeID;
      });
    },
    activeTooltipOffset: function activeTooltipOffset() {
      if (this.activeNode) {
        var halfTooltipWidth = this.textWidth / 2 + this.textPadding;
        var overflowLeft = Math.min(0, this.activeNode.x - halfTooltipWidth);
        var overflowRight = Math.max(0, this.activeNode.x + halfTooltipWidth - this.width);

        return -1 * (overflowLeft + overflowRight);
      }
    }
  },

  watch: {
    activeNode: function activeNode(next, prev) {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.$refs.nodeLabel) {
          _this3.textWidth = _this3.$refs.nodeLabel.getBBox().width;
        }
      });
    }
  },

  methods: {
    fetchCities: function fetchCities() {
      var _this4 = this;

      // cities: [{"id":148,"name":"Aarhus","abbreviation":"ARH","color":"#193941","longitude":10.203921,"latitude":56.162939}]
      axios_default.a.get("/cities.json").then(function (response) {
        _this4.cities = response.data;
      });
    },
    fetchEvents: function fetchEvents() {
      var _this5 = this;

      // events: [{
      //   "id": 17525,
      //   "chapter_id": 148,
      //   "slug": "show-me-how-to-restart-this-chapter",
      //   "starts_at": "2030-12-31T13:30:00.000Z",
      //   "ends_at": "2030-12-31T15:00:00.000Z",
      //   "name": "Show me how to restart this chapter",
      //   "description": "If you’re serious about bringing CreativeMornings to your town, we’d love to hear from you. \r\n\r\nFor full details about hosting a CreativeMornings chapter in your city, review our \u003Ca href=\"https://creativemornings.com/pages/start-a-chapter\" target=\"new\"\u003EStart a Chapter\u003C/a\u003E page and start your journey there!\r\n\r\n\u003Ch2\u003EWhat usually happens at a CreativeMornings?\u003C/h2\u003E\r\n\r\n\u003Cp\u003EMagic.\u003Cbr /\u003E\r\n\u003Cbr /\u003E\r\nRegistration for each event opens at the beginning of the week on the chapter’s CreativeMornings.com page.\r\n\r\nTickets are free, but you have to be quick because many of our events fill up fast.\r\n\r\nIf you get a ticket, you can show up (events are usually on Friday morning) and enjoy free breakfast, meet your local community, and hear an inspiring 20-minute talk from a neighbor that’s related to the monthly global theme.\r\n\r\nAfter the talk, there’s usually a Q&A and then you’re out of the door by 10 AM, inspired to pass the feelings forward.\r\n\r\n\u003Cimg src=\"https://mcusercontent.com/b8d0c821758ac4979998d6301/images/77601c6b-9abb-9439-8ea7-29932d04e7ca.jpg\"\u003E\u003Cbr /\u003E\r\nPhoto credit: Tora Chirila from CreativeMornings/Montreal.\r\n\r\n\u003Cimg src=\"https://mcusercontent.com/b8d0c821758ac4979998d6301/images/c577566c-58df-5866-3be3-1c8c4a6a1caa.jpg\"\u003E\u003Cbr /\u003E\r\n Photo credit, top left: Grzegorz Stadnik from CreativeMornings/Wroclaw. Top right: Paul Jun from CreativeMornings/NewYork. Bottom left: Mark Lobo from CreativeMornings/Melbourne. Bottom right: Rachel Jolley from CreativeMornings/StPete.\r\n\r\n\u003Cimg src=\"https://mcusercontent.com/b8d0c821758ac4979998d6301/images/f4dba2f3-117c-8d6f-dada-a797cc6e2178.png\"\u003E\u003Cbr /\u003E\r\nFor full details about hosting a CreativeMornings chapter in your city, review our \u003Ca href=\"https://creativemornings.com/pages/start-a-chapter\" target=\"new\"\u003EStart a Chapter\u003C/a\u003E page and start your journey there!\r\n\r\n",
      //   "available_ticket_count": 0
      // }]
      axios_default.a.get("/talks/upcoming.json").then(function (response) {
        _this5.events = response.data;
      });
    },
    getCoords: function getCoords() {
      var lat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var lng = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var longitude_shift = 53,
          // number of pixels your map's prime meridian is off-center.
      x_pos = 54,
          y_pos = 19,
          map_width = this.width,
          map_height = this.height + 53; // larger than 130 because we're cutting off antartica.

      var x = map_width * (180 + lng) / 360 % map_width + longitude_shift;

      // latitude: using the Mercator projection
      lat = lat * Math.PI / 180; // convert from degrees to radians
      var y = Math.log(Math.tan(lat / 2 + Math.PI / 4));
      y = map_height / 2 - map_width * y / (2 * Math.PI) + y_pos;

      x -= x_pos;
      y -= y_pos;

      return { x: x, y: y };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02531a70","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cities-map.vue
var cities_map_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-container"
  }, [_c('div', {
    staticClass: "cities-map"
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height - 30,
      "viewBox": ("0 30 " + (_vm.width + 10) + " " + (_vm.height - 30))
    }
  }, [_c('path', {
    staticClass: "cities-map__landmass",
    attrs: {
      "d": _vm.worldmapD
    }
  }), _vm._v(" "), _vm._l((_vm.nodes), function(node, i) {
    return _c('a', {
      key: node.id,
      staticClass: "cities-map__node",
      attrs: {
        "href": node.url,
        "title": node.label
      },
      on: {
        "mouseenter": function($event) {
          _vm.hoveredNodeID = node.id
        },
        "mouseleave": function($event) {
          _vm.hoveredNodeID = null
        }
      }
    }, [_c('circle', {
      attrs: {
        "r": "1.25",
        "fill": node.color,
        "cx": node.x,
        "cy": node.y
      }
    })])
  }), _vm._v(" "), (_vm.activeNode) ? _c('g', {
    staticClass: "cities-map__popup",
    attrs: {
      "transform": ("translate(" + (_vm.activeNode.x) + " " + (_vm.activeNode.y - 2.25) + ")")
    }
  }, [_c('path', {
    staticClass: "cities-map__triangle",
    attrs: {
      "d": "M0 0L0 -5L5 -5Z",
      "fill": _vm.activeNode.color
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "transform": ("translate(" + _vm.activeTooltipOffset + " 0)")
    }
  }, [_c('rect', {
    attrs: {
      "x": (_vm.textWidth / 2) * -1,
      "y": "-9.5",
      "width": _vm.textWidth + _vm.textPadding * 2,
      "height": "7",
      "fill": _vm.activeNode.color
    }
  }), _vm._v(" "), _c('text', {
    ref: "nodeLabel",
    attrs: {
      "x": _vm.textPadding,
      "y": "-4.5"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.activeNode.label) + "\n          ")])])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "map-overlay"
  })])
}
var cities_map_staticRenderFns = []
var cities_map_esExports = { render: cities_map_render, staticRenderFns: cities_map_staticRenderFns }
/* harmony default export */ var components_cities_map = (cities_map_esExports);
// CONCATENATED MODULE: ./app/javascript/components/cities-map.vue
function cities_map_injectStyle (ssrContext) {
  __webpack_require__(403)
}
var cities_map_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var cities_map___vue_styles__ = cities_map_injectStyle
/* scopeId */
var cities_map___vue_scopeId__ = "data-v-02531a70"
/* moduleIdentifier (server only) */
var cities_map___vue_module_identifier__ = null
var cities_map_Component = cities_map_normalizeComponent(
  cities_map,
  components_cities_map,
  cities_map___vue_styles__,
  cities_map___vue_scopeId__,
  cities_map___vue_module_identifier__
)

/* harmony default export */ var javascript_components_cities_map = (cities_map_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/toggle.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var toggle = ({
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String
    },
    name: {
      type: String
    },
    options: {
      type: Array
    }
  },

  computed: {
    radioGroupID: function radioGroupID() {
      return this.name || crypto.randomUUID();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5506aeec","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/toggle.vue
var toggle_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggles"
  }, _vm._l((_vm.options), function(option, idx) {
    return _c('div', {
      staticClass: "toggle"
    }, [_c('input', {
      key: option.value,
      attrs: {
        "id": option.value,
        "type": "radio",
        "name": _vm.radioGroupID
      },
      domProps: {
        "checked": option.value === _vm.value,
        "value": option.value
      },
      on: {
        "change": function($event) {
          _vm.$emit('change', $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      key: ((option.value) + "-label"),
      staticClass: "cm-button",
      attrs: {
        "for": option.value
      }
    }, [_vm._v(_vm._s(option.label))])])
  }))
}
var toggle_staticRenderFns = []
var toggle_esExports = { render: toggle_render, staticRenderFns: toggle_staticRenderFns }
/* harmony default export */ var components_toggle = (toggle_esExports);
// CONCATENATED MODULE: ./app/javascript/components/toggle.vue
function toggle_injectStyle (ssrContext) {
  __webpack_require__(405)
}
var toggle_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var toggle___vue_styles__ = toggle_injectStyle
/* scopeId */
var toggle___vue_scopeId__ = "data-v-5506aeec"
/* moduleIdentifier (server only) */
var toggle___vue_module_identifier__ = null
var toggle_Component = toggle_normalizeComponent(
  toggle,
  components_toggle,
  toggle___vue_styles__,
  toggle___vue_scopeId__,
  toggle___vue_module_identifier__
)

/* harmony default export */ var javascript_components_toggle = (toggle_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/donation-form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var donation_form = ({
  components: {
    Toggle: javascript_components_toggle
  },
  props: {
    braintreeLocale: {
      type: String
    },
    braintreeClientToken: {
      type: String
    }
  },
  data: function data() {
    return {
      amountOptions: [10, 15, 20, 25, 35, 50, 100],
      plan_id: "fieldtrips_monthly",
      error: null,
      isCustomChecked: false,
      customAmount: "",
      currentRadio: Number(window.__DATA__.current_monthly_price) || 50,
      current_monthly_price: window.__DATA__.current_monthly_price
    };
  },

  computed: {
    customAmountPlaceholder: function customAmountPlaceholder() {
      return !this.current_monthly_price || this.amountOptions.includes(Number(this.current_monthly_price)) ? "Other" : this.current_monthly_price;
    }
  },
  mounted: function mounted() {
    var _this = this;
    _this.error = null;

    var form = _this.$el.closest("form");
    var button = form.querySelector("input[type=submit]");

    braintree.dropin.create({
      authorization: _this.braintreeClientToken,
      container: "#dropin-container",
      paypal: { flow: "vault" },
      locale: _this.braintreeLocale
    }, function (createErr, instance) {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
          if (requestPaymentMethodErr) {
            _this.error = requestPaymentMethodErr;
            // An appropriate error will be shown in the UI
          } else {
            // Submit payload.nonce to your server
            _this.$refs.nonceInput.value = payload.nonce;
            form.submit();
          }
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3337b237","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/donation-form.vue
var donation_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [(_vm.error) ? _c('p', {
    staticClass: "message message-error ss-alert"
  }, [_vm._v("\n    " + _vm._s(_vm.error.message) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('Toggle', {
    attrs: {
      "options": [{
          value: 'fieldtrips_once',
          label: 'Just once'
        },
        {
          value: 'fieldtrips_monthly',
          label: 'Give monthly'
        }
      ],
      "name": "plan_id"
    },
    model: {
      value: (_vm.plan_id),
      callback: function($$v) {
        _vm.plan_id = $$v
      },
      expression: "plan_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "amounts"
  }, [_vm._l((_vm.amountOptions), function(option) {
    return _c('div', {
      staticClass: "amount"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentRadio),
        expression: "currentRadio"
      }],
      attrs: {
        "name": "price",
        "id": option,
        "type": "radio"
      },
      domProps: {
        "value": option,
        "checked": _vm._q(_vm.currentRadio, option)
      },
      on: {
        "__c": function($event) {
          _vm.currentRadio = option
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "cm-button",
      attrs: {
        "for": option
      },
      on: {
        "click": function($event) {
          _vm.isCustomChecked = false
        }
      }
    }, [_vm._v("$" + _vm._s(option))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-amount"
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "radio",
      "name": "price",
      "id": ""
    },
    domProps: {
      "value": _vm.customAmount,
      "checked": _vm.isCustomChecked
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customAmount),
      expression: "customAmount"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.customAmountPlaceholder
    },
    domProps: {
      "value": (_vm.customAmount)
    },
    on: {
      "click": function($event) {
        _vm.isCustomChecked = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customAmount = $event.target.value
      }
    }
  })])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dropin-container"
    }
  }), _vm._v(" "), _c('input', {
    ref: "nonceInput",
    attrs: {
      "type": "hidden",
      "name": "nonce"
    }
  })], 1)
}
var donation_form_staticRenderFns = []
var donation_form_esExports = { render: donation_form_render, staticRenderFns: donation_form_staticRenderFns }
/* harmony default export */ var components_donation_form = (donation_form_esExports);
// CONCATENATED MODULE: ./app/javascript/components/donation-form.vue
function donation_form_injectStyle (ssrContext) {
  __webpack_require__(404)
}
var donation_form_normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var donation_form___vue_styles__ = donation_form_injectStyle
/* scopeId */
var donation_form___vue_scopeId__ = "data-v-3337b237"
/* moduleIdentifier (server only) */
var donation_form___vue_module_identifier__ = null
var donation_form_Component = donation_form_normalizeComponent(
  donation_form,
  components_donation_form,
  donation_form___vue_styles__,
  donation_form___vue_scopeId__,
  donation_form___vue_module_identifier__
)

/* harmony default export */ var javascript_components_donation_form = (donation_form_Component.exports);

// CONCATENATED MODULE: ./app/javascript/lib/scrollbar.js
var setScrollbarWidth = function setScrollbarWidth() {
  /** https://destroytoday.com/blog/100vw-and-the-horizontal-overflow-you-probably-didnt-know-about */
  var scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty("--scrollbar-width", scrollBarWidth + "px");
};
// EXTERNAL MODULE: ./node_modules/fitvids/index.js
var fitvids = __webpack_require__(239);
var fitvids_default = /*#__PURE__*/__webpack_require__.n(fitvids);

// CONCATENATED MODULE: ./app/javascript/packs/main.js






















































































var main__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function main__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

























window.I18n = main__extends({}, window.I18n);
window.I18n.locale = document.documentElement.lang;
vue["a" /* default */].prototype.I18n = window.I18n;

// helper to mount vue safely with just a dom-selector and a render function
var main_mountVue = function mountVue(_ref) {
  var selector = _ref.selector,
      _render = _ref.render;

  var nodes = [].concat(main__toConsumableArray(document.querySelectorAll(selector)));
  if (nodes.length) {
    nodes.forEach(function (node) {
      new vue["a" /* default */]({
        render: function render(t) {
          return _render(t, node);
        }
      }).$mount(node);
    });
  }
};

window.mountComponents = function () {
  main_mountVue({
    selector: "chapter-box",
    render: function render(t, node) {
      return t(javascript_company_chapter_box, {
        props: {
          chapter: JSON.parse(node.getAttribute("chapter")),
          badge: node.getAttribute("badge")
        }
      });
    }
  });
  main_mountVue({
    selector: "cities-map",
    render: function render(t, node) {
      return t(javascript_components_cities_map, {
        props: {
          type: node.getAttribute("type")
        }
      });
    }
  });
  main_mountVue({
    selector: "cm-nav-chapter-dropdown",
    render: function render(t, node) {
      return t(javascript_components_cm_nav_chapter_dropdown, {
        props: { currentChapterAbbr: node.getAttribute("current-chapter-abbr") }
      });
    }
  });
};

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".page--home")) {
    new vue["a" /* default */]({
      el: ".page--home",
      components: {
        CmButton: javascript_components_cm_button,
        FeaturedCompanies: javascript_components_featured_companies,
        FeaturedIndividuals: javascript_components_featured_individuals,
        FeaturedArticles: javascript_components_featured_articles,
        FeaturedJobs: javascript_components_featured_jobs,
        FeaturedProjects: javascript_components_featured_projects,
        CmChapterDropdowns: javascript_components_cm_chapter_dropdowns,
        CitiesMap: javascript_components_cities_map
      }
    });
  }

  main_mountVue({
    selector: "location-field",
    render: function render(t, node) {
      var props = {};

      if (node.hasAttribute("model")) {
        props = {
          model: node.getAttribute("model"),
          attribute: node.getAttribute("attribute"),
          value: JSON.parse(node.getAttribute("value")),
          placeholder: node.getAttribute("placeholder"),
          required: node.hasAttribute("required"),
          disabled: node.hasAttribute("disabled"),
          types: node.getAttribute("types")
        };
      }
      return t(location_field["a" /* default */], { props: props });
    }
  });

  main_mountVue({
    selector: "featured-jobs",
    render: function render(t) {
      return t(javascript_components_featured_jobs);
    }
  });

  main_mountVue({
    selector: "#js-company",
    render: function render(t, node) {
      var props = {};
      if (node.hasAttribute("data-company")) {
        props = {
          company: JSON.parse(node.getAttribute("data-company")),
          admin: node.hasAttribute("data-admin"),
          breakfastFoods: window.I18n.t("breakfast_foods"),
          stub: node.hasAttribute("data-stub"),
          form: node.hasAttribute("data-form")
        };
      }
      return t(javascript_company_profile, { props: props });
    }
  });

  main_mountVue({
    selector: "#keyword-input-container",
    render: function render(t) {
      return t(app_javascript_pages_jobs, {
        props: {
          filters: window.__DATA__.jobs_filters.map(function (filter) {
            var isMultiple = ["skill_tag_id", "commitment"].includes(filter.option_name);
            var options = filter.options.map(function (option) {
              return {
                label: option.name,
                value: option.val.toString()
              };
            });

            return main__extends({}, filter, {
              id: filter.option_name,
              multiple: isMultiple,
              nullLabel: isMultiple ? options[0].label : undefined,
              options: options.filter(function (option, index) {
                return isMultiple ? index > 0 : true;
              })
            });
          })
        }
      });
    }
  });

  main_mountVue({
    selector: "#companies-container",
    render: function render(t) {
      return t(javascript_pages_companies, {
        props: {
          favorites: window.__DATA__.user_favorite_companies,
          isLoggedIn: window.__DATA__.logged_in,
          filters: window.__DATA__.companies_filters.map(function (filter) {
            var isMultiple = ["skill_tag_id", "industry_id"].includes(filter.option_name);
            var options = filter.options.map(function (option) {
              return {
                label: option.name,
                value: option.val.toString()
              };
            });

            var hasNullOption = filter.option_name !== "sort_key";

            return main__extends({}, filter, {
              id: filter.option_name,
              multiple: isMultiple,
              nullLabel: hasNullOption ? options[0].label : undefined,
              options: options.filter(function (option, index) {
                return hasNullOption ? index > 0 : true;
              })
            });
          }).filter(function (filter) {
            return filter.label !== "Newest";
          })
        }
      });
    }
  });

  main_mountVue({
    selector: "#individuals-container",
    render: function render(t) {
      return t(javascript_pages_individuals, {
        props: {
          filters: window.__DATA__.individuals_filters.filter(function (filter) {
            return filter.option_name !== "chapter_id";
          }).map(function (filter) {
            var isMultiple = ["skill_tag_id"].includes(filter.option_name);
            var options = filter.options.map(function (option) {
              return {
                label: option.name,
                value: option.val.toString()
              };
            });

            return main__extends({}, filter, {
              id: filter.option_name,
              multiple: isMultiple,
              nullLabel: isMultiple ? options[0].label : undefined,
              options: options.filter(function (option, index) {
                return isMultiple ? index > 0 : true;
              })
            });
          })
        }
      });
    }
  });

  main_mountVue({
    selector: "#preview-card-container",
    render: function render(t) {
      return t(javascript_onboarding_preview_card);
    }
  });

  main_mountVue({
    selector: "#checkout-container",
    render: function render(t) {
      return t(javascript_components_checkout, {
        props: {
          plan: window.__DATA__.checkout_plan,
          initialBillingPeriod: window.__DATA__.checkout_billing_period,
          braintreeLocale: window.__DATA__.checkout_braintree_locale,
          braintreeClientToken: window.__DATA__.checkout_braintree_client_token
        }
      });
    }
  });

  main_mountVue({
    selector: "#donation-form",
    render: function render(t) {
      return t(javascript_components_donation_form, {
        props: {
          braintreeLocale: window.__DATA__.checkout_braintree_locale,
          braintreeClientToken: window.__DATA__.checkout_braintree_client_token
        }
      });
    }
  });

  mountComponents();

  setScrollbarWidth();
  Object(youtube_iframes["a" /* default */])();
  fitvids_default()();
});

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Props and attributes to mixin to Vue components replacing Rails form_for fields
// e.g. %image-field{ model: "company", attribute: "logo" }

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    model: {
      type: String,
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    value: {
      type: String
    }
  },
  computed: {
    inputId: function inputId() {
      return this.model + '_' + this.attribute;
    },
    paramName: function paramName() {
      if (this.attribute.includes(',')) {
        var attributes = this.attribute.split(',').join('][');

        return this.model + '[' + attributes + ']';
      } else {
        return this.model + '[' + this.attribute + ']';
      }
    }
  }
});

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./app/javascript/lib/google-maps.js
var google_maps = __webpack_require__(73);

// EXTERNAL MODULE: ./app/javascript/components/mixins/form-options.js
var form_options = __webpack_require__(51);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/location-field.vue
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var location_field = ({
  mixins: [form_options["a" /* default */]],

  props: {
    types: {
      type: String,
      default: '["geocode"]'
    }
  },

  mounted: function mounted() {
    var _this = this;

    var types = JSON.parse(this.types);
    google_maps["a" /* default */].load(function (google) {
      var autocomplete = new google.maps.places.Autocomplete(_this.$el, {
        types: types,
        fields: ["name", "geometry.location"]
      });
      google.maps.event.addListener(autocomplete, 'place_changed', function () {
        _this.$emit('input', _this.$el.value);
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed97150c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/location-field.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "cm-field location-input",
    attrs: {
      "type": "text",
      "autocomplete": "false",
      "id": _vm.inputId,
      "name": _vm.paramName
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, function($event) {
        _vm.$emit('input', $event.target.value)
      }],
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
      }
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_location_field = (esExports);
// CONCATENATED MODULE: ./app/javascript/components/location-field.vue
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  location_field,
  components_location_field,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var javascript_components_location_field = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_maps__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_google_maps__);
// https://www.npmjs.com/package/google-maps


__WEBPACK_IMPORTED_MODULE_0_google_maps___default.a.KEY = 'AIzaSyDGJuZ710E74n3LJ-GsNdIUowBslhwe05Y';
__WEBPACK_IMPORTED_MODULE_0_google_maps___default.a.LIBRARIES = ['places'];

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_google_maps___default.a);

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initYoutubeIframe */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initYoutubeIframeAPI; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Maybe in the future these can be classes that have handling for youtube, vimeo, etc

/**
 * Assumes `onYouTubeIframeAPIReady` has been called
 * by the 3rd-party YouTube script and `YT.Player` exists
 */
var initYoutubeIframe = function initYoutubeIframe(iframe) {
  var youtubePlayer = new YT.Player(iframe, {
    events: {
      onStateChange: function onStateChange(event) {
        var isPlaying = event.data === 1;
        if (isPlaying) {
          // Pause other players
          window.CMYoutubePlayers.filter(function (player) {
            return event.target.playerInfo.videoData.video_id !== player.playerInfo.videoData.video_id;
          }).forEach(function (player) {
            return player.pauseVideo();
          });
        }
      }
    }
  });
  window.CMYoutubePlayers.push(youtubePlayer);
};

var initYoutubeIframeAPI = function initYoutubeIframeAPI() {
  // Select all youtube embeds but NOT /talk videos, which are instantiated separately
  var youtubeIframes = [].concat(_toConsumableArray(document.querySelectorAll('iframe[src*="youtube.com/embed"]:not(.js-vid-embed)')));

  window.youtubeEG = youtubeIframes[0];

  if (youtubeIframes.length) {
    // Normalize URLs before initializing API
    youtubeIframes.forEach(function (iframe) {
      var src = new URL(iframe.src);

      // Request SSL regardless of what the user entered
      src.protocol = "https:";

      // Some embeds (eg from tumblr) add their own origin here
      src.searchParams.set("origin", window.location.origin);

      // Required for YouTube iframe API
      src.searchParams.set("enablejsapi", "1");

      // Required for YouTube iframe API
      src.searchParams.set("feature", "oembed");
      src.searchParams.set("wmode", "opaque");
      src.searchParams.set("rel", "0");

      iframe.src = src;
    });

    // YouTube script that puts YT.Player in the window context
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Window context because we need access to these everywhere
    window.CMYoutubePlayers = [];
  }

  // Function called from youtube's iframe_api script
  window.onYouTubeIframeAPIReady = function () {
    youtubeIframes.forEach(initYoutubeIframe);

    // Init CM Youtube Videos (`/talks videos)
    if (window.onCMYouTubeIframeAPIReady) {
      window.onCMYouTubeIframeAPIReady();
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (initYoutubeIframeAPI);

/***/ })

},[240]);


// WEBPACK FOOTER //
// main-19ae07235038cb5f0ab9.js